import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: string; output: string; }
  AWSURL: { input: string; output: string; }
};

export type AiModel =
  | 'GPT4';

export type AiSettings = {
  __typename?: 'AISettings';
  audienceType?: Maybe<Scalars['String']['output']>;
  blogType?: Maybe<Scalars['String']['output']>;
  greetingMessage?: Maybe<Scalars['String']['output']>;
  journalistType?: Maybe<JournalistType>;
  primaryPersona?: Maybe<Scalars['ID']['output']>;
  publicPrimaryPersona?: Maybe<Scalars['ID']['output']>;
};

export type AiSettingsInput = {
  audienceType?: InputMaybe<Scalars['String']['input']>;
  blogType?: InputMaybe<Scalars['String']['input']>;
  greetingMessage?: InputMaybe<Scalars['String']['input']>;
  journalistType?: InputMaybe<JournalistType>;
  primaryPersona?: InputMaybe<Scalars['ID']['input']>;
  publicPrimaryPersona?: InputMaybe<Scalars['ID']['input']>;
};

export type ApFeedPreviewItem = {
  __typename?: 'APFeedPreviewItem';
  byline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  imported: Scalars['Boolean']['output'];
  importedPageId?: Maybe<Scalars['String']['output']>;
  importedTitle?: Maybe<Scalars['String']['output']>;
  pubStatus?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ApFeedPreviewItemDetail = {
  __typename?: 'APFeedPreviewItemDetail';
  body?: Maybe<Scalars['AWSJSON']['output']>;
  byline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imported: Scalars['Boolean']['output'];
  importedPageId?: Maybe<Scalars['String']['output']>;
  importedTitle?: Maybe<Scalars['String']['output']>;
  lead?: Maybe<Scalars['String']['output']>;
  pubStatus?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ApNewsPricing =
  | 'ALaCarte'
  | 'Choice'
  | 'LimitedDurationSubscription'
  | 'Metered'
  | 'MeteredCredits'
  | 'Unknown'
  | 'Unlimited';

export type ApNewsTopic = {
  __typename?: 'APNewsTopic';
  active?: Maybe<Scalars['Boolean']['output']>;
  display?: Maybe<ExternalDisplay>;
  feedLink: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imgRequired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paywall?: Maybe<Paywall>;
  pricing: ApNewsPricing;
  publishStatus?: Maybe<FeedPublishStatus>;
  sectionId?: Maybe<Scalars['ID']['output']>;
};

export type ApNewsTopicConnection = {
  __typename?: 'APNewsTopicConnection';
  items: Array<ApNewsTopic>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ApNewsTopicInput = {
  active: Scalars['Boolean']['input'];
  display?: InputMaybe<ExternalDisplay>;
  id: Scalars['ID']['input'];
  imgRequired?: InputMaybe<Scalars['Boolean']['input']>;
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  sectionId: Scalars['ID']['input'];
};

export type AddItemToCollectionsInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  assetId: Scalars['ID']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
  collectionIds: Array<Scalars['ID']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type AdvertisementSystem =
  | 'custom'
  | 'googleAdManager'
  | 'internalPlaceholders'
  | 'playWire';

export type AnalyticsData = {
  __typename?: 'AnalyticsData';
  blockId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  getBlock?: Maybe<BlockConnection>;
};


export type AnalyticsDataGetBlockArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};

export type AnalyticsResult = {
  __typename?: 'AnalyticsResult';
  hitsByInterval: Array<HitsByInterval>;
  pages: Array<AnalyticsData>;
  uniqueHitsByInterval: Array<HitsByInterval>;
};

export type ArticleBodySidebarMode =
  | 'Related'
  | 'Trending';

export type ArticleConversionStat = {
  __typename?: 'ArticleConversionStat';
  blockId: Scalars['String']['output'];
  checkoutStarts: Scalars['Int']['output'];
  paywallHits: Scalars['Int']['output'];
  planViews: Scalars['Int']['output'];
  purchases: Scalars['Int']['output'];
};

export type ArticleType =
  | 'default'
  | 'event'
  | 'paid'
  | 'recurringEvent'
  | 'sponsored';

export type Asset = Node & {
  __typename?: 'Asset';
  /** Brand id for this asset belongs to */
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  /** Height of asset in px */
  height?: Maybe<Scalars['Int']['output']>;
  /** Unique id for the asset, starts with asset_ */
  id: Scalars['ID']['output'];
  /** Blurry placeholder that can be used before the image is fully loaded */
  imagePlaceholder?: Maybe<Scalars['String']['output']>;
  /** Path where this object is accessible */
  key: Scalars['String']['output'];
  /** Displayed name for the asset */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Weither is asset is public or not.
   * Public assets are accessible at https://public-assets-dev.pubgen.ai/${asset.key}?&format...
   * Private asset are accessible at https://private-assets-dev.pubgen.ai/${asset.key}?jwt=${jwt}&format...
   */
  public: Scalars['Boolean']['output'];
  /** Tags for the asset */
  tags: Array<Scalars['String']['output']>;
  /** Asset type */
  type?: Maybe<AssetType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  /** True is the asset was sucessfully uploaded */
  uploaded: Scalars['Boolean']['output'];
  /** All the block ids where this asset is used */
  usedIn: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  /** Width of asset in px */
  width?: Maybe<Scalars['Int']['output']>;
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  items: Array<Asset>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AssetInput = {
  /** Brand id for this asset belongs to */
  brandId: Scalars['ID']['input'];
  createdAt: Scalars['AWSDateTime']['input'];
  /** Height of asset in px */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Unique id for the asset, starts with asset_ */
  id: Scalars['ID']['input'];
  /** Blurry placeholder that can be used before the image is fully loaded */
  imagePlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** Path where this object is accessible */
  key: Scalars['String']['input'];
  /** Displayed name for the asset */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Weither is asset is public or not.
   * Public assets are accessible at https://public-assets-dev.pubgen.ai/${asset.key}?&format...
   * Private asset are accessible at https://private-assets-dev.pubgen.ai/${asset.key}?jwt=${jwt}&format...
   */
  public: Scalars['Boolean']['input'];
  /** Tags for the asset */
  tags: Array<Scalars['String']['input']>;
  /** Asset type */
  type?: InputMaybe<AssetType>;
  updatedAt: Scalars['AWSDateTime']['input'];
  /** True is the asset was sucessfully uploaded */
  uploaded: Scalars['Boolean']['input'];
  /** All the block ids where this asset is used */
  usedIn: Array<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
  /** Width of asset in px */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetType =
  | 'Font'
  | 'Image'
  | 'Pdf'
  | 'ZipImport';

export type Automation = {
  __typename?: 'Automation';
  /** Number of members currently progressing through the journey. */
  activeEnrollments?: Maybe<Scalars['Int']['output']>;
  /** Number of members who have finished (or exited) the journey. */
  completedEnrollments?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Optional member tag that causes an enrolled member to exit the journey (e.g. "member" to stop an upsell drip once they convert). */
  exitTag?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** For SEGMENT_DYNAMIC: timestamp of the last hourly membership reconcile. */
  lastSyncedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  replyToEmail?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  status?: Maybe<AutomationStatus>;
  steps: Array<AutomationStep>;
  trigger: AutomationTrigger;
  /** For EVENT: the lifecycle event type whose occurrence enrolls the contact. */
  triggerEventType?: Maybe<ContactEventType>;
  /** For SUBSCRIBE: the newsletter whose new subscribers get enrolled. */
  triggerNewsletterId?: Maybe<Scalars['ID']['output']>;
  /** For SEGMENT_DYNAMIC: the segment whose membership the journey follows (synced hourly). */
  triggerSegmentId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type AutomationEnrollment = {
  __typename?: 'AutomationEnrollment';
  automationId: Scalars['ID']['output'];
  /** Index of the step that will be sent next. */
  currentStep: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  enrolledAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  lastStepSentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  nextRunAt?: Maybe<Scalars['AWSDateTime']['output']>;
  siteId: Scalars['ID']['output'];
  /** ACTIVE | COMPLETED | EXITED. */
  status: Scalars['String']['output'];
};

export type AutomationEnrollmentConnection = {
  __typename?: 'AutomationEnrollmentConnection';
  items: Array<AutomationEnrollment>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AutomationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exitTag?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<AutomationStatus>;
  steps: Array<AutomationStepInput>;
  trigger: AutomationTrigger;
  triggerEventType?: InputMaybe<ContactEventType>;
  triggerNewsletterId?: InputMaybe<Scalars['ID']['input']>;
  triggerSegmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutomationStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DRAFT'
  | 'PAUSED';

/**
 * One step in a linear automation. `delay` is measured from the moment the
 * previous step was sent (or from enrollment, for the first step). Delays are
 * relative, so they are timezone-independent ("wait 2 days").
 */
export type AutomationStep = {
  __typename?: 'AutomationStep';
  /** JSON-serialized NewsletterBlock[] (same block schema as newsletters). */
  blocksJson: Scalars['AWSJSON']['output'];
  delay: Scalars['Int']['output'];
  delayUnit: AutomationStepDelayUnit;
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
};

export type AutomationStepDelayUnit =
  | 'DAYS'
  | 'HOURS'
  | 'MINUTES';

export type AutomationStepInput = {
  blocksJson: Scalars['AWSJSON']['input'];
  delay: Scalars['Int']['input'];
  delayUnit: AutomationStepDelayUnit;
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

/**
 * What enrolls a member into an automation.
 * - SUBSCRIBE: enroll automatically when a member subscribes to `triggerNewsletterId`.
 * - MANUAL: enroll explicitly via `enrollSegmentInAutomation` (one-time snapshot of
 *   the contacts a segment matches right now).
 * - SEGMENT_DYNAMIC: follow `triggerSegmentId` continuously — an hourly sync enrolls
 *   newly-matching contacts at step 1 and exits contacts that no longer match.
 * - EVENT: enroll automatically when a contact records a lifecycle event of
 *   `triggerEventType` (e.g. PLAN_STARTED, DONATION).
 */
export type AutomationTrigger =
  | 'EVENT'
  | 'MANUAL'
  | 'SEGMENT_DYNAMIC'
  | 'SUBSCRIBE';

export type Block = PublishedNode & {
  __typename?: 'Block';
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /**  block type, can be used to filter blocks when listing them  */
  blockCategory: BlockCategory;
  brandId: Scalars['ID']['output'];
  /** Cannonical name of the react component */
  componentId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  /** All block data */
  data?: Maybe<BlockData>;
  externalBlockIds: Array<Scalars['String']['output']>;
  /** dynamodb composite key, consists of blockCategory_sk_releaseDate if releaseDate exists (only for articles) */
  gsk1: Scalars['ID']['output'];
  /** dynamodb composite key only set for articles, consists of hero, lead, topStory with media, topStory without media and releaseDate */
  gsk2?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  listExternalBlocks?: Maybe<BlockConnection>;
  pageId: Scalars['ID']['output'];
  /** publication date */
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /**  if state is saved, the timestamp it was saved at  */
  savedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** the username of the user that saved the version */
  savedBy?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  /** dynamodb composite key, consists of state_savedAt */
  sk: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  state: PublishState;
  updatedAt: Scalars['AWSDateTime']['output'];
  /** Variant of the component */
  variant?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};


export type BlockListExternalBlocksArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type BlockCards = {
  __typename?: 'BlockCards';
  cards?: Maybe<Array<Card>>;
};

export type BlockCardsInput = {
  cards?: InputMaybe<Array<CardInput>>;
};

export type BlockCategory =
  | 'Cards'
  | 'CoverImage'
  | 'Divider'
  | 'EmailCapture'
  | 'Faq'
  | 'FooterSho'
  | 'GoogleAd'
  | 'Pub404'
  | 'PubAccount'
  | 'PubAdHero'
  | 'PubAllAuthors'
  | 'PubAllSections'
  | 'PubAllTags'
  | 'PubArticleBody'
  | 'PubArticleHeader'
  | 'PubArticlesBySection'
  | 'PubAuthorOverview'
  | 'PubBreakingNews'
  | 'PubCheckout'
  | 'PubEvents'
  | 'PubExternalReferences'
  | 'PubGift'
  | 'PubGiftRedeem'
  | 'PubHomeHero'
  | 'PubHomeTopStories'
  | 'PubLatestArticles'
  | 'PubLeadArticle'
  | 'PubMediaTopStories'
  | 'PubNewsletters'
  | 'PubPayments'
  | 'PubSearch'
  | 'PubSectionMain'
  | 'PubSectionRelatedArticlesEmphasisAuthors'
  | 'PubSectionsTopStory'
  | 'PubSignIn'
  | 'PubSitemap'
  | 'PubSpotlight'
  | 'PubSubscribe'
  | 'PubTagHeader'
  | 'PubThankYou'
  | 'PubWeather'
  | 'PubWeatherAdvisory'
  | 'Wysiwyg';

export type BlockConnection = {
  __typename?: 'BlockConnection';
  items: Array<Block>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type BlockCoverImage = {
  __typename?: 'BlockCoverImage';
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type BlockCoverImageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockData = BlockCards | BlockCoverImage | BlockFaq | BlockPubAccount | BlockPubAdHero | BlockPubArticleBody | BlockPubArticleHeader | BlockPubArticlesBySection | BlockPubAuthorOverview | BlockPubBreakingNews | BlockPubEvents | BlockPubExternalReferences | BlockPubGift | BlockPubHomeHero | BlockPubHomeTopStories | BlockPubLeadArticle | BlockPubMediaTopStories | BlockPubNewsletters | BlockPubSearch | BlockPubSectionMainView | BlockPubSectionRelatedArticlesEmphasisAuthors | BlockPubSectionsTopStory | BlockPubSpotlight | BlockPubSubscribe | BlockPubTagHeader | BlockPubThankYou | BlockPubWeatherAdvisory | BlockWysiwyg;

export type BlockDataInput = {
  BlockCards?: InputMaybe<BlockCardsInput>;
  BlockCoverImage?: InputMaybe<BlockCoverImageInput>;
  BlockFaq?: InputMaybe<BlockFaqInput>;
  BlockPubAccount?: InputMaybe<BlockPubAccountInput>;
  BlockPubAdHero?: InputMaybe<BlockPubAdHeroInput>;
  BlockPubArticleBody?: InputMaybe<BlockPubArticleBodyInput>;
  BlockPubArticleHeader?: InputMaybe<BlockPubArticleHeaderInput>;
  BlockPubArticlesBySection?: InputMaybe<BlockPubArticlesBySectionInput>;
  BlockPubAuthorOverview?: InputMaybe<BlockPubAuthorOverviewInput>;
  BlockPubBreakingNews?: InputMaybe<BlockPubBreakingNewsInput>;
  BlockPubEvents?: InputMaybe<BlockPubEventsInput>;
  BlockPubExternalReferences?: InputMaybe<BlockPubExternalReferencesInput>;
  BlockPubGift?: InputMaybe<BlockPubGiftInput>;
  BlockPubHomeHero?: InputMaybe<BlockPubHomeHeroInput>;
  BlockPubHomeTopStories?: InputMaybe<BlockPubHomeTopStoriesInput>;
  BlockPubLeadArticle?: InputMaybe<BlockPubLeadArticleInput>;
  BlockPubMediaTopStories?: InputMaybe<BlockPubMediaTopStoriesInput>;
  BlockPubNewsletters?: InputMaybe<BlockPubNewslettersInput>;
  BlockPubSearch?: InputMaybe<BlockPubSearchInput>;
  BlockPubSectionMainView?: InputMaybe<BlockPubSectionMainViewInput>;
  BlockPubSectionRelatedArticlesEmphasisAuthors?: InputMaybe<BlockPubSectionRelatedArticlesEmphasisAuthorsInput>;
  BlockPubSectionsTopStory?: InputMaybe<BlockPubSectionsTopStoryInput>;
  BlockPubSpotlight?: InputMaybe<BlockPubSpotlightInput>;
  BlockPubSubscribe?: InputMaybe<BlockPubSubscribeInput>;
  BlockPubTagHeader?: InputMaybe<BlockPubTagHeaderInput>;
  BlockPubThankYou?: InputMaybe<BlockPubThankYouInput>;
  BlockPubWeatherAdvisory?: InputMaybe<BlockPubWeatherAdvisoryInput>;
  BlockWysiwyg?: InputMaybe<BlockWysiwygInput>;
  type: BlockDataInputType;
};

export type BlockDataInputType =
  | 'BlockCards'
  | 'BlockCoverImage'
  | 'BlockFaq'
  | 'BlockPubAccount'
  | 'BlockPubAdHero'
  | 'BlockPubArticleBody'
  | 'BlockPubArticleHeader'
  | 'BlockPubArticlesBySection'
  | 'BlockPubAuthorOverview'
  | 'BlockPubBreakingNews'
  | 'BlockPubEvents'
  | 'BlockPubExternalReferences'
  | 'BlockPubGift'
  | 'BlockPubHomeHero'
  | 'BlockPubHomeTopStories'
  | 'BlockPubLeadArticle'
  | 'BlockPubMediaTopStories'
  | 'BlockPubNewsletters'
  | 'BlockPubSearch'
  | 'BlockPubSectionMainView'
  | 'BlockPubSectionRelatedArticlesEmphasisAuthors'
  | 'BlockPubSectionsTopStory'
  | 'BlockPubSpotlight'
  | 'BlockPubSubscribe'
  | 'BlockPubTagHeader'
  | 'BlockPubThankYou'
  | 'BlockPubWeatherAdvisory'
  | 'BlockWysiwyg';

export type BlockEventStat = {
  __typename?: 'BlockEventStat';
  blockId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type BlockFaq = {
  __typename?: 'BlockFaq';
  description?: Maybe<Scalars['String']['output']>;
  faqItems?: Maybe<Array<FaqItem>>;
};

export type BlockFaqInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  faqItems?: InputMaybe<Array<FaqItemInput>>;
};

export type BlockPubAccount = {
  __typename?: 'BlockPubAccount';
  snippet?: Maybe<Scalars['String']['output']>;
  supportPlanLinkOverride?: Maybe<Scalars['String']['output']>;
};

export type BlockPubAccountInput = {
  snippet?: InputMaybe<Scalars['String']['input']>;
  supportPlanLinkOverride?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubAdHero = {
  __typename?: 'BlockPubAdHero';
  content?: Maybe<Scalars['AWSJSON']['output']>;
};

export type BlockPubAdHeroInput = {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type BlockPubArticleBody = {
  __typename?: 'BlockPubArticleBody';
  content?: Maybe<Scalars['AWSJSON']['output']>;
};

export type BlockPubArticleBodyInput = {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type BlockPubArticleHeader = {
  __typename?: 'BlockPubArticleHeader';
  authors?: Maybe<Array<Scalars['String']['output']>>;
  blurryPlaceholder?: Maybe<Scalars['String']['output']>;
  byline?: Maybe<Scalars['String']['output']>;
  carousel?: Maybe<Array<Carousel>>;
  detachedFromFeed?: Maybe<Scalars['Boolean']['output']>;
  eReaderPdfLink?: Maybe<Scalars['String']['output']>;
  editorNotes?: Maybe<Scalars['String']['output']>;
  eventBeginDate?: Maybe<Scalars['AWSDateTime']['output']>;
  eventButtonSubhead?: Maybe<Scalars['String']['output']>;
  eventEndDate?: Maybe<Scalars['AWSDateTime']['output']>;
  eventICal?: Maybe<Scalars['String']['output']>;
  eventLocation?: Maybe<Scalars['String']['output']>;
  eventPhoneContact?: Maybe<Scalars['String']['output']>;
  eventPreCTACopy?: Maybe<Scalars['String']['output']>;
  eventTicketLabel?: Maybe<Scalars['String']['output']>;
  eventTicketUrl?: Maybe<Scalars['String']['output']>;
  eventVenueName?: Maybe<Scalars['String']['output']>;
  externalDisplay?: Maybe<ExternalDisplay>;
  featuredMediaType?: Maybe<FeaturedMediaType>;
  feeds?: Maybe<Array<Scalars['String']['output']>>;
  galleryAspectRatio?: Maybe<GalleryAspectRatio>;
  galleryType?: Maybe<GalleryType>;
  hideRelatedArticles?: Maybe<Scalars['Boolean']['output']>;
  hideWriterBoilerplate?: Maybe<Scalars['Boolean']['output']>;
  iframeAspectRatio?: Maybe<IframeAspectRatio>;
  iframeCaption?: Maybe<Scalars['String']['output']>;
  iframeCredits?: Maybe<Scalars['String']['output']>;
  iframeLink?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  imageCredit?: Maybe<Scalars['String']['output']>;
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageMetadata?: Maybe<Array<Scalars['String']['output']>>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  isAPNews?: Maybe<Scalars['Boolean']['output']>;
  isIframe?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<Scalars['String']['output']>>;
  onlineEventUrl?: Maybe<Scalars['String']['output']>;
  paidPostImgHeight?: Maybe<Scalars['Int']['output']>;
  paidPostImgSrc?: Maybe<Scalars['String']['output']>;
  paidPostImgWidth?: Maybe<Scalars['Int']['output']>;
  paidPostName?: Maybe<Scalars['String']['output']>;
  paidPostUrl?: Maybe<Scalars['String']['output']>;
  paywall?: Maybe<Paywall>;
  printReleaseDate?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  sponsoredCaption?: Maybe<Scalars['String']['output']>;
  sponsoredImgHeight?: Maybe<Scalars['Int']['output']>;
  sponsoredImgSrc?: Maybe<Scalars['String']['output']>;
  sponsoredImgWidth?: Maybe<Scalars['Int']['output']>;
  sponsoredUrl?: Maybe<Scalars['String']['output']>;
  storyLayout?: Maybe<StoryLayout>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  toReview?: Maybe<Scalars['Boolean']['output']>;
  type: ArticleType;
};

export type BlockPubArticleHeaderInput = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  blurryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  byline?: InputMaybe<Scalars['String']['input']>;
  carousel?: InputMaybe<Array<CarouselInput>>;
  detachedFromFeed?: InputMaybe<Scalars['Boolean']['input']>;
  eReaderPdfLink?: InputMaybe<Scalars['String']['input']>;
  editorNotes?: InputMaybe<Scalars['String']['input']>;
  eventBeginDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eventButtonSubhead?: InputMaybe<Scalars['String']['input']>;
  eventEndDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eventICal?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  eventPhoneContact?: InputMaybe<Scalars['String']['input']>;
  eventPreCTACopy?: InputMaybe<Scalars['String']['input']>;
  eventTicketLabel?: InputMaybe<Scalars['String']['input']>;
  eventTicketUrl?: InputMaybe<Scalars['String']['input']>;
  eventVenueName?: InputMaybe<Scalars['String']['input']>;
  externalDisplay?: InputMaybe<ExternalDisplay>;
  featuredMediaType?: InputMaybe<FeaturedMediaType>;
  feeds?: InputMaybe<Array<Scalars['String']['input']>>;
  galleryAspectRatio?: InputMaybe<GalleryAspectRatio>;
  galleryType?: InputMaybe<GalleryType>;
  hideRelatedArticles?: InputMaybe<Scalars['Boolean']['input']>;
  hideWriterBoilerplate?: InputMaybe<Scalars['Boolean']['input']>;
  iframeAspectRatio?: InputMaybe<IframeAspectRatio>;
  iframeCaption?: InputMaybe<Scalars['String']['input']>;
  iframeCredits?: InputMaybe<Scalars['String']['input']>;
  iframeLink?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageCredit?: InputMaybe<Scalars['String']['input']>;
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  imageMetadata?: InputMaybe<Array<Scalars['String']['input']>>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  isAPNews?: InputMaybe<Scalars['Boolean']['input']>;
  isIframe?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  onlineEventUrl?: InputMaybe<Scalars['String']['input']>;
  paidPostImgHeight?: InputMaybe<Scalars['Int']['input']>;
  paidPostImgSrc?: InputMaybe<Scalars['String']['input']>;
  paidPostImgWidth?: InputMaybe<Scalars['Int']['input']>;
  paidPostName?: InputMaybe<Scalars['String']['input']>;
  paidPostUrl?: InputMaybe<Scalars['String']['input']>;
  paywall?: InputMaybe<Paywall>;
  printReleaseDate?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  sponsoredCaption?: InputMaybe<Scalars['String']['input']>;
  sponsoredImgHeight?: InputMaybe<Scalars['Int']['input']>;
  sponsoredImgSrc?: InputMaybe<Scalars['String']['input']>;
  sponsoredImgWidth?: InputMaybe<Scalars['Int']['input']>;
  sponsoredUrl?: InputMaybe<Scalars['String']['input']>;
  storyLayout?: InputMaybe<StoryLayout>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  toReview?: InputMaybe<Scalars['Boolean']['input']>;
  type: ArticleType;
};

export type BlockPubArticleRelatedArticles = {
  __typename?: 'BlockPubArticleRelatedArticles';
  content?: Maybe<Scalars['AWSJSON']['output']>;
  defaultHideImageBackground?: Maybe<Scalars['Boolean']['output']>;
  eReaderDefaultFitMode?: Maybe<Scalars['String']['output']>;
  eReaderDefaultViewMode?: Maybe<Scalars['String']['output']>;
  eReaderInitializesFullscreen?: Maybe<Scalars['Boolean']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubArticleRelatedArticlesInput = {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  defaultHideImageBackground?: InputMaybe<Scalars['Boolean']['input']>;
  eReaderDefaultFitMode?: InputMaybe<Scalars['String']['input']>;
  eReaderDefaultViewMode?: InputMaybe<Scalars['String']['input']>;
  eReaderInitializesFullscreen?: InputMaybe<Scalars['Boolean']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubArticlesBySection = {
  __typename?: 'BlockPubArticlesBySection';
  articleOverride1?: Maybe<BlockPubHomeTopStoryArticleData>;
  articleOverride2?: Maybe<BlockPubHomeTopStoryArticleData>;
  articleOverride3?: Maybe<BlockPubHomeTopStoryArticleData>;
  articleOverride4?: Maybe<BlockPubHomeTopStoryArticleData>;
  hideDivider?: Maybe<Scalars['Boolean']['output']>;
  pubArticlesBySectionLayout?: Maybe<BlockPubArticlesBySectionLayout>;
  section?: Maybe<Scalars['String']['output']>;
  showDescription?: Maybe<Scalars['Boolean']['output']>;
};

export type BlockPubArticlesBySectionInput = {
  articleOverride1?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articleOverride2?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articleOverride3?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articleOverride4?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  hideDivider?: InputMaybe<Scalars['Boolean']['input']>;
  pubArticlesBySectionLayout?: InputMaybe<BlockPubArticlesBySectionLayout>;
  section?: InputMaybe<Scalars['String']['input']>;
  showDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPubArticlesBySectionLayout =
  | 'FEATURED_THREE_UP'
  | 'FOUR_COLUMNS'
  | 'THREE_COLUMNS';

export type BlockPubAuthorOverview = {
  __typename?: 'BlockPubAuthorOverview';
  biography?: Maybe<Scalars['AWSJSON']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookUsername?: Maybe<Scalars['String']['output']>;
  instagramUsername?: Maybe<Scalars['String']['output']>;
  linkedInUsername?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pictureHeight?: Maybe<Scalars['Int']['output']>;
  pictureWidth?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  writerBoilerplate?: Maybe<Scalars['AWSJSON']['output']>;
  xHandle?: Maybe<Scalars['String']['output']>;
  youtubeChannelHandle?: Maybe<Scalars['String']['output']>;
};

export type BlockPubAuthorOverviewInput = {
  biography?: InputMaybe<Scalars['AWSJSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookUsername?: InputMaybe<Scalars['String']['input']>;
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  linkedInUsername?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pictureHeight?: InputMaybe<Scalars['Int']['input']>;
  pictureWidth?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  writerBoilerplate?: InputMaybe<Scalars['AWSJSON']['input']>;
  xHandle?: InputMaybe<Scalars['String']['input']>;
  youtubeChannelHandle?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubBreakingNews = {
  __typename?: 'BlockPubBreakingNews';
  customText?: Maybe<Scalars['String']['output']>;
  customTextLink?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BlockPubBreakingNewsInput = {
  customText?: InputMaybe<Scalars['String']['input']>;
  customTextLink?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubEvents = {
  __typename?: 'BlockPubEvents';
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubEventsInput = {
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubExternalReferences = {
  __typename?: 'BlockPubExternalReferences';
  externalReferences: Array<ExternalReference>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubExternalReferencesInput = {
  externalReferences: Array<ExternalReferenceInput>;
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubFooter = {
  __typename?: 'BlockPubFooter';
  copyrigthName?: Maybe<Scalars['String']['output']>;
  logoHeight?: Maybe<Scalars['Int']['output']>;
  logoSrc?: Maybe<Scalars['String']['output']>;
  logoWidth?: Maybe<Scalars['Int']['output']>;
  menu1Id?: Maybe<Scalars['String']['output']>;
  menu2Id?: Maybe<Scalars['String']['output']>;
  menu3Id?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type BlockPubFooterInput = {
  copyrigthName?: InputMaybe<Scalars['String']['input']>;
  logoHeight?: InputMaybe<Scalars['Int']['input']>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  logoWidth?: InputMaybe<Scalars['Int']['input']>;
  menu1Id?: InputMaybe<Scalars['String']['input']>;
  menu2Id?: InputMaybe<Scalars['String']['input']>;
  menu3Id?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubGift = {
  __typename?: 'BlockPubGift';
  disclaimer?: Maybe<Scalars['AWSJSON']['output']>;
  faqItems?: Maybe<Array<FaqItem>>;
  headerLogoHeight?: Maybe<Scalars['Int']['output']>;
  headerLogoSrc?: Maybe<Scalars['String']['output']>;
  headerLogoWidth?: Maybe<Scalars['Int']['output']>;
  headerSubtitle?: Maybe<Scalars['String']['output']>;
  headerTitle?: Maybe<Scalars['String']['output']>;
  showHeaderGIF?: Maybe<Scalars['Boolean']['output']>;
  starredGiftProductId?: Maybe<Scalars['String']['output']>;
  stripePlansOrderedByProductId?: Maybe<Array<Scalars['String']['output']>>;
};

export type BlockPubGiftInput = {
  disclaimer?: InputMaybe<Scalars['AWSJSON']['input']>;
  faqItems?: InputMaybe<Array<FaqItemInput>>;
  headerLogoHeight?: InputMaybe<Scalars['Int']['input']>;
  headerLogoSrc?: InputMaybe<Scalars['String']['input']>;
  headerLogoWidth?: InputMaybe<Scalars['Int']['input']>;
  headerSubtitle?: InputMaybe<Scalars['String']['input']>;
  headerTitle?: InputMaybe<Scalars['String']['input']>;
  showHeaderGIF?: InputMaybe<Scalars['Boolean']['input']>;
  starredGiftProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlansOrderedByProductId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BlockPubHeaderMenu = {
  __typename?: 'BlockPubHeaderMenu';
  customCtaLabel?: Maybe<Scalars['String']['output']>;
  customCtaLink?: Maybe<Scalars['String']['output']>;
  customCtaType?: Maybe<HeaderCustomCtaType>;
  drawerMenu1Id?: Maybe<Scalars['String']['output']>;
  drawerMenu2Id?: Maybe<Scalars['String']['output']>;
  drawerMenu3Id?: Maybe<Scalars['String']['output']>;
  drawerMenu4Id?: Maybe<Scalars['String']['output']>;
  gtmAlternativeImgHeight?: Maybe<Scalars['Int']['output']>;
  gtmAlternativeImgLink?: Maybe<Scalars['String']['output']>;
  gtmAlternativeImgSrc?: Maybe<Scalars['String']['output']>;
  gtmAlternativeImgWidth?: Maybe<Scalars['Int']['output']>;
  hideCustomCta?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  layout?: Maybe<HeaderLayout>;
  leaderBoardAdPosition?: Maybe<LeaderboardPosition>;
  logoHeight?: Maybe<Scalars['Int']['output']>;
  logoSize?: Maybe<LogoSize>;
  logoSrc?: Maybe<Scalars['String']['output']>;
  logoWidth?: Maybe<Scalars['Int']['output']>;
  mainMenuId?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubHeaderMenuInput = {
  customCtaLabel?: InputMaybe<Scalars['String']['input']>;
  customCtaLink?: InputMaybe<Scalars['String']['input']>;
  customCtaType?: InputMaybe<HeaderCustomCtaType>;
  drawerMenu1Id?: InputMaybe<Scalars['String']['input']>;
  drawerMenu2Id?: InputMaybe<Scalars['String']['input']>;
  drawerMenu3Id?: InputMaybe<Scalars['String']['input']>;
  drawerMenu4Id?: InputMaybe<Scalars['String']['input']>;
  gtmAlternativeImgHeight?: InputMaybe<Scalars['Int']['input']>;
  gtmAlternativeImgLink?: InputMaybe<Scalars['String']['input']>;
  gtmAlternativeImgSrc?: InputMaybe<Scalars['String']['input']>;
  gtmAlternativeImgWidth?: InputMaybe<Scalars['Int']['input']>;
  hideCustomCta?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<HeaderLayout>;
  leaderBoardAdPosition?: InputMaybe<LeaderboardPosition>;
  logoHeight?: InputMaybe<Scalars['Int']['input']>;
  logoSize?: InputMaybe<LogoSize>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  logoWidth?: InputMaybe<Scalars['Int']['input']>;
  mainMenuId?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubHomeHero = {
  __typename?: 'BlockPubHomeHero';
  articleHeaderID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imgHeight?: Maybe<Scalars['Int']['output']>;
  imgSrc?: Maybe<Scalars['String']['output']>;
  imgWidth?: Maybe<Scalars['Int']['output']>;
  isAutomatic?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BlockPubHomeHeroInput = {
  articleHeaderID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imgHeight?: InputMaybe<Scalars['Int']['input']>;
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  imgWidth?: InputMaybe<Scalars['Int']['input']>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubHomeTopStories = {
  __typename?: 'BlockPubHomeTopStories';
  articlesId1?: Maybe<BlockPubHomeTopStoryArticleData>;
  articlesId2?: Maybe<BlockPubHomeTopStoryArticleData>;
  articlesId3?: Maybe<BlockPubHomeTopStoryArticleData>;
  articlesId4?: Maybe<BlockPubHomeTopStoryArticleData>;
  articlesId5?: Maybe<BlockPubHomeTopStoryArticleData>;
  articlesId6?: Maybe<BlockPubHomeTopStoryArticleData>;
  pubHomeTopStoriesLayout?: Maybe<BlockPubHomeTopStoriesLayout>;
  sectionsToExclude?: Maybe<Array<Scalars['String']['output']>>;
  sponsoredArticle?: Maybe<BlockPubHomeTopStorySponsoredArticleData>;
  topStoriesLimit?: Maybe<Scalars['Int']['output']>;
};

export type BlockPubHomeTopStoriesInput = {
  articlesId1?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articlesId2?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articlesId3?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articlesId4?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articlesId5?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  articlesId6?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  pubHomeTopStoriesLayout?: InputMaybe<BlockPubHomeTopStoriesLayout>;
  sectionsToExclude?: InputMaybe<Array<Scalars['String']['input']>>;
  sponsoredArticle?: InputMaybe<BlockPubHomeTopStorySponsoredArticleDataInput>;
  topStoriesLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockPubHomeTopStoriesLayout =
  | 'HERO_CENTERED_STACKED_RAILS'
  | 'LIST_WITH_SIDEBAR'
  | 'TOP_STORIES_ONLY';

export type BlockPubHomeTopStoryArticleData = {
  __typename?: 'BlockPubHomeTopStoryArticleData';
  articleHeaderID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imgHeight?: Maybe<Scalars['Int']['output']>;
  imgSrc?: Maybe<Scalars['String']['output']>;
  imgWidth?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BlockPubHomeTopStoryArticleDataInput = {
  articleHeaderID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imgHeight?: InputMaybe<Scalars['Int']['input']>;
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  imgWidth?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubHomeTopStorySponsoredArticleData = {
  __typename?: 'BlockPubHomeTopStorySponsoredArticleData';
  articleHeaderID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imgHeight?: Maybe<Scalars['Int']['output']>;
  imgSrc?: Maybe<Scalars['String']['output']>;
  imgWidth?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BlockPubHomeTopStorySponsoredArticleDataInput = {
  articleHeaderID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imgHeight?: InputMaybe<Scalars['Int']['input']>;
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  imgWidth?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubLeadArticle = {
  __typename?: 'BlockPubLeadArticle';
  articleHeaderID?: Maybe<Scalars['String']['output']>;
  articleHeaderID2?: Maybe<Scalars['String']['output']>;
  articleHeaderID3?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  id2?: Maybe<Scalars['String']['output']>;
  id3?: Maybe<Scalars['String']['output']>;
  imgHeight?: Maybe<Scalars['Int']['output']>;
  imgHeight2?: Maybe<Scalars['Int']['output']>;
  imgHeight3?: Maybe<Scalars['Int']['output']>;
  imgSrc?: Maybe<Scalars['String']['output']>;
  imgSrc2?: Maybe<Scalars['String']['output']>;
  imgSrc3?: Maybe<Scalars['String']['output']>;
  imgWidth?: Maybe<Scalars['Int']['output']>;
  imgWidth2?: Maybe<Scalars['Int']['output']>;
  imgWidth3?: Maybe<Scalars['Int']['output']>;
  isAutomatic?: Maybe<Scalars['Boolean']['output']>;
  isAutomatic2?: Maybe<Scalars['Boolean']['output']>;
  isAutomatic3?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  isVisible2?: Maybe<Scalars['Boolean']['output']>;
  isVisible3?: Maybe<Scalars['Boolean']['output']>;
  layout?: Maybe<BlockPubLeadArticleLayout>;
  layout2?: Maybe<BlockPubLeadArticleLayout>;
  layout3?: Maybe<BlockPubLeadArticleLayout>;
  slug?: Maybe<Scalars['String']['output']>;
  slug2?: Maybe<Scalars['String']['output']>;
  slug3?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
  title3?: Maybe<Scalars['String']['output']>;
};

export type BlockPubLeadArticleInput = {
  articleHeaderID?: InputMaybe<Scalars['String']['input']>;
  articleHeaderID2?: InputMaybe<Scalars['String']['input']>;
  articleHeaderID3?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id2?: InputMaybe<Scalars['String']['input']>;
  id3?: InputMaybe<Scalars['String']['input']>;
  imgHeight?: InputMaybe<Scalars['Int']['input']>;
  imgHeight2?: InputMaybe<Scalars['Int']['input']>;
  imgHeight3?: InputMaybe<Scalars['Int']['input']>;
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  imgSrc2?: InputMaybe<Scalars['String']['input']>;
  imgSrc3?: InputMaybe<Scalars['String']['input']>;
  imgWidth?: InputMaybe<Scalars['Int']['input']>;
  imgWidth2?: InputMaybe<Scalars['Int']['input']>;
  imgWidth3?: InputMaybe<Scalars['Int']['input']>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  isAutomatic2?: InputMaybe<Scalars['Boolean']['input']>;
  isAutomatic3?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible2?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible3?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<BlockPubLeadArticleLayout>;
  layout2?: InputMaybe<BlockPubLeadArticleLayout>;
  layout3?: InputMaybe<BlockPubLeadArticleLayout>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug2?: InputMaybe<Scalars['String']['input']>;
  slug3?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title2?: InputMaybe<Scalars['String']['input']>;
  title3?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubLeadArticleLayout =
  | 'IMAGE_LEFT_TEXT_RIGHT'
  | 'TEXT_LEFT_IMAGE_RIGHT';

export type BlockPubMediaTopStories = {
  __typename?: 'BlockPubMediaTopStories';
  filterOutApStories?: Maybe<Scalars['Boolean']['output']>;
  mediaGalleryIsVisible?: Maybe<Scalars['Boolean']['output']>;
  socialGalleries?: Maybe<Array<Maybe<SocialGallery>>>;
};

export type BlockPubMediaTopStoriesInput = {
  filterOutApStories?: InputMaybe<Scalars['Boolean']['input']>;
  mediaGalleryIsVisible?: InputMaybe<Scalars['Boolean']['input']>;
  socialGalleries?: InputMaybe<Array<InputMaybe<SocialGalleryInput>>>;
};

export type BlockPubNavSqueeze = {
  __typename?: 'BlockPubNavSqueeze';
  logoHeight?: Maybe<Scalars['Int']['output']>;
  logoSize?: Maybe<LogoSize>;
  logoSrc?: Maybe<Scalars['String']['output']>;
  logoWidth?: Maybe<Scalars['Int']['output']>;
};

export type BlockPubNavSqueezeInput = {
  logoHeight?: InputMaybe<Scalars['Int']['input']>;
  logoSize?: InputMaybe<LogoSize>;
  logoSrc?: InputMaybe<Scalars['String']['input']>;
  logoWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockPubNewsletters = {
  __typename?: 'BlockPubNewsletters';
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubNewslettersInput = {
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubPaywall = {
  __typename?: 'BlockPubPaywall';
  disablePaywall?: Maybe<Scalars['Boolean']['output']>;
  numberOfArticlesWithPaywallWarning?: Maybe<Scalars['Int']['output']>;
  numberOfFreeArticlesAllowedPerMonth?: Maybe<Scalars['Int']['output']>;
  paywallType?: Maybe<PaywallType>;
};

export type BlockPubPaywallInput = {
  disablePaywall?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfArticlesWithPaywallWarning?: InputMaybe<Scalars['Int']['input']>;
  numberOfFreeArticlesAllowedPerMonth?: InputMaybe<Scalars['Int']['input']>;
  paywallType?: InputMaybe<PaywallType>;
};

export type BlockPubPromo = {
  __typename?: 'BlockPubPromo';
  customPopupTimeInSecondsForGift?: Maybe<Scalars['Int']['output']>;
  customPopupTimeInSecondsForNewsletter?: Maybe<Scalars['Int']['output']>;
  customPopupTimeInSecondsForPromo?: Maybe<Scalars['Int']['output']>;
  customSubtitleForNewsletter?: Maybe<Scalars['String']['output']>;
  customSuccessSubtitleForNewsletter?: Maybe<Scalars['String']['output']>;
  customSuccessTitleForNewsletter?: Maybe<Scalars['String']['output']>;
  customTitleForGift?: Maybe<Scalars['String']['output']>;
  customTitleForNewsletter?: Maybe<Scalars['String']['output']>;
  customTitleForPromo?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  giftModalCooldownForNonSubscribers?: Maybe<Scalars['Int']['output']>;
  giftModalCooldownForSubscribers?: Maybe<Scalars['Int']['output']>;
  modalContentType?: Maybe<BlockPubPromoModalContentType>;
  newsletterModalCooldownForNonSubscribers?: Maybe<Scalars['Int']['output']>;
  /** Newsletter (CUSTOM/PubGen) popup target. Active when newsletterProvider == CUSTOM. Kept separate so switching providers doesn't overwrite the other provider's selection. */
  newsletterModalCustomNewsletterId?: Maybe<Scalars['String']['output']>;
  /** Newsletter (Mailchimp/legacy) popup target. Active when newsletterProvider != CUSTOM. */
  newsletterModalNewsletterId?: Maybe<Scalars['String']['output']>;
  promoModalCooldownForNonSubscribers?: Maybe<Scalars['Int']['output']>;
  promoModalCooldownForSubscribers?: Maybe<Scalars['Int']['output']>;
  starredGiftProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder1Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder1ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder2Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder2ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder3Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder3ProductId?: Maybe<Scalars['String']['output']>;
};

export type BlockPubPromoInput = {
  customPopupTimeInSecondsForGift?: InputMaybe<Scalars['Int']['input']>;
  customPopupTimeInSecondsForNewsletter?: InputMaybe<Scalars['Int']['input']>;
  customPopupTimeInSecondsForPromo?: InputMaybe<Scalars['Int']['input']>;
  customSubtitleForNewsletter?: InputMaybe<Scalars['String']['input']>;
  customSuccessSubtitleForNewsletter?: InputMaybe<Scalars['String']['input']>;
  customSuccessTitleForNewsletter?: InputMaybe<Scalars['String']['input']>;
  customTitleForGift?: InputMaybe<Scalars['String']['input']>;
  customTitleForNewsletter?: InputMaybe<Scalars['String']['input']>;
  customTitleForPromo?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  giftModalCooldownForNonSubscribers?: InputMaybe<Scalars['Int']['input']>;
  giftModalCooldownForSubscribers?: InputMaybe<Scalars['Int']['input']>;
  modalContentType?: InputMaybe<BlockPubPromoModalContentType>;
  newsletterModalCooldownForNonSubscribers?: InputMaybe<Scalars['Int']['input']>;
  newsletterModalCustomNewsletterId?: InputMaybe<Scalars['String']['input']>;
  newsletterModalNewsletterId?: InputMaybe<Scalars['String']['input']>;
  promoModalCooldownForNonSubscribers?: InputMaybe<Scalars['Int']['input']>;
  starredGiftProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder1Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder1ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder2Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder2ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder3Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder3ProductId?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubPromoModalContentType =
  | 'gift'
  | 'newsletter'
  | 'promo';

export type BlockPubSearch = {
  __typename?: 'BlockPubSearch';
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubSearchInput = {
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubSectionMainView = {
  __typename?: 'BlockPubSectionMainView';
  articlesPerRelatedTag?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['AWSJSON']['output']>;
  hideTopStories?: Maybe<Scalars['Boolean']['output']>;
  horizLazyLoadArticleScript?: Maybe<Scalars['String']['output']>;
  horizontal1HeaderScriptOverride?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<SectionLayoutStyle>;
  name?: Maybe<Scalars['String']['output']>;
  preGridArticleNumber?: Maybe<Scalars['Int']['output']>;
  relatedTags?: Maybe<Array<Scalars['String']['output']>>;
  snippet?: Maybe<Scalars['String']['output']>;
  topStoryArticleOverride?: Maybe<BlockPubHomeTopStoryArticleData>;
  verticalHeaderScriptOverride?: Maybe<Scalars['String']['output']>;
};

export type BlockPubSectionMainViewInput = {
  articlesPerRelatedTag?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  hideTopStories?: InputMaybe<Scalars['Boolean']['input']>;
  horizLazyLoadArticleScript?: InputMaybe<Scalars['String']['input']>;
  horizontal1HeaderScriptOverride?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<SectionLayoutStyle>;
  name?: InputMaybe<Scalars['String']['input']>;
  preGridArticleNumber?: InputMaybe<Scalars['Int']['input']>;
  relatedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  topStoryArticleOverride?: InputMaybe<BlockPubHomeTopStoryArticleDataInput>;
  verticalHeaderScriptOverride?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubSectionRelatedArticlesEmphasisAuthors = {
  __typename?: 'BlockPubSectionRelatedArticlesEmphasisAuthors';
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<Scalars['String']['output']>;
};

export type BlockPubSectionRelatedArticlesEmphasisAuthorsInput = {
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubSectionsTopStory = {
  __typename?: 'BlockPubSectionsTopStory';
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  sectionIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type BlockPubSectionsTopStoryInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  sectionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BlockPubSpotlight = {
  __typename?: 'BlockPubSpotlight';
  customHtmlSnippet?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relatedTags?: Maybe<Array<Scalars['String']['output']>>;
  spotlightDescription?: Maybe<Scalars['AWSJSON']['output']>;
};

export type BlockPubSpotlightInput = {
  customHtmlSnippet?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relatedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  spotlightDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type BlockPubSubscribe = {
  __typename?: 'BlockPubSubscribe';
  disclaimer?: Maybe<Scalars['AWSJSON']['output']>;
  discountApplicationSuccessText?: Maybe<Scalars['String']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  discountPromotionalText?: Maybe<Scalars['String']['output']>;
  pageDescription?: Maybe<Scalars['AWSJSON']['output']>;
  promoStripePlanOrder1Frequency?: Maybe<StripePlanFrequency>;
  promoStripePlanOrder1ProductId?: Maybe<Scalars['String']['output']>;
  promoStripePlanOrder2Frequency?: Maybe<StripePlanFrequency>;
  promoStripePlanOrder2ProductId?: Maybe<Scalars['String']['output']>;
  promoStripePlanOrder3Frequency?: Maybe<StripePlanFrequency>;
  promoStripePlanOrder3ProductId?: Maybe<Scalars['String']['output']>;
  secondaryPlansIntroText?: Maybe<Scalars['AWSJSON']['output']>;
  showCustomDonation?: Maybe<Scalars['Boolean']['output']>;
  showPromosInSubscribePage?: Maybe<Scalars['Boolean']['output']>;
  stripePlanOrder1Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder1ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder2Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder2ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder3Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder3ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder4Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder4ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder5Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder5ProductId?: Maybe<Scalars['String']['output']>;
  stripePlanOrder6Frequency?: Maybe<StripePlanFrequency>;
  stripePlanOrder6ProductId?: Maybe<Scalars['String']['output']>;
  stripeReadersChoicePlanFrequency?: Maybe<StripePlanFrequency>;
  stripeReadersChoicePlanProductId?: Maybe<Scalars['String']['output']>;
};

export type BlockPubSubscribeInput = {
  disclaimer?: InputMaybe<Scalars['AWSJSON']['input']>;
  discountApplicationSuccessText?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  discountPromotionalText?: InputMaybe<Scalars['String']['input']>;
  pageDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
  promoStripePlanOrder1Frequency?: InputMaybe<StripePlanFrequency>;
  promoStripePlanOrder1ProductId?: InputMaybe<Scalars['String']['input']>;
  promoStripePlanOrder2Frequency?: InputMaybe<StripePlanFrequency>;
  promoStripePlanOrder2ProductId?: InputMaybe<Scalars['String']['input']>;
  promoStripePlanOrder3Frequency?: InputMaybe<StripePlanFrequency>;
  promoStripePlanOrder3ProductId?: InputMaybe<Scalars['String']['input']>;
  secondaryPlansIntroText?: InputMaybe<Scalars['AWSJSON']['input']>;
  showCustomDonation?: InputMaybe<Scalars['Boolean']['input']>;
  showPromosInSubscribePage?: InputMaybe<Scalars['Boolean']['input']>;
  stripePlanOrder1Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder1ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder2Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder2ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder3Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder3ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder4Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder4ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder5Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder5ProductId?: InputMaybe<Scalars['String']['input']>;
  stripePlanOrder6Frequency?: InputMaybe<StripePlanFrequency>;
  stripePlanOrder6ProductId?: InputMaybe<Scalars['String']['input']>;
  stripeReadersChoicePlanFrequency?: InputMaybe<StripePlanFrequency>;
  stripeReadersChoicePlanProductId?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubTagHeader = {
  __typename?: 'BlockPubTagHeader';
  articlesPerRelatedTag?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['AWSJSON']['output']>;
  horizLazyLoadArticleScript?: Maybe<Scalars['String']['output']>;
  horizontal1HeaderScriptOverride?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relatedTags?: Maybe<Array<Scalars['String']['output']>>;
  snippet?: Maybe<Scalars['String']['output']>;
  verticalHeaderScriptOverride?: Maybe<Scalars['String']['output']>;
};

export type BlockPubTagHeaderInput = {
  articlesPerRelatedTag?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  horizLazyLoadArticleScript?: InputMaybe<Scalars['String']['input']>;
  horizontal1HeaderScriptOverride?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relatedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  verticalHeaderScriptOverride?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubThankYou = {
  __typename?: 'BlockPubThankYou';
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BlockPubThankYouInput = {
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type BlockPubWeatherAdvisory = {
  __typename?: 'BlockPubWeatherAdvisory';
  isVisible?: Maybe<Scalars['Boolean']['output']>;
};

export type BlockPubWeatherAdvisoryInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTemplate = PublishedNode & {
  __typename?: 'BlockTemplate';
  blockCategory: BlockTemplateCategory;
  brandId: Scalars['ID']['output'];
  /** Cannonical name of the react component */
  componentId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  /** All block data */
  data?: Maybe<BlockTemplateData>;
  /** dynamodb composite key, consists of blockTemplateCategory_sk */
  gsk1: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** publication date */
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** if state is saved, the timestamp it was saved at */
  savedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** the username of the user that saved the version */
  savedBy?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  /** dynamodb internal composite key, consists of state_savedAt */
  sk: Scalars['ID']['output'];
  state: PublishState;
  updatedAt: Scalars['AWSDateTime']['output'];
  /** Variant of the component */
  variant?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type BlockTemplateCategory =
  | 'EmailCapture'
  | 'PubArticleRelatedArticles'
  | 'PubAuthorRelatedArticles'
  | 'PubFooter'
  | 'PubHeaderMenu'
  | 'PubNavSqueeze'
  | 'PubPaywallArticle'
  | 'PubPromo'
  | 'PubSectionRelatedArticles'
  | 'PubSectionTopStories'
  | 'PubTagRelatedArticles';

export type BlockTemplateConnection = {
  __typename?: 'BlockTemplateConnection';
  items: Array<BlockTemplate>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type BlockTemplateData = BlockPubArticleRelatedArticles | BlockPubFooter | BlockPubHeaderMenu | BlockPubNavSqueeze | BlockPubPaywall | BlockPubPromo;

export type BlockTemplateDataInput = {
  BlockPubArticleRelatedArticles?: InputMaybe<BlockPubArticleRelatedArticlesInput>;
  BlockPubFooter?: InputMaybe<BlockPubFooterInput>;
  BlockPubHeaderMenu?: InputMaybe<BlockPubHeaderMenuInput>;
  BlockPubNavSqueeze?: InputMaybe<BlockPubNavSqueezeInput>;
  BlockPubPaywall?: InputMaybe<BlockPubPaywallInput>;
  BlockPubPromo?: InputMaybe<BlockPubPromoInput>;
  type: BlockTemplateDataInputType;
};

export type BlockTemplateDataInputType =
  | 'BlockPubArticleRelatedArticles'
  | 'BlockPubFooter'
  | 'BlockPubHeaderMenu'
  | 'BlockPubNavSqueeze'
  | 'BlockPubPaywall'
  | 'BlockPubPromo';

export type BlockVariant = {
  __typename?: 'BlockVariant';
  componentId: Scalars['String']['output'];
  defaultVariant: Scalars['String']['output'];
};

export type BlockVariantInput = {
  componentId: Scalars['String']['input'];
  defaultVariant: Scalars['String']['input'];
};

export type BlockWysiwyg = {
  __typename?: 'BlockWysiwyg';
  content?: Maybe<Scalars['AWSJSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BlockWysiwygInput = {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Brand object. Brands belong to a single workspace, they have a brandStyle and can include sites and apps */
export type Brand = Node & {
  __typename?: 'Brand';
  /**
   * The active brand style for a brand, brands can only have a single active brandStyle.
   * It is automatically applied to all other apps in the brand
   */
  brandStyleId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  /** gets the data for the brand style with id brandStyleId */
  getBrandStyle?: Maybe<BrandStyle>;
  /** Unique id for the brand, starts with brand_ */
  id: Scalars['ID']['output'];
  /** Site id for the indentity site */
  identitySiteId?: Maybe<Scalars['ID']['output']>;
  /** List all assets for a brand */
  listBrandAssets?: Maybe<AssetConnection>;
  /** List all sites for a brand */
  listBrandSites?: Maybe<SiteConnection>;
  /** list all brand styles for this brand */
  listBrandStyles?: Maybe<BrandStyleConnection>;
  /** List all the users that have access to this workspace and their permissions */
  listWorkspaceUsers?: Maybe<WorkspaceUserConnection>;
  /** Displayed name of the brand. Chosen by the user, uniqueness is not required */
  name: Scalars['String']['output'];
  /**
   * Path of the brand. A brand is accessible on the url https://${subdomain}.app.pubgen.ai/brands/path.
   * As such paths are unique on a workspace level, uniqueness is checked on brand update and at brand creation.
   */
  path: Scalars['String']['output'];
  /** Site id for the active playbook not used yet */
  playbookSiteId?: Maybe<Scalars['ID']['output']>;
  /** Site id for the publication site */
  publicationSiteId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
  /** Id of the workspace the brand belongs to */
  workspaceId: Scalars['ID']['output'];
};


/** Brand object. Brands belong to a single workspace, they have a brandStyle and can include sites and apps */
export type BrandListBrandAssetsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


/** Brand object. Brands belong to a single workspace, they have a brandStyle and can include sites and apps */
export type BrandListBrandSitesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteCategory?: InputMaybe<SiteCategory>;
};


/** Brand object. Brands belong to a single workspace, they have a brandStyle and can include sites and apps */
export type BrandListBrandStylesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


/** Brand object. Brands belong to a single workspace, they have a brandStyle and can include sites and apps */
export type BrandListWorkspaceUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type BrandConnection = {
  __typename?: 'BrandConnection';
  items: Array<Brand>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/**
 * Possible roles on the brand level.
 * TODO: there should be a reference document explaining the available roles
 */
export type BrandGroup =
  | 'Builder'
  | 'Creator'
  | 'Guest';

/** The permissions associated to a brand for a given workspaceUser */
export type BrandGroupType = {
  __typename?: 'BrandGroupType';
  brandId: Scalars['ID']['output'];
  groups: Array<BrandGroup>;
};

/** The permissions associated to a brand for a given workspaceUser */
export type BrandGroupTypeInput = {
  brandId: Scalars['ID']['input'];
  groups: Array<BrandGroup>;
};

export type BrandStyle = Node & {
  __typename?: 'BrandStyle';
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  /** Unique id for the brand style, starts with bstyle_ */
  id: Scalars['ID']['output'];
  properties: ClientThemeProperties;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
};

export type BrandStyleConnection = {
  __typename?: 'BrandStyleConnection';
  items: Array<BrandStyle>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/**
 * Fields to apply to every selected article. Any property left unset means "leave it as is".
 * Tags, authors, and metadata support Add/Remove/Replace semantics:
 * - If `replaceX` is present, the entire list is replaced with that value.
 * - Otherwise `addX` is unioned with the existing list and `removeX` is subtracted.
 */
export type BulkEditArticleChangesInput = {
  addAuthors?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMetadata?: InputMaybe<Array<Scalars['String']['input']>>;
  addTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  byline?: InputMaybe<BulkEditNullableStringInput>;
  removeAuthors?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMetadata?: InputMaybe<Array<Scalars['String']['input']>>;
  removeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  replaceAuthors?: InputMaybe<Array<Scalars['ID']['input']>>;
  replaceMetadata?: InputMaybe<Array<Scalars['String']['input']>>;
  replaceTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  setArchiveDate?: InputMaybe<BulkEditNullableDateInput>;
  setExternalDisplay?: InputMaybe<BulkEditNullableExternalDisplayInput>;
  setPaywall?: InputMaybe<BulkEditNullablePaywallInput>;
  setPrintReleaseDate?: InputMaybe<BulkEditNullableDateInput>;
  setReleaseDate?: InputMaybe<BulkEditNullableDateInput>;
  setSection?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkEditArticleResult = {
  __typename?: 'BulkEditArticleResult';
  pageId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: BulkEditItemStatus;
};

export type BulkEditArticlesInput = {
  changes: BulkEditArticleChangesInput;
  finalState: BulkEditFinalState;
  pageIds: Array<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
};

export type BulkEditArticlesJob = {
  __typename?: 'BulkEditArticlesJob';
  createdAt: Scalars['AWSDateTime']['output'];
  failed: Scalars['Int']['output'];
  jobId: Scalars['ID']['output'];
  processed: Scalars['Int']['output'];
  results?: Maybe<Array<BulkEditArticleResult>>;
  skipped: Scalars['Int']['output'];
  status: BulkEditJobStatus;
  succeeded: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type BulkEditArticlesResponse = {
  __typename?: 'BulkEditArticlesResponse';
  jobId?: Maybe<Scalars['ID']['output']>;
  mode: BulkEditExecMode;
  results?: Maybe<Array<BulkEditArticleResult>>;
};

/** Execution mode returned by bulkEditArticles. */
export type BulkEditExecMode =
  /** An asynchronous job was enqueued. Poll getBulkEditArticlesJob(jobId). */
  | 'ASYNC'
  /** All items were processed synchronously in the request. */
  | 'SYNC';

/** Final-state policy applied to every article touched by a bulk edit. */
export type BulkEditFinalState =
  /** Save then archive every actionable story (requires input.changes.setArchiveDate). */
  | 'ARCHIVE'
  /** Update Latest only. Published stories are re-published so the field changes go live; Drafted/Saved/UnpublishedChanges stories stay where they are. */
  | 'KEEP'
  /** Save then publish every actionable story (equivalent to clicking Save then Publish in the single-story editor). */
  | 'PUBLISH'
  /** Save every actionable story (equivalent to clicking Save in the single-story editor). The live published version, if any, is untouched. */
  | 'SAVE';

/** Per-item outcome of a bulk edit. */
export type BulkEditItemStatus =
  | 'FAILED'
  | 'SKIPPED'
  | 'SUCCEEDED';

/** Lifecycle state of an async bulk edit job. */
export type BulkEditJobStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'RUNNING';

/** Optional nullable AWSDateTime change. */
export type BulkEditNullableDateInput = {
  value?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

/** Optional nullable ExternalDisplay change. */
export type BulkEditNullableExternalDisplayInput = {
  value?: InputMaybe<ExternalDisplay>;
};

/** Optional nullable Paywall change. */
export type BulkEditNullablePaywallInput = {
  value?: InputMaybe<Paywall>;
};

/**
 * Optional nullable string change. Presence indicates a change. value: null clears the field.
 * Absence of the parent property means leave the existing value unchanged.
 */
export type BulkEditNullableStringInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type BulkSupportPlanAcrossWorkspaceInput = {
  action: BulkSupportPlanAction;
  email: Scalars['AWSEmail']['input'];
  workspaceDomain: Scalars['String']['input'];
};

export type BulkSupportPlanAcrossWorkspaceResult = {
  __typename?: 'BulkSupportPlanAcrossWorkspaceResult';
  action: BulkSupportPlanAction;
  email: Scalars['AWSEmail']['output'];
  results: Array<BulkSupportPlanSiteResult>;
};

export type BulkSupportPlanAction =
  | 'CREATE'
  | 'REMOVE';

export type BulkSupportPlanSiteResult = {
  __typename?: 'BulkSupportPlanSiteResult';
  brandId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  siteName?: Maybe<Scalars['String']['output']>;
  status: BulkSupportPlanStatus;
};

export type BulkSupportPlanStatus =
  | 'ADDED'
  | 'ERROR'
  | 'REMOVED'
  | 'SKIPPED';

export type Card = {
  __typename?: 'Card';
  content?: Maybe<Scalars['AWSJSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CardInput = {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Carousel = {
  __typename?: 'Carousel';
  alt?: Maybe<Scalars['String']['output']>;
  blurryPlaceholder?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  enablePrintOnDemand?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  metadata?: Maybe<Array<Scalars['String']['output']>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CarouselInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  blurryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  enablePrintOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageInput = {
  content: Scalars['String']['input'];
  role: RoleType;
};

export type ChatMessageType =
  | 'greeting'
  | 'message';

export type ChatbotImage = {
  __typename?: 'ChatbotImage';
  height?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ChatbotMessageSubscriptionInput = {
  currentNumberOfResults?: InputMaybe<Scalars['Int']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  fullMessage?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['ID']['input'];
  status: ChatbotMessageSubscriptionPayloadStatus;
  text?: InputMaybe<Scalars['String']['input']>;
  totalNumberOfResults?: InputMaybe<Scalars['Int']['input']>;
  type: MessageSubscriptionType;
  username: Scalars['ID']['input'];
};

export type ChatbotMessageSubscriptionPayload = {
  __typename?: 'ChatbotMessageSubscriptionPayload';
  currentNumberOfResults?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fullMessage?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['ID']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  siteId: Scalars['ID']['output'];
  status: ChatbotMessageSubscriptionPayloadStatus;
  text?: Maybe<Scalars['String']['output']>;
  totalNumberOfResults?: Maybe<Scalars['Int']['output']>;
  type: MessageSubscriptionType;
  username: Scalars['ID']['output'];
};

export type ChatbotMessageSubscriptionPayloadStatus =
  | 'completed'
  | 'error'
  | 'inProgress'
  | 'started';

export type ChatbotPageBlacklist = {
  __typename?: 'ChatbotPageBlacklist';
  account?: Maybe<Scalars['Boolean']['output']>;
  contactUs?: Maybe<Scalars['Boolean']['output']>;
  gift?: Maybe<Scalars['Boolean']['output']>;
  giftRedeem?: Maybe<Scalars['Boolean']['output']>;
  hideFromAllPages?: Maybe<Scalars['Boolean']['output']>;
  home?: Maybe<Scalars['Boolean']['output']>;
  latestStories?: Maybe<Scalars['Boolean']['output']>;
  newsletters?: Maybe<Scalars['Boolean']['output']>;
  printOrderTracking?: Maybe<Scalars['Boolean']['output']>;
  privacyPolicy?: Maybe<Scalars['Boolean']['output']>;
  search?: Maybe<Scalars['Boolean']['output']>;
  sections?: Maybe<Scalars['Boolean']['output']>;
  signIn?: Maybe<Scalars['Boolean']['output']>;
  stories?: Maybe<Scalars['Boolean']['output']>;
  subscribe?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Scalars['Boolean']['output']>;
  terms?: Maybe<Scalars['Boolean']['output']>;
  thankYou?: Maybe<Scalars['Boolean']['output']>;
  writers?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatbotPageBlacklistInput = {
  account?: InputMaybe<Scalars['Boolean']['input']>;
  contactUs?: InputMaybe<Scalars['Boolean']['input']>;
  gift?: InputMaybe<Scalars['Boolean']['input']>;
  giftRedeem?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromAllPages?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['Boolean']['input']>;
  latestStories?: InputMaybe<Scalars['Boolean']['input']>;
  newsletters?: InputMaybe<Scalars['Boolean']['input']>;
  printOrderTracking?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['Boolean']['input']>;
  sections?: InputMaybe<Scalars['Boolean']['input']>;
  signIn?: InputMaybe<Scalars['Boolean']['input']>;
  stories?: InputMaybe<Scalars['Boolean']['input']>;
  subscribe?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Scalars['Boolean']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
  thankYou?: InputMaybe<Scalars['Boolean']['input']>;
  writers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientThemeProperties = {
  __typename?: 'ClientThemeProperties';
  darkModeColors: Colors;
  fonts?: Maybe<Array<Font>>;
  lightModeColors: Colors;
  typography: Typography;
};

export type ClientThemePropertiesInput = {
  darkModeColors: ColorsInput;
  fonts?: InputMaybe<Array<FontInput>>;
  lightModeColors: ColorsInput;
  typography: TypographyInput;
};

export type Collection = {
  __typename?: 'Collection';
  collectionId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  getCollectionLength?: Maybe<Scalars['Int']['output']>;
  listCollectionItems?: Maybe<CollectionItemConnection>;
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type CollectionListCollectionItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  items: Array<Collection>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type CollectionItem = {
  __typename?: 'CollectionItem';
  /** The alt text for the asset */
  alt?: Maybe<Scalars['String']['output']>;
  assetId: Scalars['ID']['output'];
  assetKey: Scalars['String']['output'];
  /** The caption for the asset */
  caption?: Maybe<Scalars['String']['output']>;
  /** The id of the collection this asset belongs to */
  collectionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  /** The credit for the asset */
  credit?: Maybe<Scalars['String']['output']>;
  /** Height of the asset in px. Null for non-image assets such as PDFs. */
  height?: Maybe<Scalars['Int']['output']>;
  /** Metadata for the asset */
  metadata?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  /** Width of the asset in px. Null for non-image assets such as PDFs. */
  width?: Maybe<Scalars['Int']['output']>;
};

export type CollectionItemConnection = {
  __typename?: 'CollectionItemConnection';
  items: Array<CollectionItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Colors = {
  __typename?: 'Colors';
  ale: Scalars['String']['output'];
  lin: Scalars['String']['output'];
  pri: Scalars['String']['output'];
  sec: Scalars['String']['output'];
  suc: Scalars['String']['output'];
  war: Scalars['String']['output'];
};

export type ColorsInput = {
  ale: Scalars['String']['input'];
  lin: Scalars['String']['input'];
  pri: Scalars['String']['input'];
  sec: Scalars['String']['input'];
  suc: Scalars['String']['input'];
  war: Scalars['String']['input'];
};

export type ColumnInchMethod =
  | 'character'
  | 'word';

export type ColumnInchSettings = {
  __typename?: 'ColumnInchSettings';
  charactersPerColumnInch?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<ColumnInchMethod>;
  wordsPerInch?: Maybe<Scalars['Float']['output']>;
};

export type ColumnInchSettingsInput = {
  charactersPerColumnInch?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<ColumnInchMethod>;
  wordsPerInch?: InputMaybe<Scalars['Float']['input']>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  countyCode?: Maybe<Scalars['String']['output']>;
  mainEmail?: Maybe<Scalars['AWSEmail']['output']>;
  mainPhoneNumber?: Maybe<Scalars['String']['output']>;
  noaaGridPoint?: Maybe<Scalars['String']['output']>;
  sendSubscriptionLifecycleEmailsToCustomer?: Maybe<Scalars['Boolean']['output']>;
  supportEmail?: Maybe<Scalars['AWSEmail']['output']>;
  supportPhoneNumber?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type CompanyInfoInput = {
  cityName?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  countyCode?: InputMaybe<Scalars['String']['input']>;
  mainEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  mainPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  noaaGridPoint?: InputMaybe<Scalars['String']['input']>;
  sendSubscriptionLifecycleEmailsToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  supportEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  supportPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectSiteToMailchimpInput = {
  code: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  consentIp?: Maybe<Scalars['String']['output']>;
  consentSource?: Maybe<Scalars['String']['output']>;
  consentTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Derived lifecycle state, computed from the contact's ContactEvent log. */
  lifecycle?: Maybe<ContactLifecycle>;
  siteId: Scalars['ID']['output'];
  source: ContactSource;
  status: ContactStatus;
  /** Newsletters this contact is subscribed to (the subscription relationship). The send pipeline targets these when a newsletter has no explicit segments. */
  subscribedNewsletterIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Per-newsletter opt-out: newsletter IDs this contact has unsubscribed from
   * individually. They stay ACTIVE for every other newsletter; the send pipeline
   * skips a newsletter whose ID is in this list. A full unsubscribe instead flips
   * `status` to UNSUBSCRIBED.
   */
  suppressedNewsletterIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Stored facts on the contact. The unit of lightweight targeting; a 'list' is a tag. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  unsubscribeToken: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  items: Array<Contact>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ContactCsvImportTarget = {
  __typename?: 'ContactCsvImportTarget';
  jobId: Scalars['ID']['output'];
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** A single recorded lifecycle event for a contact. Append-only activity log entry. */
export type ContactEvent = {
  __typename?: 'ContactEvent';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** JSON-serialized event metadata (e.g. planId, stripeSubscriptionId, amountCents, currency). */
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  /** When the event occurred (ISO). */
  occurredAt: Scalars['AWSDateTime']['output'];
  siteId: Scalars['ID']['output'];
  type: ContactEventType;
};

export type ContactEventConnection = {
  __typename?: 'ContactEventConnection';
  items: Array<ContactEvent>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/**
 * Auto-generated PubGen lifecycle events recorded on a contact (custom-provider
 * sites). Append-only; the source of truth for the `ContactLifecycle` projection,
 * event-based segment rules, and the EVENT automation trigger.
 * - SIGNED_IN: the person created/verified an account on the site.
 * - PLAN_STARTED: a paid subscription became active.
 * - PLAN_CANCELLED: the person no longer has any active paid subscription.
 * - DONATION: a one-time donation was completed.
 */
export type ContactEventType =
  | 'DONATION'
  | 'PLAN_CANCELLED'
  | 'PLAN_STARTED'
  | 'SIGNED_IN';

export type ContactInput = {
  consentIp?: InputMaybe<Scalars['String']['input']>;
  consentSource?: InputMaybe<Scalars['String']['input']>;
  consentTimestamp?: InputMaybe<Scalars['AWSDateTime']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  source?: InputMaybe<ContactSource>;
  status?: InputMaybe<ContactStatus>;
  subscribedNewsletterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Derived 'current state' of a contact, computed from its ContactEvent log. Stored
 * on the contact row so segments can target lifecycle state at send time without
 * extra queries.
 */
export type ContactLifecycle = {
  __typename?: 'ContactLifecycle';
  cancelledAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastDonationAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastDonationCents?: Maybe<Scalars['Int']['output']>;
  /** ACTIVE | CANCELLED | NONE. */
  planStatus?: Maybe<Scalars['String']['output']>;
  signedInAt?: Maybe<Scalars['AWSDateTime']['output']>;
  subscribedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  totalDonationCents?: Maybe<Scalars['Int']['output']>;
};

export type ContactSource =
  | 'API'
  | 'AUTO_TAG'
  | 'CMS_MANUAL'
  | 'CSV_IMPORT'
  | 'PUBLIC_SUBSCRIBE'
  | 'WEB_SIGNUP';

export type ContactStatus =
  | 'ACTIVE'
  | 'BOUNCED'
  | 'COMPLAINED'
  | 'PENDING'
  | 'UNSUBSCRIBED';

export type ContactType =
  | 'ASSOCIATION'
  | 'COMPANY'
  | 'PERSON'
  | 'PUBLIC_BODY'
  | 'RESELLER';

export type ContentCreditsAccount = {
  __typename?: 'ContentCreditsAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
};

export type ContextTemplate = {
  __typename?: 'ContextTemplate';
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type Conversation = {
  __typename?: 'Conversation';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  siteId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  items: Array<Conversation>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ConversionAnalyticsResult = {
  __typename?: 'ConversionAnalyticsResult';
  topArticles: Array<ArticleConversionStat>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type CoordinatesInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateAccountLinkResult = {
  __typename?: 'CreateAccountLinkResult';
  status: StripeAccountStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateAssetInput = {
  brandId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  public: Scalars['Boolean']['input'];
  tags: Array<Scalars['String']['input']>;
  type: AssetType;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBlockInput = {
  archivedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  blockCategory: BlockCategory;
  /** Cannonical name of the react component */
  componentId: Scalars['String']['input'];
  /** All block data */
  data?: InputMaybe<BlockDataInput>;
  externalBlockIds: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
  /** Variant of the component */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBlockTemplateInput = {
  blockCategory: BlockTemplateCategory;
  /** Cannonical name of the react component */
  componentId: Scalars['String']['input'];
  /** All block data */
  data?: InputMaybe<BlockTemplateDataInput>;
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  /** Variant of the component */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBrandInput = {
  brandStyle: CreateBrandStyleInput;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateBrandStyleInput = {
  brandId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  properties: ClientThemePropertiesInput;
};

export type CreateCollectionInput = {
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateContextTemplateInput = {
  active: Scalars['Boolean']['input'];
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateDonationProductInput = {
  collectPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  maximumAmount?: InputMaybe<Scalars['Int']['input']>;
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  stripeDescription: Scalars['String']['input'];
};

export type CreateExternalFeedInput = {
  active: Scalars['Boolean']['input'];
  display?: InputMaybe<ExternalDisplay>;
  imgRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parserType: ExternalParserType;
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  sectionId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type CreateFeaturedChatbotPromptInput = {
  active: Scalars['Boolean']['input'];
  category: FeaturedChatbotPromptCategory;
  label: Scalars['String']['input'];
  pageType: FeaturedChatbotpageType;
  prompt: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateFeedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FeedFilterInput>>;
  name: Scalars['String']['input'];
  webhooks?: InputMaybe<Array<FeedWebhookInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreatePageInput = {
  /** create additional local blocks at the same time as the request to create the page */
  createLocalblocks: Array<CreateBlockInput>;
  id: Scalars['ID']['input'];
  /** JSON representation of the local block data, blockOrder for local blocks */
  localBlockSlots: Array<LocalBlockSlotInput>;
  pageCategory: PageCategory;
  publishPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** redirect the page to another url */
  redirect?: InputMaybe<RedirectConfigInput>;
  siteId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  /** id of the page template that should be used to display this page */
  templateId: Scalars['ID']['input'];
};

export type CreatePageTemplateInput = {
  /** JSON representation of the blocks templates data, blockOrder for block templates */
  blockTemplates: Array<LocalBlockSlotInput>;
  /**
   * JSON representation of the blocks variants.
   * For each block that can be present on the page template, specifies the variant that should be displayed for this block
   */
  blockVariants: Array<BlockVariantInput>;
  componentId: PageTemplateComponentId;
  /** create addition block templates at the same time as the page template */
  createBlockTemplates?: InputMaybe<Array<CreateBlockTemplateInput>>;
  id: Scalars['ID']['input'];
  /**
   * the category of templates available for this page template, allows filtering by this property.
   * for example: if you want to find out the different templates that you can use for a page, then you can filter via pageTemplateCategory to find the ones that are inter-exchangeable.
   */
  pageTemplateCategory: PageTemplateCategory;
  siteId: Scalars['ID']['input'];
};

export type CreatePersonaInput = {
  answerStyle: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreatePublicPersonaInput = {
  active: Scalars['Boolean']['input'];
  answerStyle: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image?: InputMaybe<UpdateChatbotImageInput>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateQuestionInput = {
  answer: Scalars['String']['input'];
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  questionKey: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateSiteInput = {
  brandId: Scalars['ID']['input'];
  chatbotAsSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  companyInfo?: InputMaybe<CompanyInfoInput>;
  /** create additional pages templates at the same time as creating the site */
  createPageTemplates?: InputMaybe<Array<CreatePageTemplateInput>>;
  /** create additional pages at the same time as creating the site */
  createPages?: InputMaybe<Array<CreatePageInput>>;
  emailCapture?: InputMaybe<EmailCaptureInput>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  siteCategory: SiteCategory;
};

export type CreateSubscriptionGiftInput = {
  isActive: Scalars['Boolean']['input'];
  numberOfGiftedMonths: Scalars['Int']['input'];
  planProductId: Scalars['ID']['input'];
  priceInCents: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateSubscriptionPlanInput = {
  adSettings?: InputMaybe<PlanAdSettings>;
  benefits?: InputMaybe<Scalars['AWSJSON']['input']>;
  clickSubscribeLinkOverrideMonthly?: InputMaybe<Scalars['String']['input']>;
  clickSubscribeLinkOverrideYearly?: InputMaybe<Scalars['String']['input']>;
  collectPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  collectShipping?: InputMaybe<Scalars['Boolean']['input']>;
  ctaMonthly?: InputMaybe<Scalars['String']['input']>;
  ctaYearly?: InputMaybe<Scalars['String']['input']>;
  monthlyPlanLabel?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  optionalMonthlyState?: InputMaybe<OptionalPriceState>;
  optionalProductDescription?: InputMaybe<Scalars['String']['input']>;
  optionalProductName?: InputMaybe<Scalars['String']['input']>;
  optionalYearlyState?: InputMaybe<OptionalPriceState>;
  planSummary?: InputMaybe<Scalars['String']['input']>;
  priceForMonthlyOptionalChoice?: InputMaybe<Scalars['Int']['input']>;
  priceForMonthlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  priceForYearlyOptionalChoice?: InputMaybe<Scalars['Int']['input']>;
  priceForYearlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  priceSubtitleMonthly?: InputMaybe<Scalars['String']['input']>;
  priceSubtitleYearly?: InputMaybe<Scalars['String']['input']>;
  printOnly?: InputMaybe<Scalars['Boolean']['input']>;
  promoCouponIdMonthly?: InputMaybe<Scalars['ID']['input']>;
  promoCouponIdYearly?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
  stripeDescription: Scalars['String']['input'];
  struckOutPriceForYearlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  struckOutpriceForMonthlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  yearlyPlanLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionPromoInput = {
  durationInMonths: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  percentageOff: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateWildcardRedirectInput = {
  destination: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  matchType: WildcardMatchType;
  note?: InputMaybe<Scalars['String']['input']>;
  permanent: Scalars['Boolean']['input'];
  preserveQuery: Scalars['Boolean']['input'];
  preserveSuffix: Scalars['Boolean']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['ID']['input'];
  source: Scalars['String']['input'];
};

/** Input used to create a workspace. */
export type CreateWorkspaceInput = {
  /** Unique id for the workspace, starts with work_ */
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
  workspaceUserId: Scalars['ID']['input'];
};

/**
 * Reponse type for the createWorkspace Mutation.
 * Creating a workspace also creates a workspace user with admin role
 */
export type CreateWorkspaceResponse = {
  __typename?: 'CreateWorkspaceResponse';
  workspace: Workspace;
  workspaceUser: WorkspaceUser;
};

export type CreateWorkspaceUserInput = {
  brandGroups: Array<BrandGroupTypeInput>;
  id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
  workspaceGroups: Array<WorkspaceGroup>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateWorkspaceUserResponse = {
  __typename?: 'CreateWorkspaceUserResponse';
  inviteLink?: Maybe<Scalars['String']['output']>;
  workspaceUser: WorkspaceUser;
};

export type CreateWorkspaceWritingRuleInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ruleText: Scalars['String']['input'];
  type: WritingRuleType;
  workspaceId: Scalars['ID']['input'];
};

export type CreateWritingRuleInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ruleText: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  type: WritingRuleType;
};

export type CreateWritingRuleSiteSettingInput = {
  active: Scalars['Boolean']['input'];
  globalRuleId?: InputMaybe<Scalars['ID']['input']>;
  level: WritingRuleSiteSettingLevel;
  siteId: Scalars['ID']['input'];
  workspaceRuleId?: InputMaybe<Scalars['ID']['input']>;
};

/** Currencies are lowercase letters in stripe api */
export type Currency =
  | 'eur'
  | 'usd';

export type CurrentWeather = {
  __typename?: 'CurrentWeather';
  /** data formated as 'Sun 20' */
  date: Scalars['String']['output'];
  highTemp: Scalars['String']['output'];
  img: Scalars['String']['output'];
  lowTemp: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  temp: Scalars['String']['output'];
};

export type CustomAd = {
  __typename?: 'CustomAd';
  href?: Maybe<Scalars['String']['output']>;
  imgHeight?: Maybe<Scalars['Int']['output']>;
  imgSrc?: Maybe<Scalars['String']['output']>;
  imgWidth?: Maybe<Scalars['Int']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomAdInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  imgHeight?: InputMaybe<Scalars['Int']['input']>;
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  imgWidth?: InputMaybe<Scalars['Int']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAds = {
  __typename?: 'CustomAds';
  articleInContent?: Maybe<CustomAd>;
  blockEmailCapture?: Maybe<CustomAd>;
  blockGoogleAd1?: Maybe<CustomAd>;
  blockGoogleAd2?: Maybe<CustomAd>;
  blockPubArticleBody?: Maybe<CustomAd>;
  blockPubArticleRelatedArticles?: Maybe<CustomAd>;
  blockPubAuthorRelatedArticles?: Maybe<CustomAd>;
  blockPubHeaderMenu?: Maybe<CustomAd>;
  blockPubHomeTopStories?: Maybe<CustomAd>;
  blockPubLatestArticles?: Maybe<CustomAd>;
  blockPubSearch?: Maybe<CustomAd>;
  blockPubSectionRelatedArticles?: Maybe<CustomAd>;
  blockPubSectionTopStories?: Maybe<CustomAd>;
  blockPubTagRelatedArticles?: Maybe<CustomAd>;
  chatbotPrimary?: Maybe<CustomAd>;
  chatbotSecondary?: Maybe<CustomAd>;
  stickyFooter?: Maybe<CustomAd>;
  video?: Maybe<CustomAd>;
};

export type CustomAdsInput = {
  articleInContent?: InputMaybe<CustomAdInput>;
  blockEmailCapture?: InputMaybe<CustomAdInput>;
  blockGoogleAd1?: InputMaybe<CustomAdInput>;
  blockGoogleAd2?: InputMaybe<CustomAdInput>;
  blockPubArticleBody?: InputMaybe<CustomAdInput>;
  blockPubArticleRelatedArticles?: InputMaybe<CustomAdInput>;
  blockPubAuthorRelatedArticles?: InputMaybe<CustomAdInput>;
  blockPubHeaderMenu?: InputMaybe<CustomAdInput>;
  blockPubHomeTopStories?: InputMaybe<CustomAdInput>;
  blockPubLatestArticles?: InputMaybe<CustomAdInput>;
  blockPubSearch?: InputMaybe<CustomAdInput>;
  blockPubSectionRelatedArticles?: InputMaybe<CustomAdInput>;
  blockPubSectionTopStories?: InputMaybe<CustomAdInput>;
  blockPubTagRelatedArticles?: InputMaybe<CustomAdInput>;
  chatbotPrimary?: InputMaybe<CustomAdInput>;
  chatbotSecondary?: InputMaybe<CustomAdInput>;
  stickyFooter?: InputMaybe<CustomAdInput>;
  video?: InputMaybe<CustomAdInput>;
};

export type CustomerPortalConfig = {
  __typename?: 'CustomerPortalConfig';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Whether subscribers can cancel their subscription in the portal. */
  allowCancellation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether subscribers can update their payment method in the portal. */
  allowPaymentMethodUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether subscribers can switch plans in the portal. */
  allowPlanSwitching?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Stripe price ids subscribers may switch to (product + frequency combos). */
  switchablePrices?: Maybe<Array<Scalars['String']['output']>>;
};

export type DayOfWeek =
  | 'FRI'
  | 'MON'
  | 'SAT'
  | 'SUN'
  | 'THU'
  | 'TUE'
  | 'WED';

export type DeleteCollectionInput = {
  collectionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DeleteSubscriptionGiftInput = {
  productId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DeleteSubscriptionPlanInput = {
  productId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DeleteSubscriptionPromoInput = {
  couponId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DeleteWildcardRedirectInput = {
  ruleId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type Domain = {
  __typename?: 'Domain';
  createdAt: Scalars['String']['output'];
  domainCloudFormation?: Maybe<Scalars['String']['output']>;
  domainCloudfront?: Maybe<Scalars['String']['output']>;
  domainName: Scalars['String']['output'];
  externalProvider: Scalars['Boolean']['output'];
  hostedZoneId?: Maybe<Scalars['String']['output']>;
  nameServers: Array<Scalars['String']['output']>;
  /** used by the domain when registering to track is the domain registering is finished or not  */
  operationId?: Maybe<Scalars['String']['output']>;
  /** used if domain is connected to a site  */
  siteId?: Maybe<Scalars['String']['output']>;
  status: DomainStatus;
  updatedAt: Scalars['String']['output'];
  /** used if domain is connected to a workspace  */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DomainInput = {
  domainCloudFormation?: InputMaybe<Scalars['String']['input']>;
  domainCloudfront?: InputMaybe<Scalars['String']['input']>;
  domainName: Scalars['String']['input'];
  externalProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hostedZoneId?: InputMaybe<Scalars['String']['input']>;
  nameServers?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DomainStatus>;
};

/**
 * this does not respect camel case but it's the direct name required by AWS sdk so easier to use like this
 * OrganizationName: Name of the organization for contact types other than PERSON.
 */
export type DomainRegistrant = {
  AddressLine1?: InputMaybe<Scalars['String']['input']>;
  AddressLine2?: InputMaybe<Scalars['String']['input']>;
  City?: InputMaybe<Scalars['String']['input']>;
  ContactType: ContactType;
  CountryCode?: InputMaybe<Scalars['String']['input']>;
  Email: Scalars['String']['input'];
  ExtraParams?: InputMaybe<Array<ExtraParam>>;
  Fax?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  OrganizationName?: InputMaybe<Scalars['String']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  ZipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 *     Status of domain:
 * *   Registering : When not using external provider, domain is being registerd by AWS directly
 * *   WaitingNameServer : When used with external provider, domain can start creation only when name servers are changed
 * *   Creating : Domain is being created, waiting for cloudfront distribution finished (happens after Registering or WaitingNameServer step)
 * *   Active : Domain is active and can be used
 * *   Deleting : Domain is being deleted
 */
export type DomainStatus =
  | 'Active'
  | 'Creating'
  | 'Deleting'
  | 'Registering'
  | 'UpdateNeeded'
  | 'Updating'
  | 'WaitingNameServer';

export type DonationProduct = {
  __typename?: 'DonationProduct';
  collectPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  defaultAmount?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  maximumAmount?: Maybe<Scalars['Int']['output']>;
  minimumAmount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  priceId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
  stripeDescription: Scalars['String']['output'];
};

export type DonationReceipt = {
  __typename?: 'DonationReceipt';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  currency: Currency;
  sessionId: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type EmailCapture = {
  __typename?: 'EmailCapture';
  /** Show an optional first-name field on the public sign-up / newsletters block. */
  captureFirstName?: Maybe<Scalars['Boolean']['output']>;
  /** Show an optional last-name field on the public sign-up / newsletters block. */
  captureLastName?: Maybe<Scalars['Boolean']['output']>;
  /** Custom (PubGen) email-capture newsletter target. Active when newsletterProvider == CUSTOM. Kept separate so switching providers doesn't overwrite the other provider's selection. */
  customNewsletterId?: Maybe<Scalars['String']['output']>;
  /** Mailchimp (and legacy) email-capture newsletter target. Active when newsletterProvider != CUSTOM. */
  newsletterId?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EmailCaptureInput = {
  captureFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  captureLastName?: InputMaybe<Scalars['Boolean']['input']>;
  customNewsletterId?: InputMaybe<Scalars['String']['input']>;
  newsletterId?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Status of an email address on the account-global SES suppression list. */
export type EmailSuppressionStatus = {
  __typename?: 'EmailSuppressionStatus';
  /** ISO timestamp of when the suppression entry was last updated. Null when not suppressed. */
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  /** SES suppression reason (e.g. BOUNCE or COMPLAINT). Null when not suppressed. */
  reason?: Maybe<Scalars['String']['output']>;
  suppressed: Scalars['Boolean']['output'];
};

export type Embedding = {
  __typename?: 'Embedding';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  type: EmbeddingType;
};

export type EmbeddingType =
  | 'AppContext'
  | 'Article'
  | 'Documentation'
  | 'Question'
  | 'Tutorial';

/**
 * Configuration for Naviga Engage (Audience Suite).
 *
 * Engage is configured by pasting the HTML snippet Naviga delivers (typically two
 * <script> tags — a loader URL and an inline MG2Loader.init({...}) call) into the
 * configScript field. The public site parses and injects those scripts verbatim.
 */
export type EngageAccount = {
  __typename?: 'EngageAccount';
  /**
   * External URL for the publisher's account management page (e.g. https://myaccount.example.com/123/).
   * Used as the href for the MG2MyAccount button.
   */
  accountUrl?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Raw HTML configuration script as delivered by Naviga. Typically contains a
   * <script src="..."> loader tag and an inline <script>MG2Loader.init(...)</script>
   * block. The public site extracts both and injects them in order.
   */
  configScript?: Maybe<Scalars['String']['output']>;
  /**
   * External URL for the publisher's subscribe page (e.g. https://subscribe.example.com/?sitecode=123).
   * Used as the href for the MG2Subscribe button.
   */
  subscribeUrl?: Maybe<Scalars['String']['output']>;
};

export type EventAnalyticsResult = {
  __typename?: 'EventAnalyticsResult';
  eventCounts: Array<EventCount>;
  hitsByInterval: Array<HitsByInterval>;
};

export type EventArticleAnalyticsResult = {
  __typename?: 'EventArticleAnalyticsResult';
  topEventArticles: Array<EventArticleStat>;
};

export type EventArticleStat = {
  __typename?: 'EventArticleStat';
  blockId: Scalars['String']['output'];
  calendarAdds: Scalars['Int']['output'];
  calls: Scalars['Int']['output'];
  directions: Scalars['Int']['output'];
  joins: Scalars['Int']['output'];
  shares: Scalars['Int']['output'];
  ticketClicks: Scalars['Int']['output'];
};

export type EventCount = {
  __typename?: 'EventCount';
  count: Scalars['Int']['output'];
  eventType: Scalars['String']['output'];
};

export type EventsExportFormat =
  | 'CSV'
  | 'TXT';

export type ExportPageType =
  | 'Indesign'
  | 'NITF';

export type ExportPagesResponse = {
  __typename?: 'ExportPagesResponse';
  type?: Maybe<JobResultType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExternalDisplay =
  | 'default'
  | 'hero'
  | 'lead'
  | 'topStory';

export type ExternalFeed = {
  __typename?: 'ExternalFeed';
  activatedAt?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  display?: Maybe<ExternalDisplay>;
  id: Scalars['ID']['output'];
  imgRequired?: Maybe<Scalars['Boolean']['output']>;
  lastImportedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parserType: ExternalParserType;
  paywall?: Maybe<Paywall>;
  publishStatus?: Maybe<FeedPublishStatus>;
  sectionId: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ExternalFeedConnection = {
  __typename?: 'ExternalFeedConnection';
  items: Array<ExternalFeed>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ExternalFeedPreviewItem = {
  __typename?: 'ExternalFeedPreviewItem';
  body?: Maybe<Scalars['AWSJSON']['output']>;
  byline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  imported: Scalars['Boolean']['output'];
  importedPageId?: Maybe<Scalars['String']['output']>;
  lead?: Maybe<Scalars['String']['output']>;
  metadata: Array<Scalars['String']['output']>;
  publishStatus?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ExternalParserType =
  | 'Atom'
  | 'PubGenRSS'
  | 'RSS2';

export type ExternalReference = {
  __typename?: 'ExternalReference';
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  imgHeight: Scalars['Int']['output'];
  imgSrc: Scalars['String']['output'];
  imgWidth: Scalars['Int']['output'];
};

export type ExternalReferenceInput = {
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  imgHeight: Scalars['Int']['input'];
  imgSrc: Scalars['String']['input'];
  imgWidth: Scalars['Int']['input'];
};

export type ExtraParam = {
  Name: ExtraParamName;
  Value: Scalars['String']['input'];
};

export type ExtraParamName =
  | 'AU_ID_NUMBER'
  | 'AU_ID_TYPE'
  | 'BIRTH_CITY'
  | 'BIRTH_COUNTRY'
  | 'BIRTH_DATE_IN_YYYY_MM_DD'
  | 'BIRTH_DEPARTMENT'
  | 'BRAND_NUMBER'
  | 'CA_BUSINESS_ENTITY_TYPE'
  | 'CA_LEGAL_REPRESENTATIVE'
  | 'CA_LEGAL_REPRESENTATIVE_CAPACITY'
  | 'CA_LEGAL_TYPE'
  | 'DOCUMENT_NUMBER'
  | 'DUNS_NUMBER'
  | 'ES_IDENTIFICATION'
  | 'ES_IDENTIFICATION_TYPE'
  | 'ES_LEGAL_FORM'
  | 'FI_BUSINESS_NUMBER'
  | 'FI_ID_NUMBER'
  | 'FI_NATIONALITY'
  | 'FI_ORGANIZATION_TYPE'
  | 'IT_NATIONALITY'
  | 'IT_PIN'
  | 'IT_REGISTRANT_ENTITY_TYPE'
  | 'RU_PASSPORT_DATA'
  | 'SE_ID_NUMBER'
  | 'SG_ID_NUMBER'
  | 'UK_COMPANY_NUMBER'
  | 'UK_CONTACT_TYPE'
  | 'VAT_NUMBER';

export type FaqItem = {
  __typename?: 'FaqItem';
  id?: Maybe<Scalars['String']['output']>;
  panelBody?: Maybe<Scalars['AWSJSON']['output']>;
  panelHeader?: Maybe<Scalars['String']['output']>;
};

export type FaqItemInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  panelBody?: InputMaybe<Scalars['AWSJSON']['input']>;
  panelHeader?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedChatbotPrompt = {
  __typename?: 'FeaturedChatbotPrompt';
  active: Scalars['Boolean']['output'];
  category: FeaturedChatbotPromptCategory;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  pageType: FeaturedChatbotpageType;
  prompt: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type FeaturedChatbotPromptCategory =
  | 'CMS'
  | 'Site';

export type FeaturedChatbotpageType =
  | 'Article'
  | 'Home'
  | 'Section'
  | 'Tag';

export type FeaturedMediaType =
  | 'carousel'
  | 'iframe'
  | 'snippet';

export type Feed = {
  __typename?: 'Feed';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<FeedFilter>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  webhooks?: Maybe<Array<FeedWebhook>>;
  workspaceId: Scalars['ID']['output'];
};

export type FeedConnection = {
  __typename?: 'FeedConnection';
  items: Array<Feed>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type FeedFilter = {
  __typename?: 'FeedFilter';
  active: Scalars['Boolean']['output'];
  pattern: Scalars['String']['output'];
};

export type FeedFilterInput = {
  active: Scalars['Boolean']['input'];
  pattern: Scalars['String']['input'];
};

export type FeedPublishStatus =
  | 'draft'
  | 'publish'
  | 'toReview';

export type FeedSiteSubscription = {
  __typename?: 'FeedSiteSubscription';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  feedId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paywall?: Maybe<Paywall>;
  publishStatus?: Maybe<FeedPublishStatus>;
  section?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['String']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type FeedSiteSubscriptionConnection = {
  __typename?: 'FeedSiteSubscriptionConnection';
  items: Array<FeedSiteSubscription>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type FeedStory = {
  __typename?: 'FeedStory';
  articleData: Scalars['AWSJSON']['output'];
  createdAt: Scalars['String']['output'];
  displayOverride?: Maybe<ExternalDisplay>;
  feedId: Scalars['ID']['output'];
  pageId: Scalars['ID']['output'];
  releaseDateOverride?: Maybe<Scalars['String']['output']>;
  source: FeedStorySource;
  updatedAt: Scalars['String']['output'];
};

export type FeedStoryConnection = {
  __typename?: 'FeedStoryConnection';
  items: Array<FeedStory>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type FeedStorySource = {
  __typename?: 'FeedStorySource';
  brandId: Scalars['ID']['output'];
  brandName: Scalars['String']['output'];
  brandPath: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type FeedWebhook = {
  __typename?: 'FeedWebhook';
  active: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type FeedWebhookInput = {
  active: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};

export type Field = {
  __typename?: 'Field';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Font = {
  __typename?: 'Font';
  family: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSerif: Scalars['Boolean']['output'];
  style: FontStyle;
  url?: Maybe<Scalars['String']['output']>;
  weight: FontWeight;
};

export type FontCase =
  | 'capitalize'
  | 'lowercase'
  | 'normal'
  | 'uppercase';

export type FontInput = {
  family: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isSerif: Scalars['Boolean']['input'];
  style: FontStyle;
  url?: InputMaybe<Scalars['String']['input']>;
  weight: FontWeight;
};

export type FontStyle =
  | 'italic'
  | 'normal';

export type FontWeight =
  | 'black'
  | 'bold'
  | 'extraBlack'
  | 'extraBold'
  | 'extraLight'
  | 'light'
  | 'medium'
  | 'regular'
  | 'semiBold'
  | 'thin';

export type FotomotoAccount = {
  __typename?: 'FotomotoAccount';
  accountId: Scalars['ID']['output'];
};

export type GalleryAspectRatio =
  | 'fullScreenHeight'
  | 'landscape'
  | 'landscapeWidescreen'
  | 'portrait'
  | 'square';

export type GalleryType =
  | 'eReader'
  | 'gallery';

export type GenerateArticle = {
  context: Scalars['String']['input'];
  keywords: Array<Scalars['String']['input']>;
  quotes: Array<Quote>;
  section?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type GenerateArticleBodySubscription = {
  __typename?: 'GenerateArticleBodySubscription';
  articlePart?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  generationId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Int']['output'];
  result?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  siteId: Scalars['ID']['output'];
};

export type GenerateArticleBodySubscriptionInput = {
  articlePart?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  generationId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  progress: Scalars['Int']['input'];
  result?: InputMaybe<Scalars['String']['input']>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['ID']['input'];
};

export type GenerateBlog = {
  keywords: Array<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type GenerateBlogSubscriptionInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  generationId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  progress: Scalars['Int']['input'];
  result?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type GenerateBlogSubscriptionPayload = {
  __typename?: 'GenerateBlogSubscriptionPayload';
  generationId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Int']['output'];
  result?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
};

export type GenerateImageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  colorApplication?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  style?: InputMaybe<ImageStyle>;
};

export type GenerateImageSubscriptionInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  imageGenerationId: Scalars['ID']['input'];
  images?: InputMaybe<Array<AssetInput>>;
  progress: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
};

export type GenerateImageSubscriptionPayload = {
  __typename?: 'GenerateImageSubscriptionPayload';
  error?: Maybe<Scalars['String']['output']>;
  imageGenerationId: Scalars['ID']['output'];
  images?: Maybe<Array<Asset>>;
  progress: Scalars['Int']['output'];
  siteId: Scalars['ID']['output'];
};

export type GetAnalyticsForSiteParams = {
  author?: InputMaybe<Scalars['ID']['input']>;
  blockId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetAnalyticsForWorkspaceParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type GetConversionAnalyticsForSiteParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetConversionAnalyticsForWorkspaceParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type GetEventAnalyticsForSiteParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetEventAnalyticsForWorkspaceParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type GetEventArticleAnalyticsForSiteParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetEventShareBreakdownForBlockParams = {
  blockId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetTopBlocksByEventForSiteParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetTopPagesByConversionEventParams = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  sinceDate: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalWritingRule = {
  __typename?: 'GlobalWritingRule';
  id: Scalars['ID']['output'];
  level: WritingRuleLevelGlobal;
  name: Scalars['String']['output'];
  ruleText: Scalars['String']['output'];
  type: WritingRuleType;
};

export type GoogleAdsAccount = {
  __typename?: 'GoogleAdsAccount';
  adClient: Scalars['ID']['output'];
  horizontalAdSlot?: Maybe<Scalars['ID']['output']>;
  verticalAdSlot?: Maybe<Scalars['ID']['output']>;
};

export type GoogleAnalyticsAccount = {
  __typename?: 'GoogleAnalyticsAccount';
  gaMeasurementId: Scalars['ID']['output'];
};

export type GoogleTagAds = {
  __typename?: 'GoogleTagAds';
  adHeroHeaderScript?: Maybe<Scalars['String']['output']>;
  articleInContentHeaderScript?: Maybe<Scalars['String']['output']>;
  chatbotPrimaryHeaderScript?: Maybe<Scalars['String']['output']>;
  chatbotSecondaryHeaderScript?: Maybe<Scalars['String']['output']>;
  footerHeaderScript?: Maybe<Scalars['String']['output']>;
  horizontal1HeaderScript?: Maybe<Scalars['String']['output']>;
  horizontal2HeaderScript?: Maybe<Scalars['String']['output']>;
  stickyFooterHeaderScript?: Maybe<Scalars['String']['output']>;
  vertical2HeaderScript?: Maybe<Scalars['String']['output']>;
  verticalHeaderScript?: Maybe<Scalars['String']['output']>;
  videoHeaderScript?: Maybe<Scalars['String']['output']>;
};

export type GoogleTagManagerAccount = {
  __typename?: 'GoogleTagManagerAccount';
  containerId: Scalars['ID']['output'];
};

export type HeaderCustomCtaType =
  | 'DONATION'
  | 'LINK';

export type HeaderLayout =
  | 'LEFT_ALIGNED_MINIMAL'
  | 'STANDARD';

export type HitsByInterval = {
  __typename?: 'HitsByInterval';
  count: Scalars['Int']['output'];
  interval: Scalars['String']['output'];
};

export type IframeAspectRatio =
  | 'fullScreenHeight'
  | 'landscape'
  | 'portrait'
  | 'square';

export type ImageStyle =
  | 'design'
  | 'illustration'
  | 'painting'
  | 'photorealistic'
  | 'sketch'
  | 'threeDRender';

export type ImgPlaceholder = {
  __typename?: 'ImgPlaceholder';
  height?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImgPlaceholderInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportFeedResult = {
  __typename?: 'ImportFeedResult';
  articles: Array<ImportedArticle>;
  articlesCreated: Scalars['Int']['output'];
  articlesUpdated: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportPagesResponse = {
  __typename?: 'ImportPagesResponse';
  pages: Array<Page>;
  type?: Maybe<JobResultType>;
};

export type ImportedArticle = {
  __typename?: 'ImportedArticle';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IzootoAccount = {
  __typename?: 'IzootoAccount';
  active: Scalars['Boolean']['output'];
  scriptId?: Maybe<Scalars['ID']['output']>;
};

export type JobResultType =
  | 'async'
  | 'sync';

export type JournalistType =
  | 'content_creator'
  | 'domain_expert'
  | 'international'
  | 'investigative'
  | 'local'
  | 'pulitzer';

export type LeaderboardPosition =
  | 'bottom'
  | 'top';

export type LocalBlockSlot = {
  __typename?: 'LocalBlockSlot';
  ids: Array<Scalars['String']['output']>;
  slot: SlotType;
};

export type LocalBlockSlotInput = {
  ids: Array<Scalars['String']['input']>;
  slot: SlotType;
};

export type LogoSize =
  | 'large'
  | 'medium'
  | 'small';

export type MailchimpList = {
  __typename?: 'MailchimpList';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MakeItFreeAccount = {
  __typename?: 'MakeItFreeAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  publisherId?: Maybe<Scalars['String']['output']>;
};

export type MarfeelAnalyticsAccount = {
  __typename?: 'MarfeelAnalyticsAccount';
  marfeelId: Scalars['ID']['output'];
};

export type Menu = {
  __typename?: 'Menu';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<MenuItem>>;
  name: Scalars['String']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  id: Scalars['ID']['output'];
  menuIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  type?: Maybe<MenuItemType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MenuItemInput = {
  id: Scalars['ID']['input'];
  menuIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  type?: InputMaybe<MenuItemType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemType =
  | 'CHATBOT_OPEN'
  | 'MENU'
  | 'URL';

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  items: Array<Message>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type MessageSubscriptionType =
  | 'message'
  | 'prompt'
  | 'queryAnalysis'
  | 'reranking'
  | 'search';

export type MetadataImage = {
  __typename?: 'MetadataImage';
  height?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MetadataImageInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MirabelAccount = {
  __typename?: 'MirabelAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addItemToCollections: Array<CollectionItem>;
  bulkApplySupportPlanAcrossWorkspace: BulkSupportPlanAcrossWorkspaceResult;
  /** Bulk-delete many contacts (identified by email). Returns the number deleted. */
  bulkDeleteContacts: Scalars['Int']['output'];
  bulkEditArticles: BulkEditArticlesResponse;
  /** Bulk-set status on many contacts (identified by email). Returns the number of contacts updated. */
  bulkSetContactStatus: Scalars['Int']['output'];
  /** Bulk add and/or remove tags across many contacts (identified by email). Returns the number updated. */
  bulkUpdateContactTags: Scalars['Int']['output'];
  /** Cancel a scheduled (not yet sent) NewsletterSend row. */
  cancelNewsletterSend: Scalars['Boolean']['output'];
  chatbotMessageSubscription?: Maybe<ChatbotMessageSubscriptionPayload>;
  chooseMailchimpList: Scalars['Boolean']['output'];
  connectDomainForSite: Site;
  connectDomainForWorkspace: Workspace;
  /** Save a Gelato API key on a site. Validates the key with Gelato before persisting. */
  connectGelatoAccount: Site;
  connectSiteToMailchimp: Scalars['Boolean']['output'];
  connectStripeAccount: Site;
  createAccountLink: CreateAccountLinkResult;
  createAsset: CreateAssetOutput;
  createAutomation: Automation;
  /** create new block template, status is created as Latest */
  createBlock: Block;
  /** create new block template, status is created as Latest */
  createBlockTemplate: BlockTemplate;
  createBrand: Brand;
  /** create BrandStyle, status is created as Latest */
  createBrandStyle: BrandStyle;
  createCheckoutSession: Scalars['String']['output'];
  createCollection: Collection;
  createContextTemplate: ContextTemplate;
  createCustomerPortal: Scalars['String']['output'];
  createDonationProduct: DonationProduct;
  createExternalFeed: ExternalFeed;
  createFeaturedChatbotPrompt: FeaturedChatbotPrompt;
  createFeed: Feed;
  createNewsletter: Newsletter;
  createPage: Page;
  /** create new page template, status is created as Latest */
  createPageTemplate: PageTemplate;
  createPersona: Persona;
  createPublicPersona: PublicPersona;
  createQuestion: Question;
  createSegment: Segment;
  /** Register sendingDomain with Resend and return the DNS records the customer must publish. */
  createSendingDomain: SendingDomain;
  createSite: Site;
  createSubscriptionGift: SubscriptionGift;
  createSubscriptionPlan: SubscriptionPlan;
  createSubscriptionPromo: SubscriptionPromo;
  /** create a new wildcard redirect rule on a site */
  createWildcardRedirect: WildcardRedirectRule;
  createWorkspace: CreateWorkspaceResponse;
  createWorkspaceTollbitBucket: Workspace;
  createWorkspaceUser: CreateWorkspaceUserResponse;
  createWorkspaceWritingRule: WorkspaceWritingRule;
  createWritingRule: WritingRule;
  createWritingRuleSiteSetting: WritingRuleSiteSetting;
  deleteAPNewsToken: Site;
  deleteAsset: Asset;
  deleteAutomation: Scalars['Boolean']['output'];
  /**
   * delete the latest version of a block
   * we can only ever delete a block in latest version
   * to delete other versions you need to delete the page containing that version
   * we do this to ensure page version history is consistent
   */
  deleteBlock: Block;
  /** delete block template, if sk is ommited, all versions of the pae are deleted */
  deleteBlockTemplate: BlockTemplate;
  deleteBrand: Brand;
  /** delete page, if sk is ommited, all versions of the pae are deleted, always returns latest version */
  deleteBrandStyle: BrandStyle;
  deleteCollection: Collection;
  deleteContact: Scalars['Boolean']['output'];
  deleteContextTemplate: ContextTemplate;
  deleteExternalFeed: Scalars['Boolean']['output'];
  deleteFeaturedChatbotPrompt: FeaturedChatbotPrompt;
  deleteFeed: Feed;
  deleteNewsletter: Newsletter;
  /** delete page, if sk is ommited, all versions of the pae are deleted, always returns latest version */
  deletePage: Page;
  /** delete page template, if sk is ommited, all versions of the pae are deleted */
  deletePageTemplate: PageTemplate;
  deletePages: Array<Page>;
  deletePersona: Persona;
  deletePublicPersona: PublicPersona;
  deleteQuestion: Question;
  deleteReutersCredentials?: Maybe<ReutersCredentialsStatus>;
  deleteSegment: Scalars['Boolean']['output'];
  deleteSendingDomain: Scalars['Boolean']['output'];
  deleteSite: Site;
  deleteSubscriptionGift: SubscriptionGift;
  deleteSubscriptionPlan: SubscriptionPlan;
  deleteSubscriptionPromo: SubscriptionPromo;
  /** delete a wildcard redirect rule; returns the deleted rule id */
  deleteWildcardRedirect: Scalars['ID']['output'];
  deleteWorkspace: Workspace;
  deleteWorkspaceUser: WorkspaceUser;
  deleteWorkspaceWritingRule: WorkspaceWritingRule;
  deleteWritingRule: WritingRule;
  /** Clear the Gelato API key and toggle gelatoActive off. */
  disconnectGelatoAccount: Site;
  disconnectSiteToMailchimp: Scalars['Boolean']['output'];
  disconnectStripeAccount: Site;
  downloadAPNewsStory: Page;
  downloadReutersStory: Page;
  /** duplicate one or more pages, creating drafts with 'Copy of' prefix in title */
  duplicatePages: Array<Page>;
  /** Enroll every currently-active contact a segment matches into an automation (onboarding drips for an existing list). Returns the number of contacts enrolled. */
  enrollSegmentInAutomation: Scalars['Int']['output'];
  exportChatbotConversations: Scalars['String']['output'];
  exportDisputes: Scalars['String']['output'];
  exportEvents: Scalars['String']['output'];
  exportGeneralLedgerRevenueExpense: Scalars['String']['output'];
  exportMonthlyPayouts: Scalars['String']['output'];
  exportMonthlyRevenueByProduct: Scalars['String']['output'];
  /** returns the url for the xml and asset files */
  exportPages: ExportPagesResponse;
  exportPromotionalCredits: Scalars['String']['output'];
  exportRefunds: Scalars['String']['output'];
  exportSubscriberActivity: Scalars['String']['output'];
  /** returns the url for the csv file */
  exportSubscriberFulfillment: Scalars['String']['output'];
  /** returns the url for the csv file */
  exportSubscriberFulfillmentPeriod: Scalars['String']['output'];
  exportSubscriptionAdjustments: Scalars['String']['output'];
  exportTransactionData: Scalars['String']['output'];
  exportUnearnedRevenue: Scalars['String']['output'];
  exportUserData: Scalars['String']['output'];
  exportUserSignupsSessions: Scalars['String']['output'];
  /** Finalize a CSV import: parse the uploaded file and create Contact rows (applying any tags). Returns the number of rows imported. */
  finalizeContactsCsvImport: Scalars['Int']['output'];
  generateArticleBody: Scalars['ID']['output'];
  generateArticleBodySubscription?: Maybe<GenerateArticleBodySubscription>;
  generateArticleHeadline: Scalars['String']['output'];
  generateArticleLead: Scalars['String']['output'];
  generateBlog: Scalars['ID']['output'];
  generateBlogSubscription?: Maybe<GenerateBlogSubscriptionPayload>;
  generateImage: Scalars['ID']['output'];
  generateImageSubscription?: Maybe<GenerateImageSubscriptionPayload>;
  generateSectionSuggestion: Scalars['String']['output'];
  generateSignInCode: Scalars['String']['output'];
  generateSignInLink: Scalars['String']['output'];
  generateTagsSuggestion: Array<Scalars['String']['output']>;
  /** Create a presigned S3 upload target for a contacts CSV import. Optionally apply tags to every imported contact. Client must call finalizeContactsCsvImport after the upload completes. */
  importContactsCsv: ContactCsvImportTarget;
  importExternalFeedNow: ImportFeedResult;
  importPages: ImportPagesResponse;
  importSingleFeedItem: ImportFeedResult;
  orderSubscriptionPlans: Array<SubscriptionPlan>;
  /** publish a version of a block template (this deletes the current published version) */
  publishBlockTemplate: BlockTemplate;
  publishBlockTemplates: Array<BlockTemplate>;
  /** publish a version of a page (this deletes the current published version) */
  publishPage: Page;
  /** publish a version of a page template (this deletes the current published version) */
  publishPageTemplate: PageTemplate;
  publishPageToFeeds: Page;
  publishPagesToFeeds: Array<Page>;
  /** Force a poll against Resend to refresh verification status. */
  refreshSendingDomainStatus: SendingDomain;
  registerDomainForSite: Site;
  /** Not implemented yet */
  registerDomainForWorkspace: Workspace;
  /**
   * Remove an email address from the account-global SES suppression list so
   * transactional emails can be delivered to it again. Returns true on success.
   */
  removeEmailSuppression: Scalars['Boolean']['output'];
  removeItemFromCollections: Array<CollectionItem>;
  removeItemsFromCollection: Array<CollectionItem>;
  resendInvitationEmail: CreateWorkspaceUserResponse;
  /** Queue a follow-up send to recipients who were delivered the given send but did not open it. Returns the number of recipients queued. */
  resendToNonOpeners: Scalars['Int']['output'];
  /** revert an old version of a block template and saves it as the latest version (this deletes the current latest version) */
  revertBlockTemplate: BlockTemplate;
  /** revert an old version of a page and saves it as the latest version (this deletes the current latest version) */
  revertPage: Page;
  /** revert an old version of a page template and saves it as the latest version (this deletes the current latest version) */
  revertPageTemplate: PageTemplate;
  /** Generate a new per-newsroom Gelato webhook bearer token. Use after a suspected leak — invalidates the current secret. */
  rotateGelatoWebhookSecret: Site;
  saveAndPublish: Page;
  /** create saved version of a block template */
  saveBlockTemplate: BlockTemplate;
  /** create saved version of a page */
  savePage: Page;
  /** create saved version of a page template */
  savePageTemplate: PageTemplate;
  sendChatMessage: Scalars['ID']['output'];
  /** Send a test render of a newsletter to a single email address (no segment send). */
  sendTestNewsletter: Scalars['Boolean']['output'];
  setAPNewsToken: Site;
  setCustomerPortalConfiguration: Site;
  setReutersCredentials?: Maybe<ReutersCredentialsStatus>;
  syncReutersChannels: ReutersChannelSyncResult;
  unconnectDomainForSite: Site;
  unconnectDomainForWorkspace: Workspace;
  /** Manually unenroll a contact from an automation (marks their enrollment EXITED so no further steps send). Returns true if a row was exited. */
  unenrollFromAutomation: Scalars['Boolean']['output'];
  /** unpublish a version of a page (this deletes the current published version) */
  unpublishPage: Page;
  updateAPNewsTopic: ApNewsTopic;
  updateAsset: Asset;
  updateAutomation: Automation;
  /** update block, we cannot update status by calling update, use save / publish / revert Block for this */
  updateBlock: Block;
  /** update block template, we cannot update status by calling update, use save / publish / revert block template for this */
  updateBlockTemplate: BlockTemplate;
  updateBlockTemplates: Array<BlockTemplate>;
  updateBlocks: Array<Block>;
  updateBrand: Brand;
  /** update page, we cannot update status by calling update, use save / publish / revert for this */
  updateBrandStyle: BrandStyle;
  updateCollection: Collection;
  updateCollectionItem: CollectionItem;
  updateContextTemplate: ContextTemplate;
  updateDonationProduct: DonationProduct;
  updateExternalFeed: ExternalFeed;
  updateFeaturedChatbotPrompt: FeaturedChatbotPrompt;
  updateFeed: Feed;
  updateFeedSiteSubscription: FeedSiteSubscription;
  updateFeedSiteSubscriptions: Array<FeedSiteSubscription>;
  /** Toggle the kill switch. When enabling, re-validates the stored API key first. */
  updateGelatoActive: Site;
  updateNewsletter: Newsletter;
  updateNewsletters: Array<Newsletter>;
  /** update page, we cannot update status by calling update, use save / publish / revert Page for this */
  updatePage: Page;
  /** Update the slug of a page, optionnally create a 301 redirect for the old page url to the new page url */
  updatePageSlug: Page;
  /** update page template, we cannot update status by calling update, use save / publish / revert PageTemplate for this */
  updatePageTemplate: PageTemplate;
  updatePersona: Persona;
  updatePublicPersona: PublicPersona;
  updateQuestion: Question;
  updateRegisteredUser: Subscriber;
  updateReutersChannel: ReutersChannel;
  updateSegment: Segment;
  updateSite: Site;
  updateStripeAccountDetails: Site;
  updateSubscriptionGift: SubscriptionGift;
  updateSubscriptionPlan: SubscriptionPlan;
  updateSubscriptionPromo: SubscriptionPromo;
  /** update an existing wildcard redirect rule */
  updateWildcardRedirect: WildcardRedirectRule;
  updateWorkspace: Workspace;
  updateWorkspaceUser: WorkspaceUser;
  updateWorkspaceWritingRule: WorkspaceWritingRule;
  updateWritingRule: WritingRule;
  updateWritingRuleSiteSetting: WritingRuleSiteSetting;
  upsertContact: Contact;
};


export type MutationAddItemToCollectionsArgs = {
  params: AddItemToCollectionsInput;
};


export type MutationBulkApplySupportPlanAcrossWorkspaceArgs = {
  input: BulkSupportPlanAcrossWorkspaceInput;
};


export type MutationBulkDeleteContactsArgs = {
  emails: Array<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};


export type MutationBulkEditArticlesArgs = {
  input: BulkEditArticlesInput;
};


export type MutationBulkSetContactStatusArgs = {
  emails: Array<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  status: ContactStatus;
};


export type MutationBulkUpdateContactTagsArgs = {
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  emails: Array<Scalars['String']['input']>;
  removeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  siteId: Scalars['ID']['input'];
};


export type MutationCancelNewsletterSendArgs = {
  sendId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationChatbotMessageSubscriptionArgs = {
  subscription: ChatbotMessageSubscriptionInput;
};


export type MutationChooseMailchimpListArgs = {
  listId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationConnectDomainForSiteArgs = {
  domainName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationConnectDomainForWorkspaceArgs = {
  domainName: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationConnectGelatoAccountArgs = {
  apiKey: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationConnectSiteToMailchimpArgs = {
  params: ConnectSiteToMailchimpInput;
};


export type MutationConnectStripeAccountArgs = {
  accountId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationCreateAccountLinkArgs = {
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationCreateAssetArgs = {
  asset: CreateAssetInput;
};


export type MutationCreateAutomationArgs = {
  automation: AutomationInput;
};


export type MutationCreateBlockArgs = {
  block: CreateBlockInput;
};


export type MutationCreateBlockTemplateArgs = {
  blockTemplate: CreateBlockTemplateInput;
};


export type MutationCreateBrandArgs = {
  brand: CreateBrandInput;
};


export type MutationCreateBrandStyleArgs = {
  brandStyle: CreateBrandStyleInput;
};


export type MutationCreateCheckoutSessionArgs = {
  cancelUrl: Scalars['String']['input'];
  lookup: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  successUrl: Scalars['String']['input'];
};


export type MutationCreateCollectionArgs = {
  collection: CreateCollectionInput;
};


export type MutationCreateContextTemplateArgs = {
  contextTemplate: CreateContextTemplateInput;
};


export type MutationCreateCustomerPortalArgs = {
  returnUrl: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationCreateDonationProductArgs = {
  product: CreateDonationProductInput;
};


export type MutationCreateExternalFeedArgs = {
  feed: CreateExternalFeedInput;
  siteId: Scalars['ID']['input'];
};


export type MutationCreateFeaturedChatbotPromptArgs = {
  prompt: CreateFeaturedChatbotPromptInput;
};


export type MutationCreateFeedArgs = {
  feed: CreateFeedInput;
};


export type MutationCreateNewsletterArgs = {
  newsletter: NewsletterInput;
};


export type MutationCreatePageArgs = {
  page: CreatePageInput;
};


export type MutationCreatePageTemplateArgs = {
  page: CreatePageTemplateInput;
};


export type MutationCreatePersonaArgs = {
  persona: CreatePersonaInput;
};


export type MutationCreatePublicPersonaArgs = {
  persona: CreatePublicPersonaInput;
};


export type MutationCreateQuestionArgs = {
  question: CreateQuestionInput;
};


export type MutationCreateSegmentArgs = {
  segment: SegmentInput;
};


export type MutationCreateSendingDomainArgs = {
  domain: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationCreateSiteArgs = {
  site: CreateSiteInput;
};


export type MutationCreateSubscriptionGiftArgs = {
  gift: CreateSubscriptionGiftInput;
};


export type MutationCreateSubscriptionPlanArgs = {
  plan: CreateSubscriptionPlanInput;
};


export type MutationCreateSubscriptionPromoArgs = {
  promo: CreateSubscriptionPromoInput;
};


export type MutationCreateWildcardRedirectArgs = {
  input: CreateWildcardRedirectInput;
};


export type MutationCreateWorkspaceArgs = {
  workspace: CreateWorkspaceInput;
};


export type MutationCreateWorkspaceTollbitBucketArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationCreateWorkspaceUserArgs = {
  workspaceUser: CreateWorkspaceUserInput;
};


export type MutationCreateWorkspaceWritingRuleArgs = {
  workspaceWritingRule: CreateWorkspaceWritingRuleInput;
};


export type MutationCreateWritingRuleArgs = {
  writingRule: CreateWritingRuleInput;
};


export type MutationCreateWritingRuleSiteSettingArgs = {
  writingRuleSiteSetting: CreateWritingRuleSiteSettingInput;
};


export type MutationDeleteApNewsTokenArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAutomationArgs = {
  automationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteBlockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlockTemplateArgs = {
  id: Scalars['ID']['input'];
  sk?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandStyleArgs = {
  id: Scalars['ID']['input'];
  sk?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCollectionArgs = {
  collection: DeleteCollectionInput;
};


export type MutationDeleteContactArgs = {
  contactId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteContextTemplateArgs = {
  contextTemplateId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteExternalFeedArgs = {
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteFeaturedChatbotPromptArgs = {
  promptId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteFeedArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationDeleteNewsletterArgs = {
  newsletterId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePageTemplateArgs = {
  id: Scalars['ID']['input'];
  sk?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeletePagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePersonaArgs = {
  personaId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeletePublicPersonaArgs = {
  personaId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteQuestionArgs = {
  questionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteReutersCredentialsArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteSegmentArgs = {
  segmentId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteSendingDomainArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationDeleteSiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionGiftArgs = {
  gift: DeleteSubscriptionGiftInput;
};


export type MutationDeleteSubscriptionPlanArgs = {
  plan: DeleteSubscriptionPlanInput;
};


export type MutationDeleteSubscriptionPromoArgs = {
  promo: DeleteSubscriptionPromoInput;
};


export type MutationDeleteWildcardRedirectArgs = {
  input: DeleteWildcardRedirectInput;
};


export type MutationDeleteWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkspaceUserArgs = {
  username: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationDeleteWorkspaceWritingRuleArgs = {
  workspaceId: Scalars['ID']['input'];
  workspaceWritingRuleId: Scalars['ID']['input'];
};


export type MutationDeleteWritingRuleArgs = {
  siteId: Scalars['ID']['input'];
  writingRuleId: Scalars['ID']['input'];
};


export type MutationDisconnectGelatoAccountArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationDisconnectSiteToMailchimpArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationDisconnectStripeAccountArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationDownloadApNewsStoryArgs = {
  apStoryId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDownloadReutersStoryArgs = {
  itemId: Scalars['String']['input'];
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  sectionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationDuplicatePagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationEnrollSegmentInAutomationArgs = {
  automationId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationExportChatbotConversationsArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportDisputesArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportEventsArgs = {
  endDate: Scalars['String']['input'];
  format: EventsExportFormat;
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportGeneralLedgerRevenueExpenseArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportMonthlyPayoutsArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportMonthlyRevenueByProductArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportPagesArgs = {
  ids: Array<Scalars['ID']['input']>;
  type?: InputMaybe<ExportPageType>;
};


export type MutationExportPromotionalCreditsArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportRefundsArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportSubscriberActivityArgs = {
  endDate: Scalars['String']['input'];
  eventTypes: Array<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportSubscriberFulfillmentArgs = {
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<StripeSubscriptionStatus>;
};


export type MutationExportSubscriberFulfillmentPeriodArgs = {
  endDate: Scalars['String']['input'];
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  status?: InputMaybe<StripeSubscriptionStatus>;
};


export type MutationExportSubscriptionAdjustmentsArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportTransactionDataArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};


export type MutationExportUnearnedRevenueArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportUserDataArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationExportUserSignupsSessionsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFinalizeContactsCsvImportArgs = {
  s3Key: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGenerateArticleBodyArgs = {
  params: GenerateArticle;
};


export type MutationGenerateArticleBodySubscriptionArgs = {
  subscription: GenerateArticleBodySubscriptionInput;
};


export type MutationGenerateArticleHeadlineArgs = {
  body: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationGenerateArticleLeadArgs = {
  body: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationGenerateBlogArgs = {
  params: GenerateBlog;
};


export type MutationGenerateBlogSubscriptionArgs = {
  subscription: GenerateBlogSubscriptionInput;
};


export type MutationGenerateImageArgs = {
  params: GenerateImageInput;
};


export type MutationGenerateImageSubscriptionArgs = {
  subscription: GenerateImageSubscriptionInput;
};


export type MutationGenerateSectionSuggestionArgs = {
  availableSections: Array<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateSignInCodeArgs = {
  email: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationGenerateSignInLinkArgs = {
  email: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationGenerateTagsSuggestionArgs = {
  availableTags: Array<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportContactsCsvArgs = {
  fileName: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationImportExternalFeedNowArgs = {
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type MutationImportPagesArgs = {
  siteId: Scalars['ID']['input'];
  zipAssetKey: Scalars['String']['input'];
};


export type MutationImportSingleFeedItemArgs = {
  feedId: Scalars['ID']['input'];
  itemId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationOrderSubscriptionPlansArgs = {
  planIds: OrderSubscriptionPlansInput;
};


export type MutationPublishBlockTemplateArgs = {
  param: PublishPublishedNodeInput;
};


export type MutationPublishBlockTemplatesArgs = {
  param: Array<PublishPublishedNodeInput>;
};


export type MutationPublishPageArgs = {
  param: PublishPublishedNodeInput;
};


export type MutationPublishPageTemplateArgs = {
  param: PublishPublishedNodeInput;
};


export type MutationPublishPageToFeedsArgs = {
  params: PublishPageToFeedsInput;
};


export type MutationPublishPagesToFeedsArgs = {
  params: PublishPagesToFeedsInput;
};


export type MutationRefreshSendingDomainStatusArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationRegisterDomainForSiteArgs = {
  domainName: Scalars['String']['input'];
  registrantInfo: DomainRegistrant;
  siteId: Scalars['ID']['input'];
};


export type MutationRegisterDomainForWorkspaceArgs = {
  domainName: Scalars['String']['input'];
  registrantInfo: DomainRegistrant;
  workspaceId: Scalars['ID']['input'];
};


export type MutationRemoveEmailSuppressionArgs = {
  email: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationRemoveItemFromCollectionsArgs = {
  params: RemoveItemFromCollectionsInput;
};


export type MutationRemoveItemsFromCollectionArgs = {
  params: RemoveItemsFromCollectionInput;
};


export type MutationResendInvitationEmailArgs = {
  workspaceUser: ResendInvitationEmailInput;
};


export type MutationResendToNonOpenersArgs = {
  sendId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationRevertBlockTemplateArgs = {
  param: RevertPublishedNodeInput;
};


export type MutationRevertPageArgs = {
  param: RevertPublishedNodeInput;
};


export type MutationRevertPageTemplateArgs = {
  param: RevertPublishedNodeInput;
};


export type MutationRotateGelatoWebhookSecretArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationSaveAndPublishArgs = {
  blocks: Array<UpdateBlockInput>;
  page: PublishPublishedNodeInput;
};


export type MutationSaveBlockTemplateArgs = {
  param: SavePublishedNodeInput;
};


export type MutationSavePageArgs = {
  param: SavePublishedNodeInput;
};


export type MutationSavePageTemplateArgs = {
  param: SavePublishedNodeInput;
};


export type MutationSendChatMessageArgs = {
  params: SendChatMessageInput;
};


export type MutationSendTestNewsletterArgs = {
  newsletterId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  toEmail: Scalars['String']['input'];
};


export type MutationSetApNewsTokenArgs = {
  siteId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetCustomerPortalConfigurationArgs = {
  input: SetCustomerPortalConfigurationInput;
};


export type MutationSetReutersCredentialsArgs = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationSyncReutersChannelsArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationUnconnectDomainForSiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnconnectDomainForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationUnenrollFromAutomationArgs = {
  automationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationUnpublishPageArgs = {
  param: UnpublishPublishedNodeInput;
};


export type MutationUpdateApNewsTopicArgs = {
  siteId: Scalars['ID']['input'];
  topic: ApNewsTopicInput;
};


export type MutationUpdateAssetArgs = {
  asset: UpdateAssetInput;
};


export type MutationUpdateAutomationArgs = {
  automation: AutomationInput;
};


export type MutationUpdateBlockArgs = {
  block: UpdateBlockInput;
};


export type MutationUpdateBlockTemplateArgs = {
  blockTemplate: UpdateBlockTemplateInput;
};


export type MutationUpdateBlockTemplatesArgs = {
  blockTemplates: Array<UpdateBlockTemplateInput>;
};


export type MutationUpdateBlocksArgs = {
  blocks: Array<UpdateBlockInput>;
};


export type MutationUpdateBrandArgs = {
  brand: UpdateBrandInput;
};


export type MutationUpdateBrandStyleArgs = {
  brandStyle: UpdateBrandStyleInput;
};


export type MutationUpdateCollectionArgs = {
  collection: UpdateCollectionInput;
};


export type MutationUpdateCollectionItemArgs = {
  params: UpdateCollectionItemInput;
};


export type MutationUpdateContextTemplateArgs = {
  contextTemplate: UpdateContextTemplateInput;
};


export type MutationUpdateDonationProductArgs = {
  product: UpdateDonationProductInput;
};


export type MutationUpdateExternalFeedArgs = {
  feed: UpdateExternalFeedInput;
  siteId: Scalars['ID']['input'];
};


export type MutationUpdateFeaturedChatbotPromptArgs = {
  prompt: UpdateFeaturedChatbotPromptInput;
};


export type MutationUpdateFeedArgs = {
  feed: UpdateFeedInput;
};


export type MutationUpdateFeedSiteSubscriptionArgs = {
  feedSiteSubscription: UpdateFeedSiteSubscriptionInput;
};


export type MutationUpdateFeedSiteSubscriptionsArgs = {
  feedSiteSubscriptions: UpdateFeedSiteSubscriptionsInput;
};


export type MutationUpdateGelatoActiveArgs = {
  active: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationUpdateNewsletterArgs = {
  newsletter: NewsletterInput;
};


export type MutationUpdateNewslettersArgs = {
  newsletters: Array<NewsletterInput>;
};


export type MutationUpdatePageArgs = {
  page: UpdatePageInput;
};


export type MutationUpdatePageSlugArgs = {
  page: UpdatePageSlugInput;
};


export type MutationUpdatePageTemplateArgs = {
  page: UpdatePageTemplateInput;
};


export type MutationUpdatePersonaArgs = {
  persona: UpdatePersonaInput;
};


export type MutationUpdatePublicPersonaArgs = {
  persona: UpdatePublicPersonaInput;
};


export type MutationUpdateQuestionArgs = {
  question: UpdateQuestionInput;
};


export type MutationUpdateRegisteredUserArgs = {
  params: UpdateRegisteredUserInput;
};


export type MutationUpdateReutersChannelArgs = {
  channel: ReutersChannelInput;
  siteId: Scalars['ID']['input'];
};


export type MutationUpdateSegmentArgs = {
  segment: SegmentInput;
};


export type MutationUpdateSiteArgs = {
  site: UpdateSiteInput;
};


export type MutationUpdateStripeAccountDetailsArgs = {
  details: UpdateStripeAccountDetailsInput;
};


export type MutationUpdateSubscriptionGiftArgs = {
  gift: UpdateSubscriptionGiftInput;
};


export type MutationUpdateSubscriptionPlanArgs = {
  plan: UpdateSubscriptionPlanInput;
};


export type MutationUpdateSubscriptionPromoArgs = {
  promo: UpdateSubscriptionPromoInput;
};


export type MutationUpdateWildcardRedirectArgs = {
  input: UpdateWildcardRedirectInput;
};


export type MutationUpdateWorkspaceArgs = {
  workspace: UpdateWorkspaceInput;
};


export type MutationUpdateWorkspaceUserArgs = {
  workspaceUser: UpdateWorkspaceUserInput;
};


export type MutationUpdateWorkspaceWritingRuleArgs = {
  workspaceWritingRule: UpdateWorkspaceWritingRuleInput;
};


export type MutationUpdateWritingRuleArgs = {
  writingRule: UpdateWritingRuleInput;
};


export type MutationUpdateWritingRuleSiteSettingArgs = {
  writingRuleSiteSetting: UpdateWritingRuleSiteSettingInput;
};


export type MutationUpsertContactArgs = {
  contact: ContactInput;
};

export type NavigaAccount = {
  __typename?: 'NavigaAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  navigaSubscriptionAssociation?: Maybe<Array<NavigaSubscriptionAssociation>>;
  password?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  wsdlUrl?: Maybe<Scalars['String']['output']>;
};

export type NavigaSubscriptionAssociation = {
  __typename?: 'NavigaSubscriptionAssociation';
  navigaPubId: Scalars['String']['output'];
  navigaRateId: Scalars['String']['output'];
  stripeProductId: Scalars['String']['output'];
};

export type NavigaSubscriptionAssociationInput = {
  navigaPubId: Scalars['String']['input'];
  navigaRateId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
};

export type Newsletter = {
  __typename?: 'Newsletter';
  description?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<NewsletterKind>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<NewsletterProvider>;
  /** CUSTOM provider only: contiguous ordering of PUBLIC newsletters on the public site. Null/undefined when HIDDEN. */
  publicOrder?: Maybe<Scalars['Int']['output']>;
  /** CUSTOM provider only: whether this newsletter is offered on the public sign-up surfaces. Defaults to HIDDEN when unset. */
  publicVisibility?: Maybe<NewsletterPublicVisibility>;
  replyToEmail?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<NewsletterSchedule>;
  /** Segments this newsletter targets when sending. Empty/null = send to all contacts subscribed to this newsletter. */
  segmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  siteId: Scalars['ID']['output'];
  status?: Maybe<NewsletterStatus>;
  template?: Maybe<NewsletterTemplate>;
};

export type NewsletterCadence =
  | 'CUSTOM_CRON'
  | 'DAILY'
  | 'ONE_OFF'
  | 'WEEKLY';

export type NewsletterInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<NewsletterKind>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<NewsletterProvider>;
  publicOrder?: InputMaybe<Scalars['Int']['input']>;
  publicVisibility?: InputMaybe<NewsletterPublicVisibility>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<NewsletterScheduleInput>;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<NewsletterStatus>;
  template?: InputMaybe<NewsletterTemplateInput>;
};

export type NewsletterKind =
  | 'EDITORIAL'
  | 'MARKETING';

export type NewsletterProvider =
  | 'CUSTOM'
  | 'MAILCHIMP';

/**
 * Controls whether a CUSTOM-provider newsletter is offered on the public site's
 * sign-up surfaces. Kept as an enum (not a boolean) so future visibility states
 * can be added without a data migration. Two-state for now: PUBLIC (listed) and
 * HIDDEN (not listed). Legacy / Mailchimp rows have no value and are unaffected.
 */
export type NewsletterPublicVisibility =
  | 'HIDDEN'
  | 'PUBLIC';

export type NewsletterSchedule = {
  __typename?: 'NewsletterSchedule';
  cadence: NewsletterCadence;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  endAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** For CUSTOM_CRON: the recurrence rule as an iCal VEVENT string (DTSTART + RRULE), produced by the recurring-event builder. DTSTART is an absolute UTC instant, so occurrences are timezone-resolved at build time. */
  iCal?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['AWSDateTime']['output']>;
  timeOfDay?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type NewsletterScheduleInput = {
  cadence: NewsletterCadence;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  endAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  iCal?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterSectionLayout =
  | 'CARD'
  | 'FULL_WIDTH'
  | 'IMAGE_LEFT'
  | 'IMAGE_RIGHT'
  | 'TEXT_ABOVE'
  | 'TEXT_BELOW'
  | 'WIRE';

export type NewsletterSend = {
  __typename?: 'NewsletterSend';
  bounces?: Maybe<Scalars['Int']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  complaints?: Maybe<Scalars['Int']['output']>;
  costCents?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newsletterId: Scalars['ID']['output'];
  newsletterName?: Maybe<Scalars['String']['output']>;
  opens?: Maybe<Scalars['Int']['output']>;
  /** Number of recipients resolved at send time. */
  recipientSnapshot?: Maybe<Scalars['Int']['output']>;
  scheduledFor: Scalars['AWSDateTime']['output'];
  sentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  siteId: Scalars['ID']['output'];
  status: NewsletterSendStatus;
  unsubscribes?: Maybe<Scalars['Int']['output']>;
};

export type NewsletterSendConnection = {
  __typename?: 'NewsletterSendConnection';
  items: Array<NewsletterSend>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type NewsletterSendStatus =
  | 'CANCELLED'
  | 'FAILED'
  | 'RENDERING'
  | 'SCHEDULED'
  | 'SENDING'
  | 'SENT';

export type NewsletterStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DRAFT'
  | 'PAUSED'
  | 'SCHEDULED';

export type NewsletterSubscription = Node & {
  __typename?: 'NewsletterSubscription';
  /** Time stamp of the time this object was created  */
  createdAt: Scalars['AWSDateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newsletterId: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  type: NewsletterSubscriptionType;
  /** Time stamp of the time this object was modified  */
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
  /** Number of times this object was modified (older versions of the object are not saved) */
  version: Scalars['Int']['output'];
};

export type NewsletterSubscriptionConnection = {
  __typename?: 'NewsletterSubscriptionConnection';
  items: Array<NewsletterSubscription>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type NewsletterSubscriptionType =
  | 'NSS';

/**
 * Newsletter template stored as an ordered array of typed blocks (WYSIWYG-ready).
 * Block schema lives in `shared/newsletterBlocks.ts`. We serialize/deserialize as
 * AWSJSON to keep AppSync resolver wiring simple while preserving full type
 * safety in TypeScript via discriminated unions.
 */
export type NewsletterTemplate = {
  __typename?: 'NewsletterTemplate';
  /** JSON-serialized NewsletterBlock[] (see shared/newsletterBlocks.ts). */
  blocksJson: Scalars['AWSJSON']['output'];
};

export type NewsletterTemplateInput = {
  blocksJson: Scalars['AWSJSON']['input'];
};

export type NewzwareAccount = {
  __typename?: 'NewzwareAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  editionCode?: Maybe<Scalars['String']['output']>;
  instanceUrl?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
};

/** Generic types for non versioned data. Only one version is saved */
export type Node = {
  /** Time stamp of the time this object was created  */
  createdAt: Scalars['AWSDateTime']['output'];
  /** Unique id for the model */
  id: Scalars['ID']['output'];
  /** Time stamp of the time this object was modified  */
  updatedAt: Scalars['AWSDateTime']['output'];
  /** Number of times this object was modified (older versions of the object are not saved) */
  version: Scalars['Int']['output'];
};

export type OptionalPriceState =
  | 'Active'
  | 'Inactive';

export type OrderSubscriptionPlansInput = {
  productIds: Array<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
};

export type Page = PublishedNode & {
  __typename?: 'Page';
  brandId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  /** the username of the user that created the page */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** will return all versions of the page if status is not set */
  getPageTemplate?: Maybe<PageTemplateConnection>;
  /** dynamodb composite key, consists of pageCategory_sk */
  gsk1: Scalars['ID']['output'];
  /** dynamodb composite key, consists of slug_sk */
  gsk2: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** List all the external blocks attached to this page with additionalBlocks property */
  listPageAdditionalBlocks?: Maybe<BlockConnection>;
  /** List all the local blocks attached to this page */
  listPageLocalBlocks?: Maybe<BlockConnection>;
  /** JSON representing the local blocks and what slot thet belong to */
  localBlockSlots: Array<LocalBlockSlot>;
  /** page type, this can be used to filter pages */
  pageCategory: PageCategory;
  /** publication date */
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** redirect url to another url */
  redirect?: Maybe<RedirectConfig>;
  /** if state is saved, the timestamp it was saved at */
  savedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** the username of the user that saved the version */
  savedBy?: Maybe<Scalars['String']['output']>;
  /** Custom canonical URL for republished content (e.g., Texas Tribune URL) */
  seoCanonical?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoImageHeight?: Maybe<Scalars['Int']['output']>;
  /** S3 key for per-page social share / SEO image */
  seoImageSrc?: Maybe<Scalars['String']['output']>;
  seoImageWidth?: Maybe<Scalars['Int']['output']>;
  /** If true, adds noindex meta tag to exclude page from search engines */
  seoNoindex?: Maybe<Scalars['Boolean']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  /** dynamodb internal composite key, consists of state_savedAt */
  sk: Scalars['ID']['output'];
  /** the slug of the published page */
  slug: Scalars['String']['output'];
  state: PublishState;
  /** id of the page template that should be used to display this page */
  templateId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
};


export type PageGetPageTemplateArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type PageListPageAdditionalBlocksArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type PageListPageLocalBlocksArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};

export type PageCategory =
  | 'Identity'
  | 'Publication404'
  | 'PublicationAccount'
  | 'PublicationAllAuthors'
  | 'PublicationAllSections'
  | 'PublicationAllTags'
  | 'PublicationArticle'
  | 'PublicationAuthor'
  | 'PublicationCheckout'
  | 'PublicationContactUs'
  | 'PublicationEvents'
  | 'PublicationGift'
  | 'PublicationGiftRedeem'
  | 'PublicationHome'
  | 'PublicationLatestArticles'
  | 'PublicationNewsletters'
  | 'PublicationPayments'
  | 'PublicationPrivacyPolicy'
  | 'PublicationSearch'
  | 'PublicationSection'
  | 'PublicationSignIn'
  | 'PublicationSitemap'
  | 'PublicationSpotlight'
  | 'PublicationSubscribe'
  | 'PublicationTag'
  | 'PublicationTerms'
  | 'PublicationThankYou'
  | 'Redirect';

export type PageConnection = {
  __typename?: 'PageConnection';
  items: Array<Page>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PageConversionResult = {
  __typename?: 'PageConversionResult';
  topPages: Array<PageConversionStat>;
};

export type PageConversionStat = {
  __typename?: 'PageConversionStat';
  count: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/**
 * Page templates represents all the information required to render a page object.
 * Changing a page template will modify the look and feel of all pages associated with this page template
 */
export type PageTemplate = PublishedNode & {
  __typename?: 'PageTemplate';
  /** JSON representation of the blocks templates data, blockOrder for block templates  */
  blockTemplates: Array<LocalBlockSlot>;
  /** For each block that can be present on the page template, specifies the variant that should be displayed for this block  */
  blockVariants: Array<BlockVariant>;
  brandId: Scalars['ID']['output'];
  /** react component ID for this template */
  componentId: PageTemplateComponentId;
  createdAt: Scalars['AWSDateTime']['output'];
  /** dynamodb composite key, consists of pageTemplateCategory_sk */
  gsk1: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** get the block templates referenced in blockTemplates  */
  listBlockTemplates?: Maybe<BlockTemplateConnection>;
  /**
   * the category of templates available for this page template, allows filtering by this property.
   * for example: if you want to find out the different templates that you can use for a page, then you can filter via pageTemplateCategory to find the ones that are inter-exchangeable.
   */
  pageTemplateCategory: PageTemplateCategory;
  /** publication date */
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** if state is saved, the timestamp it was saved at  */
  savedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** the username of the user that saved the version */
  savedBy?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  /** dynamodb internal composite key, consists of state_savedAt  */
  sk: Scalars['ID']['output'];
  state: PublishState;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
};


/**
 * Page templates represents all the information required to render a page object.
 * Changing a page template will modify the look and feel of all pages associated with this page template
 */
export type PageTemplateListBlockTemplatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};

export type PageTemplateCategory =
  | 'FooterOnly'
  | 'Identity'
  | 'PublicationArticle'
  | 'PublicationAuthor'
  | 'PublicationMain'
  | 'PublicationMainWithoutEmailCapture'
  | 'PublicationSection'
  | 'PublicationSpotlight'
  | 'PublicationSqueeze'
  | 'PublicationTag';

export type PageTemplateComponentId =
  | 'pageTemplateVertical'
  | 'pageTemplate_VisualIdentity1';

export type PageTemplateConnection = {
  __typename?: 'PageTemplateConnection';
  items: Array<PageTemplate>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/** Used for pagination of all nodes that return multiple items */
export type PaginationInput = {
  /** Max number of items to return, if it is not set, the maximum number of pages will be returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** NextToken returned by previous api call, used to get the following page */
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentFrequency =
  | 'MONTH'
  | 'TWENTY_EIGHT_DAYS'
  | 'YEAR';

/**
 * whether the article is hidden behind a paywall
 * * Subscriber: only show to paying subscribers
 * * Metered: show to paying subscribers and for free users limit the number of views
 * * Free: show all users
 */
export type Paywall =
  | 'Metered'
  | 'Public'
  | 'SignInOnly'
  | 'Subscribed';

export type PaywallType =
  | 'default'
  | 'sign_in_only';

export type Persona = {
  __typename?: 'Persona';
  answerStyle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type PlanAdSettings =
  | 'AllAds'
  | 'Limited'
  | 'NoAds';

export type PlanType =
  /** plan that is not visible to the user, but is used for the free trial and offers */
  | 'hidden'
  /** plan that is handled outside of stripe with legacy payment system */
  | 'legacy'
  /** default plan that is visible and can be subscribed to */
  | 'visible';

export type PrintOrder = {
  __typename?: 'PrintOrder';
  createdAt: Scalars['AWSDateTime']['output'];
  /** Customer email collected at checkout */
  customerEmail: Scalars['String']['output'];
  /** Short customer-facing reference (PG-XXXXXXXX, ~8 chars, ambiguous-character-free). Surfaced on the thank-you page, confirmation email, and tracking page input. Lookup-only via GSI2; not the DDB sort key. */
  customerOrderRef?: Maybe<Scalars['String']['output']>;
  /** Unique id for the order record (UUID generated at creation) */
  id: Scalars['ID']['output'];
  /** S3/CDN asset key for the source image; combined with PUBLIC_ASSETS_DOMAIN for the full URL */
  imageAssetKey: Scalars['String']['output'];
  /** PubGen-side order reference id, formatted ${siteId}:${stripeSessionId}. Internal canonical id used by Stripe + Gelato + DDB sort keys. Long, customer-unfriendly. */
  orderReferenceId: Scalars['String']['output'];
  /** Product type chosen by the customer (poster | canvas | photo | mug | t-shirt) */
  productType: Scalars['String']['output'];
  /** Print-on-demand provider that fulfilled the order (e.g. 'gelato') */
  provider: Scalars['String']['output'];
  /** Provider-side order id (e.g. Gelato's id returned by POST /orders) */
  providerOrderId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /** Serialized shipping address (JSON) */
  shippingAddress: Scalars['AWSJSON']['output'];
  /** Site that owns the order */
  siteId: Scalars['ID']['output'];
  /** Current order status (created, processing, printing, shipped, delivered, cancelled, etc.) */
  status: Scalars['String']['output'];
  /** Stripe Checkout Session id that paid for the order */
  stripeSessionId: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PubgenSubscription = {
  __typename?: 'PubgenSubscription';
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: StripeSubscriptionStatus;
};

export type PublicPersona = {
  __typename?: 'PublicPersona';
  active: Scalars['Boolean']['output'];
  answerStyle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ChatbotImage>;
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type PublishPageToFeedsInput = {
  displayOverride?: InputMaybe<ExternalDisplay>;
  feeds: Array<Scalars['ID']['input']>;
  pageId: Scalars['ID']['input'];
  releaseDateOverride?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type PublishPagesToFeedsInput = {
  displayOverride?: InputMaybe<ExternalDisplay>;
  feeds: Array<Scalars['ID']['input']>;
  pageIds: Array<Scalars['ID']['input']>;
  releaseDateOverride?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type PublishPublishedNodeInput = {
  id: Scalars['ID']['input'];
  releaseDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

/**
 * Status of Published Node:
 * * Saved is a Previously saved version
 * * Published is the Published version
 * * Latest is the Latest current version
 */
export type PublishState =
  | 'Archived'
  | 'Latest'
  | 'Published'
  | 'Saved'
  | 'UnpublishedChanges';

/** Generic types for versioned data, more than one version can be saved, or published */
export type PublishedNode = {
  /** Time stamp of the time this object was created */
  createdAt: Scalars['AWSDateTime']['output'];
  /** Unique id for the model  */
  id: Scalars['ID']['output'];
  /** publication date */
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Used for versioning, savedAt indicates the time at which the version is saved. */
  savedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** the username of the user that saved the version */
  savedBy?: Maybe<Scalars['String']['output']>;
  /** dynamodb internal composite key, consists of state_savedAt */
  sk: Scalars['ID']['output'];
  /** State of the version, can be Saved, Published or Latest */
  state: PublishState;
  /** Time stamp of the time this object was modified */
  updatedAt: Scalars['AWSDateTime']['output'];
  /**
   * Number of times this partical object version was modified
   * old changed properties for a version are not saved
   * To save a new version you need to use the changeState Mutation for this object.
   */
  version: Scalars['Int']['output'];
};

export type PublishedStatusInput = {
  /** if state is saved, the timestamp it was saved at  */
  savedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  state: PublishState;
};

export type Query = {
  __typename?: 'Query';
  checkDomainAvailability: Scalars['Boolean']['output'];
  /**
   * CSV report of articles whose releaseDate falls within the given local-calendar
   * range, inclusive of both ends.
   * - startDate / endDate: YYYY-MM-DD interpreted in the resolved time zone. The
   *   range is inclusive on both ends. Range cannot exceed 31 days.
   * - timeZone: IANA zone (e.g. "America/Chicago"). If omitted, falls back to the
   *   site's companyInfo.timeZone, then to UTC.
   * Returns the CSV as a string. The 31-day cap keeps the response under AppSync's
   * 1MB limit; longer windows would require switching to the async S3 + email
   * pattern used by other exports.
   */
  exportArticlesPublishedReport: Scalars['String']['output'];
  getAPNewsFeedItemDetail: ApFeedPreviewItemDetail;
  getAPNewsToken?: Maybe<Scalars['String']['output']>;
  getAnalyticsForSite: AnalyticsResult;
  getAnalyticsForWorkspace: AnalyticsResult;
  getAsset: Asset;
  getAutomation?: Maybe<Automation>;
  /** will return all versions of the block if status is not set */
  getBlock: BlockConnection;
  /** will return all versions of the block if status is not set */
  getBlockTemplate: BlockTemplateConnection;
  /** will return all versions of the block if status is not set  */
  getBlockTemplates: BlockTemplateConnection;
  /** will return all versions of the block if status is not set */
  getBlocks: BlockConnection;
  getBrand: Brand;
  /**
   * Get a brand attached to this workspace by it's path
   * Paths are unique on a workspace level but not on a global level so it is not possible to retrieve a brand by it's path only
   */
  getBrandByPath: Brand;
  /** will return all versions of the brand style if status is not set */
  getBrandStyle: BrandStyle;
  getBulkEditArticlesJob: BulkEditArticlesJob;
  getCollection: Collection;
  getCollectionItem: CollectionItem;
  getCollectionItemsByAssetId: Array<CollectionItem>;
  getConversation?: Maybe<Conversation>;
  getConversionAnalyticsForSite: ConversionAnalyticsResult;
  getConversionAnalyticsForWorkspace: ConversionAnalyticsResult;
  /**
   * Check whether an email address is on the account-global SES suppression list.
   * Used by newsroom support staff to diagnose why a customer is not receiving
   * sign-in or other transactional emails.
   */
  getEmailSuppressionStatus: EmailSuppressionStatus;
  getEventAnalyticsForSite: EventAnalyticsResult;
  getEventAnalyticsForWorkspace: EventAnalyticsResult;
  getEventArticleAnalyticsForSite: EventArticleAnalyticsResult;
  getEventShareBreakdownForBlock: ShareBreakdownResult;
  getExternalFeed?: Maybe<ExternalFeed>;
  getFeed: Feed;
  getNewsletter?: Maybe<Newsletter>;
  /** will return all versions of the page if status is not set */
  getPage: PageConnection;
  getPageBySlug: PageConnection;
  /** will return all versions of the page if status is not set */
  getPageTemplate: PageTemplateConnection;
  /** Look up a Gelato print order by its reference id. If `email` is supplied, it must match the order's customerEmail. */
  getPrintOrder?: Maybe<PrintOrder>;
  getReutersCredentials?: Maybe<ReutersCredentialsStatus>;
  getReutersItemDetail: ReutersItemDetail;
  getSegment?: Maybe<Segment>;
  getSendingDomain?: Maybe<SendingDomain>;
  getSite: Site;
  getSubscriberById: Subscriber;
  getSubscriberBySubscriptionIdAndPlanId: Subscriber;
  getTopBlocksByEventForSite: TopBlocksByEventResult;
  getTopPagesByConversionEvent: PageConversionResult;
  /**
   * Get a workspace by it's domain, this function works also with a custom domain
   * Domain should be of type ${subdomain}.app.pubgen.ai for non custom domain and of type ${domainName} for a custom domain
   */
  getWorkspaceByDomain: Workspace;
  /** Get a single user that has access to this workspace and their permissions */
  getWorkspaceUser: WorkspaceUser;
  listAPNewsTopics: ApNewsTopicConnection;
  /** Lists enrollments most-recent-first. Pass `search` to filter by email prefix (alphabetical order while searching). */
  listAutomationEnrollments?: Maybe<AutomationEnrollmentConnection>;
  listAutomations?: Maybe<Array<Automation>>;
  listBrandAssets: AssetConnection;
  listBrandSites: SiteConnection;
  /** will return all versions of the brand styles if status is not set */
  listBrandStyles: BrandStyleConnection;
  listCollectionItems: CollectionItemConnection;
  listCollections: CollectionConnection;
  /** Lifecycle event history for a single contact (newest first). */
  listContactEvents?: Maybe<ContactEventConnection>;
  /** List contacts. With no segmentId: the full site contact list. With a segmentId: a live preview of the contacts the segment's rules currently match. */
  listContacts?: Maybe<ContactConnection>;
  listContextTemplates: Array<ContextTemplate>;
  listConversationMessages?: Maybe<MessageConnection>;
  listExternalFeeds: ExternalFeedConnection;
  listFeaturedChatbotPrompts: Array<FeaturedChatbotPrompt>;
  listFeedSiteSubscriptions: FeedSiteSubscriptionConnection;
  listFeedStories: FeedStoryConnection;
  listFeeds: FeedConnection;
  listGlobalWritingRules: Array<GlobalWritingRule>;
  listMailchimpLists: Array<MailchimpList>;
  listNewsletterSends?: Maybe<NewsletterSendConnection>;
  listNewsletterSubscriptions?: Maybe<NewsletterSubscriptionConnection>;
  listNewsletters?: Maybe<Array<Newsletter>>;
  /** List all the local blocks attached to this page */
  listPageLocalBlocks: BlockConnection;
  listPersonas: Array<Persona>;
  listPublicPersonas: Array<PublicPersona>;
  listQuestions: Array<Question>;
  listReutersChannels: ReutersChannelConnection;
  listSegments?: Maybe<SegmentConnection>;
  /** Per-recipient engagement (delivered/opened/clicked/bounced/complained) for one send. */
  listSendRecipientEngagement?: Maybe<SendRecipientEngagementConnection>;
  /** will return all versions of the blocks if status is not set */
  listSiteBlockTemplates: BlockTemplateConnection;
  /** will return all versions of the blocks if status is not set */
  listSiteBlocks: BlockConnection;
  listSiteConversations?: Maybe<ConversationConnection>;
  /** will return all versions of the pages if status is not set */
  listSitePageTemplates: PageTemplateConnection;
  /** will return all versions of the pages if status is not set */
  listSitePages: PageConnection;
  listUpcomingNewsletterSends?: Maybe<NewsletterSendConnection>;
  /** List all the workspaces a user has access to */
  listUserWorkspaces: Array<Workspace>;
  /** List all the brands attached to this workspace */
  listWorkspaceBrands: BrandConnection;
  /** List all the users that have access to this workspace and their permissions */
  listWorkspaceUsers: WorkspaceUserConnection;
  listWorkspaceWritingRules: Array<WorkspaceWritingRule>;
  listWritingRuleSiteSettings: Array<WritingRuleSiteSetting>;
  listWritingRules: Array<WritingRule>;
  previewAPNewsFeedItems: Array<ApFeedPreviewItem>;
  previewExternalFeedItems: Array<ExternalFeedPreviewItem>;
  searchReutersItems: ReutersSearchResult;
  /** Validates Mirabel API connection using form input credentials */
  validateMirabelConnection: ValidateMirabelConnectionResponse;
  /** Validates Naviga CirculationPro connection and subscription associations using form input data */
  validateNavigaConnection: ValidateNavigaConnectionResponse;
};


export type QueryCheckDomainAvailabilityArgs = {
  domainName: Scalars['String']['input'];
};


export type QueryExportArticlesPublishedReportArgs = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetApNewsFeedItemDetailArgs = {
  apStoryId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetApNewsTokenArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryGetAnalyticsForSiteArgs = {
  params: GetAnalyticsForSiteParams;
};


export type QueryGetAnalyticsForWorkspaceArgs = {
  params: GetAnalyticsForWorkspaceParams;
};


export type QueryGetAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAutomationArgs = {
  automationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetBlockArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetBlockTemplateArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetBlockTemplatesArgs = {
  blockIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetBlocksArgs = {
  blockIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBrandByPathArgs = {
  path: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetBrandStyleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBulkEditArticlesJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetCollectionArgs = {
  collectionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetCollectionItemArgs = {
  assetId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetCollectionItemsByAssetIdArgs = {
  assetId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetConversationArgs = {
  conversationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetConversionAnalyticsForSiteArgs = {
  params: GetConversionAnalyticsForSiteParams;
};


export type QueryGetConversionAnalyticsForWorkspaceArgs = {
  params: GetConversionAnalyticsForWorkspaceParams;
};


export type QueryGetEmailSuppressionStatusArgs = {
  email: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetEventAnalyticsForSiteArgs = {
  params: GetEventAnalyticsForSiteParams;
};


export type QueryGetEventAnalyticsForWorkspaceArgs = {
  params: GetEventAnalyticsForWorkspaceParams;
};


export type QueryGetEventArticleAnalyticsForSiteArgs = {
  params: GetEventArticleAnalyticsForSiteParams;
};


export type QueryGetEventShareBreakdownForBlockArgs = {
  params: GetEventShareBreakdownForBlockParams;
};


export type QueryGetExternalFeedArgs = {
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetFeedArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetNewsletterArgs = {
  newsletterId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetPageArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetPageBySlugArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetPageTemplateArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryGetPrintOrderArgs = {
  customerOrderRef?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orderReferenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReutersCredentialsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryGetReutersItemDetailArgs = {
  itemId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetSegmentArgs = {
  segmentId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryGetSendingDomainArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryGetSiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubscriberByIdArgs = {
  siteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetSubscriberBySubscriptionIdAndPlanIdArgs = {
  planId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type QueryGetTopBlocksByEventForSiteArgs = {
  params: GetTopBlocksByEventForSiteParams;
};


export type QueryGetTopPagesByConversionEventArgs = {
  params: GetTopPagesByConversionEventParams;
};


export type QueryGetWorkspaceByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetWorkspaceUserArgs = {
  username: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryListApNewsTopicsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListAutomationEnrollmentsArgs = {
  automationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};


export type QueryListAutomationsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListBrandAssetsArgs = {
  brandId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryListBrandSitesArgs = {
  brandId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  siteCategory?: InputMaybe<SiteCategory>;
};


export type QueryListBrandStylesArgs = {
  brandId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryListCollectionItemsArgs = {
  collectionId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListCollectionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListContactEventsArgs = {
  email: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListContactsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
};


export type QueryListContextTemplatesArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListConversationMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  order?: InputMaybe<SortOrder>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListExternalFeedsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListFeaturedChatbotPromptsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListFeedSiteSubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListFeedStoriesArgs = {
  feedId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryListFeedsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryListGlobalWritingRulesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryListMailchimpListsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListNewsletterSendsArgs = {
  newsletterId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListNewsletterSubscriptionsArgs = {
  newsletterId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListNewslettersArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListPageLocalBlocksArgs = {
  blockCategory?: InputMaybe<BlockCategory>;
  pageId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryListPersonasArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListPublicPersonasArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  siteId: Scalars['ID']['input'];
};


export type QueryListQuestionsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListReutersChannelsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListSegmentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListSendRecipientEngagementArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sendId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryListSiteBlockTemplatesArgs = {
  blockCategory?: InputMaybe<BlockTemplateCategory>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryListSiteBlocksArgs = {
  blockCategory?: InputMaybe<BlockCategory>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryListSiteConversationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListSitePageTemplatesArgs = {
  pageCategory?: InputMaybe<PageCategory>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryListSitePagesArgs = {
  pageCategories?: InputMaybe<Array<PageCategory>>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type QueryListUpcomingNewsletterSendsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
};


export type QueryListWorkspaceBrandsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryListWorkspaceUsersArgs = {
  brandId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryListWorkspaceWritingRulesArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryListWritingRuleSiteSettingsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryListWritingRulesArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryPreviewApNewsFeedItemsArgs = {
  siteId: Scalars['ID']['input'];
  topicId: Scalars['Int']['input'];
};


export type QueryPreviewExternalFeedItemsArgs = {
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type QuerySearchReutersItemsArgs = {
  input: ReutersSearchInput;
  siteId: Scalars['ID']['input'];
};


export type QueryValidateMirabelConnectionArgs = {
  input: ValidateMirabelConnectionInput;
};


export type QueryValidateNavigaConnectionArgs = {
  input: ValidateNavigaConnectionInput;
};

export type Question = {
  __typename?: 'Question';
  answer: Scalars['String']['output'];
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  questionKey: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export type Quote = {
  author: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ReccurenceInterval =
  | 'day'
  | 'month'
  | 'week'
  | 'year';

export type RedirectConfig = {
  __typename?: 'RedirectConfig';
  /** url to redirect to, can be relative or absolute */
  destination: Scalars['String']['output'];
  /** if true, the status code will be set to 301 */
  permanent: Scalars['Boolean']['output'];
};

export type RedirectConfigInput = {
  /** url to redirect to, can be relative or absolute */
  destination: Scalars['String']['input'];
  /** if true, the status code will be set to 301 */
  permanent: Scalars['Boolean']['input'];
};

export type RemoveItemFromCollectionsInput = {
  assetId: Scalars['ID']['input'];
  collectionIds: Array<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
};

export type RemoveItemsFromCollectionInput = {
  assetIds: Array<Scalars['ID']['input']>;
  collectionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type ResendInvitationEmailInput = {
  username: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type ReutersAssociatedImage = {
  __typename?: 'ReutersAssociatedImage';
  caption?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type ReutersChannel = {
  __typename?: 'ReutersChannel';
  active?: Maybe<Scalars['Boolean']['output']>;
  alias: Scalars['String']['output'];
  channelCategory?: Maybe<Scalars['String']['output']>;
  display?: Maybe<ExternalDisplay>;
  imgRequired?: Maybe<Scalars['Boolean']['output']>;
  mediaType?: Maybe<ReutersMediaType>;
  name: Scalars['String']['output'];
  paywall?: Maybe<Paywall>;
  publishStatus?: Maybe<FeedPublishStatus>;
  sectionId?: Maybe<Scalars['ID']['output']>;
};

export type ReutersChannelConnection = {
  __typename?: 'ReutersChannelConnection';
  items: Array<ReutersChannel>;
};

export type ReutersChannelInput = {
  active: Scalars['Boolean']['input'];
  alias: Scalars['String']['input'];
  display?: InputMaybe<ExternalDisplay>;
  imgRequired?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<ReutersMediaType>;
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  sectionId: Scalars['ID']['input'];
};

export type ReutersChannelSyncResult = {
  __typename?: 'ReutersChannelSyncResult';
  addedChannels: Scalars['Int']['output'];
  removedChannels: Scalars['Int']['output'];
  syncedAt: Scalars['AWSDateTime']['output'];
  totalSubscriptions: Scalars['Int']['output'];
};

export type ReutersCredentialsStatus = {
  __typename?: 'ReutersCredentialsStatus';
  clientId?: Maybe<Scalars['String']['output']>;
  isConfigured: Scalars['Boolean']['output'];
};

export type ReutersEntitlementIssue = {
  __typename?: 'ReutersEntitlementIssue';
  code: Scalars['String']['output'];
  invalidChannels: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  requestedChannels: Array<Scalars['String']['output']>;
};

export type ReutersItemDetail = {
  __typename?: 'ReutersItemDetail';
  associatedImages?: Maybe<Array<ReutersAssociatedImage>>;
  body?: Maybe<Scalars['String']['output']>;
  byline?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  firstCreated?: Maybe<Scalars['String']['output']>;
  fragment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importabilityCode?: Maybe<Scalars['String']['output']>;
  importabilityMessage?: Maybe<Scalars['String']['output']>;
  importable: Scalars['Boolean']['output'];
  imported: Scalars['Boolean']['output'];
  importedPageId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  pubStatus?: Maybe<Scalars['String']['output']>;
  recommendedDownloadMode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urgency?: Maybe<Scalars['Int']['output']>;
  usageTerms?: Maybe<Scalars['String']['output']>;
  versionCreated?: Maybe<Scalars['String']['output']>;
};

export type ReutersMediaType =
  | 'COMPOSITE'
  | 'PICTURE'
  | 'TEXT';

export type ReutersSearchInput = {
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  excludeChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<ReutersMediaType>;
  mediaTypes?: InputMaybe<Array<ReutersMediaType>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ReutersSortField>;
};

export type ReutersSearchItem = {
  __typename?: 'ReutersSearchItem';
  byline?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  fragment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imported: Scalars['Boolean']['output'];
  importedPageId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  versionedGuid?: Maybe<Scalars['String']['output']>;
};

export type ReutersSearchResult = {
  __typename?: 'ReutersSearchResult';
  entitlementIssue?: Maybe<ReutersEntitlementIssue>;
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<ReutersSearchItem>;
  totalHits: Scalars['Int']['output'];
};

export type ReutersSortField =
  | 'DATE'
  | 'SCORE';

export type RevertPublishedNodeInput = {
  id: Scalars['ID']['input'];
  savedAt: Scalars['AWSDateTime']['input'];
};

export type RoleType =
  | 'assistant'
  | 'user';

export type SavePublishedNodeInput = {
  id: Scalars['ID']['input'];
};

export type SectionLayoutStyle =
  | 'grid'
  | 'lines'
  | 'twoColumns';

/**
 * A Segment is a saved, query-only targeting group. Membership is never stored; it
 * is computed at send (and previewed in the CMS) by evaluating `rulesJson` against
 * the site's contacts. Supported rules (all optional, AND-ed together):
 * - includeTags: [String!]      contact must have at least one of these tags
 * - excludeTags: [String!]      contact must have none of these tags
 * - subscribedNewsletterId: ID  contact is subscribed to this newsletter
 * - openedSendId: ID            contact opened this prior send
 * - clickedSendId: ID           contact clicked this prior send
 * - notOpenedSendId: ID         contact did NOT open this prior send
 * - planStatus: String          contact's lifecycle plan status ("ACTIVE" | "CANCELLED")
 * - hasDonated: Boolean          contact has at least one recorded donation
 * - donatedWithinDays: Int       contact's last donation was within N days
 * - signedInWithinDays: Int      contact signed in within N days
 */
export type Segment = {
  __typename?: 'Segment';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rulesJson?: Maybe<Scalars['AWSJSON']['output']>;
  siteId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SegmentConnection = {
  __typename?: 'SegmentConnection';
  items: Array<Segment>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type SegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rulesJson?: InputMaybe<Scalars['AWSJSON']['input']>;
  siteId: Scalars['ID']['input'];
};

export type SendChatMessageInput = {
  /**
   * In-context documentation key (next-app/docs/). When set, the referenced doc
   * is injected into the chatbot context (Ask-AI handoff from a field doc modal).
   */
  docKey?: InputMaybe<Scalars['String']['input']>;
  messages: Array<ChatMessageInput>;
  model?: InputMaybe<AiModel>;
  pagePath: Scalars['String']['input'];
  personaId?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
  type: ChatMessageType;
};

/**
 * Per-recipient engagement for a single send. One row per (send, recipient),
 * written by the Resend webhook and auto-expired by DynamoDB TTL (~90 days).
 */
export type SendRecipientEngagement = {
  __typename?: 'SendRecipientEngagement';
  bouncedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  clickCount?: Maybe<Scalars['Int']['output']>;
  clickedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  complainedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  email: Scalars['String']['output'];
  openCount?: Maybe<Scalars['Int']['output']>;
  openedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SendRecipientEngagementConnection = {
  __typename?: 'SendRecipientEngagementConnection';
  items: Array<SendRecipientEngagement>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type SendingDomain = {
  __typename?: 'SendingDomain';
  autoInjected?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  records?: Maybe<Array<SendingDomainDnsRecord>>;
  siteId: Scalars['ID']['output'];
  status: SendingDomainStatus;
  verifiedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SendingDomainDnsRecord = {
  __typename?: 'SendingDomainDnsRecord';
  host: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  recordType: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type SendingDomainStatus =
  | 'FAILED'
  | 'PENDING'
  | 'VERIFIED';

export type SetCustomerPortalConfigurationInput = {
  allowCancellation: Scalars['Boolean']['input'];
  allowPaymentMethodUpdate: Scalars['Boolean']['input'];
  allowPlanSwitching: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
  /** Required (non-empty) when allowPlanSwitching is true; Stripe price ids. */
  switchablePrices?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ShareBreakdownEntry = {
  __typename?: 'ShareBreakdownEntry';
  count: Scalars['Int']['output'];
  method: Scalars['String']['output'];
};

export type ShareBreakdownResult = {
  __typename?: 'ShareBreakdownResult';
  entries: Array<ShareBreakdownEntry>;
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Site = Node & {
  __typename?: 'Site';
  adSystem?: Maybe<AdvertisementSystem>;
  adTxtContent?: Maybe<Scalars['String']['output']>;
  /** Brand id this site belongs to */
  aiSettings?: Maybe<AiSettings>;
  /**
   * Controls what is rendered in the right-column sidebar of the article body block on story pages.
   * When 'Related' (default), shows tag/section-related articles computed at SSR.
   * When 'Trending', the sidebar is hydrated client-side from per-site trending analytics
   * via the /api/trending-stories endpoint, so freshness isn't gated by the page Redis cache.
   */
  articleBodySidebarMode?: Maybe<ArticleBodySidebarMode>;
  authToken?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ID']['output'];
  brandStyleId: Scalars['ID']['output'];
  chatOpenByDefault?: Maybe<Scalars['Boolean']['output']>;
  chatbotAsSidebar?: Maybe<Scalars['Boolean']['output']>;
  chatbotImage?: Maybe<ChatbotImage>;
  chatbotMinimizedDisplayName?: Maybe<Scalars['String']['output']>;
  chatbotPageBlacklist?: Maybe<ChatbotPageBlacklist>;
  columnInchSettings?: Maybe<ColumnInchSettings>;
  /** general info about the publication */
  companyInfo?: Maybe<CompanyInfo>;
  connectedFotomotoAccount?: Maybe<FotomotoAccount>;
  connectedGoogleAdsAccount?: Maybe<GoogleAdsAccount>;
  connectedGoogleAnalyticsAccount?: Maybe<GoogleAnalyticsAccount>;
  connectedGoogleTagManagerAccount?: Maybe<GoogleTagManagerAccount>;
  connectedIzootoAccount?: Maybe<IzootoAccount>;
  connectedMarfeelAnalyticsAccount?: Maybe<MarfeelAnalyticsAccount>;
  connectedStripeAccount?: Maybe<StripeAccount>;
  contentCreditsAccount?: Maybe<ContentCreditsAccount>;
  createdAt: Scalars['AWSDateTime']['output'];
  customAds?: Maybe<CustomAds>;
  defaultArticleAccess?: Maybe<Paywall>;
  defaultArticleExternalDisplay?: Maybe<ExternalDisplay>;
  defaultMetadata?: Maybe<Array<Scalars['String']['output']>>;
  disableAuthentication?: Maybe<Scalars['Boolean']['output']>;
  disableCmsChatbot?: Maybe<Scalars['Boolean']['output']>;
  disableLeadGeneration?: Maybe<Scalars['Boolean']['output']>;
  disableStoryGeneration?: Maybe<Scalars['Boolean']['output']>;
  disableTitleGeneration?: Maybe<Scalars['Boolean']['output']>;
  domain?: Maybe<Domain>;
  domainName?: Maybe<Scalars['String']['output']>;
  domainStatus?: Maybe<DomainStatus>;
  emailCapture?: Maybe<EmailCapture>;
  emailServiceAutoTagSignedIn?: Maybe<Scalars['Boolean']['output']>;
  emailServiceAutoTagSubscribed?: Maybe<Scalars['Boolean']['output']>;
  engageAccount?: Maybe<EngageAccount>;
  exportAuthToken?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  /** Kill switch for Gelato print-on-demand. Both gelatoApiKey and gelatoActive must be truthy to surface print buttons. */
  gelatoActive?: Maybe<Scalars['Boolean']['output']>;
  /** Gelato print-on-demand API key (server-side only; never exposed to public site for unauthorized callers) */
  gelatoApiKey?: Maybe<Scalars['String']['output']>;
  /** List of editorial product type ids the newsroom (or school) enables for print-on-demand (e.g. 'poster', 'mug', 't-shirt'). Null/empty falls back to the default-on subset of PRINT_ON_DEMAND_PRODUCTS in shared/print-on-demand-products.ts. Edited via the CMS Print on Demand settings page. */
  gelatoEnabledProductTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Fraction (0.0 - 5.0) of the Gelato cost the newsroom adds as retail margin. Buyer pays cost x (1 + markup). PubGen takes 10% of the markup only — Gelato cost flows untouched to the newsroom Connect account. Null/undefined falls back to PRINT_ON_DEMAND_DEFAULT_NEWSROOM_MARKUP_PERCENT (0.4). */
  gelatoNewsroomMarkupPercent?: Maybe<Scalars['Float']['output']>;
  /** Per-newsroom bearer token Gelato sends in webhook Authorization headers. Auto-generated on connect; rotatable. Server-side only — never exposed to the public site. */
  gelatoWebhookSecret?: Maybe<Scalars['String']['output']>;
  getAvailableNewsletters?: Maybe<Array<Newsletter>>;
  getBrand?: Maybe<Brand>;
  getBrandStyle?: Maybe<BrandStyle>;
  getMostViewedStories?: Maybe<BlockConnection>;
  /** Get a page by its slug. */
  getPageBySlug?: Maybe<PageConnection>;
  getWeatherData?: Maybe<WeatherData>;
  googleTagAds?: Maybe<GoogleTagAds>;
  /** gsi1sk is the dynamodb composite key, consists of connectedStripeAccount.id */
  gsi1pk?: Maybe<Scalars['String']['output']>;
  /** gsi1sk is the dynamodb composite key, consists of connectedStripeAccount.id */
  gsi1sk?: Maybe<Scalars['String']['output']>;
  /** gsi2sk is the dynamodb composite key, consists of authToken */
  gsi2pk?: Maybe<Scalars['String']['output']>;
  /** gsi2sk is the dynamodb composite key, consists of authToken */
  gsi2sk?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imgPlaceholder?: Maybe<ImgPlaceholder>;
  /** UI language of the site (public site, CMS, and generated emails). Absent means 'en'. */
  language?: Maybe<SiteLanguage>;
  /**
   * When true, this site's language follows the workspace default: the concrete
   * `language` value is (re-)materialized from Workspace.language on save and
   * whenever the workspace language changes. CMS-only metadata — all rendering
   * paths keep reading the concrete `language` field.
   */
  languageFollowsWorkspace?: Maybe<Scalars['Boolean']['output']>;
  listCollections?: Maybe<CollectionConnection>;
  listFeedSiteSubscriptions?: Maybe<FeedSiteSubscriptionConnection>;
  /** list all site blocks templates. */
  listSiteBlockTemplates?: Maybe<BlockTemplateConnection>;
  /** list all site blocks. */
  listSiteBlocks?: Maybe<BlockConnection>;
  /** list all site page templates. */
  listSitePageTemplates?: Maybe<PageTemplateConnection>;
  /** list all site pages. */
  listSitePages?: Maybe<PageConnection>;
  makeItFreeAccount?: Maybe<MakeItFreeAccount>;
  maxFullIndexDate?: Maybe<Scalars['AWSDateTime']['output']>;
  menus?: Maybe<Array<Menu>>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metadataImage?: Maybe<MetadataImage>;
  mirabelAccount?: Maybe<MirabelAccount>;
  name: Scalars['String']['output'];
  navigaAccount?: Maybe<NavigaAccount>;
  /** Hard cap on emails per day (CUSTOM provider). Anti-burst guardrail. */
  newsletterDailyEmailLimit?: Maybe<Scalars['Int']['output']>;
  /** Stripe SubscriptionItem id for the metered newsletter_emails price. */
  newsletterMeteredSubscriptionItemId?: Maybe<Scalars['String']['output']>;
  /** Hard cap on emails per calendar month (CUSTOM provider). Null = no cap. */
  newsletterMonthlyEmailLimit?: Maybe<Scalars['Int']['output']>;
  /**
   * Which email service the site uses to send newsletters. Legacy sites default to
   * MAILCHIMP. CUSTOM activates the PubGen-native Resend-backed pipeline with
   * contacts, segments, scheduled sends, and Stripe metered billing.
   */
  newsletterProvider?: Maybe<NewsletterProvider>;
  /** When true, all newsletter sends for this site are paused (set on payment_failed or abuse threshold). */
  newsletterSendsPaused?: Maybe<Scalars['Boolean']['output']>;
  newspapersDotComSubdomain?: Maybe<Scalars['String']['output']>;
  newspapersDotComTPAKey?: Maybe<Scalars['String']['output']>;
  newzwareAccount?: Maybe<NewzwareAccount>;
  playWirePubId?: Maybe<Scalars['String']['output']>;
  playWireWebId?: Maybe<Scalars['String']['output']>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  pubgenSubscription?: Maybe<PubgenSubscription>;
  /**
   * Publisher-picked subset of newsletter IDs to surface on the public sign-up /
   * newsletters block. Null/empty = show all live (non-draft) newsletters.
   */
  publicNewsletterIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Name of the S3 folder used as the source for NITF article transfers into this site.
   * Used as a safety guard by the NITF transfer job to prevent transferring articles
   * from the wrong folder into the wrong site.
   */
  s3TransferFolderName?: Maybe<Scalars['String']['output']>;
  /**
   * When true (default), sends a confirmation email after a user subscribes to one
   * or more newsletters via Mailchimp. Set to false if the publisher prefers to run
   * their own subscriber messaging (e.g. via Mailchimp campaigns).
   */
  sendNewsletterSubscriptionEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Domain used as the From: address envelope when sending via the CUSTOM provider. */
  sendingDomain?: Maybe<Scalars['String']['output']>;
  /** True when DKIM/SPF/DMARC records for `sendingDomain` are verified in Resend. */
  sendingDomainVerified?: Maybe<Scalars['Boolean']['output']>;
  seoPublicationName?: Maybe<Scalars['String']['output']>;
  /** ISO-3166 alpha-2 country codes the newsroom allows print-on-demand shipping to. Empty/null defaults to ['US','CA']. */
  shippingCountries?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of the site, this can be used to filter sites by type when listing them */
  siteCategory: SiteCategory;
  storyCommentsOnByDefault?: Maybe<Scalars['Boolean']['output']>;
  titleTag?: Maybe<Scalars['String']['output']>;
  tollbitAnalyticsEnabled?: Maybe<Scalars['Boolean']['output']>;
  typesense: TypesenseSiteSettings;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
  /** wildcard redirect rules for this site, evaluated on exact-slug miss */
  wildcardRedirects?: Maybe<Array<WildcardRedirectRule>>;
};


export type SiteGetPageBySlugArgs = {
  pagination?: InputMaybe<PaginationInput>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type SiteListCollectionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type SiteListFeedSiteSubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type SiteListSiteBlockTemplatesArgs = {
  blockCategory?: InputMaybe<BlockTemplateCategory>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type SiteListSiteBlocksArgs = {
  blockCategory?: InputMaybe<BlockCategory>;
  pagination?: InputMaybe<PaginationInput>;
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
};


export type SiteListSitePageTemplatesArgs = {
  pageCategory?: InputMaybe<PageCategory>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};


export type SiteListSitePagesArgs = {
  pageCategory?: InputMaybe<PageCategory>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<PublishedStatusInput>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  items: Array<Site>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

/**
 * UI language for the site. Drives the public site rendering language,
 * the CMS UI language when working inside the site, and Lambda-generated
 * user-facing text (newsletters, transactional emails). Absent means 'en'.
 */
export type SiteLanguage =
  | 'en'
  | 'fr';

/** order in vertical page is top, header, main, footer */
export type SlotType =
  | 'footer'
  | 'header'
  | 'main'
  | 'top';

export type SocialGallery = {
  __typename?: 'SocialGallery';
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<SocialGalleryLocation>;
  type?: Maybe<SocialGalleryType>;
};

export type SocialGalleryInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<SocialGalleryLocation>;
  type?: InputMaybe<SocialGalleryType>;
};

export type SocialGalleryLocation =
  | 'ABOVE_MEDIA_GALLERY'
  | 'AFTER_FIRST_ARTICLES_BY_SECTION'
  | 'AFTER_HOME_TOP_STORIES'
  | 'AFTER_WEATHER';

export type SocialGalleryType =
  | 'INSTAGRAM_REELS'
  | 'YOUTUBE_SHORTS';

export type SortDirection =
  | 'ASC'
  | 'DESC';

export type SortOrder =
  | 'asc'
  | 'desc';

export type StoryLayout =
  | 'default'
  | 'noSidebar';

export type StripeAccount = {
  __typename?: 'StripeAccount';
  accountId: Scalars['ID']['output'];
  customerPortalConfig?: Maybe<CustomerPortalConfig>;
  donationProduct?: Maybe<DonationProduct>;
  notificationEmail?: Maybe<Scalars['String']['output']>;
  /** Recipient(s) notified whenever a Stripe customer updates their email or address. Comma-separated for multiple. */
  profileChangeNotificationEmail?: Maybe<Scalars['String']['output']>;
  status: StripeAccountStatus;
  subscriptionGifts?: Maybe<Array<SubscriptionGift>>;
  subscriptionPlans: Array<SubscriptionPlan>;
  subscriptionPromos?: Maybe<Array<SubscriptionPromo>>;
  supportPlans?: Maybe<Array<SubscriptionPlan>>;
  type?: Maybe<StripeAccountType>;
};

/**
 * Stripe account status
 * active - account is active and can be used (charges_enabled)
 * pending - account was just created details are not yet submitted
 * detailsSubmitted - account details are submitted and pending approval by stripe
 */
export type StripeAccountStatus =
  | 'active'
  | 'detailsSubmitted'
  | 'pending';

export type StripeAccountType =
  /** stripe account is connected to a donation page */
  | 'donation'
  /** stripe account is connected to a publication (default ) */
  | 'publication';

export type StripeCoupon = {
  __typename?: 'StripeCoupon';
  amount_off?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percent_off?: Maybe<Scalars['Int']['output']>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  created: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type StripeDiscount = {
  __typename?: 'StripeDiscount';
  coupon?: Maybe<StripeCoupon>;
};

export type StripeGiftCoupon = {
  __typename?: 'StripeGiftCoupon';
  checkoutSessionId: Scalars['ID']['output'];
  couponId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  planProductId: Scalars['ID']['output'];
  redeemedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  redeemedBy?: Maybe<Scalars['ID']['output']>;
  session: Scalars['AWSJSON']['output'];
  siteId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type StripePlan = {
  __typename?: 'StripePlan';
  /** amount in cents */
  amount: Scalars['Int']['output'];
  /** currency code */
  currency: Currency;
  /** price id */
  id: Scalars['ID']['output'];
  interval: ReccurenceInterval;
  interval_count: Scalars['Int']['output'];
  /** product id */
  product: Scalars['ID']['output'];
};

export type StripePlanFrequency =
  | 'monthly'
  | 'yearly';

/** price of a stripe products, includes information about recurrency and free trial for subscriptions */
export type StripePrice = {
  __typename?: 'StripePrice';
  currency: Currency;
  id: Scalars['ID']['output'];
  recurring?: Maybe<StripeReccurence>;
  /** unit_amount property in stripe api */
  unitAmount?: Maybe<Scalars['Int']['output']>;
};

export type StripeReccurence = {
  __typename?: 'StripeReccurence';
  interval?: Maybe<ReccurenceInterval>;
  /** interval_count property in stripe api */
  intervalCount?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  cancel_at_period_end: Scalars['Boolean']['output'];
  created: Scalars['Int']['output'];
  discount?: Maybe<StripeDiscount>;
  id: Scalars['ID']['output'];
  items: SubscriptionItem;
  siteId: Scalars['ID']['output'];
  status: StripeSubscriptionStatus;
  userId: Scalars['ID']['output'];
};

/**
 * Pubgen subscription status
 * Documentation: https://docs.stripe.com/billing/subscriptions/webhooks#state-changes
 */
export type StripeSubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'paused'
  | 'trialing'
  | 'unpaid';

export type Subscriber = {
  __typename?: 'Subscriber';
  donationReceipts?: Maybe<Array<DonationReceipt>>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  legacyPassword?: Maybe<Scalars['String']['output']>;
  legacyUsername?: Maybe<Scalars['String']['output']>;
  newsletterSubscriptions?: Maybe<Array<NewsletterSubscription>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<ShippingAddress>;
  siteId: Scalars['String']['output'];
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeGiftCoupons?: Maybe<Array<StripeGiftCoupon>>;
  stripeSubscriptions?: Maybe<Array<StripeSubscription>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onArticleGeneration?: Maybe<GenerateArticleBodySubscription>;
  onBlockChanged?: Maybe<Block>;
  onBlogGeneration?: Maybe<GenerateBlogSubscriptionPayload>;
  onChatbotMessage?: Maybe<ChatbotMessageSubscriptionPayload>;
  onImageGeneration?: Maybe<GenerateImageSubscriptionPayload>;
  onPageChanged?: Maybe<Page>;
  onSiteChanged?: Maybe<Site>;
};


export type SubscriptionOnArticleGenerationArgs = {
  generationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type SubscriptionOnBlockChangedArgs = {
  pageId: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};


export type SubscriptionOnBlogGenerationArgs = {
  generationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type SubscriptionOnChatbotMessageArgs = {
  siteId: Scalars['ID']['input'];
  username: Scalars['ID']['input'];
};


export type SubscriptionOnImageGenerationArgs = {
  imageGenerationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type SubscriptionOnPageChangedArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['ID']['input'];
};


export type SubscriptionOnSiteChangedArgs = {
  id: Scalars['ID']['input'];
};

export type SubscriptionGift = {
  __typename?: 'SubscriptionGift';
  couponId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  numberOfGiftedMonths: Scalars['Int']['output'];
  planProductId: Scalars['ID']['output'];
  priceId: Scalars['ID']['output'];
  priceInCents: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  data: Array<SubscriptionItemData>;
};

export type SubscriptionItemData = {
  __typename?: 'SubscriptionItemData';
  plan: StripePlan;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  adSettings?: Maybe<PlanAdSettings>;
  benefits?: Maybe<Scalars['AWSJSON']['output']>;
  clickSubscribeLinkOverrideMonthly?: Maybe<Scalars['String']['output']>;
  clickSubscribeLinkOverrideYearly?: Maybe<Scalars['String']['output']>;
  collectPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  /** whether the plan requires collecting shipping information */
  collectShipping?: Maybe<Scalars['Boolean']['output']>;
  ctaMonthly?: Maybe<Scalars['String']['output']>;
  ctaYearly?: Maybe<Scalars['String']['output']>;
  monthlyPlanLabel?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  optionalMonthlyState?: Maybe<OptionalPriceState>;
  optionalPriceIdMonthly?: Maybe<Scalars['ID']['output']>;
  optionalPriceIdYearly?: Maybe<Scalars['ID']['output']>;
  optionalProductDescription?: Maybe<Scalars['String']['output']>;
  optionalProductId?: Maybe<Scalars['ID']['output']>;
  optionalProductName?: Maybe<Scalars['String']['output']>;
  optionalYearlyState?: Maybe<OptionalPriceState>;
  planSummary?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<PlanType>;
  previousPriceIds: Array<Scalars['ID']['output']>;
  priceForMonthlyOptionalChoice?: Maybe<Scalars['Int']['output']>;
  priceForMonthlyToggleChoice?: Maybe<Scalars['Int']['output']>;
  priceForYearlyOptionalChoice?: Maybe<Scalars['Int']['output']>;
  priceForYearlyToggleChoice?: Maybe<Scalars['Int']['output']>;
  priceSubtitleMonthly?: Maybe<Scalars['String']['output']>;
  priceSubtitleYearly?: Maybe<Scalars['String']['output']>;
  printOnly?: Maybe<Scalars['Boolean']['output']>;
  productId: Scalars['ID']['output'];
  /** id of the promo coupon to be used for this plan automatically */
  promoCouponIdMonthly?: Maybe<Scalars['ID']['output']>;
  promoCouponIdYearly?: Maybe<Scalars['ID']['output']>;
  stripeDescription: Scalars['String']['output'];
  stripePriceIdMonthly: Scalars['ID']['output'];
  stripePriceIdYearly: Scalars['ID']['output'];
  struckOutPriceForYearlyToggleChoice?: Maybe<Scalars['Int']['output']>;
  struckOutpriceForMonthlyToggleChoice?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  yearlyPlanLabel?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlanConnection = {
  __typename?: 'SubscriptionPlanConnection';
  items: Array<SubscriptionPlan>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPromo = {
  __typename?: 'SubscriptionPromo';
  couponId: Scalars['ID']['output'];
  durationInMonths: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentageOff: Scalars['Int']['output'];
  siteId: Scalars['ID']['output'];
};

export type TollbitWorkspaceAnalytics = {
  __typename?: 'TollbitWorkspaceAnalytics';
  bucketName: Scalars['String']['output'];
  bucketRegion: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TopBlocksByEventResult = {
  __typename?: 'TopBlocksByEventResult';
  topBlocks: Array<BlockEventStat>;
};

export type TypesenseSiteSettings = {
  __typename?: 'TypesenseSiteSettings';
  cmsKey: Scalars['String']['output'];
  siteKey: Scalars['String']['output'];
};

export type Typo = {
  __typename?: 'Typo';
  fontCase: FontCase;
  fontId?: Maybe<Scalars['ID']['output']>;
  fontSize: Scalars['Int']['output'];
  letterSpacing: Scalars['Float']['output'];
  lineHeight: Scalars['Float']['output'];
  spaceAfter: Scalars['Int']['output'];
};

export type TypoInput = {
  fontCase: FontCase;
  fontId?: InputMaybe<Scalars['ID']['input']>;
  fontSize: Scalars['Int']['input'];
  letterSpacing: Scalars['Float']['input'];
  lineHeight: Scalars['Float']['input'];
  spaceAfter: Scalars['Int']['input'];
};

export type Typography = {
  __typename?: 'Typography';
  blockquote: Typo;
  body1: Typo;
  body2: Typo;
  button: Typo;
  caption: Typo;
  code: Typo;
  h1: Typo;
  h2: Typo;
  h3: Typo;
  h4: Typo;
  h5: Typo;
  h6: Typo;
  overline: Typo;
  subtitle1: Typo;
  subtitle2: Typo;
};

export type TypographyInput = {
  blockquote: TypoInput;
  body1: TypoInput;
  body2: TypoInput;
  button: TypoInput;
  caption: TypoInput;
  code: TypoInput;
  h1: TypoInput;
  h2: TypoInput;
  h3: TypoInput;
  h4: TypoInput;
  h5: TypoInput;
  h6: TypoInput;
  overline: TypoInput;
  subtitle1: TypoInput;
  subtitle2: TypoInput;
};

export type UnpublishPublishedNodeInput = {
  id: Scalars['ID']['input'];
};

export type UpdateAssetInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBlockInput = {
  archivedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  /** Cannonical name of the react component */
  componentId?: InputMaybe<Scalars['String']['input']>;
  /** All block data */
  data?: InputMaybe<BlockDataInput>;
  externalBlockIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  /** Variant of the component */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockTemplateInput = {
  /** Cannonical name of the react component */
  componentId: Scalars['String']['input'];
  /** All block data */
  data?: InputMaybe<BlockTemplateDataInput>;
  id: Scalars['ID']['input'];
  /** Variant of the component */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrandInput = {
  brandStyleId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  playbookSiteId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateBrandStyleInput = {
  id: Scalars['ID']['input'];
  properties: ClientThemePropertiesInput;
};

export type UpdateChatbotImageInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCollectionInput = {
  collectionId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type UpdateCollectionItemInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  assetId: Scalars['ID']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
  collectionId: Scalars['ID']['input'];
  credit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type UpdateContentCreditsAccountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContextTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type UpdateDonationProductInput = {
  collectPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  maximumAmount?: InputMaybe<Scalars['Int']['input']>;
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  priceId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  stripeDescription: Scalars['String']['input'];
};

export type UpdateEngageAccountInput = {
  accountUrl?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configScript?: InputMaybe<Scalars['String']['input']>;
  subscribeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalFeedInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<ExternalDisplay>;
  id: Scalars['ID']['input'];
  imgRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parserType?: InputMaybe<ExternalParserType>;
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeaturedChatbotPromptInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<FeaturedChatbotPromptCategory>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<FeaturedChatbotpageType>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type UpdateFeedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FeedFilterInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  webhooks?: InputMaybe<Array<FeedWebhookInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateFeedSiteSubscriptionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  feedId: Scalars['ID']['input'];
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  section?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateFeedSiteSubscriptionsFeedInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<ExternalDisplay>;
  feedId: Scalars['ID']['input'];
  paywall?: InputMaybe<Paywall>;
  publishStatus?: InputMaybe<FeedPublishStatus>;
  section?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFeedSiteSubscriptionsInput = {
  feedSiteSubscriptions: Array<UpdateFeedSiteSubscriptionsFeedInput>;
  siteId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type UpdateFotomotoAccountInput = {
  accountId: Scalars['ID']['input'];
};

export type UpdateGoogleAdsAccountInput = {
  adClient: Scalars['ID']['input'];
  horizontalAdSlot?: InputMaybe<Scalars['ID']['input']>;
  verticalAdSlot?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGoogleAnalyticsAccountInput = {
  gaMeasurementId: Scalars['ID']['input'];
};

export type UpdateGoogleTagAdsInput = {
  adHeroHeaderScript?: InputMaybe<Scalars['String']['input']>;
  articleInContentHeaderScript?: InputMaybe<Scalars['String']['input']>;
  chatbotPrimaryHeaderScript?: InputMaybe<Scalars['String']['input']>;
  chatbotSecondaryHeaderScript?: InputMaybe<Scalars['String']['input']>;
  footerHeaderScript?: InputMaybe<Scalars['String']['input']>;
  horizontal1HeaderScript?: InputMaybe<Scalars['String']['input']>;
  horizontal2HeaderScript?: InputMaybe<Scalars['String']['input']>;
  stickyFooterHeaderScript?: InputMaybe<Scalars['String']['input']>;
  vertical2HeaderScript?: InputMaybe<Scalars['String']['input']>;
  verticalHeaderScript?: InputMaybe<Scalars['String']['input']>;
  videoHeaderScript?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGoogleTagManagerAccountInput = {
  containerId: Scalars['ID']['input'];
};

export type UpdateIzootoAccountInput = {
  active: Scalars['Boolean']['input'];
  scriptId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMakeItFreeAccountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMarfeelAnalyticsAccountInput = {
  marfeelId: Scalars['ID']['input'];
};

export type UpdateMenuInput = {
  id: Scalars['ID']['input'];
  items?: InputMaybe<Array<MenuItemInput>>;
  name: Scalars['String']['input'];
};

export type UpdateMirabelAccountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNavigaAccountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  navigaSubscriptionAssociation?: InputMaybe<Array<NavigaSubscriptionAssociationInput>>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  wsdlUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewzwareAccountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  editionCode?: InputMaybe<Scalars['String']['input']>;
  instanceUrl?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageInput = {
  id: Scalars['ID']['input'];
  localBlockSlots?: InputMaybe<Array<LocalBlockSlotInput>>;
  /** redirect configuration for redirect pages */
  redirect?: InputMaybe<RedirectConfigInput>;
  /** Custom canonical URL for republished content (e.g., Texas Tribune URL) */
  seoCanonical?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoImageHeight?: InputMaybe<Scalars['Int']['input']>;
  /** S3 key for per-page social share / SEO image */
  seoImageSrc?: InputMaybe<Scalars['String']['input']>;
  seoImageWidth?: InputMaybe<Scalars['Int']['input']>;
  /** If true, adds noindex meta tag to exclude page from search engines */
  seoNoindex?: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  /** id of the page template that should be used to display this page */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePageSlugInput = {
  create301redirect?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
};

export type UpdatePageTemplateInput = {
  /** JSON representation of the blocks templates data, blockOrder for block templates */
  blockTemplates?: InputMaybe<Array<LocalBlockSlotInput>>;
  /**
   * JSON representation of the blocks variants.
   * For each block that can be present on the page template, specifies the variant that should be displayed for this block
   */
  blockVariants?: InputMaybe<Array<BlockVariantInput>>;
  componentId: PageTemplateComponentId;
  id: Scalars['ID']['input'];
};

export type UpdatePersonaInput = {
  answerStyle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type UpdatePublicPersonaInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answerStyle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<UpdateChatbotImageInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type UpdateQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  questionKey?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type UpdateRegisteredUserInput = {
  email: Scalars['ID']['input'];
  shippingAddress?: InputMaybe<ShippingAddressInput>;
  siteId: Scalars['ID']['input'];
};

export type UpdateSiteInput = {
  adSystem?: InputMaybe<AdvertisementSystem>;
  adTxtContent?: InputMaybe<Scalars['String']['input']>;
  aiSettings?: InputMaybe<AiSettingsInput>;
  articleBodySidebarMode?: InputMaybe<ArticleBodySidebarMode>;
  chatOpenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  chatbotAsSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  chatbotImage?: InputMaybe<UpdateChatbotImageInput>;
  chatbotMinimizedDisplayName?: InputMaybe<Scalars['String']['input']>;
  chatbotPageBlacklist?: InputMaybe<ChatbotPageBlacklistInput>;
  columnInchSettings?: InputMaybe<ColumnInchSettingsInput>;
  companyInfo?: InputMaybe<CompanyInfoInput>;
  connectedFotomotoAccount?: InputMaybe<UpdateFotomotoAccountInput>;
  connectedGoogleAdsAccount?: InputMaybe<UpdateGoogleAdsAccountInput>;
  connectedGoogleAnalyticsAccount?: InputMaybe<UpdateGoogleAnalyticsAccountInput>;
  connectedGoogleTagManagerAccount?: InputMaybe<UpdateGoogleTagManagerAccountInput>;
  connectedIzootoAccount?: InputMaybe<UpdateIzootoAccountInput>;
  connectedMarfeelAnalyticsAccount?: InputMaybe<UpdateMarfeelAnalyticsAccountInput>;
  contentCreditsAccount?: InputMaybe<UpdateContentCreditsAccountInput>;
  customAds?: InputMaybe<CustomAdsInput>;
  defaultArticleAccess?: InputMaybe<Paywall>;
  defaultArticleExternalDisplay?: InputMaybe<ExternalDisplay>;
  defaultMetadata?: InputMaybe<Array<Scalars['String']['input']>>;
  disableAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  disableCmsChatbot?: InputMaybe<Scalars['Boolean']['input']>;
  disableLeadGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  disableStoryGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  disableTitleGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  emailCapture?: InputMaybe<EmailCaptureInput>;
  emailServiceAutoTagSignedIn?: InputMaybe<Scalars['Boolean']['input']>;
  emailServiceAutoTagSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  engageAccount?: InputMaybe<UpdateEngageAccountInput>;
  exportAuthToken?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  gelatoActive?: InputMaybe<Scalars['Boolean']['input']>;
  gelatoApiKey?: InputMaybe<Scalars['String']['input']>;
  gelatoEnabledProductTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  gelatoNewsroomMarkupPercent?: InputMaybe<Scalars['Float']['input']>;
  gelatoWebhookSecret?: InputMaybe<Scalars['String']['input']>;
  googleTagAds?: InputMaybe<UpdateGoogleTagAdsInput>;
  id: Scalars['ID']['input'];
  imgPlaceholder?: InputMaybe<ImgPlaceholderInput>;
  language?: InputMaybe<SiteLanguage>;
  languageFollowsWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
  makeItFreeAccount?: InputMaybe<UpdateMakeItFreeAccountInput>;
  menus?: InputMaybe<Array<UpdateMenuInput>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metadataImage?: InputMaybe<MetadataImageInput>;
  mirabelAccount?: InputMaybe<UpdateMirabelAccountInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  navigaAccount?: InputMaybe<UpdateNavigaAccountInput>;
  newsletterDailyEmailLimit?: InputMaybe<Scalars['Int']['input']>;
  newsletterMeteredSubscriptionItemId?: InputMaybe<Scalars['String']['input']>;
  newsletterMonthlyEmailLimit?: InputMaybe<Scalars['Int']['input']>;
  newsletterProvider?: InputMaybe<NewsletterProvider>;
  newsletterSendsPaused?: InputMaybe<Scalars['Boolean']['input']>;
  newspapersDotComSubdomain?: InputMaybe<Scalars['String']['input']>;
  newspapersDotComTPAKey?: InputMaybe<Scalars['String']['input']>;
  newzwareAccount?: InputMaybe<UpdateNewzwareAccountInput>;
  playWirePubId?: InputMaybe<Scalars['String']['input']>;
  playWireWebId?: InputMaybe<Scalars['String']['input']>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
  publicNewsletterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Name of the S3 folder used as the source for NITF article transfers into this site.
   * Must match the `folder` payload field of the NITF transfer job, otherwise the
   * transfer is refused (unless `skipFolderGuard: true` is passed).
   */
  s3TransferFolderName?: InputMaybe<Scalars['String']['input']>;
  sendNewsletterSubscriptionEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendingDomain?: InputMaybe<Scalars['String']['input']>;
  sendingDomainVerified?: InputMaybe<Scalars['Boolean']['input']>;
  seoPublicationName?: InputMaybe<Scalars['String']['input']>;
  shippingCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  storyCommentsOnByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  titleTag?: InputMaybe<Scalars['String']['input']>;
  tollbitAnalyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStripeAccountDetailsInput = {
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  profileChangeNotificationEmail?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  type?: InputMaybe<StripeAccountType>;
};

export type UpdateSubscriptionGiftInput = {
  isActive: Scalars['Boolean']['input'];
  priceInCents: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type UpdateSubscriptionPlanInput = {
  adSettings?: InputMaybe<PlanAdSettings>;
  benefits?: InputMaybe<Scalars['AWSJSON']['input']>;
  clickSubscribeLinkOverrideMonthly?: InputMaybe<Scalars['String']['input']>;
  clickSubscribeLinkOverrideYearly?: InputMaybe<Scalars['String']['input']>;
  collectPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  collectShipping?: InputMaybe<Scalars['Boolean']['input']>;
  ctaMonthly?: InputMaybe<Scalars['String']['input']>;
  ctaYearly?: InputMaybe<Scalars['String']['input']>;
  monthlyPlanLabel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optionalMonthlyState?: InputMaybe<OptionalPriceState>;
  optionalProductDescription?: InputMaybe<Scalars['String']['input']>;
  optionalProductName?: InputMaybe<Scalars['String']['input']>;
  optionalYearlyState?: InputMaybe<OptionalPriceState>;
  planSummary?: InputMaybe<Scalars['String']['input']>;
  priceForMonthlyOptionalChoice?: InputMaybe<Scalars['Int']['input']>;
  priceForMonthlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  priceForYearlyOptionalChoice?: InputMaybe<Scalars['Int']['input']>;
  priceForYearlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  priceSubtitleMonthly?: InputMaybe<Scalars['String']['input']>;
  priceSubtitleYearly?: InputMaybe<Scalars['String']['input']>;
  printOnly?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  promoCouponIdMonthly?: InputMaybe<Scalars['ID']['input']>;
  promoCouponIdYearly?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
  stripeDescription?: InputMaybe<Scalars['String']['input']>;
  struckOutPriceForYearlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  struckOutpriceForMonthlyToggleChoice?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  yearlyPlanLabel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionPromoInput = {
  couponId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type UpdateWildcardRedirectInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  matchType?: InputMaybe<WildcardMatchType>;
  note?: InputMaybe<Scalars['String']['input']>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  preserveQuery?: InputMaybe<Scalars['Boolean']['input']>;
  preserveSuffix?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  ruleId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to update a workspace.
 * * If a field is not set it will not be modified,
 * * If a field is set to null, it will be removed.
 * To update the domainName, use the mutation connect / unconnect DomainForWorkspace
 */
export type UpdateWorkspaceInput = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<SiteLanguage>;
  name?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceUserInput = {
  /** New brand level roles  */
  brandGroups: Array<BrandGroupTypeInput>;
  /** username of the workspaceUser  */
  username: Scalars['String']['input'];
  /** New workspace level roles  */
  workspaceGroups: Array<WorkspaceGroup>;
  /** workspaceId of the workspaceUser  */
  workspaceId: Scalars['ID']['input'];
};

export type UpdateWorkspaceWritingRuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ruleText?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateWritingRuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ruleText?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  type: WritingRuleType;
};

export type UpdateWritingRuleSiteSettingInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type ValidateMirabelConnectionData = {
  __typename?: 'ValidateMirabelConnectionData';
  connectionValid: Scalars['Boolean']['output'];
  issues: Array<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type ValidateMirabelConnectionInput = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  tenant: Scalars['String']['input'];
};

export type ValidateMirabelConnectionResponse = {
  __typename?: 'ValidateMirabelConnectionResponse';
  data?: Maybe<ValidateMirabelConnectionData>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ValidateNavigaConnectionData = {
  __typename?: 'ValidateNavigaConnectionData';
  connectionValid: Scalars['Boolean']['output'];
  issues: Array<Scalars['String']['output']>;
  validatedSubscriptions: Array<ValidatedSubscriptionAssociation>;
};

export type ValidateNavigaConnectionInput = {
  password: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  subscriptionAssociations: Array<ValidateNavigaSubscriptionAssociationInput>;
  username: Scalars['String']['input'];
  wsdlUrl: Scalars['String']['input'];
};

export type ValidateNavigaConnectionResponse = {
  __typename?: 'ValidateNavigaConnectionResponse';
  data?: Maybe<ValidateNavigaConnectionData>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ValidateNavigaSubscriptionAssociationInput = {
  navigaPubId: Scalars['String']['input'];
  navigaRateId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
};

export type ValidatedSubscriptionAssociation = {
  __typename?: 'ValidatedSubscriptionAssociation';
  error?: Maybe<Scalars['String']['output']>;
  navigaPubId: Scalars['String']['output'];
  navigaRateId: Scalars['String']['output'];
  publicationName?: Maybe<Scalars['String']['output']>;
  stripeProductId: Scalars['String']['output'];
  subRateName?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type WeatherAdvisory = {
  __typename?: 'WeatherAdvisory';
  /** description of the advisory */
  description?: Maybe<Scalars['String']['output']>;
  /** expires of the advisory */
  expires?: Maybe<Scalars['String']['output']>;
  /** id of the advisory message */
  id?: Maybe<Scalars['String']['output']>;
  /** instructions of the advisory */
  instructions?: Maybe<Scalars['String']['output']>;
  /** Mesage to display */
  message: Scalars['String']['output'];
  /** timestamp of the advisory */
  timestamp?: Maybe<Scalars['String']['output']>;
  /** Hyperlink weather site */
  weatherSiteUrl: Scalars['String']['output'];
};

export type WeatherData = {
  __typename?: 'WeatherData';
  currentWeather: CurrentWeather;
  weatherAdvisory?: Maybe<WeatherAdvisory>;
  weatherSlots: Array<WeatherSlot>;
};

export type WeatherSlot = {
  __typename?: 'WeatherSlot';
  /** data formated as 'Sun 20' */
  date: Scalars['String']['output'];
  highTemp: Scalars['String']['output'];
  img: Scalars['String']['output'];
  lowTemp: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/**
 * Match strategy for a WildcardRedirectRule. v1 only supports PREFIX; reserved for
 * TEMPLATE / REGEX in future versions. Adding a new value is an additive change.
 */
export type WildcardMatchType =
  | 'PREFIX';

/**
 * A site-scoped redirect rule that matches many incoming paths at once. Evaluated
 * only when an exact-slug page lookup misses, so exact pages always take
 * precedence over wildcards.
 */
export type WildcardRedirectRule = {
  __typename?: 'WildcardRedirectRule';
  createdAt: Scalars['AWSDateTime']['output'];
  /** v1 PREFIX mode: literal destination path or URL, e.g. '/calendar/events/' */
  destination: Scalars['String']['output'];
  /** disabled rules are ignored at match time without being deleted */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  matchType: WildcardMatchType;
  /** free-form operator notes */
  note?: Maybe<Scalars['String']['output']>;
  /** if true, the status code will be 301, otherwise 302 */
  permanent: Scalars['Boolean']['output'];
  /** if true, the original query string is appended to the destination */
  preserveQuery: Scalars['Boolean']['output'];
  /** if true, the suffix after `source` is appended to `destination` */
  preserveSuffix: Scalars['Boolean']['output'];
  /** explicit tie-breaker when multiple rules could match; higher wins; null = unset */
  priority?: Maybe<Scalars['Int']['output']>;
  /** v1 PREFIX mode: the path prefix to match, e.g. '/events/' */
  source: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

/**
 * Workspace, it's the top level object that holds all the others.
 * Each user has a access to a number of workspaces through it's workspaceUser permissions
 */
export type Workspace = Node & {
  __typename?: 'Workspace';
  createdAt: Scalars['AWSDateTime']['output'];
  /**
   * The custom Domain for the workspace, has additional info about the domain including status.
   * It should always be available if the domainName is set
   */
  domain?: Maybe<Domain>;
  /** The custom domain name for the workspace, if present this workspace can be accessed at htps://${sdomain} */
  domainName?: Maybe<Scalars['String']['output']>;
  /**
   * Get a brand attached to this workspace by it's path.
   * Paths are unique on a workspace level but not on a global level so it is not possible to retrieve a brand by it's path only
   */
  getBrandByPath?: Maybe<Brand>;
  /** Get a feed for this workspace by it's id */
  getFeed?: Maybe<Feed>;
  /** Get a single user that has access to this workspace and their permissions */
  getWorkspaceUser?: Maybe<WorkspaceUser>;
  /** Unique id for the workspace, starts with work_ */
  id: Scalars['ID']['output'];
  /**
   * Default UI language for the workspace's sites. Absent means 'en'.
   * Changing it re-materializes the language of every site whose
   * languageFollowsWorkspace flag is set (or that never chose a language).
   */
  language?: Maybe<SiteLanguage>;
  /** List all the feeds for this workspace */
  listFeeds?: Maybe<FeedConnection>;
  /** List all the brands attached to this workspace */
  listWorkspaceBrands?: Maybe<BrandConnection>;
  /** List all the writing rules for this workspace */
  listWorkspaceWritingRules: Array<WorkspaceWritingRule>;
  /** Displayed name of the workspace */
  name: Scalars['String']['output'];
  /** The subdomain for the workspace, this workspace can be accessed at htps://${subdomain}.app.pubgen.ai */
  subdomain: Scalars['String']['output'];
  /** Workspace-level TollBit analytics configuration. */
  tollbitAnalytics?: Maybe<TollbitWorkspaceAnalytics>;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
};


/**
 * Workspace, it's the top level object that holds all the others.
 * Each user has a access to a number of workspaces through it's workspaceUser permissions
 */
export type WorkspaceGetBrandByPathArgs = {
  path: Scalars['String']['input'];
};


/**
 * Workspace, it's the top level object that holds all the others.
 * Each user has a access to a number of workspaces through it's workspaceUser permissions
 */
export type WorkspaceGetFeedArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Workspace, it's the top level object that holds all the others.
 * Each user has a access to a number of workspaces through it's workspaceUser permissions
 */
export type WorkspaceGetWorkspaceUserArgs = {
  username: Scalars['ID']['input'];
};


/**
 * Workspace, it's the top level object that holds all the others.
 * Each user has a access to a number of workspaces through it's workspaceUser permissions
 */
export type WorkspaceListFeedsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


/**
 * Workspace, it's the top level object that holds all the others.
 * Each user has a access to a number of workspaces through it's workspaceUser permissions
 */
export type WorkspaceListWorkspaceBrandsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

/**
 * Possible roles on the workspace level.
 * TODO: there should be a reference document explaining the available roles
 */
export type WorkspaceGroup =
  | 'Accounting'
  | 'Admin'
  | 'Builder'
  | 'Creator'
  | 'Guest'
  | 'None';

/** Represents the permissions a user has to a workspace. */
export type WorkspaceUser = Node & {
  __typename?: 'WorkspaceUser';
  /** Access on the brand level, permissions on this level are applied only on the specified brand */
  brandGroups: Array<BrandGroupType>;
  createdAt: Scalars['AWSDateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique id for the workspace, starts with wuser_ */
  id: Scalars['ID']['output'];
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  /** The username (email) for the user */
  username: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  /** Access on the workspace level, permissions on this level are applied to all brands of the workspace */
  workspaceGroups: Array<WorkspaceGroup>;
  /** The id of the workspace */
  workspaceId: Scalars['ID']['output'];
};

/**
 * If nextToken is set, it means all items were not returned by a query and more are available on the next page.
 * Retry the same operation with paginationInput.nextToken set to the returned nextToken to get next page
 */
export type WorkspaceUserConnection = {
  __typename?: 'WorkspaceUserConnection';
  items: Array<WorkspaceUser>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceWritingRule = {
  __typename?: 'WorkspaceWritingRule';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  level: WritingRuleLevelWorkspace;
  name: Scalars['String']['output'];
  ruleText: Scalars['String']['output'];
  type: WritingRuleType;
  workspaceId: Scalars['ID']['output'];
};

export type WritingRule = {
  __typename?: 'WritingRule';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  level?: Maybe<WritingRuleLevelSite>;
  name: Scalars['String']['output'];
  ruleText: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  type?: Maybe<WritingRuleType>;
};

export type WritingRuleLevelGlobal =
  | 'Global';

export type WritingRuleLevelSite =
  | 'Site';

export type WritingRuleLevelWorkspace =
  | 'Workspace';

/** Settings for a writing rule for a site */
export type WritingRuleSiteSetting = {
  __typename?: 'WritingRuleSiteSetting';
  active: Scalars['Boolean']['output'];
  globalRuleId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
  workspaceRuleId?: Maybe<Scalars['ID']['output']>;
};

export type WritingRuleSiteSettingLevel =
  | 'Global'
  | 'Workspace';

export type WritingRuleType =
  | 'Body'
  | 'Lead'
  | 'Title';

export type CreateAssetOutput = {
  __typename?: 'createAssetOutput';
  asset: Asset;
  signedUrl: Scalars['String']['output'];
};

export type SiteCategory =
  | 'Identity'
  | 'Playbook'
  | 'Publication';

type BlockDataFragment_BlockCards_Fragment = { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null };

type BlockDataFragment_BlockCoverImage_Fragment = { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null };

type BlockDataFragment_BlockFaq_Fragment = { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null };

type BlockDataFragment_BlockPubAccount_Fragment = { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null };

type BlockDataFragment_BlockPubAdHero_Fragment = { __typename: 'BlockPubAdHero', content?: any | null };

type BlockDataFragment_BlockPubArticleBody_Fragment = { __typename: 'BlockPubArticleBody', content?: any | null };

type BlockDataFragment_BlockPubArticleHeader_Fragment = { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null };

type BlockDataFragment_BlockPubArticlesBySection_Fragment = { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null };

type BlockDataFragment_BlockPubAuthorOverview_Fragment = { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null };

type BlockDataFragment_BlockPubBreakingNews_Fragment = { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null };

type BlockDataFragment_BlockPubEvents_Fragment = { __typename: 'BlockPubEvents', snippet?: string | null };

type BlockDataFragment_BlockPubExternalReferences_Fragment = { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> };

type BlockDataFragment_BlockPubGift_Fragment = { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null };

type BlockDataFragment_BlockPubHomeHero_Fragment = { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null };

type BlockDataFragment_BlockPubHomeTopStories_Fragment = { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null };

type BlockDataFragment_BlockPubLeadArticle_Fragment = { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null };

type BlockDataFragment_BlockPubMediaTopStories_Fragment = { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null };

type BlockDataFragment_BlockPubNewsletters_Fragment = { __typename: 'BlockPubNewsletters', snippet?: string | null };

type BlockDataFragment_BlockPubSearch_Fragment = { __typename: 'BlockPubSearch', snippet?: string | null };

type BlockDataFragment_BlockPubSectionMainView_Fragment = { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null };

type BlockDataFragment_BlockPubSectionRelatedArticlesEmphasisAuthors_Fragment = { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null };

type BlockDataFragment_BlockPubSectionsTopStory_Fragment = { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null };

type BlockDataFragment_BlockPubSpotlight_Fragment = { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null };

type BlockDataFragment_BlockPubSubscribe_Fragment = { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null };

type BlockDataFragment_BlockPubTagHeader_Fragment = { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null };

type BlockDataFragment_BlockPubThankYou_Fragment = { __typename: 'BlockPubThankYou', snippet?: string | null };

type BlockDataFragment_BlockPubWeatherAdvisory_Fragment = { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null };

type BlockDataFragment_BlockWysiwyg_Fragment = { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null };

export type BlockDataFragmentFragment = BlockDataFragment_BlockCards_Fragment | BlockDataFragment_BlockCoverImage_Fragment | BlockDataFragment_BlockFaq_Fragment | BlockDataFragment_BlockPubAccount_Fragment | BlockDataFragment_BlockPubAdHero_Fragment | BlockDataFragment_BlockPubArticleBody_Fragment | BlockDataFragment_BlockPubArticleHeader_Fragment | BlockDataFragment_BlockPubArticlesBySection_Fragment | BlockDataFragment_BlockPubAuthorOverview_Fragment | BlockDataFragment_BlockPubBreakingNews_Fragment | BlockDataFragment_BlockPubEvents_Fragment | BlockDataFragment_BlockPubExternalReferences_Fragment | BlockDataFragment_BlockPubGift_Fragment | BlockDataFragment_BlockPubHomeHero_Fragment | BlockDataFragment_BlockPubHomeTopStories_Fragment | BlockDataFragment_BlockPubLeadArticle_Fragment | BlockDataFragment_BlockPubMediaTopStories_Fragment | BlockDataFragment_BlockPubNewsletters_Fragment | BlockDataFragment_BlockPubSearch_Fragment | BlockDataFragment_BlockPubSectionMainView_Fragment | BlockDataFragment_BlockPubSectionRelatedArticlesEmphasisAuthors_Fragment | BlockDataFragment_BlockPubSectionsTopStory_Fragment | BlockDataFragment_BlockPubSpotlight_Fragment | BlockDataFragment_BlockPubSubscribe_Fragment | BlockDataFragment_BlockPubTagHeader_Fragment | BlockDataFragment_BlockPubThankYou_Fragment | BlockDataFragment_BlockPubWeatherAdvisory_Fragment | BlockDataFragment_BlockWysiwyg_Fragment;

type BlockTemplateDataFragment_BlockPubArticleRelatedArticles_Fragment = { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null };

type BlockTemplateDataFragment_BlockPubFooter_Fragment = { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null };

type BlockTemplateDataFragment_BlockPubHeaderMenu_Fragment = { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null };

type BlockTemplateDataFragment_BlockPubNavSqueeze_Fragment = { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null };

type BlockTemplateDataFragment_BlockPubPaywall_Fragment = { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null };

type BlockTemplateDataFragment_BlockPubPromo_Fragment = { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null };

export type BlockTemplateDataFragmentFragment = BlockTemplateDataFragment_BlockPubArticleRelatedArticles_Fragment | BlockTemplateDataFragment_BlockPubFooter_Fragment | BlockTemplateDataFragment_BlockPubHeaderMenu_Fragment | BlockTemplateDataFragment_BlockPubNavSqueeze_Fragment | BlockTemplateDataFragment_BlockPubPaywall_Fragment | BlockTemplateDataFragment_BlockPubPromo_Fragment;

export type ClientThemePropertiesFragmentFragment = { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } };

export type CreateDonationProductMutationVariables = Exact<{
  product: CreateDonationProductInput;
}>;


export type CreateDonationProductMutation = { __typename?: 'Mutation', createDonationProduct: { __typename?: 'DonationProduct', siteId: string, productId: string, name: string, isActive: boolean, stripeDescription: string, priceId: string, collectPhoneNumber?: boolean | null, minimumAmount?: number | null, maximumAmount?: number | null, defaultAmount?: number | null } };

export type UpdateDonationProductMutationVariables = Exact<{
  product: UpdateDonationProductInput;
}>;


export type UpdateDonationProductMutation = { __typename?: 'Mutation', updateDonationProduct: { __typename?: 'DonationProduct', siteId: string, productId: string, name: string, isActive: boolean, stripeDescription: string, priceId: string, collectPhoneNumber?: boolean | null, minimumAmount?: number | null, maximumAmount?: number | null, defaultAmount?: number | null } };

export type AddItemToCollectionsMutationVariables = Exact<{
  params: AddItemToCollectionsInput;
}>;


export type AddItemToCollectionsMutation = { __typename?: 'Mutation', addItemToCollections: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, metadata?: Array<string> | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string }> };

export type BulkApplySupportPlanAcrossWorkspaceMutationVariables = Exact<{
  input: BulkSupportPlanAcrossWorkspaceInput;
}>;


export type BulkApplySupportPlanAcrossWorkspaceMutation = { __typename?: 'Mutation', bulkApplySupportPlanAcrossWorkspace: { __typename?: 'BulkSupportPlanAcrossWorkspaceResult', email: string, action: BulkSupportPlanAction, results: Array<{ __typename?: 'BulkSupportPlanSiteResult', siteId: string, brandId: string, siteName?: string | null, status: BulkSupportPlanStatus, message?: string | null }> } };

export type BulkEditArticlesMutationVariables = Exact<{
  input: BulkEditArticlesInput;
}>;


export type BulkEditArticlesMutation = { __typename?: 'Mutation', bulkEditArticles: { __typename?: 'BulkEditArticlesResponse', jobId?: string | null, mode: BulkEditExecMode, results?: Array<{ __typename?: 'BulkEditArticleResult', pageId: string, status: BulkEditItemStatus, reason?: string | null }> | null } };

export type ChooseMailchimpListMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type ChooseMailchimpListMutation = { __typename?: 'Mutation', chooseMailchimpList: boolean };

export type ConnectGelatoAccountMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
}>;


export type ConnectGelatoAccountMutation = { __typename?: 'Mutation', connectGelatoAccount: { __typename?: 'Site', id: string, gelatoApiKey?: string | null, gelatoWebhookSecret?: string | null, gelatoActive?: boolean | null, gelatoNewsroomMarkupPercent?: number | null, gelatoEnabledProductTypes?: Array<string> | null } };

export type ConnectSiteToMailchimpMutationVariables = Exact<{
  params: ConnectSiteToMailchimpInput;
}>;


export type ConnectSiteToMailchimpMutation = { __typename?: 'Mutation', connectSiteToMailchimp: boolean };

export type ConnectStripeAccountMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type ConnectStripeAccountMutation = { __typename?: 'Mutation', connectStripeAccount: { __typename?: 'Site', id: string, name: string, version: number, updatedAt: string, siteCategory: SiteCategory, brandId: string, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, status: StripeAccountStatus, notificationEmail?: string | null, type?: StripeAccountType | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, struckOutpriceForMonthlyToggleChoice?: number | null, struckOutPriceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, stripeDescription: string, productId: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, promoCouponIdMonthly?: string | null, promoCouponIdYearly?: string | null }> } | null } };

export type CreateAccountLinkMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
  refreshUrl: Scalars['String']['input'];
}>;


export type CreateAccountLinkMutation = { __typename?: 'Mutation', createAccountLink: { __typename?: 'CreateAccountLinkResult', url?: string | null, status: StripeAccountStatus } };

export type CreateAssetMutationVariables = Exact<{
  asset: CreateAssetInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'createAssetOutput', signedUrl: string, asset: { __typename?: 'Asset', brandId: string, createdAt: string, id: string, imagePlaceholder?: string | null, key: string, name?: string | null, updatedAt: string, public: boolean, uploaded: boolean, usedIn: Array<string>, version: number, width?: number | null, height?: number | null } } };

export type CreateBlockMutationVariables = Exact<{
  block: CreateBlockInput;
}>;


export type CreateBlockMutation = { __typename?: 'Mutation', createBlock: { __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, id: string, gsk1: string, pageId: string, savedAt?: string | null, variant?: string | null, version: number, updatedAt: string, archivedAt?: string | null, state: PublishState, sk: string, siteId: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null } };

export type CreateBrandMutationVariables = Exact<{
  brand: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'Brand', id: string, version: number, createdAt: string, updatedAt: string, name: string, path: string, workspaceId: string, brandStyleId: string, listBrandSites?: { __typename?: 'SiteConnection', items: Array<{ __typename?: 'Site', id: string, name: string, domainName?: string | null, pubgenSubscription?: { __typename?: 'PubgenSubscription', id: string, status: StripeSubscriptionStatus } | null, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainCloudfront?: string | null, domainName: string, externalProvider: boolean, hostedZoneId?: string | null, nameServers: Array<string>, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null }> } | null } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  lookup: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  cancelUrl: Scalars['String']['input'];
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession: string };

export type CreateCollectionMutationVariables = Exact<{
  collection: CreateCollectionInput;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', createCollection: { __typename?: 'Collection', collectionId: string, name: string, siteId: string } };

export type CreateContextTemplateMutationVariables = Exact<{
  contextTemplate: CreateContextTemplateInput;
}>;


export type CreateContextTemplateMutation = { __typename?: 'Mutation', createContextTemplate: { __typename?: 'ContextTemplate', siteId: string, id: string, name: string, content: string, active: boolean } };

export type CreateCustomerPortalMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
}>;


export type CreateCustomerPortalMutation = { __typename?: 'Mutation', createCustomerPortal: string };

export type CreateExternalFeedMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  feed: CreateExternalFeedInput;
}>;


export type CreateExternalFeedMutation = { __typename?: 'Mutation', createExternalFeed: { __typename?: 'ExternalFeed', id: string } };

export type CreateFeaturedChatbotPromptMutationVariables = Exact<{
  prompt: CreateFeaturedChatbotPromptInput;
}>;


export type CreateFeaturedChatbotPromptMutation = { __typename?: 'Mutation', createFeaturedChatbotPrompt: { __typename?: 'FeaturedChatbotPrompt', siteId: string, prompt: string, active: boolean, label: string, category: FeaturedChatbotPromptCategory, pageType: FeaturedChatbotpageType } };

export type CreateFeedMutationVariables = Exact<{
  feed: CreateFeedInput;
}>;


export type CreateFeedMutation = { __typename?: 'Mutation', createFeed: { __typename?: 'Feed', id: string, workspaceId: string, name: string, description?: string | null, createdAt: string, updatedAt: string, webhooks?: Array<{ __typename?: 'FeedWebhook', url: string, active: boolean }> | null, filters?: Array<{ __typename?: 'FeedFilter', pattern: string, active: boolean }> | null } };

export type CreateNewsletterMutationVariables = Exact<{
  newsletter: NewsletterInput;
}>;


export type CreateNewsletterMutation = { __typename?: 'Mutation', createNewsletter: { __typename?: 'Newsletter', siteId: string, name: string, id: string } };

export type CreatePageMutationVariables = Exact<{
  page: CreatePageInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, version: number, createdAt: string, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null } };

export type CreatePersonaMutationVariables = Exact<{
  persona: CreatePersonaInput;
}>;


export type CreatePersonaMutation = { __typename?: 'Mutation', createPersona: { __typename?: 'Persona', siteId: string, id: string, name: string, description: string, answerStyle: string } };

export type CreatePublicPersonaMutationVariables = Exact<{
  persona: CreatePublicPersonaInput;
}>;


export type CreatePublicPersonaMutation = { __typename?: 'Mutation', createPublicPersona: { __typename?: 'PublicPersona', siteId: string, id: string, name: string, description: string, answerStyle: string, active: boolean } };

export type CreateQuestionMutationVariables = Exact<{
  question: CreateQuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion: { __typename?: 'Question', siteId: string, id: string, question: string, answer: string, questionKey: string, deprecated?: boolean | null } };

export type CreateSiteMutationVariables = Exact<{
  site: CreateSiteInput;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite: { __typename?: 'Site', brandId: string, createdAt: string, domainName?: string | null, id: string, name: string, updatedAt: string, version: number, domain?: { __typename?: 'Domain', createdAt: string, domainCloudfront?: string | null, domainName: string, hostedZoneId?: string | null, nameServers: Array<string>, externalProvider: boolean, domainCloudFormation?: string | null, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null, getBrand?: { __typename?: 'Brand', path: string, name: string, workspaceId: string, id: string } | null } };

export type CreateSubscriptionGiftMutationVariables = Exact<{
  gift: CreateSubscriptionGiftInput;
}>;


export type CreateSubscriptionGiftMutation = { __typename?: 'Mutation', createSubscriptionGift: { __typename?: 'SubscriptionGift', siteId: string, productId: string, priceId: string, planProductId: string, couponId: string, numberOfGiftedMonths: number, priceInCents: number, isActive: boolean } };

export type CreateSubscriptionPlanMutationVariables = Exact<{
  plan: CreateSubscriptionPlanInput;
}>;


export type CreateSubscriptionPlanMutation = { __typename?: 'Mutation', createSubscriptionPlan: { __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, collectPhoneNumber?: boolean | null, collectShipping?: boolean | null, adSettings?: PlanAdSettings | null, printOnly?: boolean | null, optionalProductId?: string | null, optionalProductName?: string | null, optionalProductDescription?: string | null, priceForMonthlyOptionalChoice?: number | null, priceForYearlyOptionalChoice?: number | null, optionalMonthlyState?: OptionalPriceState | null, optionalYearlyState?: OptionalPriceState | null, monthlyPlanLabel?: string | null, yearlyPlanLabel?: string | null } };

export type CreateSubscriptionPromoMutationVariables = Exact<{
  promo: CreateSubscriptionPromoInput;
}>;


export type CreateSubscriptionPromoMutation = { __typename?: 'Mutation', createSubscriptionPromo: { __typename?: 'SubscriptionPromo', siteId: string, couponId: string, name: string, percentageOff: number, durationInMonths: number } };

export type CreateWildcardRedirectMutationVariables = Exact<{
  input: CreateWildcardRedirectInput;
}>;


export type CreateWildcardRedirectMutation = { __typename?: 'Mutation', createWildcardRedirect: { __typename?: 'WildcardRedirectRule', id: string, matchType: WildcardMatchType, source: string, destination: string, preserveSuffix: boolean, preserveQuery: boolean, permanent: boolean, enabled: boolean, priority?: number | null, note?: string | null, createdAt: string, updatedAt: string } };

export type CreateWorkspaceMutationVariables = Exact<{
  workspace: CreateWorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace: { __typename?: 'CreateWorkspaceResponse', workspace: { __typename?: 'Workspace', createdAt: string, domainName?: string | null, id: string, name: string, subdomain: string, updatedAt: string, version: number, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainCloudfront?: string | null, domainName: string, externalProvider: boolean, hostedZoneId?: string | null, nameServers: Array<string>, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null }, workspaceUser: { __typename?: 'WorkspaceUser', id: string, version: number, createdAt: string, updatedAt: string, workspaceId: string, username: string, workspaceGroups: Array<WorkspaceGroup>, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } } };

export type CreateWorkspaceTollbitBucketMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type CreateWorkspaceTollbitBucketMutation = { __typename?: 'Mutation', createWorkspaceTollbitBucket: { __typename?: 'Workspace', id: string, tollbitAnalytics?: { __typename?: 'TollbitWorkspaceAnalytics', bucketName: string, bucketRegion: string, createdAt: string, updatedAt: string } | null } };

export type CreateWorkspaceUserMutationVariables = Exact<{
  workspaceUser: CreateWorkspaceUserInput;
}>;


export type CreateWorkspaceUserMutation = { __typename?: 'Mutation', createWorkspaceUser: { __typename?: 'CreateWorkspaceUserResponse', inviteLink?: string | null, workspaceUser: { __typename?: 'WorkspaceUser', id: string, version: number, createdAt: string, updatedAt: string, workspaceId: string, username: string, workspaceGroups: Array<WorkspaceGroup>, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } } };

export type CreateWorkspaceWritingRuleMutationVariables = Exact<{
  workspaceWritingRule: CreateWorkspaceWritingRuleInput;
}>;


export type CreateWorkspaceWritingRuleMutation = { __typename?: 'Mutation', createWorkspaceWritingRule: { __typename?: 'WorkspaceWritingRule', workspaceId: string, id: string, name: string, ruleText: string, active: boolean, type: WritingRuleType, level: WritingRuleLevelWorkspace } };

export type CreateWritingRuleMutationVariables = Exact<{
  writingRule: CreateWritingRuleInput;
}>;


export type CreateWritingRuleMutation = { __typename?: 'Mutation', createWritingRule: { __typename?: 'WritingRule', siteId: string, name: string, ruleText: string, active: boolean, type?: WritingRuleType | null } };

export type DeleteAssetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAssetMutation = { __typename?: 'Mutation', deleteAsset: { __typename?: 'Asset', brandId: string, createdAt: string, height?: number | null, id: string, imagePlaceholder?: string | null, key: string, name?: string | null, public: boolean, tags: Array<string>, type?: AssetType | null, updatedAt: string, uploaded: boolean, usedIn: Array<string>, version: number, width?: number | null } };

export type DeleteBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBlockMutation = { __typename?: 'Mutation', deleteBlock: { __typename?: 'Block', id: string } };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand: { __typename?: 'Brand', id: string, name: string } };

export type DeleteCollectionMutationVariables = Exact<{
  collection: DeleteCollectionInput;
}>;


export type DeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection: { __typename?: 'Collection', collectionId: string, name: string, siteId: string } };

export type DeleteContextTemplateMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  contextTemplateId: Scalars['ID']['input'];
}>;


export type DeleteContextTemplateMutation = { __typename?: 'Mutation', deleteContextTemplate: { __typename?: 'ContextTemplate', siteId: string, id: string, name: string, content: string, active: boolean } };

export type DeleteExternalFeedMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteExternalFeedMutation = { __typename?: 'Mutation', deleteExternalFeed: boolean };

export type DeleteFeaturedChatbotPromptMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  promptId: Scalars['ID']['input'];
}>;


export type DeleteFeaturedChatbotPromptMutation = { __typename?: 'Mutation', deleteFeaturedChatbotPrompt: { __typename?: 'FeaturedChatbotPrompt', siteId: string, id: string, prompt: string, active: boolean, label: string, category: FeaturedChatbotPromptCategory, pageType: FeaturedChatbotpageType } };

export type DeleteFeedMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteFeedMutation = { __typename?: 'Mutation', deleteFeed: { __typename?: 'Feed', id: string, workspaceId: string, name: string, description?: string | null, createdAt: string, updatedAt: string } };

export type DeleteNewsletterMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  newsletterId: Scalars['ID']['input'];
}>;


export type DeleteNewsletterMutation = { __typename?: 'Mutation', deleteNewsletter: { __typename?: 'Newsletter', siteId: string, name: string, id: string } };

export type DeletePageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage: { __typename?: 'Page', id: string, slug: string, sk: string } };

export type DeletePagesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePagesMutation = { __typename?: 'Mutation', deletePages: Array<{ __typename?: 'Page', id: string, slug: string, sk: string }> };

export type DeletePersonaMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  personaId: Scalars['ID']['input'];
}>;


export type DeletePersonaMutation = { __typename?: 'Mutation', deletePersona: { __typename?: 'Persona', siteId: string, id: string, name: string, description: string, answerStyle: string } };

export type DeletePublicPersonaMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  personaId: Scalars['ID']['input'];
}>;


export type DeletePublicPersonaMutation = { __typename?: 'Mutation', deletePublicPersona: { __typename?: 'PublicPersona', siteId: string, id: string, name: string, description: string, answerStyle: string, active: boolean } };

export type DeleteQuestionMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: { __typename?: 'Question', siteId: string, id: string, question: string, answer: string, questionKey: string, deprecated?: boolean | null } };

export type DeleteSiteMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite: { __typename?: 'Site', id: string, name: string } };

export type DeleteSubscriptionGiftMutationVariables = Exact<{
  gift: DeleteSubscriptionGiftInput;
}>;


export type DeleteSubscriptionGiftMutation = { __typename?: 'Mutation', deleteSubscriptionGift: { __typename?: 'SubscriptionGift', productId: string } };

export type DeleteSubscriptionPlanMutationVariables = Exact<{
  plan: DeleteSubscriptionPlanInput;
}>;


export type DeleteSubscriptionPlanMutation = { __typename?: 'Mutation', deleteSubscriptionPlan: { __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, collectPhoneNumber?: boolean | null, collectShipping?: boolean | null, adSettings?: PlanAdSettings | null, printOnly?: boolean | null, monthlyPlanLabel?: string | null, yearlyPlanLabel?: string | null } };

export type DeleteSubscriptionPromoMutationVariables = Exact<{
  promo: DeleteSubscriptionPromoInput;
}>;


export type DeleteSubscriptionPromoMutation = { __typename?: 'Mutation', deleteSubscriptionPromo: { __typename?: 'SubscriptionPromo', siteId: string, couponId: string, name: string, percentageOff: number, durationInMonths: number } };

export type DeleteWildcardRedirectMutationVariables = Exact<{
  input: DeleteWildcardRedirectInput;
}>;


export type DeleteWildcardRedirectMutation = { __typename?: 'Mutation', deleteWildcardRedirect: string };

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace: { __typename?: 'Workspace', name: string, id: string, subdomain: string, updatedAt: string } };

export type DeleteWorkspaceUserMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
}>;


export type DeleteWorkspaceUserMutation = { __typename?: 'Mutation', deleteWorkspaceUser: { __typename?: 'WorkspaceUser', id: string, version: number, createdAt: string, updatedAt: string, workspaceId: string, username: string, workspaceGroups: Array<WorkspaceGroup>, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } };

export type DeleteWorkspaceWritingRuleMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  workspaceWritingRuleId: Scalars['ID']['input'];
}>;


export type DeleteWorkspaceWritingRuleMutation = { __typename?: 'Mutation', deleteWorkspaceWritingRule: { __typename?: 'WorkspaceWritingRule', workspaceId: string, id: string, name: string, ruleText: string, active: boolean, type: WritingRuleType, level: WritingRuleLevelWorkspace } };

export type DeleteWritingRuleMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  writingRuleId: Scalars['ID']['input'];
}>;


export type DeleteWritingRuleMutation = { __typename?: 'Mutation', deleteWritingRule: { __typename?: 'WritingRule', siteId: string, id: string, name: string, ruleText: string, active: boolean, type?: WritingRuleType | null } };

export type DisconnectGelatoAccountMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type DisconnectGelatoAccountMutation = { __typename?: 'Mutation', disconnectGelatoAccount: { __typename?: 'Site', id: string, gelatoApiKey?: string | null, gelatoWebhookSecret?: string | null, gelatoActive?: boolean | null, gelatoNewsroomMarkupPercent?: number | null, gelatoEnabledProductTypes?: Array<string> | null } };

export type DisconnectSiteToMailchimpMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type DisconnectSiteToMailchimpMutation = { __typename?: 'Mutation', disconnectSiteToMailchimp: boolean };

export type DisconnectStripeAccountMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type DisconnectStripeAccountMutation = { __typename?: 'Mutation', disconnectStripeAccount: { __typename?: 'Site', id: string, name: string, version: number, updatedAt: string, siteCategory: SiteCategory, brandId: string, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, status: StripeAccountStatus, notificationEmail?: string | null, type?: StripeAccountType | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, struckOutpriceForMonthlyToggleChoice?: number | null, struckOutPriceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, stripeDescription: string, productId: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, promoCouponIdMonthly?: string | null, promoCouponIdYearly?: string | null }> } | null } };

export type DownloadApNewsStoryMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  apStoryId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
}>;


export type DownloadApNewsStoryMutation = { __typename?: 'Mutation', downloadAPNewsStory: { __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null } };

export type DuplicatePagesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DuplicatePagesMutation = { __typename?: 'Mutation', duplicatePages: Array<{ __typename?: 'Page', id: string, slug: string, sk: string, state: PublishState, pageCategory: PageCategory, siteId: string, brandId: string }> };

export type ExportChatbotConversationsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportChatbotConversationsMutation = { __typename?: 'Mutation', exportChatbotConversations: string };

export type ExportDisputesMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportDisputesMutation = { __typename?: 'Mutation', exportDisputes: string };

export type ExportEventsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  format: EventsExportFormat;
}>;


export type ExportEventsMutation = { __typename?: 'Mutation', exportEvents: string };

export type ExportGeneralLedgerRevenueExpenseMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportGeneralLedgerRevenueExpenseMutation = { __typename?: 'Mutation', exportGeneralLedgerRevenueExpense: string };

export type ExportMonthlyPayoutsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportMonthlyPayoutsMutation = { __typename?: 'Mutation', exportMonthlyPayouts: string };

export type ExportMonthlyRevenueByProductMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportMonthlyRevenueByProductMutation = { __typename?: 'Mutation', exportMonthlyRevenueByProduct: string };

export type ExportPagesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type?: InputMaybe<ExportPageType>;
}>;


export type ExportPagesMutation = { __typename?: 'Mutation', exportPages: { __typename?: 'ExportPagesResponse', type?: JobResultType | null, url?: string | null } };

export type ExportPromotionalCreditsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportPromotionalCreditsMutation = { __typename?: 'Mutation', exportPromotionalCredits: string };

export type ExportRefundsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportRefundsMutation = { __typename?: 'Mutation', exportRefunds: string };

export type ExportSubscriberActivityMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  eventTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportSubscriberActivityMutation = { __typename?: 'Mutation', exportSubscriberActivity: string };

export type ExportSubscriberFulfillmentMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<StripeSubscriptionStatus>;
}>;


export type ExportSubscriberFulfillmentMutation = { __typename?: 'Mutation', exportSubscriberFulfillment: string };

export type ExportSubscriberFulfillmentPeriodMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  products?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<StripeSubscriptionStatus>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportSubscriberFulfillmentPeriodMutation = { __typename?: 'Mutation', exportSubscriberFulfillmentPeriod: string };

export type ExportSubscriptionAdjustmentsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportSubscriptionAdjustmentsMutation = { __typename?: 'Mutation', exportSubscriptionAdjustments: string };

export type ExportTransactionDataMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportTransactionDataMutation = { __typename?: 'Mutation', exportTransactionData: string };

export type ExportUnearnedRevenueMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportUnearnedRevenueMutation = { __typename?: 'Mutation', exportUnearnedRevenue: string };

export type ExportUserDataMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ExportUserDataMutation = { __typename?: 'Mutation', exportUserData: string };

export type ExportUserSignupsSessionsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportUserSignupsSessionsMutation = { __typename?: 'Mutation', exportUserSignupsSessions: string };

export type GenerateArticleBodyMutationVariables = Exact<{
  generateArticle: GenerateArticle;
}>;


export type GenerateArticleBodyMutation = { __typename?: 'Mutation', generateArticleBody: string };

export type GenerateArticleHeadlineMutationVariables = Exact<{
  body: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type GenerateArticleHeadlineMutation = { __typename?: 'Mutation', generateArticleHeadline: string };

export type GenerateArticleLeadMutationVariables = Exact<{
  body: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type GenerateArticleLeadMutation = { __typename?: 'Mutation', generateArticleLead: string };

export type GenerateBlogMutationVariables = Exact<{
  generateBlog: GenerateBlog;
}>;


export type GenerateBlogMutation = { __typename?: 'Mutation', generateBlog: string };

export type GenerateImageMutationVariables = Exact<{
  generateImage: GenerateImageInput;
}>;


export type GenerateImageMutation = { __typename?: 'Mutation', generateImage: string };

export type GenerateSectionSuggestionMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  availableSections: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateSectionSuggestionMutation = { __typename?: 'Mutation', generateSectionSuggestion: string };

export type GenerateSignInCodeMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type GenerateSignInCodeMutation = { __typename?: 'Mutation', generateSignInCode: string };

export type GenerateSignInLinkMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type GenerateSignInLinkMutation = { __typename?: 'Mutation', generateSignInLink: string };

export type GenerateTagsSuggestionMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  availableTags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateTagsSuggestionMutation = { __typename?: 'Mutation', generateTagsSuggestion: Array<string> };

export type ImportExternalFeedNowMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
}>;


export type ImportExternalFeedNowMutation = { __typename?: 'Mutation', importExternalFeedNow: { __typename?: 'ImportFeedResult', success: boolean, articlesCreated: number, skipped: number, errors: number, articles: Array<{ __typename?: 'ImportedArticle', title: string, url: string }> } };

export type ImportPagesMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  zipAssetKey: Scalars['String']['input'];
}>;


export type ImportPagesMutation = { __typename?: 'Mutation', importPages: { __typename?: 'ImportPagesResponse', type?: JobResultType | null, pages: Array<{ __typename?: 'Page', id: string, brandId: string, createdAt: string, gsk1: string, gsk2: string, pageCategory: PageCategory, savedAt?: string | null, sk: string, siteId: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number }> } };

export type ImportSingleFeedItemMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  feedId: Scalars['ID']['input'];
  itemId: Scalars['String']['input'];
}>;


export type ImportSingleFeedItemMutation = { __typename?: 'Mutation', importSingleFeedItem: { __typename?: 'ImportFeedResult', success: boolean, articlesCreated: number, articlesUpdated: number, skipped: number, errors: number, articles: Array<{ __typename?: 'ImportedArticle', title: string, url: string }> } };

export type OrderSubscriptionPlansMutationVariables = Exact<{
  planIds: OrderSubscriptionPlansInput;
}>;


export type OrderSubscriptionPlansMutation = { __typename?: 'Mutation', orderSubscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, collectPhoneNumber?: boolean | null, collectShipping?: boolean | null, adSettings?: PlanAdSettings | null, printOnly?: boolean | null, monthlyPlanLabel?: string | null, yearlyPlanLabel?: string | null }> };

export type PublishBlockTemplateMutationVariables = Exact<{
  pageTemplate: PublishPublishedNodeInput;
}>;


export type PublishBlockTemplateMutation = { __typename?: 'Mutation', publishBlockTemplate: { __typename?: 'BlockTemplate', blockCategory: BlockTemplateCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, id: string, publishedAt?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, variant?: string | null, version: number, data?: { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null } | { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null } | { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null } | { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null } | { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null } | { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null } | null } };

export type PublishBlockTemplatesMutationVariables = Exact<{
  input: Array<PublishPublishedNodeInput> | PublishPublishedNodeInput;
}>;


export type PublishBlockTemplatesMutation = { __typename?: 'Mutation', publishBlockTemplates: Array<{ __typename?: 'BlockTemplate', blockCategory: BlockTemplateCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, id: string, publishedAt?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, variant?: string | null, version: number, data?: { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null } | { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null } | { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null } | { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null } | { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null } | { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null } | null }> };

export type PublishPageMutationVariables = Exact<{
  page: PublishPublishedNodeInput;
}>;


export type PublishPageMutation = { __typename?: 'Mutation', publishPage: { __typename?: 'Page', brandId: string, createdAt: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, publishedAt?: string | null, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, version: number } };

export type PublishPagesToFeedsMutationVariables = Exact<{
  params: PublishPagesToFeedsInput;
}>;


export type PublishPagesToFeedsMutation = { __typename?: 'Mutation', publishPagesToFeeds: Array<{ __typename?: 'Page', id: string, sk: string, slug: string, pageCategory: PageCategory }> };

export type RemoveEmailSuppressionMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type RemoveEmailSuppressionMutation = { __typename?: 'Mutation', removeEmailSuppression: boolean };

export type RemoveItemFromCollectionsMutationVariables = Exact<{
  params: RemoveItemFromCollectionsInput;
}>;


export type RemoveItemFromCollectionsMutation = { __typename?: 'Mutation', removeItemFromCollections: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string }> };

export type RemoveItemsFromCollectionMutationVariables = Exact<{
  params: RemoveItemsFromCollectionInput;
}>;


export type RemoveItemsFromCollectionMutation = { __typename?: 'Mutation', removeItemsFromCollection: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string }> };

export type ResendInvitationEmailMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
}>;


export type ResendInvitationEmailMutation = { __typename?: 'Mutation', resendInvitationEmail: { __typename?: 'CreateWorkspaceUserResponse', inviteLink?: string | null, workspaceUser: { __typename?: 'WorkspaceUser', id: string, version: number, createdAt: string, updatedAt: string, workspaceId: string, username: string, workspaceGroups: Array<WorkspaceGroup>, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } } };

export type RevertPageMutationVariables = Exact<{
  param: RevertPublishedNodeInput;
}>;


export type RevertPageMutation = { __typename?: 'Mutation', revertPage: { __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null } };

export type RotateGelatoWebhookSecretMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type RotateGelatoWebhookSecretMutation = { __typename?: 'Mutation', rotateGelatoWebhookSecret: { __typename?: 'Site', id: string, gelatoApiKey?: string | null, gelatoWebhookSecret?: string | null, gelatoActive?: boolean | null, gelatoNewsroomMarkupPercent?: number | null, gelatoEnabledProductTypes?: Array<string> | null } };

export type SavePageMutationVariables = Exact<{
  param: SavePublishedNodeInput;
}>;


export type SavePageMutation = { __typename?: 'Mutation', savePage: { __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null } };

export type SendChatMessageMutationVariables = Exact<{
  params: SendChatMessageInput;
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: string };

export type SetApNewsTokenMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
}>;


export type SetApNewsTokenMutation = { __typename?: 'Mutation', setAPNewsToken: { __typename?: 'Site', brandId: string } };

export type SetCustomerPortalConfigurationMutationVariables = Exact<{
  input: SetCustomerPortalConfigurationInput;
}>;


export type SetCustomerPortalConfigurationMutation = { __typename?: 'Mutation', setCustomerPortalConfiguration: { __typename?: 'Site', id: string, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, customerPortalConfig?: { __typename?: 'CustomerPortalConfig', id?: string | null, enabled: boolean, isDefault?: boolean | null, active?: boolean | null, allowPaymentMethodUpdate?: boolean | null, allowCancellation?: boolean | null, allowPlanSwitching?: boolean | null, switchablePrices?: Array<string> | null } | null } | null } };

export type UnpublishPageMutationVariables = Exact<{
  page: UnpublishPublishedNodeInput;
}>;


export type UnpublishPageMutation = { __typename?: 'Mutation', unpublishPage: { __typename?: 'Page', brandId: string, createdAt: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, publishedAt?: string | null, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, version: number } };

export type UpdateApNewsTopicMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  topic: ApNewsTopicInput;
}>;


export type UpdateApNewsTopicMutation = { __typename?: 'Mutation', updateAPNewsTopic: { __typename?: 'APNewsTopic', id: number, name: string, pricing: ApNewsPricing, feedLink: string, active?: boolean | null, sectionId?: string | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, display?: ExternalDisplay | null, imgRequired?: boolean | null } };

export type UpdateAssetMutationVariables = Exact<{
  asset: UpdateAssetInput;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', updateAsset: { __typename?: 'Asset', brandId: string, createdAt: string, height?: number | null, id: string, imagePlaceholder?: string | null, key: string, name?: string | null, public: boolean, tags: Array<string>, type?: AssetType | null, updatedAt: string, uploaded: boolean, usedIn: Array<string>, version: number, width?: number | null } };

export type UpdateBlockMutationVariables = Exact<{
  updateBlockInput: UpdateBlockInput;
}>;


export type UpdateBlockMutation = { __typename?: 'Mutation', updateBlock: { __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null } };

export type UpdateBlockTemplateMutationVariables = Exact<{
  updateBlockTemplateInput: UpdateBlockTemplateInput;
}>;


export type UpdateBlockTemplateMutation = { __typename?: 'Mutation', updateBlockTemplate: { __typename?: 'BlockTemplate', blockCategory: BlockTemplateCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, id: string, publishedAt?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, variant?: string | null, version: number, data?: { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null } | { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null } | { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null } | { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null } | { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null } | { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null } | null } };

export type UpdateBlockTemplatesMutationVariables = Exact<{
  input: Array<UpdateBlockTemplateInput> | UpdateBlockTemplateInput;
}>;


export type UpdateBlockTemplatesMutation = { __typename?: 'Mutation', updateBlockTemplates: Array<{ __typename?: 'BlockTemplate', blockCategory: BlockTemplateCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, id: string, publishedAt?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, variant?: string | null, version: number, data?: { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null } | { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null } | { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null } | { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null } | { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null } | { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null } | null }> };

export type UpdateBlocksMutationVariables = Exact<{
  updateBlocksInput: Array<UpdateBlockInput> | UpdateBlockInput;
}>;


export type UpdateBlocksMutation = { __typename?: 'Mutation', updateBlocks: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> };

export type UpdateBrandMutationVariables = Exact<{
  brand: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'Brand', id: string, version: number, createdAt: string, updatedAt: string, name: string, path: string, workspaceId: string, brandStyleId: string } };

export type UpdateBrandStyleMutationVariables = Exact<{
  brandStyle: UpdateBrandStyleInput;
}>;


export type UpdateBrandStyleMutation = { __typename?: 'Mutation', updateBrandStyle: { __typename?: 'BrandStyle', brandId: string, createdAt: string, id: string, updatedAt: string, version: number, properties: { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } } } };

export type UpdateCollectionMutationVariables = Exact<{
  collection: UpdateCollectionInput;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'Collection', collectionId: string, name: string, siteId: string, listCollectionItems?: { __typename?: 'CollectionItemConnection', items: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string, metadata?: Array<string> | null }> } | null } };

export type UpdateCollectionItemMutationVariables = Exact<{
  params: UpdateCollectionItemInput;
}>;


export type UpdateCollectionItemMutation = { __typename?: 'Mutation', updateCollectionItem: { __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string, metadata?: Array<string> | null } };

export type ConnectDomainForSiteMutationVariables = Exact<{
  domainName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type ConnectDomainForSiteMutation = { __typename?: 'Mutation', connectDomainForSite: { __typename?: 'Site', brandId: string, createdAt: string, domainName?: string | null, id: string, name: string, updatedAt: string, version: number, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainCloudfront?: string | null, domainName: string, externalProvider: boolean, hostedZoneId?: string | null, nameServers: Array<string>, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null } };

export type UpdateContextTemplateMutationVariables = Exact<{
  contextTemplate: UpdateContextTemplateInput;
}>;


export type UpdateContextTemplateMutation = { __typename?: 'Mutation', updateContextTemplate: { __typename?: 'ContextTemplate', siteId: string, id: string, name: string, content: string, active: boolean } };

export type UpdateExternalFeedMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  feed: UpdateExternalFeedInput;
}>;


export type UpdateExternalFeedMutation = { __typename?: 'Mutation', updateExternalFeed: { __typename?: 'ExternalFeed', id: string } };

export type UpdateFeaturedChatbotPromptMutationVariables = Exact<{
  prompt: UpdateFeaturedChatbotPromptInput;
}>;


export type UpdateFeaturedChatbotPromptMutation = { __typename?: 'Mutation', updateFeaturedChatbotPrompt: { __typename?: 'FeaturedChatbotPrompt', siteId: string, id: string, prompt: string, active: boolean, label: string, category: FeaturedChatbotPromptCategory, pageType: FeaturedChatbotpageType } };

export type UpdateFeedMutationVariables = Exact<{
  feed: UpdateFeedInput;
}>;


export type UpdateFeedMutation = { __typename?: 'Mutation', updateFeed: { __typename?: 'Feed', id: string, workspaceId: string, name: string, description?: string | null, createdAt: string, updatedAt: string, webhooks?: Array<{ __typename?: 'FeedWebhook', url: string, active: boolean }> | null, filters?: Array<{ __typename?: 'FeedFilter', pattern: string, active: boolean }> | null } };

export type UpdateFeedSiteSubscriptionsMutationVariables = Exact<{
  feedSiteSubscriptions: UpdateFeedSiteSubscriptionsInput;
}>;


export type UpdateFeedSiteSubscriptionsMutation = { __typename?: 'Mutation', updateFeedSiteSubscriptions: Array<{ __typename?: 'FeedSiteSubscription', workspaceId: string, feedId: string, siteId: string, active?: boolean | null, name: string, description?: string | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, section?: string | null, createdAt: string, updatedAt: string, tags?: Array<string> | null }> };

export type UpdateGelatoActiveMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateGelatoActiveMutation = { __typename?: 'Mutation', updateGelatoActive: { __typename?: 'Site', id: string, gelatoApiKey?: string | null, gelatoActive?: boolean | null, gelatoNewsroomMarkupPercent?: number | null, gelatoEnabledProductTypes?: Array<string> | null } };

export type UpdateNewsletterMutationVariables = Exact<{
  newsletter: NewsletterInput;
}>;


export type UpdateNewsletterMutation = { __typename?: 'Mutation', updateNewsletter: { __typename?: 'Newsletter', siteId: string, name: string, description?: string | null, id: string, order?: number | null } };

export type UpdateNewslettersMutationVariables = Exact<{
  newsletters: Array<NewsletterInput> | NewsletterInput;
}>;


export type UpdateNewslettersMutation = { __typename?: 'Mutation', updateNewsletters: Array<{ __typename?: 'Newsletter', siteId: string, name: string, description?: string | null, id: string, order?: number | null }> };

export type UpdatePageMutationVariables = Exact<{
  page: UpdatePageInput;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage: { __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, seoImageSrc?: string | null, seoImageWidth?: number | null, seoImageHeight?: number | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null } };

export type UpdatePageSlugMutationVariables = Exact<{
  page: UpdatePageSlugInput;
}>;


export type UpdatePageSlugMutation = { __typename?: 'Mutation', updatePageSlug: { __typename?: 'Page', id: string, brandId: string, createdAt: string, gsk1: string, gsk2: string, pageCategory: PageCategory, savedAt?: string | null, sk: string, siteId: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number } };

export type UpdatePersonaMutationVariables = Exact<{
  persona: UpdatePersonaInput;
}>;


export type UpdatePersonaMutation = { __typename?: 'Mutation', updatePersona: { __typename?: 'Persona', siteId: string, id: string, name: string, description: string, answerStyle: string } };

export type UpdatePublicPersonaMutationVariables = Exact<{
  persona: UpdatePublicPersonaInput;
}>;


export type UpdatePublicPersonaMutation = { __typename?: 'Mutation', updatePublicPersona: { __typename?: 'PublicPersona', siteId: string, id: string, name: string, description: string, answerStyle: string, active: boolean } };

export type UpdateQuestionMutationVariables = Exact<{
  question: UpdateQuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion: { __typename?: 'Question', siteId: string, id: string, question: string, answer: string, questionKey: string, deprecated?: boolean | null } };

export type UpdateRegisteredUserMutationVariables = Exact<{
  params: UpdateRegisteredUserInput;
}>;


export type UpdateRegisteredUserMutation = { __typename?: 'Mutation', updateRegisteredUser: { __typename?: 'Subscriber', id: string, email: string, legacyPassword?: string | null, legacyUsername?: string | null, phoneNumber?: string | null, shippingAddress?: { __typename?: 'ShippingAddress', firstName?: string | null, lastName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } };

export type UpdateSiteMutationVariables = Exact<{
  site: UpdateSiteInput;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite: { __typename?: 'Site', id: string, brandId: string, name: string, favicon?: string | null, protected?: boolean | null, chatOpenByDefault?: boolean | null, version: number, updatedAt: string, createdAt: string, domainName?: string | null, siteCategory: SiteCategory, defaultArticleAccess?: Paywall | null, defaultArticleExternalDisplay?: ExternalDisplay | null, defaultMetadata?: Array<string> | null, disableStoryGeneration?: boolean | null, disableTitleGeneration?: boolean | null, disableLeadGeneration?: boolean | null, disableCmsChatbot?: boolean | null, emailServiceAutoTagSignedIn?: boolean | null, emailServiceAutoTagSubscribed?: boolean | null, sendNewsletterSubscriptionEmail?: boolean | null, newsletterProvider?: NewsletterProvider | null, tollbitAnalyticsEnabled?: boolean | null, newspapersDotComTPAKey?: string | null, newspapersDotComSubdomain?: string | null, chatbotMinimizedDisplayName?: string | null, adTxtContent?: string | null, adSystem?: AdvertisementSystem | null, playWirePubId?: string | null, playWireWebId?: string | null, shippingCountries?: Array<string> | null, emailCapture?: { __typename?: 'EmailCapture', title?: string | null, subtitle?: string | null, newsletterId?: string | null, customNewsletterId?: string | null } | null, newzwareAccount?: { __typename?: 'NewzwareAccount', active?: boolean | null, instanceUrl?: string | null, site?: string | null, editionCode?: string | null } | null, engageAccount?: { __typename?: 'EngageAccount', active?: boolean | null, configScript?: string | null, subscribeUrl?: string | null, accountUrl?: string | null } | null, mirabelAccount?: { __typename?: 'MirabelAccount', active?: boolean | null, baseUrl?: string | null, tenant?: string | null, apiKey?: string | null } | null, makeItFreeAccount?: { __typename?: 'MakeItFreeAccount', active?: boolean | null, publisherId?: string | null, apiKey?: string | null } | null, connectedIzootoAccount?: { __typename?: 'IzootoAccount', active: boolean, scriptId?: string | null } | null, navigaAccount?: { __typename?: 'NavigaAccount', username?: string | null, password?: string | null, wsdlUrl?: string | null, active?: boolean | null, navigaSubscriptionAssociation?: Array<{ __typename?: 'NavigaSubscriptionAssociation', stripeProductId: string, navigaPubId: string }> | null } | null, imgPlaceholder?: { __typename?: 'ImgPlaceholder', src?: string | null, width?: number | null, height?: number | null } | null, metadataImage?: { __typename?: 'MetadataImage', src?: string | null, width?: number | null, height?: number | null } | null, chatbotImage?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null, aiSettings?: { __typename?: 'AISettings', journalistType?: JournalistType | null, audienceType?: string | null, blogType?: string | null, primaryPersona?: string | null, publicPrimaryPersona?: string | null, greetingMessage?: string | null } | null, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string }, menus?: Array<{ __typename?: 'Menu', id: string, name: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, type?: MenuItemType | null, menuIds?: Array<string> | null }> | null }> | null, googleTagAds?: { __typename?: 'GoogleTagAds', verticalHeaderScript?: string | null, vertical2HeaderScript?: string | null, horizontal1HeaderScript?: string | null, horizontal2HeaderScript?: string | null, footerHeaderScript?: string | null, adHeroHeaderScript?: string | null } | null, customAds?: { __typename?: 'CustomAds', blockPubHeaderMenu?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSearch?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleBody?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubLatestArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubAuthorRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubTagRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubHomeTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockEmailCapture?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd1?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd2?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | null, getBrand?: { __typename?: 'Brand', id: string, brandStyleId: string, createdAt: string, version: number, updatedAt: string, name: string, path: string, getBrandStyle?: { __typename?: 'BrandStyle', id: string, brandId: string, createdAt: string, updatedAt: string, version: number, properties: { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } } } | null, listBrandStyles?: { __typename?: 'BrandStyleConnection', items: Array<{ __typename?: 'BrandStyle', brandId: string, createdAt: string, id: string, version: number, updatedAt: string, properties: { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } } }> } | null } | null, companyInfo?: { __typename?: 'CompanyInfo', cityName?: string | null, countyCode?: string | null, mainEmail?: string | null, mainPhoneNumber?: string | null, noaaGridPoint?: string | null, supportEmail?: string | null, supportPhoneNumber?: string | null, timeZone?: string | null, sendSubscriptionLifecycleEmailsToCustomer?: boolean | null, coordinates?: { __typename?: 'Coordinates', lat?: number | null, lng?: number | null } | null } | null } };

export type UpdateStripeAccountDetailsMutationVariables = Exact<{
  details: UpdateStripeAccountDetailsInput;
}>;


export type UpdateStripeAccountDetailsMutation = { __typename?: 'Mutation', updateStripeAccountDetails: { __typename?: 'Site', id: string, name: string, version: number, updatedAt: string, siteCategory: SiteCategory, brandId: string, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, status: StripeAccountStatus, notificationEmail?: string | null, profileChangeNotificationEmail?: string | null, type?: StripeAccountType | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, struckOutpriceForMonthlyToggleChoice?: number | null, struckOutPriceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, stripeDescription: string, productId: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, promoCouponIdMonthly?: string | null, promoCouponIdYearly?: string | null }> } | null } };

export type UpdateSubscriptionGiftMutationVariables = Exact<{
  gift: UpdateSubscriptionGiftInput;
}>;


export type UpdateSubscriptionGiftMutation = { __typename?: 'Mutation', updateSubscriptionGift: { __typename?: 'SubscriptionGift', siteId: string, productId: string, priceId: string, planProductId: string, couponId: string, numberOfGiftedMonths: number, priceInCents: number, isActive: boolean } };

export type UpdateSubscriptionPlanMutationVariables = Exact<{
  plan: UpdateSubscriptionPlanInput;
}>;


export type UpdateSubscriptionPlanMutation = { __typename?: 'Mutation', updateSubscriptionPlan: { __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, collectShipping?: boolean | null, collectPhoneNumber?: boolean | null, adSettings?: PlanAdSettings | null, printOnly?: boolean | null, optionalProductId?: string | null, optionalProductName?: string | null, optionalProductDescription?: string | null, priceForMonthlyOptionalChoice?: number | null, priceForYearlyOptionalChoice?: number | null, optionalMonthlyState?: OptionalPriceState | null, optionalYearlyState?: OptionalPriceState | null, monthlyPlanLabel?: string | null, yearlyPlanLabel?: string | null } };

export type UpdateSubscriptionPromoMutationVariables = Exact<{
  promo: UpdateSubscriptionPromoInput;
}>;


export type UpdateSubscriptionPromoMutation = { __typename?: 'Mutation', updateSubscriptionPromo: { __typename?: 'SubscriptionPromo', siteId: string, couponId: string, name: string, percentageOff: number, durationInMonths: number } };

export type UnconnectDomainForSiteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnconnectDomainForSiteMutation = { __typename?: 'Mutation', unconnectDomainForSite: { __typename?: 'Site', brandId: string, createdAt: string, domainName?: string | null, id: string, name: string, updatedAt: string, version: number, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainName: string, externalProvider: boolean, domainCloudfront?: string | null, hostedZoneId?: string | null, nameServers: Array<string>, updatedAt: string, operationId?: string | null, siteId?: string | null, status: DomainStatus, workspaceId?: string | null } | null } };

export type UpdateWildcardRedirectMutationVariables = Exact<{
  input: UpdateWildcardRedirectInput;
}>;


export type UpdateWildcardRedirectMutation = { __typename?: 'Mutation', updateWildcardRedirect: { __typename?: 'WildcardRedirectRule', id: string, matchType: WildcardMatchType, source: string, destination: string, preserveSuffix: boolean, preserveQuery: boolean, permanent: boolean, enabled: boolean, priority?: number | null, note?: string | null, createdAt: string, updatedAt: string } };

export type UpdateWorkspaceMutationVariables = Exact<{
  workspace: UpdateWorkspaceInput;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'Mutation', updateWorkspace: { __typename?: 'Workspace', id: string, name: string, subdomain: string, language?: SiteLanguage | null, updatedAt: string, version: number } };

export type UpdateWorkspaceUserMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
  workspaceGroups: Array<WorkspaceGroup> | WorkspaceGroup;
  brandGroups: Array<BrandGroupTypeInput> | BrandGroupTypeInput;
}>;


export type UpdateWorkspaceUserMutation = { __typename?: 'Mutation', updateWorkspaceUser: { __typename?: 'WorkspaceUser', createdAt: string, firstName?: string | null, id: string, lastName?: string | null, isConfirmed?: boolean | null, updatedAt: string, username: string, version: number, workspaceId: string, workspaceGroups: Array<WorkspaceGroup>, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } };

export type UpdateWorkspaceWritingRuleMutationVariables = Exact<{
  workspaceWritingRule: UpdateWorkspaceWritingRuleInput;
}>;


export type UpdateWorkspaceWritingRuleMutation = { __typename?: 'Mutation', updateWorkspaceWritingRule: { __typename?: 'WorkspaceWritingRule', workspaceId: string, id: string, name: string, ruleText: string, active: boolean, type: WritingRuleType, level: WritingRuleLevelWorkspace } };

export type UpdateWritingRuleMutationVariables = Exact<{
  writingRule: UpdateWritingRuleInput;
}>;


export type UpdateWritingRuleMutation = { __typename?: 'Mutation', updateWritingRule: { __typename?: 'WritingRule', siteId: string, id: string, name: string, ruleText: string, active: boolean, type?: WritingRuleType | null } };

export type CreateSegmentMutationVariables = Exact<{
  segment: SegmentInput;
}>;


export type CreateSegmentMutation = { __typename?: 'Mutation', createSegment: { __typename?: 'Segment', id: string, siteId: string, name: string, description?: string | null, rulesJson?: any | null } };

export type UpdateSegmentMutationVariables = Exact<{
  segment: SegmentInput;
}>;


export type UpdateSegmentMutation = { __typename?: 'Mutation', updateSegment: { __typename?: 'Segment', id: string, siteId: string, name: string, description?: string | null, rulesJson?: any | null } };

export type DeleteSegmentMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
}>;


export type DeleteSegmentMutation = { __typename?: 'Mutation', deleteSegment: boolean };

export type UpsertContactMutationVariables = Exact<{
  contact: ContactInput;
}>;


export type UpsertContactMutation = { __typename?: 'Mutation', upsertContact: { __typename?: 'Contact', id: string, siteId: string, email: string, firstName?: string | null, lastName?: string | null, tags?: Array<string> | null, subscribedNewsletterIds?: Array<string> | null, status: ContactStatus, source: ContactSource } };

export type DeleteContactMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: boolean };

export type BulkSetContactStatusMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  status: ContactStatus;
}>;


export type BulkSetContactStatusMutation = { __typename?: 'Mutation', bulkSetContactStatus: number };

export type BulkDeleteContactsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkDeleteContactsMutation = { __typename?: 'Mutation', bulkDeleteContacts: number };

export type BulkUpdateContactTagsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  addTags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  removeTags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BulkUpdateContactTagsMutation = { __typename?: 'Mutation', bulkUpdateContactTags: number };

export type ImportContactsCsvMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ImportContactsCsvMutation = { __typename?: 'Mutation', importContactsCsv: { __typename?: 'ContactCsvImportTarget', uploadUrl: string, jobId: string, s3Key: string } };

export type FinalizeContactsCsvImportMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FinalizeContactsCsvImportMutation = { __typename?: 'Mutation', finalizeContactsCsvImport: number };

export type ListAutomationsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListAutomationsQuery = { __typename?: 'Query', listAutomations?: Array<{ __typename?: 'Automation', id: string, siteId: string, name: string, description?: string | null, status?: AutomationStatus | null, trigger: AutomationTrigger, triggerNewsletterId?: string | null, triggerSegmentId?: string | null, triggerEventType?: ContactEventType | null, activeEnrollments?: number | null, completedEnrollments?: number | null, lastSyncedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, steps: Array<{ __typename?: 'AutomationStep', id: string, delay: number, delayUnit: AutomationStepDelayUnit, subject: string, blocksJson: any }> }> | null };

export type GetAutomationQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  automationId: Scalars['ID']['input'];
}>;


export type GetAutomationQuery = { __typename?: 'Query', getAutomation?: { __typename?: 'Automation', id: string, siteId: string, name: string, description?: string | null, status?: AutomationStatus | null, trigger: AutomationTrigger, triggerNewsletterId?: string | null, triggerSegmentId?: string | null, triggerEventType?: ContactEventType | null, fromName?: string | null, replyToEmail?: string | null, exitTag?: string | null, activeEnrollments?: number | null, completedEnrollments?: number | null, lastSyncedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, steps: Array<{ __typename?: 'AutomationStep', id: string, delay: number, delayUnit: AutomationStepDelayUnit, subject: string, blocksJson: any }> } | null };

export type ListAutomationEnrollmentsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  automationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAutomationEnrollmentsQuery = { __typename?: 'Query', listAutomationEnrollments?: { __typename?: 'AutomationEnrollmentConnection', nextToken?: string | null, items: Array<{ __typename?: 'AutomationEnrollment', id: string, email: string, currentStep: number, status: string, enrolledAt?: string | null, nextRunAt?: string | null, lastStepSentAt?: string | null }> } | null };

export type CreateAutomationMutationVariables = Exact<{
  automation: AutomationInput;
}>;


export type CreateAutomationMutation = { __typename?: 'Mutation', createAutomation: { __typename?: 'Automation', id: string } };

export type UpdateAutomationMutationVariables = Exact<{
  automation: AutomationInput;
}>;


export type UpdateAutomationMutation = { __typename?: 'Mutation', updateAutomation: { __typename?: 'Automation', id: string } };

export type DeleteAutomationMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  automationId: Scalars['ID']['input'];
}>;


export type DeleteAutomationMutation = { __typename?: 'Mutation', deleteAutomation: boolean };

export type EnrollSegmentInAutomationMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  automationId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
}>;


export type EnrollSegmentInAutomationMutation = { __typename?: 'Mutation', enrollSegmentInAutomation: number };

export type UnenrollFromAutomationMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  automationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type UnenrollFromAutomationMutation = { __typename?: 'Mutation', unenrollFromAutomation: boolean };

export type GetNewsletterSendLimitsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetNewsletterSendLimitsQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, newsletterDailyEmailLimit?: number | null, newsletterMonthlyEmailLimit?: number | null, newsletterProvider?: NewsletterProvider | null } };

export type ListNewsletterSendsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  newsletterId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListNewsletterSendsQuery = { __typename?: 'Query', listNewsletterSends?: { __typename?: 'NewsletterSendConnection', nextToken?: string | null, items: Array<{ __typename?: 'NewsletterSend', id: string, siteId: string, newsletterId: string, newsletterName?: string | null, scheduledFor: string, sentAt?: string | null, status: NewsletterSendStatus, recipientSnapshot?: number | null, delivered?: number | null, opens?: number | null, clicks?: number | null, bounces?: number | null, complaints?: number | null, unsubscribes?: number | null, costCents?: number | null, errorMessage?: string | null }> } | null };

export type ListUpcomingNewsletterSendsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListUpcomingNewsletterSendsQuery = { __typename?: 'Query', listUpcomingNewsletterSends?: { __typename?: 'NewsletterSendConnection', nextToken?: string | null, items: Array<{ __typename?: 'NewsletterSend', id: string, siteId: string, newsletterId: string, newsletterName?: string | null, scheduledFor: string, status: NewsletterSendStatus }> } | null };

export type CancelNewsletterSendMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  sendId: Scalars['ID']['input'];
}>;


export type CancelNewsletterSendMutation = { __typename?: 'Mutation', cancelNewsletterSend: boolean };

export type ListSendRecipientEngagementQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  sendId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListSendRecipientEngagementQuery = { __typename?: 'Query', listSendRecipientEngagement?: { __typename?: 'SendRecipientEngagementConnection', nextToken?: string | null, items: Array<{ __typename?: 'SendRecipientEngagement', email: string, deliveredAt?: string | null, openedAt?: string | null, openCount?: number | null, clickedAt?: string | null, clickCount?: number | null, bouncedAt?: string | null, complainedAt?: string | null }> } | null };

export type ResendToNonOpenersMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  sendId: Scalars['ID']['input'];
}>;


export type ResendToNonOpenersMutation = { __typename?: 'Mutation', resendToNonOpeners: number };

export type SendTestNewsletterMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  newsletterId: Scalars['ID']['input'];
  toEmail: Scalars['String']['input'];
}>;


export type SendTestNewsletterMutation = { __typename?: 'Mutation', sendTestNewsletter: boolean };

export type GetSendingDomainQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSendingDomainQuery = { __typename?: 'Query', getSendingDomain?: { __typename?: 'SendingDomain', id: string, siteId: string, domain: string, status: SendingDomainStatus, autoInjected?: boolean | null, createdAt?: string | null, verifiedAt?: string | null, records?: Array<{ __typename?: 'SendingDomainDnsRecord', recordType: string, host: string, value: string, ttl?: number | null, priority?: number | null }> | null } | null };

export type CreateSendingDomainMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  domain: Scalars['String']['input'];
}>;


export type CreateSendingDomainMutation = { __typename?: 'Mutation', createSendingDomain: { __typename?: 'SendingDomain', id: string, domain: string, status: SendingDomainStatus, autoInjected?: boolean | null, records?: Array<{ __typename?: 'SendingDomainDnsRecord', recordType: string, host: string, value: string, ttl?: number | null, priority?: number | null }> | null } };

export type RefreshSendingDomainStatusMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type RefreshSendingDomainStatusMutation = { __typename?: 'Mutation', refreshSendingDomainStatus: { __typename?: 'SendingDomain', id: string, status: SendingDomainStatus, verifiedAt?: string | null } };

export type DeleteSendingDomainMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type DeleteSendingDomainMutation = { __typename?: 'Mutation', deleteSendingDomain: boolean };

export type ExportArticlesPublishedReportQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportArticlesPublishedReportQuery = { __typename?: 'Query', exportArticlesPublishedReport: string };

export type GetApNewsFeedItemDetailQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  apStoryId: Scalars['String']['input'];
}>;


export type GetApNewsFeedItemDetailQuery = { __typename?: 'Query', getAPNewsFeedItemDetail: { __typename?: 'APFeedPreviewItemDetail', id: string, title: string, byline?: string | null, releaseDate?: string | null, pubStatus?: string | null, lead?: string | null, body?: any | null, imported: boolean, importedPageId?: string | null, importedTitle?: string | null, skipReason?: string | null } };

export type GetAnalyticsForSiteQueryVariables = Exact<{
  params: GetAnalyticsForSiteParams;
}>;


export type GetAnalyticsForSiteQuery = { __typename?: 'Query', getAnalyticsForSite: { __typename?: 'AnalyticsResult', pages: Array<{ __typename?: 'AnalyticsData', blockId: string, count: number, getBlock?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null }>, hitsByInterval: Array<{ __typename?: 'HitsByInterval', interval: string, count: number }>, uniqueHitsByInterval: Array<{ __typename?: 'HitsByInterval', interval: string, count: number }> } };

export type GetAnalyticsForWorkspaceQueryVariables = Exact<{
  params: GetAnalyticsForWorkspaceParams;
}>;


export type GetAnalyticsForWorkspaceQuery = { __typename?: 'Query', getAnalyticsForWorkspace: { __typename?: 'AnalyticsResult', hitsByInterval: Array<{ __typename?: 'HitsByInterval', interval: string, count: number }>, uniqueHitsByInterval: Array<{ __typename?: 'HitsByInterval', interval: string, count: number }> } };

export type GetApNewsTokenQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetApNewsTokenQuery = { __typename?: 'Query', getAPNewsToken?: string | null };

export type GetAssetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssetQuery = { __typename?: 'Query', getAsset: { __typename?: 'Asset', brandId: string, createdAt: string, height?: number | null, id: string, imagePlaceholder?: string | null, key: string, name?: string | null, public: boolean, tags: Array<string>, type?: AssetType | null, updatedAt: string, uploaded: boolean, usedIn: Array<string>, version: number, width?: number | null } };

export type GetBlockQueryVariables = Exact<{
  blockId: Scalars['ID']['input'];
}>;


export type GetBlockQuery = { __typename?: 'Query', getBlock: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } };

export type GetBlocksQueryVariables = Exact<{
  blockIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
}>;


export type GetBlocksQuery = { __typename?: 'Query', getBlocks: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } };

export type GetBrandStyleQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetBrandStyleQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', version: number, updatedAt: string, name: string, favicon?: string | null, protected?: boolean | null, chatOpenByDefault?: boolean | null, id: string, brandId: string, getBrandStyle?: { __typename?: 'BrandStyle', id: string, brandId: string, createdAt: string, updatedAt: string, version: number, properties: { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } } } | null } };

export type GetBulkEditArticlesJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetBulkEditArticlesJobQuery = { __typename?: 'Query', getBulkEditArticlesJob: { __typename?: 'BulkEditArticlesJob', jobId: string, status: BulkEditJobStatus, total: number, processed: number, succeeded: number, failed: number, skipped: number, createdAt: string, updatedAt: string, results?: Array<{ __typename?: 'BulkEditArticleResult', pageId: string, status: BulkEditItemStatus, reason?: string | null }> | null } };

export type GetCollectionQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCollectionQuery = { __typename?: 'Query', getCollection: { __typename?: 'Collection', collectionId: string, name: string, siteId: string, listCollectionItems?: { __typename?: 'CollectionItemConnection', nextToken?: string | null, items: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, metadata?: Array<string> | null }> } | null } };

export type GetCollectionItemQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type GetCollectionItemQuery = { __typename?: 'Query', getCollectionItem: { __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, metadata?: Array<string> | null } };

export type GetCollectionItemsByAssetIdQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type GetCollectionItemsByAssetIdQuery = { __typename?: 'Query', getCollectionItemsByAssetId: Array<{ __typename?: 'CollectionItem', assetId: string, collectionId?: string | null }> };

export type GetConversationAndMessagesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  order?: InputMaybe<SortOrder>;
}>;


export type GetConversationAndMessagesQuery = { __typename?: 'Query', getConversation?: { __typename?: 'Conversation', id: string, siteId: string, userId: string, title?: string | null, createdAt?: string | null, updatedAt?: string | null } | null, listConversationMessages?: { __typename?: 'MessageConnection', nextToken?: string | null, items: Array<{ __typename?: 'Message', id: string, conversationId: string, userId?: string | null, role: string, content: string, createdAt?: string | null, updatedAt?: string | null }> } | null };

export type GetConversionAnalyticsForSiteQueryVariables = Exact<{
  params: GetConversionAnalyticsForSiteParams;
}>;


export type GetConversionAnalyticsForSiteQuery = { __typename?: 'Query', getConversionAnalyticsForSite: { __typename?: 'ConversionAnalyticsResult', topArticles: Array<{ __typename?: 'ArticleConversionStat', blockId: string, paywallHits: number, planViews: number, checkoutStarts: number, purchases: number }> } };

export type GetConversionAnalyticsForWorkspaceQueryVariables = Exact<{
  params: GetConversionAnalyticsForWorkspaceParams;
}>;


export type GetConversionAnalyticsForWorkspaceQuery = { __typename?: 'Query', getConversionAnalyticsForWorkspace: { __typename?: 'ConversionAnalyticsResult', topArticles: Array<{ __typename?: 'ArticleConversionStat', blockId: string, paywallHits: number, planViews: number, checkoutStarts: number, purchases: number }> } };

export type GetEditFieldsSiteDefaultsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEditFieldsSiteDefaultsQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, defaultArticleAccess?: Paywall | null, defaultArticleExternalDisplay?: ExternalDisplay | null, companyInfo?: { __typename?: 'CompanyInfo', timeZone?: string | null } | null } };

export type GetEmailSuppressionStatusQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type GetEmailSuppressionStatusQuery = { __typename?: 'Query', getEmailSuppressionStatus: { __typename?: 'EmailSuppressionStatus', suppressed: boolean, reason?: string | null, lastUpdateTime?: string | null } };

export type GetEventAnalyticsForSiteQueryVariables = Exact<{
  params: GetEventAnalyticsForSiteParams;
}>;


export type GetEventAnalyticsForSiteQuery = { __typename?: 'Query', getEventAnalyticsForSite: { __typename?: 'EventAnalyticsResult', eventCounts: Array<{ __typename?: 'EventCount', eventType: string, count: number }>, hitsByInterval: Array<{ __typename?: 'HitsByInterval', interval: string, count: number }> } };

export type GetEventAnalyticsForWorkspaceQueryVariables = Exact<{
  params: GetEventAnalyticsForWorkspaceParams;
}>;


export type GetEventAnalyticsForWorkspaceQuery = { __typename?: 'Query', getEventAnalyticsForWorkspace: { __typename?: 'EventAnalyticsResult', eventCounts: Array<{ __typename?: 'EventCount', eventType: string, count: number }>, hitsByInterval: Array<{ __typename?: 'HitsByInterval', interval: string, count: number }> } };

export type GetEventArticleAnalyticsForSiteQueryVariables = Exact<{
  params: GetEventArticleAnalyticsForSiteParams;
}>;


export type GetEventArticleAnalyticsForSiteQuery = { __typename?: 'Query', getEventArticleAnalyticsForSite: { __typename?: 'EventArticleAnalyticsResult', topEventArticles: Array<{ __typename?: 'EventArticleStat', blockId: string, ticketClicks: number, calendarAdds: number, shares: number, calls: number, directions: number, joins: number }> } };

export type GetEventShareBreakdownForBlockQueryVariables = Exact<{
  params: GetEventShareBreakdownForBlockParams;
}>;


export type GetEventShareBreakdownForBlockQuery = { __typename?: 'Query', getEventShareBreakdownForBlock: { __typename?: 'ShareBreakdownResult', entries: Array<{ __typename?: 'ShareBreakdownEntry', method: string, count: number }> } };

export type GetExternalFeedQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetExternalFeedQuery = { __typename?: 'Query', getExternalFeed?: { __typename?: 'ExternalFeed', id: string, siteId: string, name: string, url: string, parserType: ExternalParserType, active: boolean, activatedAt?: string | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, display?: ExternalDisplay | null, sectionId: string, imgRequired?: boolean | null, lastImportedAt?: string | null, createdAt: string, updatedAt: string } | null };

export type GetFeedQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetFeedQuery = { __typename?: 'Query', getFeed: { __typename?: 'Feed', id: string, workspaceId: string, name: string, description?: string | null, createdAt: string, updatedAt: string, webhooks?: Array<{ __typename?: 'FeedWebhook', url: string, active: boolean }> | null, filters?: Array<{ __typename?: 'FeedFilter', pattern: string, active: boolean }> | null } };

export type GetNewsletterQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  newsletterId: Scalars['ID']['input'];
}>;


export type GetNewsletterQuery = { __typename?: 'Query', getNewsletter?: { __typename?: 'Newsletter', id: string, siteId: string, name: string, description?: string | null, order?: number | null, kind?: NewsletterKind | null, status?: NewsletterStatus | null, provider?: NewsletterProvider | null, publicVisibility?: NewsletterPublicVisibility | null, publicOrder?: number | null, segmentIds?: Array<string> | null, fromName?: string | null, replyToEmail?: string | null, template?: { __typename?: 'NewsletterTemplate', blocksJson: any } | null, schedule?: { __typename?: 'NewsletterSchedule', cadence: NewsletterCadence, daysOfWeek?: Array<DayOfWeek> | null, timeOfDay?: string | null, timezone?: string | null, startAt?: string | null, endAt?: string | null, iCal?: string | null } | null } | null };

export type GetPageQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type GetPageQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', brandId: string, domainName?: string | null, id: string, name: string, seoPublicationName?: string | null, titleTag?: string | null, metaDescription?: string | null, favicon?: string | null, protected?: boolean | null, chatOpenByDefault?: boolean | null, version: number, updatedAt: string, defaultArticleAccess?: Paywall | null, defaultArticleExternalDisplay?: ExternalDisplay | null, storyCommentsOnByDefault?: boolean | null, adSystem?: AdvertisementSystem | null, disableStoryGeneration?: boolean | null, disableTitleGeneration?: boolean | null, disableLeadGeneration?: boolean | null, gelatoApiKey?: string | null, gelatoActive?: boolean | null, menus?: Array<{ __typename?: 'Menu', id: string, name: string }> | null, chatbotImage?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string }, companyInfo?: { __typename?: 'CompanyInfo', timeZone?: string | null } | null, columnInchSettings?: { __typename?: 'ColumnInchSettings', method?: ColumnInchMethod | null, wordsPerInch?: number | null, charactersPerColumnInch?: number | null } | null, listSitePageTemplates?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', pageTemplateCategory: PageTemplateCategory, id: string, sk: string }> } | null }, getPage: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number, createdAt: string, createdBy?: string | null, seoTitle?: string | null, seoDescription?: string | null, seoCanonical?: string | null, seoNoindex?: boolean | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null }> } };

export type GetPageAndLocalBlocksQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetPageAndLocalBlocksQuery = { __typename?: 'Query', getPage: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', brandId: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number, createdAt: string, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, version: number }> } | null }> } };

export type GetPageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type GetPageBySlugQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', brandId: string, domainName?: string | null, id: string, name: string, titleTag?: string | null, metaDescription?: string | null, favicon?: string | null, protected?: boolean | null, chatOpenByDefault?: boolean | null, version: number, updatedAt: string, chatbotMinimizedDisplayName?: string | null, adSystem?: AdvertisementSystem | null, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string }, chatbotImage?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null, menus?: Array<{ __typename?: 'Menu', id: string, name: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, type?: MenuItemType | null, menuIds?: Array<string> | null }> | null }> | null, listSitePageTemplates?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', pageTemplateCategory: PageTemplateCategory, id: string, sk: string }> } | null }, getPageBySlug: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, seoCanonical?: string | null, seoNoindex?: boolean | null, seoImageSrc?: string | null, seoImageWidth?: number | null, seoImageHeight?: number | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, slug: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null }> } };

export type GetPageBySlugForRedirectQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
}>;


export type GetPageBySlugForRedirectQuery = { __typename?: 'Query', getPageBySlug: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', id: string, sk: string, slug: string, pageCategory: PageCategory, createdAt: string, updatedAt: string, redirect?: { __typename?: 'RedirectConfig', destination: string, permanent: boolean } | null }> } };

export type GetPagePublicationSettingsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetPagePublicationSettingsQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, brandId: string, name: string, seoPublicationName?: string | null, authToken?: string | null, exportAuthToken?: string | null, disableStoryGeneration?: boolean | null, disableTitleGeneration?: boolean | null, disableLeadGeneration?: boolean | null, disableCmsChatbot?: boolean | null, disableAuthentication?: boolean | null, emailServiceAutoTagSignedIn?: boolean | null, emailServiceAutoTagSubscribed?: boolean | null, sendNewsletterSubscriptionEmail?: boolean | null, tollbitAnalyticsEnabled?: boolean | null, s3TransferFolderName?: string | null, newspapersDotComTPAKey?: string | null, newspapersDotComSubdomain?: string | null, storyCommentsOnByDefault?: boolean | null, language?: SiteLanguage | null, languageFollowsWorkspace?: boolean | null, articleBodySidebarMode?: ArticleBodySidebarMode | null, favicon?: string | null, protected?: boolean | null, defaultArticleAccess?: Paywall | null, defaultArticleExternalDisplay?: ExternalDisplay | null, defaultMetadata?: Array<string> | null, chatOpenByDefault?: boolean | null, version: number, updatedAt: string, chatbotMinimizedDisplayName?: string | null, gelatoApiKey?: string | null, gelatoWebhookSecret?: string | null, gelatoActive?: boolean | null, gelatoNewsroomMarkupPercent?: number | null, gelatoEnabledProductTypes?: Array<string> | null, shippingCountries?: Array<string> | null, adTxtContent?: string | null, newsletterProvider?: NewsletterProvider | null, adSystem?: AdvertisementSystem | null, playWirePubId?: string | null, playWireWebId?: string | null, domainName?: string | null, newzwareAccount?: { __typename?: 'NewzwareAccount', active?: boolean | null, instanceUrl?: string | null, site?: string | null, editionCode?: string | null } | null, engageAccount?: { __typename?: 'EngageAccount', active?: boolean | null, configScript?: string | null, subscribeUrl?: string | null, accountUrl?: string | null } | null, mirabelAccount?: { __typename?: 'MirabelAccount', active?: boolean | null, baseUrl?: string | null, tenant?: string | null, apiKey?: string | null } | null, contentCreditsAccount?: { __typename?: 'ContentCreditsAccount', active?: boolean | null, apiKey?: string | null } | null, makeItFreeAccount?: { __typename?: 'MakeItFreeAccount', active?: boolean | null, publisherId?: string | null, apiKey?: string | null } | null, navigaAccount?: { __typename?: 'NavigaAccount', username?: string | null, password?: string | null, wsdlUrl?: string | null, active?: boolean | null, navigaSubscriptionAssociation?: Array<{ __typename?: 'NavigaSubscriptionAssociation', stripeProductId: string, navigaPubId: string, navigaRateId: string }> | null } | null, chatbotPageBlacklist?: { __typename?: 'ChatbotPageBlacklist', hideFromAllPages?: boolean | null, home?: boolean | null, stories?: boolean | null, writers?: boolean | null, tags?: boolean | null, sections?: boolean | null, search?: boolean | null, latestStories?: boolean | null, newsletters?: boolean | null, signIn?: boolean | null, subscribe?: boolean | null, account?: boolean | null, contactUs?: boolean | null, terms?: boolean | null, privacyPolicy?: boolean | null, thankYou?: boolean | null, gift?: boolean | null, giftRedeem?: boolean | null, printOrderTracking?: boolean | null } | null, pubgenSubscription?: { __typename?: 'PubgenSubscription', id: string, status: StripeSubscriptionStatus } | null, imgPlaceholder?: { __typename?: 'ImgPlaceholder', src?: string | null, width?: number | null, height?: number | null } | null, metadataImage?: { __typename?: 'MetadataImage', src?: string | null, width?: number | null, height?: number | null } | null, chatbotImage?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null, connectedGoogleAnalyticsAccount?: { __typename?: 'GoogleAnalyticsAccount', gaMeasurementId: string } | null, connectedMarfeelAnalyticsAccount?: { __typename?: 'MarfeelAnalyticsAccount', marfeelId: string } | null, connectedIzootoAccount?: { __typename?: 'IzootoAccount', active: boolean, scriptId?: string | null } | null, connectedGoogleTagManagerAccount?: { __typename?: 'GoogleTagManagerAccount', containerId: string } | null, connectedFotomotoAccount?: { __typename?: 'FotomotoAccount', accountId: string } | null, connectedGoogleAdsAccount?: { __typename?: 'GoogleAdsAccount', adClient: string, verticalAdSlot?: string | null, horizontalAdSlot?: string | null } | null, googleTagAds?: { __typename?: 'GoogleTagAds', verticalHeaderScript?: string | null, vertical2HeaderScript?: string | null, chatbotPrimaryHeaderScript?: string | null, chatbotSecondaryHeaderScript?: string | null, horizontal1HeaderScript?: string | null, horizontal2HeaderScript?: string | null, footerHeaderScript?: string | null, adHeroHeaderScript?: string | null, stickyFooterHeaderScript?: string | null, articleInContentHeaderScript?: string | null, videoHeaderScript?: string | null } | null, customAds?: { __typename?: 'CustomAds', blockPubHeaderMenu?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSearch?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleBody?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubLatestArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubAuthorRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubTagRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubHomeTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockEmailCapture?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd1?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd2?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, chatbotPrimary?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, chatbotSecondary?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, stickyFooter?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleInContent?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, video?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, videoUrl?: string | null } | null } | null, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string }, emailCapture?: { __typename?: 'EmailCapture', title?: string | null, subtitle?: string | null, newsletterId?: string | null, customNewsletterId?: string | null } | null, aiSettings?: { __typename?: 'AISettings', journalistType?: JournalistType | null, audienceType?: string | null, blogType?: string | null, primaryPersona?: string | null, publicPrimaryPersona?: string | null, greetingMessage?: string | null } | null, companyInfo?: { __typename?: 'CompanyInfo', cityName?: string | null, countyCode?: string | null, mainEmail?: string | null, mainPhoneNumber?: string | null, noaaGridPoint?: string | null, supportEmail?: string | null, supportPhoneNumber?: string | null, timeZone?: string | null, sendSubscriptionLifecycleEmailsToCustomer?: boolean | null, coordinates?: { __typename?: 'Coordinates', lat?: number | null, lng?: number | null } | null } | null, columnInchSettings?: { __typename?: 'ColumnInchSettings', method?: ColumnInchMethod | null, wordsPerInch?: number | null, charactersPerColumnInch?: number | null } | null, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, status: StripeAccountStatus, notificationEmail?: string | null, profileChangeNotificationEmail?: string | null, type?: StripeAccountType | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, struckOutpriceForMonthlyToggleChoice?: number | null, struckOutPriceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, collectShipping?: boolean | null, collectPhoneNumber?: boolean | null, clickSubscribeLinkOverrideMonthly?: string | null, clickSubscribeLinkOverrideYearly?: string | null, promoCouponIdMonthly?: string | null, promoCouponIdYearly?: string | null, adSettings?: PlanAdSettings | null, printOnly?: boolean | null, optionalProductId?: string | null, optionalProductName?: string | null, optionalProductDescription?: string | null, priceForMonthlyOptionalChoice?: number | null, priceForYearlyOptionalChoice?: number | null, optionalMonthlyState?: OptionalPriceState | null, optionalYearlyState?: OptionalPriceState | null, monthlyPlanLabel?: string | null, yearlyPlanLabel?: string | null, ctaMonthly?: string | null, ctaYearly?: string | null }>, supportPlans?: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleYearly?: string | null, priceSubtitleMonthly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, collectShipping?: boolean | null }> | null, subscriptionGifts?: Array<{ __typename?: 'SubscriptionGift', siteId: string, productId: string, priceId: string, planProductId: string, couponId: string, numberOfGiftedMonths: number, priceInCents: number, isActive: boolean }> | null, subscriptionPromos?: Array<{ __typename?: 'SubscriptionPromo', siteId: string, couponId: string, name: string, percentageOff: number, durationInMonths: number }> | null, donationProduct?: { __typename?: 'DonationProduct', productId: string, priceId: string, name: string, stripeDescription: string, isActive: boolean, siteId: string, collectPhoneNumber?: boolean | null, minimumAmount?: number | null, maximumAmount?: number | null, defaultAmount?: number | null } | null, customerPortalConfig?: { __typename?: 'CustomerPortalConfig', id?: string | null, enabled: boolean, isDefault?: boolean | null, active?: boolean | null, allowPaymentMethodUpdate?: boolean | null, allowCancellation?: boolean | null, allowPlanSwitching?: boolean | null, switchablePrices?: Array<string> | null } | null } | null, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainCloudfront?: string | null, domainName: string, externalProvider: boolean, hostedZoneId?: string | null, nameServers: Array<string>, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null, getBrand?: { __typename?: 'Brand', workspaceId: string, id: string, brandStyleId: string, createdAt: string, version: number, updatedAt: string, name: string, path: string, getBrandStyle?: { __typename?: 'BrandStyle', id: string, brandId: string, createdAt: string, updatedAt: string, version: number, properties: { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } } } | null, listBrandStyles?: { __typename?: 'BrandStyleConnection', items: Array<{ __typename?: 'BrandStyle', brandId: string, createdAt: string, id: string, version: number, updatedAt: string, properties: { __typename?: 'ClientThemeProperties', lightModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, darkModeColors: { __typename?: 'Colors', pri: string, sec: string, lin: string, ale: string, suc: string, war: string }, fonts?: Array<{ __typename?: 'Font', id: string, url?: string | null, family: string, weight: FontWeight, style: FontStyle, isSerif: boolean }> | null, typography: { __typename?: 'Typography', h1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h3: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h4: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h5: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, h6: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, subtitle2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body1: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, body2: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, button: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, caption: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, overline: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, blockquote: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number }, code: { __typename?: 'Typo', fontId?: string | null, fontCase: FontCase, fontSize: number, lineHeight: number, letterSpacing: number, spaceAfter: number } } } }> } | null } | null } };

export type GetRedirectPageQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetRedirectPageQuery = { __typename?: 'Query', getPage: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', id: string, sk: string, slug: string, pageCategory: PageCategory, createdAt: string, updatedAt: string, redirect?: { __typename?: 'RedirectConfig', destination: string, permanent: boolean } | null }> } };

export type GetSavedPageVersionsQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetSavedPageVersionsQuery = { __typename?: 'Query', getPage: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', createdBy?: string | null, savedBy?: string | null, brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, seoCanonical?: string | null, seoNoindex?: boolean | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, savedBy?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null }> } };

export type GetSegmentQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
}>;


export type GetSegmentQuery = { __typename?: 'Query', getSegment?: { __typename?: 'Segment', id: string, siteId: string, name: string, description?: string | null, rulesJson?: any | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetSiteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSiteQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', brandId: string, createdAt: string, domainName?: string | null, protected?: boolean | null, id: string, name: string, seoPublicationName?: string | null, titleTag?: string | null, metaDescription?: string | null, updatedAt: string, version: number, disableTitleGeneration?: boolean | null, disableLeadGeneration?: boolean | null, disableStoryGeneration?: boolean | null, disableCmsChatbot?: boolean | null, emailServiceAutoTagSignedIn?: boolean | null, emailServiceAutoTagSubscribed?: boolean | null, sendNewsletterSubscriptionEmail?: boolean | null, storyCommentsOnByDefault?: boolean | null, language?: SiteLanguage | null, articleBodySidebarMode?: ArticleBodySidebarMode | null, defaultArticleAccess?: Paywall | null, defaultArticleExternalDisplay?: ExternalDisplay | null, defaultMetadata?: Array<string> | null, adSystem?: AdvertisementSystem | null, gelatoApiKey?: string | null, gelatoActive?: boolean | null, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, status: StripeAccountStatus, notificationEmail?: string | null, type?: StripeAccountType | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, struckOutpriceForMonthlyToggleChoice?: number | null, struckOutPriceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, collectShipping?: boolean | null, collectPhoneNumber?: boolean | null, clickSubscribeLinkOverrideMonthly?: string | null, clickSubscribeLinkOverrideYearly?: string | null, promoCouponIdMonthly?: string | null, promoCouponIdYearly?: string | null, adSettings?: PlanAdSettings | null, printOnly?: boolean | null, optionalProductId?: string | null, optionalProductName?: string | null, optionalProductDescription?: string | null, priceForMonthlyOptionalChoice?: number | null, priceForYearlyOptionalChoice?: number | null, optionalMonthlyState?: OptionalPriceState | null, optionalYearlyState?: OptionalPriceState | null, monthlyPlanLabel?: string | null, yearlyPlanLabel?: string | null, ctaMonthly?: string | null, ctaYearly?: string | null }>, supportPlans?: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleYearly?: string | null, priceSubtitleMonthly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, collectShipping?: boolean | null }> | null } | null, companyInfo?: { __typename?: 'CompanyInfo', timeZone?: string | null } | null, columnInchSettings?: { __typename?: 'ColumnInchSettings', method?: ColumnInchMethod | null, wordsPerInch?: number | null, charactersPerColumnInch?: number | null } | null, menus?: Array<{ __typename?: 'Menu', id: string, name: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, type?: MenuItemType | null, menuIds?: Array<string> | null }> | null }> | null, chatbotImage?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null, customAds?: { __typename?: 'CustomAds', blockPubHeaderMenu?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSearch?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleBody?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubLatestArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubAuthorRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubTagRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubHomeTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockEmailCapture?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd1?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd2?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleInContent?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | null, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string }, domain?: { __typename?: 'Domain', createdAt: string, domainCloudfront?: string | null, domainName: string, hostedZoneId?: string | null, nameServers: Array<string>, externalProvider: boolean, domainCloudFormation?: string | null, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null, listSitePageTemplates?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', pageTemplateCategory: PageTemplateCategory, id: string, sk: string }> } | null } };

export type GetSitePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
}>;


export type GetSitePageQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, brandId: string, createdAt: string, domainName?: string | null, name: string, seoPublicationName?: string | null, titleTag?: string | null, metaDescription?: string | null, favicon?: string | null, protected?: boolean | null, disableAuthentication?: boolean | null, chatOpenByDefault?: boolean | null, version: number, updatedAt: string, siteCategory: SiteCategory, brandStyleId: string, defaultArticleAccess?: Paywall | null, disableStoryGeneration?: boolean | null, storyCommentsOnByDefault?: boolean | null, chatbotMinimizedDisplayName?: string | null, adSystem?: AdvertisementSystem | null, newzwareAccount?: { __typename?: 'NewzwareAccount', active?: boolean | null, instanceUrl?: string | null, site?: string | null, editionCode?: string | null } | null, engageAccount?: { __typename?: 'EngageAccount', active?: boolean | null, configScript?: string | null, subscribeUrl?: string | null, accountUrl?: string | null } | null, mirabelAccount?: { __typename?: 'MirabelAccount', active?: boolean | null, baseUrl?: string | null, tenant?: string | null, apiKey?: string | null } | null, contentCreditsAccount?: { __typename?: 'ContentCreditsAccount', active?: boolean | null, apiKey?: string | null } | null, imgPlaceholder?: { __typename?: 'ImgPlaceholder', src?: string | null, width?: number | null, height?: number | null } | null, metadataImage?: { __typename?: 'MetadataImage', src?: string | null, width?: number | null, height?: number | null } | null, chatbotImage?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null, menus?: Array<{ __typename?: 'Menu', id: string, name: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, type?: MenuItemType | null, menuIds?: Array<string> | null }> | null }> | null, customAds?: { __typename?: 'CustomAds', blockPubHeaderMenu?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSearch?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleBody?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubLatestArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubAuthorRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubTagRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubHomeTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockEmailCapture?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubArticleRelatedArticles?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockPubSectionTopStories?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd1?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, blockGoogleAd2?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, chatbotPrimary?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, chatbotSecondary?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleInContent?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, video?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, videoUrl?: string | null } | null, stickyFooter?: { __typename?: 'CustomAd', href?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | null, emailCapture?: { __typename?: 'EmailCapture', title?: string | null, subtitle?: string | null, newsletterId?: string | null } | null, connectedStripeAccount?: { __typename?: 'StripeAccount', accountId: string, status: StripeAccountStatus, notificationEmail?: string | null, type?: StripeAccountType | null, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, clickSubscribeLinkOverrideMonthly?: string | null, clickSubscribeLinkOverrideYearly?: string | null, struckOutpriceForMonthlyToggleChoice?: number | null, struckOutPriceForYearlyToggleChoice?: number | null, priceSubtitleMonthly?: string | null, priceSubtitleYearly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string>, collectShipping?: boolean | null, collectPhoneNumber?: boolean | null, promoCouponIdMonthly?: string | null, promoCouponIdYearly?: string | null, ctaMonthly?: string | null, ctaYearly?: string | null }>, supportPlans?: Array<{ __typename?: 'SubscriptionPlan', benefits?: any | null, planSummary?: string | null, name: string, subtitle?: string | null, priceForMonthlyToggleChoice?: number | null, priceForYearlyToggleChoice?: number | null, priceSubtitleYearly?: string | null, priceSubtitleMonthly?: string | null, productId: string, stripeDescription: string, stripePriceIdMonthly: string, stripePriceIdYearly: string, previousPriceIds: Array<string> }> | null, subscriptionGifts?: Array<{ __typename?: 'SubscriptionGift', siteId: string, productId: string, priceId: string, planProductId: string, couponId: string, numberOfGiftedMonths: number, priceInCents: number, isActive: boolean }> | null, subscriptionPromos?: Array<{ __typename?: 'SubscriptionPromo', siteId: string, couponId: string, name: string, percentageOff: number, durationInMonths: number }> | null, donationProduct?: { __typename?: 'DonationProduct', siteId: string, productId: string, name: string, isActive: boolean, stripeDescription: string, priceId: string } | null } | null, connectedGoogleAdsAccount?: { __typename?: 'GoogleAdsAccount', adClient: string, verticalAdSlot?: string | null, horizontalAdSlot?: string | null } | null, googleTagAds?: { __typename?: 'GoogleTagAds', verticalHeaderScript?: string | null, vertical2HeaderScript?: string | null, chatbotPrimaryHeaderScript?: string | null, chatbotSecondaryHeaderScript?: string | null, horizontal1HeaderScript?: string | null, horizontal2HeaderScript?: string | null, footerHeaderScript?: string | null, adHeroHeaderScript?: string | null, articleInContentHeaderScript?: string | null, videoHeaderScript?: string | null, stickyFooterHeaderScript?: string | null } | null, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string }, connectedGoogleAnalyticsAccount?: { __typename?: 'GoogleAnalyticsAccount', gaMeasurementId: string } | null, connectedMarfeelAnalyticsAccount?: { __typename?: 'MarfeelAnalyticsAccount', marfeelId: string } | null, companyInfo?: { __typename?: 'CompanyInfo', noaaGridPoint?: string | null, countyCode?: string | null, timeZone?: string | null, cityName?: string | null, mainPhoneNumber?: string | null, mainEmail?: string | null, supportPhoneNumber?: string | null, supportEmail?: string | null, coordinates?: { __typename?: 'Coordinates', lat?: number | null, lng?: number | null } | null } | null, getMostViewedStories?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, getWeatherData?: { __typename?: 'WeatherData', currentWeather: { __typename?: 'CurrentWeather', temp: string, date: string, highTemp: string, lowTemp: string, summary: string, img: string }, weatherSlots: Array<{ __typename?: 'WeatherSlot', date: string, highTemp: string, lowTemp: string, summary: string, img: string }>, weatherAdvisory?: { __typename?: 'WeatherAdvisory', message: string, weatherSiteUrl: string, instructions?: string | null, description?: string | null, timestamp?: string | null, expires?: string | null, id?: string | null } | null } | null, getAvailableNewsletters?: Array<{ __typename?: 'Newsletter', id: string, name: string, siteId: string, description?: string | null, order?: number | null }> | null, listSitePageTemplates?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', pageTemplateCategory: PageTemplateCategory, id: string, sk: string }> } | null, listSiteBlockTemplates?: { __typename?: 'BlockTemplateConnection', items: Array<{ __typename?: 'BlockTemplate', blockCategory: BlockTemplateCategory, brandId: string, componentId: string, createdAt: string, id: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, version: number, gsk1: string, data?: { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null } | { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null } | { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null } | { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null } | { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null } | { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null } | null }> } | null, getPageBySlug?: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', brandId: string, gsk1: string, gsk2: string, id: string, pageCategory: PageCategory, savedAt?: string | null, siteId: string, sk: string, slug: string, state: PublishState, templateId: string, updatedAt: string, publishedAt?: string | null, version: number, createdAt: string, seoTitle?: string | null, seoDescription?: string | null, seoCanonical?: string | null, seoNoindex?: boolean | null, seoImageSrc?: string | null, seoImageWidth?: number | null, seoImageHeight?: number | null, getPageTemplate?: { __typename?: 'PageTemplateConnection', items: Array<{ __typename?: 'PageTemplate', brandId: string, createdAt: string, id: string, pageTemplateCategory: PageTemplateCategory, componentId: PageTemplateComponentId, savedAt?: string | null, siteId: string, sk: string, updatedAt: string, state: PublishState, version: number, blockTemplates: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, blockVariants: Array<{ __typename?: 'BlockVariant', componentId: string, defaultVariant: string }> }> } | null, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, createdAt: string, gsk1: string, id: string, componentId: string, pageId: string, variant?: string | null, savedAt?: string | null, siteId: string, sk: string, state: PublishState, updatedAt: string, archivedAt?: string | null, version: number, externalBlockIds: Array<string>, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null, localBlockSlots: Array<{ __typename?: 'LocalBlockSlot', ids: Array<string>, slot: SlotType }>, listPageAdditionalBlocks?: { __typename?: 'BlockConnection', nextToken?: string | null, items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, componentId: string, id: string, variant?: string | null, version: number, state: PublishState, pageId: string, createdAt: string, sk: string, updatedAt: string, archivedAt?: string | null, brandId: string, gsk1: string, siteId: string, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null, listExternalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', blockCategory: BlockCategory, brandId: string, componentId: string, createdAt: string, gsk1: string, externalBlockIds: Array<string>, id: string, pageId: string, savedAt?: string | null, siteId: string, state: PublishState, updatedAt: string, archivedAt?: string | null, sk: string, variant?: string | null, version: number, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } | null }> } | null }> } | null } };

export type GetSiteSubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSiteSubscriptionQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, name: string, pubgenSubscription?: { __typename?: 'PubgenSubscription', id: string, status: StripeSubscriptionStatus } | null } };

export type GetSiteWildcardRedirectsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSiteWildcardRedirectsQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, name: string, wildcardRedirects?: Array<{ __typename?: 'WildcardRedirectRule', id: string, matchType: WildcardMatchType, source: string, destination: string, preserveSuffix: boolean, preserveQuery: boolean, permanent: boolean, enabled: boolean, priority?: number | null, note?: string | null, createdAt: string, updatedAt: string }> | null } };

export type GetSubscriberByIdQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetSubscriberByIdQuery = { __typename?: 'Query', getSubscriberById: { __typename?: 'Subscriber', id: string, email: string, legacyPassword?: string | null, legacyUsername?: string | null, phoneNumber?: string | null, siteId: string, shippingAddress?: { __typename?: 'ShippingAddress', firstName?: string | null, lastName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } };

export type GetSubscriberBySubscriptionIdAndPlanIdQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
}>;


export type GetSubscriberBySubscriptionIdAndPlanIdQuery = { __typename?: 'Query', getSubscriberBySubscriptionIdAndPlanId: { __typename?: 'Subscriber', id: string, email: string, legacyPassword?: string | null, legacyUsername?: string | null, phoneNumber?: string | null, siteId: string, shippingAddress?: { __typename?: 'ShippingAddress', firstName?: string | null, lastName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } };

export type GetTimezoneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTimezoneQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, companyInfo?: { __typename?: 'CompanyInfo', timeZone?: string | null } | null } };

export type GetTopBlocksByEventForSiteQueryVariables = Exact<{
  params: GetTopBlocksByEventForSiteParams;
}>;


export type GetTopBlocksByEventForSiteQuery = { __typename?: 'Query', getTopBlocksByEventForSite: { __typename?: 'TopBlocksByEventResult', topBlocks: Array<{ __typename?: 'BlockEventStat', blockId: string, count: number }> } };

export type GetTopPagesByConversionEventQueryVariables = Exact<{
  params: GetTopPagesByConversionEventParams;
}>;


export type GetTopPagesByConversionEventQuery = { __typename?: 'Query', getTopPagesByConversionEvent: { __typename?: 'PageConversionResult', topPages: Array<{ __typename?: 'PageConversionStat', url: string, count: number }> } };

export type GetTypesenseKeyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTypesenseKeyQuery = { __typename?: 'Query', getSite: { __typename?: 'Site', id: string, typesense: { __typename?: 'TypesenseSiteSettings', cmsKey: string, siteKey: string } } };

export type GetUserByDomainQueryVariables = Exact<{
  path: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  username: Scalars['ID']['input'];
}>;


export type GetUserByDomainQuery = { __typename?: 'Query', getWorkspaceByDomain: { __typename?: 'Workspace', domainName?: string | null, id: string, name: string, version: number, updatedAt: string, subdomain: string, getBrandByPath?: { __typename?: 'Brand', id: string, name: string, path: string } | null, getWorkspaceUser?: { __typename?: 'WorkspaceUser', createdAt: string, id: string, updatedAt: string, username: string, version: number, workspaceGroups: Array<WorkspaceGroup>, workspaceId: string, firstName?: string | null, lastName?: string | null, isConfirmed?: boolean | null, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } | null } };

export type GetWorkspaceByDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type GetWorkspaceByDomainQuery = { __typename?: 'Query', getWorkspaceByDomain: { __typename?: 'Workspace', id: string, name: string, subdomain: string, language?: SiteLanguage | null, updatedAt: string, version: number, listWorkspaceBrands?: { __typename?: 'BrandConnection', nextToken?: string | null, items: Array<{ __typename?: 'Brand', name: string, path: string, id: string, listBrandSites?: { __typename?: 'SiteConnection', items: Array<{ __typename?: 'Site', id: string, name: string, domainName?: string | null, pubgenSubscription?: { __typename?: 'PubgenSubscription', id: string, status: StripeSubscriptionStatus } | null, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainCloudfront?: string | null, domainName: string, externalProvider: boolean, hostedZoneId?: string | null, nameServers: Array<string>, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null }> } | null }> } | null, tollbitAnalytics?: { __typename?: 'TollbitWorkspaceAnalytics', bucketName: string, bucketRegion: string, createdAt: string, updatedAt: string } | null } };

export type GetWorkspaceByDomainWithUserQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  username: Scalars['ID']['input'];
}>;


export type GetWorkspaceByDomainWithUserQuery = { __typename?: 'Query', getWorkspaceByDomain: { __typename?: 'Workspace', id: string, name: string, subdomain: string, updatedAt: string, version: number, listWorkspaceBrands?: { __typename?: 'BrandConnection', nextToken?: string | null, items: Array<{ __typename?: 'Brand', name: string, path: string, id: string, listBrandSites?: { __typename?: 'SiteConnection', items: Array<{ __typename?: 'Site', id: string, name: string, domainName?: string | null, pubgenSubscription?: { __typename?: 'PubgenSubscription', id: string, status: StripeSubscriptionStatus } | null }> } | null }> } | null, tollbitAnalytics?: { __typename?: 'TollbitWorkspaceAnalytics', bucketName: string, bucketRegion: string, createdAt: string, updatedAt: string } | null, getWorkspaceUser?: { __typename?: 'WorkspaceUser', createdAt: string, firstName?: string | null, id: string, isConfirmed?: boolean | null, lastName?: string | null, updatedAt: string, username: string, version: number, workspaceGroups: Array<WorkspaceGroup>, workspaceId: string, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } | null } };

export type GetWorkspaceByDomainWithUserAndFeedsQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  username: Scalars['ID']['input'];
}>;


export type GetWorkspaceByDomainWithUserAndFeedsQuery = { __typename?: 'Query', getWorkspaceByDomain: { __typename?: 'Workspace', id: string, name: string, subdomain: string, updatedAt: string, version: number, listFeeds?: { __typename?: 'FeedConnection', nextToken?: string | null, items: Array<{ __typename?: 'Feed', id: string, name: string, description?: string | null }> } | null, listWorkspaceBrands?: { __typename?: 'BrandConnection', nextToken?: string | null, items: Array<{ __typename?: 'Brand', name: string, path: string, id: string, listBrandSites?: { __typename?: 'SiteConnection', items: Array<{ __typename?: 'Site', id: string, name: string, domainName?: string | null, pubgenSubscription?: { __typename?: 'PubgenSubscription', id: string, status: StripeSubscriptionStatus } | null }> } | null }> } | null, getWorkspaceUser?: { __typename?: 'WorkspaceUser', createdAt: string, firstName?: string | null, id: string, isConfirmed?: boolean | null, lastName?: string | null, updatedAt: string, username: string, version: number, workspaceGroups: Array<WorkspaceGroup>, workspaceId: string, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } | null } };

export type ListApNewsTopicsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListApNewsTopicsQuery = { __typename?: 'Query', listAPNewsTopics: { __typename?: 'APNewsTopicConnection', items: Array<{ __typename?: 'APNewsTopic', id: number, name: string, pricing: ApNewsPricing, feedLink: string, active?: boolean | null, sectionId?: string | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, display?: ExternalDisplay | null, imgRequired?: boolean | null }> } };

export type ListCollectionItemsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListCollectionItemsQuery = { __typename?: 'Query', listCollectionItems: { __typename?: 'CollectionItemConnection', nextToken?: string | null, items: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string, metadata?: Array<string> | null }> } };

export type ListCollectionsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListCollectionsQuery = { __typename?: 'Query', listCollections: { __typename?: 'CollectionConnection', items: Array<{ __typename?: 'Collection', collectionId: string, name: string, siteId: string, getCollectionLength?: number | null, createdAt: string, updatedAt: string, listCollectionItems?: { __typename?: 'CollectionItemConnection', items: Array<{ __typename?: 'CollectionItem', name?: string | null, assetKey: string, siteId: string, assetId: string, collectionId?: string | null, credit?: string | null, caption?: string | null, alt?: string | null, width?: number | null, height?: number | null, createdAt: string, updatedAt: string, metadata?: Array<string> | null }> } | null }> } };

export type ListContactsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  segmentId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListContactsQuery = { __typename?: 'Query', listContacts?: { __typename?: 'ContactConnection', nextToken?: string | null, items: Array<{ __typename?: 'Contact', id: string, siteId: string, email: string, firstName?: string | null, lastName?: string | null, tags?: Array<string> | null, subscribedNewsletterIds?: Array<string> | null, status: ContactStatus, source: ContactSource, unsubscribeToken: string, createdAt?: string | null, updatedAt?: string | null, lifecycle?: { __typename?: 'ContactLifecycle', signedInAt?: string | null, planStatus?: string | null, subscribedAt?: string | null, cancelledAt?: string | null, lastDonationAt?: string | null, lastDonationCents?: number | null, totalDonationCents?: number | null } | null }> } | null };

export type ListContactEventsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListContactEventsQuery = { __typename?: 'Query', listContactEvents?: { __typename?: 'ContactEventConnection', nextToken?: string | null, items: Array<{ __typename?: 'ContactEvent', id: string, type: ContactEventType, occurredAt: string, metadata?: any | null, createdAt?: string | null }> } | null };

export type ListContextTemplatesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListContextTemplatesQuery = { __typename?: 'Query', listContextTemplates: Array<{ __typename?: 'ContextTemplate', siteId: string, id: string, name: string, content: string, active: boolean }> };

export type QueryListExternalFeedsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type QueryListExternalFeedsQuery = { __typename?: 'Query', listExternalFeeds: { __typename?: 'ExternalFeedConnection', items: Array<{ __typename?: 'ExternalFeed', id: string, name: string, url: string, parserType: ExternalParserType, active: boolean, activatedAt?: string | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, display?: ExternalDisplay | null, sectionId: string, imgRequired?: boolean | null, lastImportedAt?: string | null, createdAt: string, updatedAt: string }> } };

export type ListFeaturedChatbotPromptsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListFeaturedChatbotPromptsQuery = { __typename?: 'Query', listFeaturedChatbotPrompts: Array<{ __typename?: 'FeaturedChatbotPrompt', siteId: string, id: string, prompt: string, active: boolean, label: string, category: FeaturedChatbotPromptCategory, pageType: FeaturedChatbotpageType }> };

export type ListFeedSiteSubscriptionsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListFeedSiteSubscriptionsQuery = { __typename?: 'Query', listFeedSiteSubscriptions: { __typename?: 'FeedSiteSubscriptionConnection', nextToken?: string | null, items: Array<{ __typename?: 'FeedSiteSubscription', workspaceId: string, feedId: string, siteId: string, active?: boolean | null, name: string, description?: string | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, section?: string | null, createdAt: string, updatedAt: string, tags?: Array<string> | null }> } };

export type ListFeedStoriesQueryVariables = Exact<{
  feedId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListFeedStoriesQuery = { __typename?: 'Query', listFeedStories: { __typename?: 'FeedStoryConnection', nextToken?: string | null, items: Array<{ __typename?: 'FeedStory', feedId: string, pageId: string, articleData: any, releaseDateOverride?: string | null, displayOverride?: ExternalDisplay | null, createdAt: string, updatedAt: string, source: { __typename?: 'FeedStorySource', siteId: string, brandId: string, brandName: string, brandPath: string } }> } };

export type ListFeedsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;


export type ListFeedsQuery = { __typename?: 'Query', listFeeds: { __typename?: 'FeedConnection', nextToken?: string | null, items: Array<{ __typename?: 'Feed', id: string, workspaceId: string, name: string, description?: string | null, createdAt: string, updatedAt: string, webhooks?: Array<{ __typename?: 'FeedWebhook', url: string, active: boolean }> | null, filters?: Array<{ __typename?: 'FeedFilter', pattern: string, active: boolean }> | null }> } };

export type ListMailchimpListsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListMailchimpListsQuery = { __typename?: 'Query', listMailchimpLists: Array<{ __typename?: 'MailchimpList', name: string, id: string }> };

export type ListNewslettersQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListNewslettersQuery = { __typename?: 'Query', listNewsletters?: Array<{ __typename?: 'Newsletter', id: string, name: string, description?: string | null, siteId: string, order?: number | null, kind?: NewsletterKind | null, status?: NewsletterStatus | null, provider?: NewsletterProvider | null, publicVisibility?: NewsletterPublicVisibility | null, publicOrder?: number | null }> | null };

export type ListPersonasQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListPersonasQuery = { __typename?: 'Query', listPersonas: Array<{ __typename?: 'Persona', id: string, name: string, description: string, siteId: string, answerStyle: string }> };

export type ListPublicPersonasQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListPublicPersonasQuery = { __typename?: 'Query', listPublicPersonas: Array<{ __typename?: 'PublicPersona', id: string, name: string, description: string, siteId: string, answerStyle: string, active: boolean, image?: { __typename?: 'ChatbotImage', src?: string | null, width?: number | null, height?: number | null } | null }> };

export type ListQuestionsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListQuestionsQuery = { __typename?: 'Query', listQuestions: Array<{ __typename?: 'Question', id: string, question: string, answer: string, siteId: string, questionKey: string, deprecated?: boolean | null }> };

export type ListSegmentsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListSegmentsQuery = { __typename?: 'Query', listSegments?: { __typename?: 'SegmentConnection', nextToken?: string | null, items: Array<{ __typename?: 'Segment', id: string, siteId: string, name: string, description?: string | null, rulesJson?: any | null, createdAt?: string | null, updatedAt?: string | null }> } | null };

export type ListSiteBlockTemplatesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  blockCategory?: InputMaybe<BlockTemplateCategory>;
  status?: InputMaybe<PublishedStatusInput>;
}>;


export type ListSiteBlockTemplatesQuery = { __typename?: 'Query', listSiteBlockTemplates: { __typename?: 'BlockTemplateConnection', items: Array<{ __typename?: 'BlockTemplate', id: string, sk: string, gsk1: string, brandId: string, version: number, updatedAt: string, blockCategory: BlockTemplateCategory, publishedAt?: string | null, componentId: string, data?: { __typename: 'BlockPubArticleRelatedArticles', content?: any | null, snippet?: string | null, eReaderInitializesFullscreen?: boolean | null, eReaderDefaultViewMode?: string | null, eReaderDefaultFitMode?: string | null, defaultHideImageBackground?: boolean | null } | { __typename: 'BlockPubFooter', menu1Id?: string | null, menu2Id?: string | null, menu3Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, tagline?: string | null, copyrigthName?: string | null, snippet?: string | null } | { __typename: 'BlockPubHeaderMenu', mainMenuId?: string | null, drawerMenu1Id?: string | null, drawerMenu2Id?: string | null, drawerMenu3Id?: string | null, drawerMenu4Id?: string | null, logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null, layout?: HeaderLayout | null, customCtaLabel?: string | null, customCtaLink?: string | null, customCtaType?: HeaderCustomCtaType | null, hideCustomCta?: boolean | null, isVisible?: boolean | null, leaderBoardAdPosition?: LeaderboardPosition | null, gtmAlternativeImgSrc?: string | null, gtmAlternativeImgHeight?: number | null, gtmAlternativeImgWidth?: number | null, gtmAlternativeImgLink?: string | null, snippet?: string | null } | { __typename: 'BlockPubNavSqueeze', logoWidth?: number | null, logoHeight?: number | null, logoSrc?: string | null, logoSize?: LogoSize | null } | { __typename: 'BlockPubPaywall', numberOfFreeArticlesAllowedPerMonth?: number | null, numberOfArticlesWithPaywallWarning?: number | null, disablePaywall?: boolean | null, paywallType?: PaywallType | null } | { __typename: 'BlockPubPromo', disabled?: boolean | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, promoModalCooldownForNonSubscribers?: number | null, giftModalCooldownForSubscribers?: number | null, giftModalCooldownForNonSubscribers?: number | null, customTitleForPromo?: string | null, customPopupTimeInSecondsForPromo?: number | null, customTitleForGift?: string | null, customPopupTimeInSecondsForGift?: number | null, modalContentType?: BlockPubPromoModalContentType | null, starredGiftProductId?: string | null, newsletterModalNewsletterId?: string | null, newsletterModalCustomNewsletterId?: string | null, customTitleForNewsletter?: string | null, customSubtitleForNewsletter?: string | null, customSuccessTitleForNewsletter?: string | null, customSuccessSubtitleForNewsletter?: string | null, customPopupTimeInSecondsForNewsletter?: number | null, newsletterModalCooldownForNonSubscribers?: number | null } | null }> } };

export type ListSiteBlocksQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  blockCategory?: InputMaybe<BlockCategory>;
  status?: InputMaybe<PublishedStatusInput>;
}>;


export type ListSiteBlocksQuery = { __typename?: 'Query', listSiteBlocks: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', id: string, sk: string, gsk1: string, brandId: string, version: number, updatedAt: string, blockCategory: BlockCategory, publishedAt?: string | null, componentId: string, archivedAt?: string | null, slug: string, data?: { __typename: 'BlockCards', cards?: Array<{ __typename?: 'Card', id?: string | null, title?: string | null, content?: any | null }> | null } | { __typename: 'BlockCoverImage', tagline?: string | null, title?: string | null, description?: string | null, src?: string | null, width?: number | null, height?: number | null, snippet?: string | null } | { __typename: 'BlockFaq', description?: string | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubAccount', supportPlanLinkOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubAdHero', content?: any | null } | { __typename: 'BlockPubArticleBody', content?: any | null } | { __typename: 'BlockPubArticleHeader', authors?: Array<string> | null, blurryPlaceholder?: string | null, byline?: string | null, externalDisplay?: ExternalDisplay | null, featuredMediaType?: FeaturedMediaType | null, image?: string | null, imageCaption?: string | null, imageCredit?: string | null, imageAlt?: string | null, imageMetadata?: Array<string> | null, isIframe?: boolean | null, imageWidth?: number | null, imageHeight?: number | null, paidPostName?: string | null, paidPostImgSrc?: string | null, paidPostImgHeight?: number | null, paidPostImgWidth?: number | null, paidPostUrl?: string | null, sponsoredCaption?: string | null, sponsoredImgSrc?: string | null, sponsoredImgHeight?: number | null, sponsoredImgWidth?: number | null, releaseDate?: string | null, printReleaseDate?: string | null, toReview?: boolean | null, paywall?: Paywall | null, sponsoredUrl?: string | null, summary?: string | null, section?: string | null, snippet?: string | null, tags?: Array<string> | null, title?: string | null, type: ArticleType, galleryType?: GalleryType | null, galleryAspectRatio?: GalleryAspectRatio | null, eReaderPdfLink?: string | null, iframeAspectRatio?: IframeAspectRatio | null, iframeLink?: string | null, iframeCaption?: string | null, iframeCredits?: string | null, editorNotes?: string | null, isAPNews?: boolean | null, showComments?: boolean | null, feeds?: Array<string> | null, metadata?: Array<string> | null, eventBeginDate?: string | null, eventEndDate?: string | null, eventICal?: string | null, eventTicketUrl?: string | null, eventTicketLabel?: string | null, eventPreCTACopy?: string | null, eventVenueName?: string | null, eventLocation?: string | null, onlineEventUrl?: string | null, eventPhoneContact?: string | null, storyLayout?: StoryLayout | null, hideWriterBoilerplate?: boolean | null, hideRelatedArticles?: boolean | null, detachedFromFeed?: boolean | null, carousel?: Array<{ __typename?: 'Carousel', key: string, blurryPlaceholder?: string | null, height?: number | null, width?: number | null, caption?: string | null, credits?: string | null, alt?: string | null, metadata?: Array<string> | null, enablePrintOnDemand?: boolean | null }> | null } | { __typename: 'BlockPubArticlesBySection', section?: string | null, hideDivider?: boolean | null, pubArticlesBySectionLayout?: BlockPubArticlesBySectionLayout | null, showDescription?: boolean | null, articleOverride1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articleOverride4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubAuthorOverview', name?: string | null, position?: string | null, biography?: any | null, picture?: string | null, pictureWidth?: number | null, pictureHeight?: number | null, email?: string | null, xHandle?: string | null, linkedInUsername?: string | null, instagramUsername?: string | null, facebookUsername?: string | null, youtubeChannelHandle?: string | null, phoneNumber?: string | null, writerBoilerplate?: any | null } | { __typename: 'BlockPubBreakingNews', title?: string | null, href?: string | null, isCustom?: boolean | null, customText?: string | null, customTextLink?: string | null, isVisible?: boolean | null } | { __typename: 'BlockPubEvents', snippet?: string | null } | { __typename: 'BlockPubExternalReferences', snippet?: string | null, externalReferences: Array<{ __typename?: 'ExternalReference', ctaText?: string | null, ctaLink?: string | null, imgSrc: string, imgHeight: number, imgWidth: number }> } | { __typename: 'BlockPubGift', headerLogoSrc?: string | null, headerLogoWidth?: number | null, headerLogoHeight?: number | null, showHeaderGIF?: boolean | null, headerTitle?: string | null, headerSubtitle?: string | null, stripePlansOrderedByProductId?: Array<string> | null, starredGiftProductId?: string | null, disclaimer?: any | null, faqItems?: Array<{ __typename?: 'FaqItem', id?: string | null, panelHeader?: string | null, panelBody?: any | null }> | null } | { __typename: 'BlockPubHomeHero', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | { __typename: 'BlockPubHomeTopStories', topStoriesLimit?: number | null, sectionsToExclude?: Array<string> | null, pubHomeTopStoriesLayout?: BlockPubHomeTopStoriesLayout | null, articlesId1?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId2?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId3?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId4?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId5?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, articlesId6?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null, sponsoredArticle?: { __typename?: 'BlockPubHomeTopStorySponsoredArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubLeadArticle', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, isAutomatic?: boolean | null, isVisible?: boolean | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null, title2?: string | null, slug2?: string | null, id2?: string | null, articleHeaderID2?: string | null, isAutomatic2?: boolean | null, isVisible2?: boolean | null, imgSrc2?: string | null, imgHeight2?: number | null, imgWidth2?: number | null, title3?: string | null, slug3?: string | null, id3?: string | null, articleHeaderID3?: string | null, isAutomatic3?: boolean | null, isVisible3?: boolean | null, imgSrc3?: string | null, imgHeight3?: number | null, imgWidth3?: number | null, leadArticleLayout?: BlockPubLeadArticleLayout | null, leadArticleLayout2?: BlockPubLeadArticleLayout | null, leadArticleLayout3?: BlockPubLeadArticleLayout | null } | { __typename: 'BlockPubMediaTopStories', filterOutApStories?: boolean | null, mediaGalleryIsVisible?: boolean | null, socialGalleries?: Array<{ __typename?: 'SocialGallery', type?: SocialGalleryType | null, items?: Array<string | null> | null, isVisible?: boolean | null, location?: SocialGalleryLocation | null } | null> | null } | { __typename: 'BlockPubNewsletters', snippet?: string | null } | { __typename: 'BlockPubSearch', snippet?: string | null } | { __typename: 'BlockPubSectionMainView', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null, layout?: SectionLayoutStyle | null, preGridArticleNumber?: number | null, hideTopStories?: boolean | null, topStoryArticleOverride?: { __typename?: 'BlockPubHomeTopStoryArticleData', title?: string | null, slug?: string | null, id?: string | null, articleHeaderID?: string | null, imgSrc?: string | null, imgHeight?: number | null, imgWidth?: number | null } | null } | { __typename: 'BlockPubSectionRelatedArticlesEmphasisAuthors', section?: string | null, isHidden?: boolean | null } | { __typename: 'BlockPubSectionsTopStory', sectionIds?: Array<string> | null, isVisible?: boolean | null } | { __typename: 'BlockPubSpotlight', name?: string | null, spotlightDescription?: any | null, customHtmlSnippet?: string | null, relatedTags?: Array<string> | null } | { __typename: 'BlockPubSubscribe', pageDescription?: any | null, discountCode?: string | null, disclaimer?: any | null, discountPromotionalText?: string | null, discountApplicationSuccessText?: string | null, stripePlanOrder1Frequency?: StripePlanFrequency | null, stripePlanOrder2Frequency?: StripePlanFrequency | null, stripePlanOrder3Frequency?: StripePlanFrequency | null, stripePlanOrder4Frequency?: StripePlanFrequency | null, stripePlanOrder5Frequency?: StripePlanFrequency | null, stripePlanOrder6Frequency?: StripePlanFrequency | null, stripePlanOrder1ProductId?: string | null, stripePlanOrder2ProductId?: string | null, stripePlanOrder3ProductId?: string | null, stripePlanOrder4ProductId?: string | null, stripePlanOrder5ProductId?: string | null, stripePlanOrder6ProductId?: string | null, promoStripePlanOrder1Frequency?: StripePlanFrequency | null, promoStripePlanOrder2Frequency?: StripePlanFrequency | null, promoStripePlanOrder3Frequency?: StripePlanFrequency | null, promoStripePlanOrder1ProductId?: string | null, promoStripePlanOrder2ProductId?: string | null, promoStripePlanOrder3ProductId?: string | null, showPromosInSubscribePage?: boolean | null, secondaryPlansIntroText?: any | null, stripeReadersChoicePlanFrequency?: StripePlanFrequency | null, stripeReadersChoicePlanProductId?: string | null, showCustomDonation?: boolean | null } | { __typename: 'BlockPubTagHeader', name?: string | null, content?: any | null, relatedTags?: Array<string> | null, articlesPerRelatedTag?: number | null, horizontal1HeaderScriptOverride?: string | null, horizLazyLoadArticleScript?: string | null, verticalHeaderScriptOverride?: string | null, snippet?: string | null } | { __typename: 'BlockPubThankYou', snippet?: string | null } | { __typename: 'BlockPubWeatherAdvisory', isVisible?: boolean | null } | { __typename: 'BlockWysiwyg', title?: string | null, content?: any | null } | null }> } };

export type ListSiteConversationsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListSiteConversationsQuery = { __typename?: 'Query', listSiteConversations?: { __typename?: 'ConversationConnection', nextToken?: string | null, items: Array<{ __typename?: 'Conversation', id: string, siteId: string, userId: string, title?: string | null, isAnonymous?: boolean | null, createdAt?: string | null, updatedAt?: string | null }> } | null };

export type ListSitePagesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  pageCategories?: InputMaybe<Array<PageCategory> | PageCategory>;
  status: PublishedStatusInput;
}>;


export type ListSitePagesQuery = { __typename?: 'Query', listSitePages: { __typename?: 'PageConnection', items: Array<{ __typename?: 'Page', id: string, slug: string, state: PublishState, sk: string, publishedAt?: string | null, updatedAt: string, pageCategory: PageCategory, listPageLocalBlocks?: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', id: string, sk: string, publishedAt?: string | null, updatedAt: string }> } | null }> } };

export type ListSiteTagsLightweightQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  status?: InputMaybe<PublishedStatusInput>;
}>;


export type ListSiteTagsLightweightQuery = { __typename?: 'Query', listSiteBlocks: { __typename?: 'BlockConnection', items: Array<{ __typename?: 'Block', id: string, sk: string, data?: { __typename?: 'BlockCards' } | { __typename?: 'BlockCoverImage' } | { __typename?: 'BlockFaq' } | { __typename?: 'BlockPubAccount' } | { __typename?: 'BlockPubAdHero' } | { __typename?: 'BlockPubArticleBody' } | { __typename?: 'BlockPubArticleHeader' } | { __typename?: 'BlockPubArticlesBySection' } | { __typename?: 'BlockPubAuthorOverview' } | { __typename?: 'BlockPubBreakingNews' } | { __typename?: 'BlockPubEvents' } | { __typename?: 'BlockPubExternalReferences' } | { __typename?: 'BlockPubGift' } | { __typename?: 'BlockPubHomeHero' } | { __typename?: 'BlockPubHomeTopStories' } | { __typename?: 'BlockPubLeadArticle' } | { __typename?: 'BlockPubMediaTopStories' } | { __typename?: 'BlockPubNewsletters' } | { __typename?: 'BlockPubSearch' } | { __typename?: 'BlockPubSectionMainView' } | { __typename?: 'BlockPubSectionRelatedArticlesEmphasisAuthors' } | { __typename?: 'BlockPubSectionsTopStory' } | { __typename?: 'BlockPubSpotlight' } | { __typename?: 'BlockPubSubscribe' } | { __typename?: 'BlockPubTagHeader', name?: string | null } | { __typename?: 'BlockPubThankYou' } | { __typename?: 'BlockPubWeatherAdvisory' } | { __typename?: 'BlockWysiwyg' } | null }> } };

export type ListUserWorkspacesQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListUserWorkspacesQuery = { __typename?: 'Query', listUserWorkspaces: Array<{ __typename?: 'Workspace', createdAt: string, domainName?: string | null, id: string, name: string, subdomain: string, updatedAt: string, version: number, domain?: { __typename?: 'Domain', createdAt: string, domainCloudFormation?: string | null, domainCloudfront?: string | null, domainName: string, externalProvider: boolean, hostedZoneId?: string | null, nameServers: Array<string>, operationId?: string | null, siteId?: string | null, status: DomainStatus, updatedAt: string, workspaceId?: string | null } | null, listWorkspaceBrands?: { __typename?: 'BrandConnection', nextToken?: string | null, items: Array<{ __typename?: 'Brand', id: string, name: string }> } | null, getWorkspaceUser?: { __typename?: 'WorkspaceUser', createdAt: string, firstName?: string | null, id: string, isConfirmed?: boolean | null, lastName?: string | null, updatedAt: string, username: string, version: number, workspaceGroups: Array<WorkspaceGroup>, workspaceId: string, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } | null }> };

export type QueryListWorkspaceRulesViaDomainWithUserQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  username: Scalars['ID']['input'];
}>;


export type QueryListWorkspaceRulesViaDomainWithUserQuery = { __typename?: 'Query', getWorkspaceByDomain: { __typename?: 'Workspace', id: string, name: string, subdomain: string, updatedAt: string, version: number, listWorkspaceWritingRules: Array<{ __typename?: 'WorkspaceWritingRule', workspaceId: string, id: string, name: string, ruleText: string, active: boolean, type: WritingRuleType, level: WritingRuleLevelWorkspace }>, getWorkspaceUser?: { __typename?: 'WorkspaceUser', createdAt: string, firstName?: string | null, id: string, isConfirmed?: boolean | null, lastName?: string | null, updatedAt: string, username: string, version: number, workspaceGroups: Array<WorkspaceGroup>, workspaceId: string, brandGroups: Array<{ __typename?: 'BrandGroupType', brandId: string, groups: Array<BrandGroup> }> } | null } };

export type ListWorkspaceUsersViaDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  path: Scalars['String']['input'];
}>;


export type ListWorkspaceUsersViaDomainQuery = { __typename?: 'Query', getWorkspaceByDomain: { __typename?: 'Workspace', name: string, subdomain: string, updatedAt: string, version: number, id: string, domainName?: string | null, getBrandByPath?: { __typename?: 'Brand', name: string, path: string, id: string, listWorkspaceUsers?: { __typename?: 'WorkspaceUserConnection', items: Array<{ __typename?: 'WorkspaceUser', id: string, version: number, username: string, firstName?: string | null, lastName?: string | null, isConfirmed?: boolean | null, workspaceId: string, createdAt: string, updatedAt: string, workspaceGroups: Array<WorkspaceGroup>, brandGroups: Array<{ __typename?: 'BrandGroupType', groups: Array<BrandGroup>, brandId: string }> }> } | null } | null } };

export type ListWritingRulesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListWritingRulesQuery = { __typename?: 'Query', listWritingRules: Array<{ __typename?: 'WritingRule', siteId: string, id: string, name: string, ruleText: string, active: boolean, type?: WritingRuleType | null }> };

export type PreviewApNewsFeedItemsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  topicId: Scalars['Int']['input'];
}>;


export type PreviewApNewsFeedItemsQuery = { __typename?: 'Query', previewAPNewsFeedItems: Array<{ __typename?: 'APFeedPreviewItem', id: string, title: string, byline?: string | null, releaseDate?: string | null, pubStatus?: string | null, imageUrl?: string | null, imported: boolean, importedPageId?: string | null, importedTitle?: string | null, skipReason?: string | null }> };

export type PreviewExternalFeedItemsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type PreviewExternalFeedItemsQuery = { __typename?: 'Query', previewExternalFeedItems: Array<{ __typename?: 'ExternalFeedPreviewItem', id: string, title: string, byline?: string | null, releaseDate?: string | null, publishStatus?: string | null, lead?: string | null, tags: Array<string>, metadata: Array<string>, imageUrl?: string | null, body?: any | null, imported: boolean, importedPageId?: string | null, section?: string | null }> };

export type ValidateMirabelConnectionQueryVariables = Exact<{
  input: ValidateMirabelConnectionInput;
}>;


export type ValidateMirabelConnectionQuery = { __typename?: 'Query', validateMirabelConnection: { __typename?: 'ValidateMirabelConnectionResponse', success: boolean, error?: string | null, errorCode?: string | null, data?: { __typename?: 'ValidateMirabelConnectionData', connectionValid: boolean, issues: Array<string>, statusCode?: number | null, statusMessage?: string | null } | null } };

export type ValidateNavigaConnectionQueryVariables = Exact<{
  input: ValidateNavigaConnectionInput;
}>;


export type ValidateNavigaConnectionQuery = { __typename?: 'Query', validateNavigaConnection: { __typename?: 'ValidateNavigaConnectionResponse', success: boolean, error?: string | null, errorCode?: string | null, data?: { __typename?: 'ValidateNavigaConnectionData', connectionValid: boolean, issues: Array<string>, validatedSubscriptions: Array<{ __typename?: 'ValidatedSubscriptionAssociation', stripeProductId: string, navigaPubId: string, navigaRateId: string, publicationName?: string | null, subRateName?: string | null, valid: boolean, error?: string | null }> } | null } };

export type GetReutersCredentialsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetReutersCredentialsQuery = { __typename?: 'Query', getReutersCredentials?: { __typename?: 'ReutersCredentialsStatus', isConfigured: boolean, clientId?: string | null } | null };

export type ListReutersChannelsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ListReutersChannelsQuery = { __typename?: 'Query', listReutersChannels: { __typename?: 'ReutersChannelConnection', items: Array<{ __typename?: 'ReutersChannel', alias: string, name: string, channelCategory?: string | null, sectionId?: string | null, active?: boolean | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, display?: ExternalDisplay | null, imgRequired?: boolean | null, mediaType?: ReutersMediaType | null }> } };

export type SearchReutersItemsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  input: ReutersSearchInput;
}>;


export type SearchReutersItemsQuery = { __typename?: 'Query', searchReutersItems: { __typename?: 'ReutersSearchResult', totalHits: number, hasNextPage: boolean, entitlementIssue?: { __typename?: 'ReutersEntitlementIssue', code: string, message: string, requestedChannels: Array<string>, invalidChannels: Array<string> } | null, items: Array<{ __typename?: 'ReutersSearchItem', id: string, versionedGuid?: string | null, title: string, itemType?: string | null, byline?: string | null, date?: string | null, channel?: string | null, thumbnailUrl?: string | null, fragment?: string | null, imported: boolean, importedPageId?: string | null }> } };

export type SyncReutersChannelsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type SyncReutersChannelsMutation = { __typename?: 'Mutation', syncReutersChannels: { __typename?: 'ReutersChannelSyncResult', syncedAt: string, totalSubscriptions: number, addedChannels: number, removedChannels: number } };

export type GetReutersItemDetailQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  itemId: Scalars['String']['input'];
}>;


export type GetReutersItemDetailQuery = { __typename?: 'Query', getReutersItemDetail: { __typename?: 'ReutersItemDetail', id: string, title: string, itemType?: string | null, profile?: string | null, pubStatus?: string | null, usageTerms?: string | null, byline?: string | null, firstCreated?: string | null, versionCreated?: string | null, credit?: string | null, fragment?: string | null, channel?: string | null, slug?: string | null, thumbnailUrl?: string | null, urgency?: number | null, body?: string | null, imported: boolean, importedPageId?: string | null, importable: boolean, importabilityCode?: string | null, importabilityMessage?: string | null, recommendedDownloadMode?: string | null, associatedImages?: Array<{ __typename?: 'ReutersAssociatedImage', uri: string, thumbnailUrl?: string | null, caption?: string | null, credit?: string | null }> | null } };

export type SetReutersCredentialsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
}>;


export type SetReutersCredentialsMutation = { __typename?: 'Mutation', setReutersCredentials?: { __typename?: 'ReutersCredentialsStatus', isConfigured: boolean } | null };

export type DeleteReutersCredentialsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type DeleteReutersCredentialsMutation = { __typename?: 'Mutation', deleteReutersCredentials?: { __typename?: 'ReutersCredentialsStatus', isConfigured: boolean } | null };

export type UpdateReutersChannelMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  channel: ReutersChannelInput;
}>;


export type UpdateReutersChannelMutation = { __typename?: 'Mutation', updateReutersChannel: { __typename?: 'ReutersChannel', alias: string, name: string, channelCategory?: string | null, sectionId?: string | null, active?: boolean | null, publishStatus?: FeedPublishStatus | null, paywall?: Paywall | null, display?: ExternalDisplay | null, imgRequired?: boolean | null, mediaType?: ReutersMediaType | null } };

export type DownloadReutersStoryMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  itemId: Scalars['String']['input'];
  sectionId: Scalars['ID']['input'];
  publishStatus?: InputMaybe<FeedPublishStatus>;
  paywall?: InputMaybe<Paywall>;
}>;


export type DownloadReutersStoryMutation = { __typename?: 'Mutation', downloadReutersStory: { __typename?: 'Page', id: string, sk: string, slug: string } };

export type OnBlogGenerationSubscriptionVariables = Exact<{
  generationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type OnBlogGenerationSubscription = { __typename?: 'Subscription', onBlogGeneration?: { __typename?: 'GenerateBlogSubscriptionPayload', generationId: string, progress: number, result?: string | null, siteId: string, message?: string | null } | null };

export type OnChatbotMessageSubscriptionVariables = Exact<{
  username: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type OnChatbotMessageSubscription = { __typename?: 'Subscription', onChatbotMessage?: { __typename?: 'ChatbotMessageSubscriptionPayload', siteId: string, messageId: string, text?: string | null, username: string, sequenceNumber?: number | null, fullMessage?: string | null, status: ChatbotMessageSubscriptionPayloadStatus, prompt?: string | null, error?: string | null, totalNumberOfResults?: number | null, currentNumberOfResults?: number | null, type: MessageSubscriptionType } | null };

export type OnArticleGenerationSubscriptionVariables = Exact<{
  generationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type OnArticleGenerationSubscription = { __typename?: 'Subscription', onArticleGeneration?: { __typename?: 'GenerateArticleBodySubscription', generationId: string, progress: number, result?: string | null, siteId: string, message?: string | null, articlePart?: string | null, sequenceNumber?: number | null, error?: string | null } | null };

export type OnImageGenerationSubscriptionVariables = Exact<{
  imageGenerationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type OnImageGenerationSubscription = { __typename?: 'Subscription', onImageGeneration?: { __typename?: 'GenerateImageSubscriptionPayload', siteId: string, imageGenerationId: string, progress: number, error?: string | null, images?: Array<{ __typename?: 'Asset', id: string, public: boolean, brandId: string, key: string, uploaded: boolean, name?: string | null, width?: number | null, height?: number | null, type?: AssetType | null, tags: Array<string>, createdAt: string, updatedAt: string, version: number, usedIn: Array<string> }> | null } | null };

export const BlockDataFragmentFragmentDoc = gql`
    fragment BlockDataFragment on BlockData {
  __typename
  ... on BlockPubTagHeader {
    name
    content
    relatedTags
    articlesPerRelatedTag
    horizontal1HeaderScriptOverride
    horizLazyLoadArticleScript
    verticalHeaderScriptOverride
    snippet
  }
  ... on BlockPubAuthorOverview {
    name
    position
    biography
    picture
    pictureWidth
    pictureHeight
    email
    xHandle
    linkedInUsername
    instagramUsername
    facebookUsername
    youtubeChannelHandle
    phoneNumber
    writerBoilerplate
  }
  ... on BlockPubSectionMainView {
    name
    content
    relatedTags
    articlesPerRelatedTag
    horizontal1HeaderScriptOverride
    horizLazyLoadArticleScript
    verticalHeaderScriptOverride
    snippet
    layout
    preGridArticleNumber
    hideTopStories
    topStoryArticleOverride {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
  }
  ... on BlockPubArticleHeader {
    authors
    blurryPlaceholder
    byline
    carousel {
      key
      blurryPlaceholder
      height
      width
      caption
      credits
      alt
      metadata
      enablePrintOnDemand
    }
    externalDisplay
    featuredMediaType
    image
    imageCaption
    imageCredit
    imageAlt
    imageMetadata
    isIframe
    imageWidth
    imageHeight
    paidPostName
    paidPostImgSrc
    paidPostImgHeight
    paidPostImgWidth
    paidPostUrl
    sponsoredCaption
    sponsoredImgSrc
    sponsoredImgHeight
    sponsoredImgWidth
    releaseDate
    printReleaseDate
    toReview
    paywall
    sponsoredUrl
    summary
    section
    snippet
    tags
    title
    type
    galleryType
    galleryAspectRatio
    eReaderPdfLink
    iframeAspectRatio
    iframeLink
    iframeCaption
    iframeCredits
    editorNotes
    isAPNews
    showComments
    feeds
    metadata
    eventBeginDate
    eventEndDate
    eventICal
    eventTicketUrl
    eventTicketLabel
    eventPreCTACopy
    eventVenueName
    eventLocation
    onlineEventUrl
    eventPhoneContact
    storyLayout
    hideWriterBoilerplate
    hideRelatedArticles
    detachedFromFeed
  }
  ... on BlockPubArticleBody {
    content
  }
  ... on BlockPubMediaTopStories {
    filterOutApStories
    mediaGalleryIsVisible
    socialGalleries {
      type
      items
      isVisible
      location
    }
  }
  ... on BlockPubSectionsTopStory {
    sectionIds
    isVisible
  }
  ... on BlockPubExternalReferences {
    externalReferences {
      ctaText
      ctaLink
      imgSrc
      imgHeight
      imgWidth
    }
    snippet
  }
  ... on BlockPubSectionRelatedArticlesEmphasisAuthors {
    section
    isHidden
  }
  ... on BlockPubAdHero {
    content
  }
  ... on BlockPubBreakingNews {
    title
    href
    isCustom
    customText
    customTextLink
    isVisible
  }
  ... on BlockPubArticlesBySection {
    section
    hideDivider
    pubArticlesBySectionLayout
    showDescription
    articleOverride1 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articleOverride2 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articleOverride3 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articleOverride4 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
  }
  ... on BlockPubHomeTopStories {
    articlesId1 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articlesId2 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articlesId3 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articlesId4 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articlesId5 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    articlesId6 {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
    topStoriesLimit
    sectionsToExclude
    pubHomeTopStoriesLayout
    sponsoredArticle {
      title
      slug
      id
      articleHeaderID
      imgSrc
      imgHeight
      imgWidth
    }
  }
  ... on BlockPubHomeHero {
    title
    slug
    id
    articleHeaderID
    isAutomatic
    isVisible
    imgSrc
    imgHeight
    imgWidth
  }
  ... on BlockPubLeadArticle {
    title
    slug
    id
    articleHeaderID
    isAutomatic
    isVisible
    imgSrc
    imgHeight
    imgWidth
    leadArticleLayout: layout
    title2
    slug2
    id2
    articleHeaderID2
    isAutomatic2
    isVisible2
    imgSrc2
    imgHeight2
    imgWidth2
    leadArticleLayout2: layout2
    title3
    slug3
    id3
    articleHeaderID3
    isAutomatic3
    isVisible3
    imgSrc3
    imgHeight3
    imgWidth3
    leadArticleLayout3: layout3
  }
  ... on BlockWysiwyg {
    title
    content
  }
  ... on BlockFaq {
    description
    faqItems {
      id
      panelHeader
      panelBody
    }
  }
  ... on BlockCoverImage {
    tagline
    title
    description
    src
    width
    height
    snippet
  }
  ... on BlockCards {
    cards {
      id
      title
      content
    }
  }
  ... on BlockPubSubscribe {
    pageDescription
    discountCode
    disclaimer
    discountPromotionalText
    discountApplicationSuccessText
    stripePlanOrder1Frequency
    stripePlanOrder2Frequency
    stripePlanOrder3Frequency
    stripePlanOrder4Frequency
    stripePlanOrder5Frequency
    stripePlanOrder6Frequency
    stripePlanOrder1ProductId
    stripePlanOrder2ProductId
    stripePlanOrder3ProductId
    stripePlanOrder4ProductId
    stripePlanOrder5ProductId
    stripePlanOrder6ProductId
    promoStripePlanOrder1Frequency
    promoStripePlanOrder2Frequency
    promoStripePlanOrder3Frequency
    promoStripePlanOrder1ProductId
    promoStripePlanOrder2ProductId
    promoStripePlanOrder3ProductId
    showPromosInSubscribePage
    secondaryPlansIntroText
    stripeReadersChoicePlanFrequency
    stripeReadersChoicePlanProductId
    showCustomDonation
  }
  ... on BlockPubAccount {
    supportPlanLinkOverride
    snippet
  }
  ... on BlockPubNewsletters {
    snippet
  }
  ... on BlockPubEvents {
    snippet
  }
  ... on BlockPubThankYou {
    snippet
  }
  ... on BlockPubSearch {
    snippet
  }
  ... on BlockPubWeatherAdvisory {
    isVisible
  }
  ... on BlockPubGift {
    headerLogoSrc
    headerLogoWidth
    headerLogoHeight
    showHeaderGIF
    headerTitle
    headerSubtitle
    stripePlansOrderedByProductId
    starredGiftProductId
    disclaimer
    faqItems {
      id
      panelHeader
      panelBody
    }
  }
  ... on BlockPubSpotlight {
    name
    spotlightDescription
    customHtmlSnippet
    relatedTags
  }
}
    `;
export const BlockTemplateDataFragmentFragmentDoc = gql`
    fragment BlockTemplateDataFragment on BlockTemplateData {
  __typename
  ... on BlockPubPaywall {
    numberOfFreeArticlesAllowedPerMonth
    numberOfArticlesWithPaywallWarning
    disablePaywall
    paywallType
  }
  ... on BlockPubHeaderMenu {
    mainMenuId
    drawerMenu1Id
    drawerMenu2Id
    drawerMenu3Id
    drawerMenu4Id
    logoWidth
    logoHeight
    logoSrc
    logoSize
    layout
    customCtaLabel
    customCtaLink
    customCtaType
    hideCustomCta
    isVisible
    leaderBoardAdPosition
    gtmAlternativeImgSrc
    gtmAlternativeImgHeight
    gtmAlternativeImgWidth
    gtmAlternativeImgLink
    snippet
  }
  ... on BlockPubFooter {
    menu1Id
    menu2Id
    menu3Id
    logoWidth
    logoHeight
    logoSrc
    tagline
    copyrigthName
    snippet
  }
  ... on BlockPubNavSqueeze {
    logoWidth
    logoHeight
    logoSrc
    logoSize
  }
  ... on BlockPubArticleRelatedArticles {
    content
    snippet
    eReaderInitializesFullscreen
    eReaderDefaultViewMode
    eReaderDefaultFitMode
    defaultHideImageBackground
  }
  ... on BlockPubPromo {
    disabled
    stripePlanOrder1Frequency
    stripePlanOrder2Frequency
    stripePlanOrder3Frequency
    stripePlanOrder1ProductId
    stripePlanOrder2ProductId
    stripePlanOrder3ProductId
    promoModalCooldownForNonSubscribers
    giftModalCooldownForSubscribers
    giftModalCooldownForNonSubscribers
    customTitleForPromo
    customPopupTimeInSecondsForPromo
    customTitleForGift
    customPopupTimeInSecondsForGift
    modalContentType
    starredGiftProductId
    newsletterModalNewsletterId
    newsletterModalCustomNewsletterId
    customTitleForNewsletter
    customSubtitleForNewsletter
    customSuccessTitleForNewsletter
    customSuccessSubtitleForNewsletter
    customPopupTimeInSecondsForNewsletter
    newsletterModalCooldownForNonSubscribers
  }
}
    `;
export const ClientThemePropertiesFragmentFragmentDoc = gql`
    fragment ClientThemePropertiesFragment on ClientThemeProperties {
  lightModeColors {
    pri
    sec
    lin
    ale
    suc
    war
  }
  darkModeColors {
    pri
    sec
    lin
    ale
    suc
    war
  }
  fonts {
    id
    url
    family
    weight
    style
    isSerif
  }
  typography {
    h1 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    h2 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    h3 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    h4 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    h5 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    h6 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    subtitle1 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    subtitle2 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    body1 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    body2 {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    button {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    caption {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    overline {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    blockquote {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
    code {
      fontId
      fontCase
      fontSize
      lineHeight
      letterSpacing
      spaceAfter
    }
  }
}
    `;
export const CreateDonationProductDocument = gql`
    mutation createDonationProduct($product: CreateDonationProductInput!) {
  createDonationProduct(product: $product) {
    siteId
    productId
    name
    isActive
    stripeDescription
    priceId
    collectPhoneNumber
    minimumAmount
    maximumAmount
    defaultAmount
  }
}
    `;
export type CreateDonationProductMutationFn = Apollo.MutationFunction<CreateDonationProductMutation, CreateDonationProductMutationVariables>;

/**
 * __useCreateDonationProductMutation__
 *
 * To run a mutation, you first call `useCreateDonationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationProductMutation, { data, loading, error }] = useCreateDonationProductMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useCreateDonationProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonationProductMutation, CreateDonationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonationProductMutation, CreateDonationProductMutationVariables>(CreateDonationProductDocument, options);
      }
export type CreateDonationProductMutationHookResult = ReturnType<typeof useCreateDonationProductMutation>;
export type CreateDonationProductMutationResult = Apollo.MutationResult<CreateDonationProductMutation>;
export type CreateDonationProductMutationOptions = Apollo.BaseMutationOptions<CreateDonationProductMutation, CreateDonationProductMutationVariables>;
export const UpdateDonationProductDocument = gql`
    mutation updateDonationProduct($product: UpdateDonationProductInput!) {
  updateDonationProduct(product: $product) {
    siteId
    productId
    name
    isActive
    stripeDescription
    priceId
    collectPhoneNumber
    minimumAmount
    maximumAmount
    defaultAmount
  }
}
    `;
export type UpdateDonationProductMutationFn = Apollo.MutationFunction<UpdateDonationProductMutation, UpdateDonationProductMutationVariables>;

/**
 * __useUpdateDonationProductMutation__
 *
 * To run a mutation, you first call `useUpdateDonationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationProductMutation, { data, loading, error }] = useUpdateDonationProductMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useUpdateDonationProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonationProductMutation, UpdateDonationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonationProductMutation, UpdateDonationProductMutationVariables>(UpdateDonationProductDocument, options);
      }
export type UpdateDonationProductMutationHookResult = ReturnType<typeof useUpdateDonationProductMutation>;
export type UpdateDonationProductMutationResult = Apollo.MutationResult<UpdateDonationProductMutation>;
export type UpdateDonationProductMutationOptions = Apollo.BaseMutationOptions<UpdateDonationProductMutation, UpdateDonationProductMutationVariables>;
export const AddItemToCollectionsDocument = gql`
    mutation addItemToCollections($params: AddItemToCollectionsInput!) {
  addItemToCollections(params: $params) {
    name
    assetKey
    siteId
    assetId
    collectionId
    credit
    caption
    alt
    metadata
    width
    height
    createdAt
    updatedAt
  }
}
    `;
export type AddItemToCollectionsMutationFn = Apollo.MutationFunction<AddItemToCollectionsMutation, AddItemToCollectionsMutationVariables>;

/**
 * __useAddItemToCollectionsMutation__
 *
 * To run a mutation, you first call `useAddItemToCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToCollectionsMutation, { data, loading, error }] = useAddItemToCollectionsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAddItemToCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToCollectionsMutation, AddItemToCollectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemToCollectionsMutation, AddItemToCollectionsMutationVariables>(AddItemToCollectionsDocument, options);
      }
export type AddItemToCollectionsMutationHookResult = ReturnType<typeof useAddItemToCollectionsMutation>;
export type AddItemToCollectionsMutationResult = Apollo.MutationResult<AddItemToCollectionsMutation>;
export type AddItemToCollectionsMutationOptions = Apollo.BaseMutationOptions<AddItemToCollectionsMutation, AddItemToCollectionsMutationVariables>;
export const BulkApplySupportPlanAcrossWorkspaceDocument = gql`
    mutation bulkApplySupportPlanAcrossWorkspace($input: BulkSupportPlanAcrossWorkspaceInput!) {
  bulkApplySupportPlanAcrossWorkspace(input: $input) {
    email
    action
    results {
      siteId
      brandId
      siteName
      status
      message
    }
  }
}
    `;
export type BulkApplySupportPlanAcrossWorkspaceMutationFn = Apollo.MutationFunction<BulkApplySupportPlanAcrossWorkspaceMutation, BulkApplySupportPlanAcrossWorkspaceMutationVariables>;

/**
 * __useBulkApplySupportPlanAcrossWorkspaceMutation__
 *
 * To run a mutation, you first call `useBulkApplySupportPlanAcrossWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkApplySupportPlanAcrossWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkApplySupportPlanAcrossWorkspaceMutation, { data, loading, error }] = useBulkApplySupportPlanAcrossWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkApplySupportPlanAcrossWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<BulkApplySupportPlanAcrossWorkspaceMutation, BulkApplySupportPlanAcrossWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkApplySupportPlanAcrossWorkspaceMutation, BulkApplySupportPlanAcrossWorkspaceMutationVariables>(BulkApplySupportPlanAcrossWorkspaceDocument, options);
      }
export type BulkApplySupportPlanAcrossWorkspaceMutationHookResult = ReturnType<typeof useBulkApplySupportPlanAcrossWorkspaceMutation>;
export type BulkApplySupportPlanAcrossWorkspaceMutationResult = Apollo.MutationResult<BulkApplySupportPlanAcrossWorkspaceMutation>;
export type BulkApplySupportPlanAcrossWorkspaceMutationOptions = Apollo.BaseMutationOptions<BulkApplySupportPlanAcrossWorkspaceMutation, BulkApplySupportPlanAcrossWorkspaceMutationVariables>;
export const BulkEditArticlesDocument = gql`
    mutation bulkEditArticles($input: BulkEditArticlesInput!) {
  bulkEditArticles(input: $input) {
    jobId
    mode
    results {
      pageId
      status
      reason
    }
  }
}
    `;
export type BulkEditArticlesMutationFn = Apollo.MutationFunction<BulkEditArticlesMutation, BulkEditArticlesMutationVariables>;

/**
 * __useBulkEditArticlesMutation__
 *
 * To run a mutation, you first call `useBulkEditArticlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditArticlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditArticlesMutation, { data, loading, error }] = useBulkEditArticlesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEditArticlesMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditArticlesMutation, BulkEditArticlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditArticlesMutation, BulkEditArticlesMutationVariables>(BulkEditArticlesDocument, options);
      }
export type BulkEditArticlesMutationHookResult = ReturnType<typeof useBulkEditArticlesMutation>;
export type BulkEditArticlesMutationResult = Apollo.MutationResult<BulkEditArticlesMutation>;
export type BulkEditArticlesMutationOptions = Apollo.BaseMutationOptions<BulkEditArticlesMutation, BulkEditArticlesMutationVariables>;
export const ChooseMailchimpListDocument = gql`
    mutation chooseMailchimpList($siteId: ID!, $listId: ID!) {
  chooseMailchimpList(siteId: $siteId, listId: $listId)
}
    `;
export type ChooseMailchimpListMutationFn = Apollo.MutationFunction<ChooseMailchimpListMutation, ChooseMailchimpListMutationVariables>;

/**
 * __useChooseMailchimpListMutation__
 *
 * To run a mutation, you first call `useChooseMailchimpListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseMailchimpListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseMailchimpListMutation, { data, loading, error }] = useChooseMailchimpListMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useChooseMailchimpListMutation(baseOptions?: Apollo.MutationHookOptions<ChooseMailchimpListMutation, ChooseMailchimpListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChooseMailchimpListMutation, ChooseMailchimpListMutationVariables>(ChooseMailchimpListDocument, options);
      }
export type ChooseMailchimpListMutationHookResult = ReturnType<typeof useChooseMailchimpListMutation>;
export type ChooseMailchimpListMutationResult = Apollo.MutationResult<ChooseMailchimpListMutation>;
export type ChooseMailchimpListMutationOptions = Apollo.BaseMutationOptions<ChooseMailchimpListMutation, ChooseMailchimpListMutationVariables>;
export const ConnectGelatoAccountDocument = gql`
    mutation connectGelatoAccount($siteId: ID!, $apiKey: String!) {
  connectGelatoAccount(siteId: $siteId, apiKey: $apiKey) {
    id
    gelatoApiKey
    gelatoWebhookSecret
    gelatoActive
    gelatoNewsroomMarkupPercent
    gelatoEnabledProductTypes
  }
}
    `;
export type ConnectGelatoAccountMutationFn = Apollo.MutationFunction<ConnectGelatoAccountMutation, ConnectGelatoAccountMutationVariables>;

/**
 * __useConnectGelatoAccountMutation__
 *
 * To run a mutation, you first call `useConnectGelatoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGelatoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGelatoAccountMutation, { data, loading, error }] = useConnectGelatoAccountMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useConnectGelatoAccountMutation(baseOptions?: Apollo.MutationHookOptions<ConnectGelatoAccountMutation, ConnectGelatoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectGelatoAccountMutation, ConnectGelatoAccountMutationVariables>(ConnectGelatoAccountDocument, options);
      }
export type ConnectGelatoAccountMutationHookResult = ReturnType<typeof useConnectGelatoAccountMutation>;
export type ConnectGelatoAccountMutationResult = Apollo.MutationResult<ConnectGelatoAccountMutation>;
export type ConnectGelatoAccountMutationOptions = Apollo.BaseMutationOptions<ConnectGelatoAccountMutation, ConnectGelatoAccountMutationVariables>;
export const ConnectSiteToMailchimpDocument = gql`
    mutation connectSiteToMailchimp($params: ConnectSiteToMailchimpInput!) {
  connectSiteToMailchimp(params: $params)
}
    `;
export type ConnectSiteToMailchimpMutationFn = Apollo.MutationFunction<ConnectSiteToMailchimpMutation, ConnectSiteToMailchimpMutationVariables>;

/**
 * __useConnectSiteToMailchimpMutation__
 *
 * To run a mutation, you first call `useConnectSiteToMailchimpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSiteToMailchimpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSiteToMailchimpMutation, { data, loading, error }] = useConnectSiteToMailchimpMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConnectSiteToMailchimpMutation(baseOptions?: Apollo.MutationHookOptions<ConnectSiteToMailchimpMutation, ConnectSiteToMailchimpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectSiteToMailchimpMutation, ConnectSiteToMailchimpMutationVariables>(ConnectSiteToMailchimpDocument, options);
      }
export type ConnectSiteToMailchimpMutationHookResult = ReturnType<typeof useConnectSiteToMailchimpMutation>;
export type ConnectSiteToMailchimpMutationResult = Apollo.MutationResult<ConnectSiteToMailchimpMutation>;
export type ConnectSiteToMailchimpMutationOptions = Apollo.BaseMutationOptions<ConnectSiteToMailchimpMutation, ConnectSiteToMailchimpMutationVariables>;
export const ConnectStripeAccountDocument = gql`
    mutation connectStripeAccount($accountId: String!, $siteId: ID!) {
  connectStripeAccount(accountId: $accountId, siteId: $siteId) {
    id
    name
    version
    updatedAt
    siteCategory
    brandId
    connectedStripeAccount {
      accountId
      status
      notificationEmail
      type
      subscriptionPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        struckOutpriceForMonthlyToggleChoice
        struckOutPriceForYearlyToggleChoice
        priceSubtitleMonthly
        priceSubtitleYearly
        stripeDescription
        productId
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        promoCouponIdMonthly
        promoCouponIdYearly
      }
    }
  }
}
    `;
export type ConnectStripeAccountMutationFn = Apollo.MutationFunction<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>;

/**
 * __useConnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useConnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectStripeAccountMutation, { data, loading, error }] = useConnectStripeAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useConnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>(ConnectStripeAccountDocument, options);
      }
export type ConnectStripeAccountMutationHookResult = ReturnType<typeof useConnectStripeAccountMutation>;
export type ConnectStripeAccountMutationResult = Apollo.MutationResult<ConnectStripeAccountMutation>;
export type ConnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>;
export const CreateAccountLinkDocument = gql`
    mutation createAccountLink($siteId: ID!, $returnUrl: String!, $refreshUrl: String!) {
  createAccountLink(
    siteId: $siteId
    returnUrl: $returnUrl
    refreshUrl: $refreshUrl
  ) {
    url
    status
  }
}
    `;
export type CreateAccountLinkMutationFn = Apollo.MutationFunction<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>;

/**
 * __useCreateAccountLinkMutation__
 *
 * To run a mutation, you first call `useCreateAccountLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountLinkMutation, { data, loading, error }] = useCreateAccountLinkMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      returnUrl: // value for 'returnUrl'
 *      refreshUrl: // value for 'refreshUrl'
 *   },
 * });
 */
export function useCreateAccountLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>(CreateAccountLinkDocument, options);
      }
export type CreateAccountLinkMutationHookResult = ReturnType<typeof useCreateAccountLinkMutation>;
export type CreateAccountLinkMutationResult = Apollo.MutationResult<CreateAccountLinkMutation>;
export type CreateAccountLinkMutationOptions = Apollo.BaseMutationOptions<CreateAccountLinkMutation, CreateAccountLinkMutationVariables>;
export const CreateAssetDocument = gql`
    mutation createAsset($asset: CreateAssetInput!) {
  createAsset(asset: $asset) {
    asset {
      brandId
      createdAt
      id
      imagePlaceholder
      key
      name
      updatedAt
      public
      uploaded
      usedIn
      version
      width
      height
    }
    signedUrl
  }
}
    `;
export type CreateAssetMutationFn = Apollo.MutationFunction<CreateAssetMutation, CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      asset: // value for 'asset'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<CreateAssetMutation, CreateAssetMutationVariables>;
export const CreateBlockDocument = gql`
    mutation createBlock($block: CreateBlockInput!) {
  createBlock(block: $block) {
    blockCategory
    brandId
    componentId
    createdAt
    id
    gsk1
    pageId
    savedAt
    data {
      ...BlockDataFragment
    }
    variant
    version
    updatedAt
    archivedAt
    state
    sk
    siteId
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type CreateBlockMutationFn = Apollo.MutationFunction<CreateBlockMutation, CreateBlockMutationVariables>;

/**
 * __useCreateBlockMutation__
 *
 * To run a mutation, you first call `useCreateBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockMutation, { data, loading, error }] = useCreateBlockMutation({
 *   variables: {
 *      block: // value for 'block'
 *   },
 * });
 */
export function useCreateBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockMutation, CreateBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockMutation, CreateBlockMutationVariables>(CreateBlockDocument, options);
      }
export type CreateBlockMutationHookResult = ReturnType<typeof useCreateBlockMutation>;
export type CreateBlockMutationResult = Apollo.MutationResult<CreateBlockMutation>;
export type CreateBlockMutationOptions = Apollo.BaseMutationOptions<CreateBlockMutation, CreateBlockMutationVariables>;
export const CreateBrandDocument = gql`
    mutation createBrand($brand: CreateBrandInput!) {
  createBrand(brand: $brand) {
    id
    version
    createdAt
    updatedAt
    name
    path
    workspaceId
    brandStyleId
    listBrandSites {
      items {
        id
        name
        domainName
        pubgenSubscription {
          id
          status
        }
        domain {
          createdAt
          domainCloudFormation
          domainCloudfront
          domainName
          externalProvider
          hostedZoneId
          nameServers
          operationId
          siteId
          status
          updatedAt
          workspaceId
        }
      }
    }
  }
}
    `;
export type CreateBrandMutationFn = Apollo.MutationFunction<CreateBrandMutation, CreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandMutation, CreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<CreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<CreateBrandMutation, CreateBrandMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation createCheckoutSession($siteId: ID!, $lookup: String!, $successUrl: String!, $cancelUrl: String!) {
  createCheckoutSession(
    siteId: $siteId
    lookup: $lookup
    successUrl: $successUrl
    cancelUrl: $cancelUrl
  )
}
    `;
export type CreateCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      lookup: // value for 'lookup'
 *      successUrl: // value for 'successUrl'
 *      cancelUrl: // value for 'cancelUrl'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = Apollo.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateCollectionDocument = gql`
    mutation createCollection($collection: CreateCollectionInput!) {
  createCollection(collection: $collection) {
    collectionId
    name
    siteId
  }
}
    `;
export type CreateCollectionMutationFn = Apollo.MutationFunction<CreateCollectionMutation, CreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *   },
 * });
 */
export function useCreateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(CreateCollectionDocument, options);
      }
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>;
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const CreateContextTemplateDocument = gql`
    mutation createContextTemplate($contextTemplate: CreateContextTemplateInput!) {
  createContextTemplate(contextTemplate: $contextTemplate) {
    siteId
    id
    name
    content
    active
  }
}
    `;
export type CreateContextTemplateMutationFn = Apollo.MutationFunction<CreateContextTemplateMutation, CreateContextTemplateMutationVariables>;

/**
 * __useCreateContextTemplateMutation__
 *
 * To run a mutation, you first call `useCreateContextTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContextTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContextTemplateMutation, { data, loading, error }] = useCreateContextTemplateMutation({
 *   variables: {
 *      contextTemplate: // value for 'contextTemplate'
 *   },
 * });
 */
export function useCreateContextTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateContextTemplateMutation, CreateContextTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContextTemplateMutation, CreateContextTemplateMutationVariables>(CreateContextTemplateDocument, options);
      }
export type CreateContextTemplateMutationHookResult = ReturnType<typeof useCreateContextTemplateMutation>;
export type CreateContextTemplateMutationResult = Apollo.MutationResult<CreateContextTemplateMutation>;
export type CreateContextTemplateMutationOptions = Apollo.BaseMutationOptions<CreateContextTemplateMutation, CreateContextTemplateMutationVariables>;
export const CreateCustomerPortalDocument = gql`
    mutation createCustomerPortal($siteId: ID!, $returnUrl: String!) {
  createCustomerPortal(siteId: $siteId, returnUrl: $returnUrl)
}
    `;
export type CreateCustomerPortalMutationFn = Apollo.MutationFunction<CreateCustomerPortalMutation, CreateCustomerPortalMutationVariables>;

/**
 * __useCreateCustomerPortalMutation__
 *
 * To run a mutation, you first call `useCreateCustomerPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerPortalMutation, { data, loading, error }] = useCreateCustomerPortalMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreateCustomerPortalMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerPortalMutation, CreateCustomerPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerPortalMutation, CreateCustomerPortalMutationVariables>(CreateCustomerPortalDocument, options);
      }
export type CreateCustomerPortalMutationHookResult = ReturnType<typeof useCreateCustomerPortalMutation>;
export type CreateCustomerPortalMutationResult = Apollo.MutationResult<CreateCustomerPortalMutation>;
export type CreateCustomerPortalMutationOptions = Apollo.BaseMutationOptions<CreateCustomerPortalMutation, CreateCustomerPortalMutationVariables>;
export const CreateExternalFeedDocument = gql`
    mutation createExternalFeed($siteId: ID!, $feed: CreateExternalFeedInput!) {
  createExternalFeed(siteId: $siteId, feed: $feed) {
    id
  }
}
    `;
export type CreateExternalFeedMutationFn = Apollo.MutationFunction<CreateExternalFeedMutation, CreateExternalFeedMutationVariables>;

/**
 * __useCreateExternalFeedMutation__
 *
 * To run a mutation, you first call `useCreateExternalFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalFeedMutation, { data, loading, error }] = useCreateExternalFeedMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useCreateExternalFeedMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalFeedMutation, CreateExternalFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalFeedMutation, CreateExternalFeedMutationVariables>(CreateExternalFeedDocument, options);
      }
export type CreateExternalFeedMutationHookResult = ReturnType<typeof useCreateExternalFeedMutation>;
export type CreateExternalFeedMutationResult = Apollo.MutationResult<CreateExternalFeedMutation>;
export type CreateExternalFeedMutationOptions = Apollo.BaseMutationOptions<CreateExternalFeedMutation, CreateExternalFeedMutationVariables>;
export const CreateFeaturedChatbotPromptDocument = gql`
    mutation createFeaturedChatbotPrompt($prompt: CreateFeaturedChatbotPromptInput!) {
  createFeaturedChatbotPrompt(prompt: $prompt) {
    siteId
    prompt
    active
    label
    category
    pageType
  }
}
    `;
export type CreateFeaturedChatbotPromptMutationFn = Apollo.MutationFunction<CreateFeaturedChatbotPromptMutation, CreateFeaturedChatbotPromptMutationVariables>;

/**
 * __useCreateFeaturedChatbotPromptMutation__
 *
 * To run a mutation, you first call `useCreateFeaturedChatbotPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeaturedChatbotPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeaturedChatbotPromptMutation, { data, loading, error }] = useCreateFeaturedChatbotPromptMutation({
 *   variables: {
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useCreateFeaturedChatbotPromptMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeaturedChatbotPromptMutation, CreateFeaturedChatbotPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeaturedChatbotPromptMutation, CreateFeaturedChatbotPromptMutationVariables>(CreateFeaturedChatbotPromptDocument, options);
      }
export type CreateFeaturedChatbotPromptMutationHookResult = ReturnType<typeof useCreateFeaturedChatbotPromptMutation>;
export type CreateFeaturedChatbotPromptMutationResult = Apollo.MutationResult<CreateFeaturedChatbotPromptMutation>;
export type CreateFeaturedChatbotPromptMutationOptions = Apollo.BaseMutationOptions<CreateFeaturedChatbotPromptMutation, CreateFeaturedChatbotPromptMutationVariables>;
export const CreateFeedDocument = gql`
    mutation createFeed($feed: CreateFeedInput!) {
  createFeed(feed: $feed) {
    id
    workspaceId
    name
    description
    createdAt
    updatedAt
    webhooks {
      url
      active
    }
    filters {
      pattern
      active
    }
  }
}
    `;
export type CreateFeedMutationFn = Apollo.MutationFunction<CreateFeedMutation, CreateFeedMutationVariables>;

/**
 * __useCreateFeedMutation__
 *
 * To run a mutation, you first call `useCreateFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedMutation, { data, loading, error }] = useCreateFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useCreateFeedMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedMutation, CreateFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedMutation, CreateFeedMutationVariables>(CreateFeedDocument, options);
      }
export type CreateFeedMutationHookResult = ReturnType<typeof useCreateFeedMutation>;
export type CreateFeedMutationResult = Apollo.MutationResult<CreateFeedMutation>;
export type CreateFeedMutationOptions = Apollo.BaseMutationOptions<CreateFeedMutation, CreateFeedMutationVariables>;
export const CreateNewsletterDocument = gql`
    mutation createNewsletter($newsletter: NewsletterInput!) {
  createNewsletter(newsletter: $newsletter) {
    siteId
    name
    id
  }
}
    `;
export type CreateNewsletterMutationFn = Apollo.MutationFunction<CreateNewsletterMutation, CreateNewsletterMutationVariables>;

/**
 * __useCreateNewsletterMutation__
 *
 * To run a mutation, you first call `useCreateNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsletterMutation, { data, loading, error }] = useCreateNewsletterMutation({
 *   variables: {
 *      newsletter: // value for 'newsletter'
 *   },
 * });
 */
export function useCreateNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsletterMutation, CreateNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsletterMutation, CreateNewsletterMutationVariables>(CreateNewsletterDocument, options);
      }
export type CreateNewsletterMutationHookResult = ReturnType<typeof useCreateNewsletterMutation>;
export type CreateNewsletterMutationResult = Apollo.MutationResult<CreateNewsletterMutation>;
export type CreateNewsletterMutationOptions = Apollo.BaseMutationOptions<CreateNewsletterMutation, CreateNewsletterMutationVariables>;
export const CreatePageDocument = gql`
    mutation createPage($page: CreatePageInput!) {
  createPage(page: $page) {
    brandId
    getPageTemplate(status: {state: Latest}) {
      items {
        blockTemplates {
          ids
          slot
        }
        blockVariants {
          componentId
          defaultVariant
        }
        brandId
        createdAt
        id
        pageTemplateCategory
        componentId
        savedAt
        siteId
        sk
        updatedAt
        state
        version
      }
    }
    gsk1
    gsk2
    id
    listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
      items {
        blockCategory
        brandId
        createdAt
        gsk1
        id
        componentId
        pageId
        data {
          ...BlockDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        archivedAt
        version
        externalBlockIds
        listExternalBlocks {
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
      }
    }
    localBlockSlots {
      ids
      slot
    }
    listPageAdditionalBlocks {
      items {
        blockCategory
        componentId
        data {
          ...BlockDataFragment
        }
        id
        variant
        version
        state
        pageId
        createdAt
        sk
        updatedAt
        archivedAt
        brandId
        gsk1
        siteId
        slug
      }
    }
    pageCategory
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    version
    createdAt
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const CreatePersonaDocument = gql`
    mutation createPersona($persona: CreatePersonaInput!) {
  createPersona(persona: $persona) {
    siteId
    id
    name
    description
    answerStyle
  }
}
    `;
export type CreatePersonaMutationFn = Apollo.MutationFunction<CreatePersonaMutation, CreatePersonaMutationVariables>;

/**
 * __useCreatePersonaMutation__
 *
 * To run a mutation, you first call `useCreatePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonaMutation, { data, loading, error }] = useCreatePersonaMutation({
 *   variables: {
 *      persona: // value for 'persona'
 *   },
 * });
 */
export function useCreatePersonaMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonaMutation, CreatePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonaMutation, CreatePersonaMutationVariables>(CreatePersonaDocument, options);
      }
export type CreatePersonaMutationHookResult = ReturnType<typeof useCreatePersonaMutation>;
export type CreatePersonaMutationResult = Apollo.MutationResult<CreatePersonaMutation>;
export type CreatePersonaMutationOptions = Apollo.BaseMutationOptions<CreatePersonaMutation, CreatePersonaMutationVariables>;
export const CreatePublicPersonaDocument = gql`
    mutation createPublicPersona($persona: CreatePublicPersonaInput!) {
  createPublicPersona(persona: $persona) {
    siteId
    id
    name
    description
    answerStyle
    active
  }
}
    `;
export type CreatePublicPersonaMutationFn = Apollo.MutationFunction<CreatePublicPersonaMutation, CreatePublicPersonaMutationVariables>;

/**
 * __useCreatePublicPersonaMutation__
 *
 * To run a mutation, you first call `useCreatePublicPersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicPersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicPersonaMutation, { data, loading, error }] = useCreatePublicPersonaMutation({
 *   variables: {
 *      persona: // value for 'persona'
 *   },
 * });
 */
export function useCreatePublicPersonaMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicPersonaMutation, CreatePublicPersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicPersonaMutation, CreatePublicPersonaMutationVariables>(CreatePublicPersonaDocument, options);
      }
export type CreatePublicPersonaMutationHookResult = ReturnType<typeof useCreatePublicPersonaMutation>;
export type CreatePublicPersonaMutationResult = Apollo.MutationResult<CreatePublicPersonaMutation>;
export type CreatePublicPersonaMutationOptions = Apollo.BaseMutationOptions<CreatePublicPersonaMutation, CreatePublicPersonaMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation createQuestion($question: CreateQuestionInput!) {
  createQuestion(question: $question) {
    siteId
    id
    question
    answer
    questionKey
    deprecated
  }
}
    `;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      question: // value for 'question'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const CreateSiteDocument = gql`
    mutation createSite($site: CreateSiteInput!) {
  createSite(site: $site) {
    brandId
    createdAt
    domain {
      createdAt
      domainCloudfront
      domainName
      hostedZoneId
      nameServers
      externalProvider
      domainCloudFormation
      operationId
      siteId
      status
      updatedAt
      workspaceId
    }
    domainName
    id
    name
    updatedAt
    version
    getBrand {
      path
      name
      workspaceId
      id
    }
  }
}
    `;
export type CreateSiteMutationFn = Apollo.MutationFunction<CreateSiteMutation, CreateSiteMutationVariables>;

/**
 * __useCreateSiteMutation__
 *
 * To run a mutation, you first call `useCreateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteMutation, { data, loading, error }] = useCreateSiteMutation({
 *   variables: {
 *      site: // value for 'site'
 *   },
 * });
 */
export function useCreateSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteMutation, CreateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteMutation, CreateSiteMutationVariables>(CreateSiteDocument, options);
      }
export type CreateSiteMutationHookResult = ReturnType<typeof useCreateSiteMutation>;
export type CreateSiteMutationResult = Apollo.MutationResult<CreateSiteMutation>;
export type CreateSiteMutationOptions = Apollo.BaseMutationOptions<CreateSiteMutation, CreateSiteMutationVariables>;
export const CreateSubscriptionGiftDocument = gql`
    mutation createSubscriptionGift($gift: CreateSubscriptionGiftInput!) {
  createSubscriptionGift(gift: $gift) {
    siteId
    productId
    priceId
    planProductId
    couponId
    numberOfGiftedMonths
    priceInCents
    isActive
  }
}
    `;
export type CreateSubscriptionGiftMutationFn = Apollo.MutationFunction<CreateSubscriptionGiftMutation, CreateSubscriptionGiftMutationVariables>;

/**
 * __useCreateSubscriptionGiftMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionGiftMutation, { data, loading, error }] = useCreateSubscriptionGiftMutation({
 *   variables: {
 *      gift: // value for 'gift'
 *   },
 * });
 */
export function useCreateSubscriptionGiftMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionGiftMutation, CreateSubscriptionGiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionGiftMutation, CreateSubscriptionGiftMutationVariables>(CreateSubscriptionGiftDocument, options);
      }
export type CreateSubscriptionGiftMutationHookResult = ReturnType<typeof useCreateSubscriptionGiftMutation>;
export type CreateSubscriptionGiftMutationResult = Apollo.MutationResult<CreateSubscriptionGiftMutation>;
export type CreateSubscriptionGiftMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionGiftMutation, CreateSubscriptionGiftMutationVariables>;
export const CreateSubscriptionPlanDocument = gql`
    mutation createSubscriptionPlan($plan: CreateSubscriptionPlanInput!) {
  createSubscriptionPlan(plan: $plan) {
    benefits
    planSummary
    name
    subtitle
    priceForMonthlyToggleChoice
    priceForYearlyToggleChoice
    priceSubtitleMonthly
    priceSubtitleYearly
    productId
    stripeDescription
    stripePriceIdMonthly
    stripePriceIdYearly
    collectPhoneNumber
    collectShipping
    adSettings
    printOnly
    optionalProductId
    optionalProductName
    optionalProductDescription
    priceForMonthlyOptionalChoice
    priceForYearlyOptionalChoice
    optionalMonthlyState
    optionalYearlyState
    monthlyPlanLabel
    yearlyPlanLabel
  }
}
    `;
export type CreateSubscriptionPlanMutationFn = Apollo.MutationFunction<CreateSubscriptionPlanMutation, CreateSubscriptionPlanMutationVariables>;

/**
 * __useCreateSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionPlanMutation, { data, loading, error }] = useCreateSubscriptionPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useCreateSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionPlanMutation, CreateSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionPlanMutation, CreateSubscriptionPlanMutationVariables>(CreateSubscriptionPlanDocument, options);
      }
export type CreateSubscriptionPlanMutationHookResult = ReturnType<typeof useCreateSubscriptionPlanMutation>;
export type CreateSubscriptionPlanMutationResult = Apollo.MutationResult<CreateSubscriptionPlanMutation>;
export type CreateSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionPlanMutation, CreateSubscriptionPlanMutationVariables>;
export const CreateSubscriptionPromoDocument = gql`
    mutation CreateSubscriptionPromo($promo: CreateSubscriptionPromoInput!) {
  createSubscriptionPromo(promo: $promo) {
    siteId
    couponId
    name
    percentageOff
    durationInMonths
  }
}
    `;
export type CreateSubscriptionPromoMutationFn = Apollo.MutationFunction<CreateSubscriptionPromoMutation, CreateSubscriptionPromoMutationVariables>;

/**
 * __useCreateSubscriptionPromoMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionPromoMutation, { data, loading, error }] = useCreateSubscriptionPromoMutation({
 *   variables: {
 *      promo: // value for 'promo'
 *   },
 * });
 */
export function useCreateSubscriptionPromoMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionPromoMutation, CreateSubscriptionPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionPromoMutation, CreateSubscriptionPromoMutationVariables>(CreateSubscriptionPromoDocument, options);
      }
export type CreateSubscriptionPromoMutationHookResult = ReturnType<typeof useCreateSubscriptionPromoMutation>;
export type CreateSubscriptionPromoMutationResult = Apollo.MutationResult<CreateSubscriptionPromoMutation>;
export type CreateSubscriptionPromoMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionPromoMutation, CreateSubscriptionPromoMutationVariables>;
export const CreateWildcardRedirectDocument = gql`
    mutation createWildcardRedirect($input: CreateWildcardRedirectInput!) {
  createWildcardRedirect(input: $input) {
    id
    matchType
    source
    destination
    preserveSuffix
    preserveQuery
    permanent
    enabled
    priority
    note
    createdAt
    updatedAt
  }
}
    `;
export type CreateWildcardRedirectMutationFn = Apollo.MutationFunction<CreateWildcardRedirectMutation, CreateWildcardRedirectMutationVariables>;

/**
 * __useCreateWildcardRedirectMutation__
 *
 * To run a mutation, you first call `useCreateWildcardRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWildcardRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWildcardRedirectMutation, { data, loading, error }] = useCreateWildcardRedirectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWildcardRedirectMutation(baseOptions?: Apollo.MutationHookOptions<CreateWildcardRedirectMutation, CreateWildcardRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWildcardRedirectMutation, CreateWildcardRedirectMutationVariables>(CreateWildcardRedirectDocument, options);
      }
export type CreateWildcardRedirectMutationHookResult = ReturnType<typeof useCreateWildcardRedirectMutation>;
export type CreateWildcardRedirectMutationResult = Apollo.MutationResult<CreateWildcardRedirectMutation>;
export type CreateWildcardRedirectMutationOptions = Apollo.BaseMutationOptions<CreateWildcardRedirectMutation, CreateWildcardRedirectMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation createWorkspace($workspace: CreateWorkspaceInput!) {
  createWorkspace(workspace: $workspace) {
    workspace {
      domain {
        createdAt
        domainCloudFormation
        domainCloudfront
        domainName
        externalProvider
        hostedZoneId
        nameServers
        operationId
        siteId
        status
        updatedAt
        workspaceId
      }
      createdAt
      domainName
      id
      name
      subdomain
      updatedAt
      version
    }
    workspaceUser {
      id
      version
      createdAt
      updatedAt
      workspaceId
      username
      workspaceGroups
      brandGroups {
        brandId
        groups
      }
    }
  }
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      workspace: // value for 'workspace'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const CreateWorkspaceTollbitBucketDocument = gql`
    mutation createWorkspaceTollbitBucket($workspaceId: ID!) {
  createWorkspaceTollbitBucket(workspaceId: $workspaceId) {
    id
    tollbitAnalytics {
      bucketName
      bucketRegion
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateWorkspaceTollbitBucketMutationFn = Apollo.MutationFunction<CreateWorkspaceTollbitBucketMutation, CreateWorkspaceTollbitBucketMutationVariables>;

/**
 * __useCreateWorkspaceTollbitBucketMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceTollbitBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceTollbitBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceTollbitBucketMutation, { data, loading, error }] = useCreateWorkspaceTollbitBucketMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateWorkspaceTollbitBucketMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceTollbitBucketMutation, CreateWorkspaceTollbitBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceTollbitBucketMutation, CreateWorkspaceTollbitBucketMutationVariables>(CreateWorkspaceTollbitBucketDocument, options);
      }
export type CreateWorkspaceTollbitBucketMutationHookResult = ReturnType<typeof useCreateWorkspaceTollbitBucketMutation>;
export type CreateWorkspaceTollbitBucketMutationResult = Apollo.MutationResult<CreateWorkspaceTollbitBucketMutation>;
export type CreateWorkspaceTollbitBucketMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceTollbitBucketMutation, CreateWorkspaceTollbitBucketMutationVariables>;
export const CreateWorkspaceUserDocument = gql`
    mutation createWorkspaceUser($workspaceUser: CreateWorkspaceUserInput!) {
  createWorkspaceUser(workspaceUser: $workspaceUser) {
    workspaceUser {
      id
      version
      createdAt
      updatedAt
      workspaceId
      username
      workspaceGroups
      brandGroups {
        brandId
        groups
      }
    }
    inviteLink
  }
}
    `;
export type CreateWorkspaceUserMutationFn = Apollo.MutationFunction<CreateWorkspaceUserMutation, CreateWorkspaceUserMutationVariables>;

/**
 * __useCreateWorkspaceUserMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceUserMutation, { data, loading, error }] = useCreateWorkspaceUserMutation({
 *   variables: {
 *      workspaceUser: // value for 'workspaceUser'
 *   },
 * });
 */
export function useCreateWorkspaceUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceUserMutation, CreateWorkspaceUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceUserMutation, CreateWorkspaceUserMutationVariables>(CreateWorkspaceUserDocument, options);
      }
export type CreateWorkspaceUserMutationHookResult = ReturnType<typeof useCreateWorkspaceUserMutation>;
export type CreateWorkspaceUserMutationResult = Apollo.MutationResult<CreateWorkspaceUserMutation>;
export type CreateWorkspaceUserMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceUserMutation, CreateWorkspaceUserMutationVariables>;
export const CreateWorkspaceWritingRuleDocument = gql`
    mutation CreateWorkspaceWritingRule($workspaceWritingRule: CreateWorkspaceWritingRuleInput!) {
  createWorkspaceWritingRule(workspaceWritingRule: $workspaceWritingRule) {
    workspaceId
    id
    name
    ruleText
    active
    type
    level
  }
}
    `;
export type CreateWorkspaceWritingRuleMutationFn = Apollo.MutationFunction<CreateWorkspaceWritingRuleMutation, CreateWorkspaceWritingRuleMutationVariables>;

/**
 * __useCreateWorkspaceWritingRuleMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceWritingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceWritingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceWritingRuleMutation, { data, loading, error }] = useCreateWorkspaceWritingRuleMutation({
 *   variables: {
 *      workspaceWritingRule: // value for 'workspaceWritingRule'
 *   },
 * });
 */
export function useCreateWorkspaceWritingRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceWritingRuleMutation, CreateWorkspaceWritingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceWritingRuleMutation, CreateWorkspaceWritingRuleMutationVariables>(CreateWorkspaceWritingRuleDocument, options);
      }
export type CreateWorkspaceWritingRuleMutationHookResult = ReturnType<typeof useCreateWorkspaceWritingRuleMutation>;
export type CreateWorkspaceWritingRuleMutationResult = Apollo.MutationResult<CreateWorkspaceWritingRuleMutation>;
export type CreateWorkspaceWritingRuleMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceWritingRuleMutation, CreateWorkspaceWritingRuleMutationVariables>;
export const CreateWritingRuleDocument = gql`
    mutation createWritingRule($writingRule: CreateWritingRuleInput!) {
  createWritingRule(writingRule: $writingRule) {
    siteId
    name
    ruleText
    active
    type
  }
}
    `;
export type CreateWritingRuleMutationFn = Apollo.MutationFunction<CreateWritingRuleMutation, CreateWritingRuleMutationVariables>;

/**
 * __useCreateWritingRuleMutation__
 *
 * To run a mutation, you first call `useCreateWritingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWritingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWritingRuleMutation, { data, loading, error }] = useCreateWritingRuleMutation({
 *   variables: {
 *      writingRule: // value for 'writingRule'
 *   },
 * });
 */
export function useCreateWritingRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateWritingRuleMutation, CreateWritingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWritingRuleMutation, CreateWritingRuleMutationVariables>(CreateWritingRuleDocument, options);
      }
export type CreateWritingRuleMutationHookResult = ReturnType<typeof useCreateWritingRuleMutation>;
export type CreateWritingRuleMutationResult = Apollo.MutationResult<CreateWritingRuleMutation>;
export type CreateWritingRuleMutationOptions = Apollo.BaseMutationOptions<CreateWritingRuleMutation, CreateWritingRuleMutationVariables>;
export const DeleteAssetDocument = gql`
    mutation deleteAsset($id: ID!) {
  deleteAsset(id: $id) {
    brandId
    createdAt
    height
    id
    imagePlaceholder
    key
    name
    public
    tags
    type
    updatedAt
    uploaded
    usedIn
    version
    width
  }
}
    `;
export type DeleteAssetMutationFn = Apollo.MutationFunction<DeleteAssetMutation, DeleteAssetMutationVariables>;

/**
 * __useDeleteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetMutation, { data, loading, error }] = useDeleteAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetMutation, DeleteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetMutation, DeleteAssetMutationVariables>(DeleteAssetDocument, options);
      }
export type DeleteAssetMutationHookResult = ReturnType<typeof useDeleteAssetMutation>;
export type DeleteAssetMutationResult = Apollo.MutationResult<DeleteAssetMutation>;
export type DeleteAssetMutationOptions = Apollo.BaseMutationOptions<DeleteAssetMutation, DeleteAssetMutationVariables>;
export const DeleteBlockDocument = gql`
    mutation deleteBlock($id: ID!) {
  deleteBlock(id: $id) {
    id
  }
}
    `;
export type DeleteBlockMutationFn = Apollo.MutationFunction<DeleteBlockMutation, DeleteBlockMutationVariables>;

/**
 * __useDeleteBlockMutation__
 *
 * To run a mutation, you first call `useDeleteBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockMutation, { data, loading, error }] = useDeleteBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlockMutation, DeleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument, options);
      }
export type DeleteBlockMutationHookResult = ReturnType<typeof useDeleteBlockMutation>;
export type DeleteBlockMutationResult = Apollo.MutationResult<DeleteBlockMutation>;
export type DeleteBlockMutationOptions = Apollo.BaseMutationOptions<DeleteBlockMutation, DeleteBlockMutationVariables>;
export const DeleteBrandDocument = gql`
    mutation deleteBrand($id: ID!) {
  deleteBrand(id: $id) {
    id
    name
  }
}
    `;
export type DeleteBrandMutationFn = Apollo.MutationFunction<DeleteBrandMutation, DeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBrandMutation, DeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<DeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<DeleteBrandMutation, DeleteBrandMutationVariables>;
export const DeleteCollectionDocument = gql`
    mutation deleteCollection($collection: DeleteCollectionInput!) {
  deleteCollection(collection: $collection) {
    collectionId
    name
    siteId
  }
}
    `;
export type DeleteCollectionMutationFn = Apollo.MutationFunction<DeleteCollectionMutation, DeleteCollectionMutationVariables>;

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *   },
 * });
 */
export function useDeleteCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollectionMutation, DeleteCollectionMutationVariables>(DeleteCollectionDocument, options);
      }
export type DeleteCollectionMutationHookResult = ReturnType<typeof useDeleteCollectionMutation>;
export type DeleteCollectionMutationResult = Apollo.MutationResult<DeleteCollectionMutation>;
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>;
export const DeleteContextTemplateDocument = gql`
    mutation deleteContextTemplate($siteId: ID!, $contextTemplateId: ID!) {
  deleteContextTemplate(siteId: $siteId, contextTemplateId: $contextTemplateId) {
    siteId
    id
    name
    content
    active
  }
}
    `;
export type DeleteContextTemplateMutationFn = Apollo.MutationFunction<DeleteContextTemplateMutation, DeleteContextTemplateMutationVariables>;

/**
 * __useDeleteContextTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteContextTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContextTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContextTemplateMutation, { data, loading, error }] = useDeleteContextTemplateMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      contextTemplateId: // value for 'contextTemplateId'
 *   },
 * });
 */
export function useDeleteContextTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContextTemplateMutation, DeleteContextTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContextTemplateMutation, DeleteContextTemplateMutationVariables>(DeleteContextTemplateDocument, options);
      }
export type DeleteContextTemplateMutationHookResult = ReturnType<typeof useDeleteContextTemplateMutation>;
export type DeleteContextTemplateMutationResult = Apollo.MutationResult<DeleteContextTemplateMutation>;
export type DeleteContextTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteContextTemplateMutation, DeleteContextTemplateMutationVariables>;
export const DeleteExternalFeedDocument = gql`
    mutation deleteExternalFeed($siteId: ID!, $id: ID!) {
  deleteExternalFeed(siteId: $siteId, id: $id)
}
    `;
export type DeleteExternalFeedMutationFn = Apollo.MutationFunction<DeleteExternalFeedMutation, DeleteExternalFeedMutationVariables>;

/**
 * __useDeleteExternalFeedMutation__
 *
 * To run a mutation, you first call `useDeleteExternalFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalFeedMutation, { data, loading, error }] = useDeleteExternalFeedMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalFeedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalFeedMutation, DeleteExternalFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalFeedMutation, DeleteExternalFeedMutationVariables>(DeleteExternalFeedDocument, options);
      }
export type DeleteExternalFeedMutationHookResult = ReturnType<typeof useDeleteExternalFeedMutation>;
export type DeleteExternalFeedMutationResult = Apollo.MutationResult<DeleteExternalFeedMutation>;
export type DeleteExternalFeedMutationOptions = Apollo.BaseMutationOptions<DeleteExternalFeedMutation, DeleteExternalFeedMutationVariables>;
export const DeleteFeaturedChatbotPromptDocument = gql`
    mutation deleteFeaturedChatbotPrompt($siteId: ID!, $promptId: ID!) {
  deleteFeaturedChatbotPrompt(siteId: $siteId, promptId: $promptId) {
    siteId
    id
    prompt
    active
    label
    category
    pageType
  }
}
    `;
export type DeleteFeaturedChatbotPromptMutationFn = Apollo.MutationFunction<DeleteFeaturedChatbotPromptMutation, DeleteFeaturedChatbotPromptMutationVariables>;

/**
 * __useDeleteFeaturedChatbotPromptMutation__
 *
 * To run a mutation, you first call `useDeleteFeaturedChatbotPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeaturedChatbotPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeaturedChatbotPromptMutation, { data, loading, error }] = useDeleteFeaturedChatbotPromptMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      promptId: // value for 'promptId'
 *   },
 * });
 */
export function useDeleteFeaturedChatbotPromptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeaturedChatbotPromptMutation, DeleteFeaturedChatbotPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeaturedChatbotPromptMutation, DeleteFeaturedChatbotPromptMutationVariables>(DeleteFeaturedChatbotPromptDocument, options);
      }
export type DeleteFeaturedChatbotPromptMutationHookResult = ReturnType<typeof useDeleteFeaturedChatbotPromptMutation>;
export type DeleteFeaturedChatbotPromptMutationResult = Apollo.MutationResult<DeleteFeaturedChatbotPromptMutation>;
export type DeleteFeaturedChatbotPromptMutationOptions = Apollo.BaseMutationOptions<DeleteFeaturedChatbotPromptMutation, DeleteFeaturedChatbotPromptMutationVariables>;
export const DeleteFeedDocument = gql`
    mutation deleteFeed($workspaceId: ID!, $id: ID!) {
  deleteFeed(workspaceId: $workspaceId, id: $id) {
    id
    workspaceId
    name
    description
    createdAt
    updatedAt
  }
}
    `;
export type DeleteFeedMutationFn = Apollo.MutationFunction<DeleteFeedMutation, DeleteFeedMutationVariables>;

/**
 * __useDeleteFeedMutation__
 *
 * To run a mutation, you first call `useDeleteFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedMutation, { data, loading, error }] = useDeleteFeedMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeedMutation, DeleteFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeedMutation, DeleteFeedMutationVariables>(DeleteFeedDocument, options);
      }
export type DeleteFeedMutationHookResult = ReturnType<typeof useDeleteFeedMutation>;
export type DeleteFeedMutationResult = Apollo.MutationResult<DeleteFeedMutation>;
export type DeleteFeedMutationOptions = Apollo.BaseMutationOptions<DeleteFeedMutation, DeleteFeedMutationVariables>;
export const DeleteNewsletterDocument = gql`
    mutation deleteNewsletter($siteId: ID!, $newsletterId: ID!) {
  deleteNewsletter(siteId: $siteId, newsletterId: $newsletterId) {
    siteId
    name
    id
  }
}
    `;
export type DeleteNewsletterMutationFn = Apollo.MutationFunction<DeleteNewsletterMutation, DeleteNewsletterMutationVariables>;

/**
 * __useDeleteNewsletterMutation__
 *
 * To run a mutation, you first call `useDeleteNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsletterMutation, { data, loading, error }] = useDeleteNewsletterMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newsletterId: // value for 'newsletterId'
 *   },
 * });
 */
export function useDeleteNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNewsletterMutation, DeleteNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNewsletterMutation, DeleteNewsletterMutationVariables>(DeleteNewsletterDocument, options);
      }
export type DeleteNewsletterMutationHookResult = ReturnType<typeof useDeleteNewsletterMutation>;
export type DeleteNewsletterMutationResult = Apollo.MutationResult<DeleteNewsletterMutation>;
export type DeleteNewsletterMutationOptions = Apollo.BaseMutationOptions<DeleteNewsletterMutation, DeleteNewsletterMutationVariables>;
export const DeletePageDocument = gql`
    mutation deletePage($id: ID!) {
  deletePage(id: $id) {
    id
    slug
    sk
  }
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const DeletePagesDocument = gql`
    mutation deletePages($ids: [ID!]!) {
  deletePages(ids: $ids) {
    id
    slug
    sk
  }
}
    `;
export type DeletePagesMutationFn = Apollo.MutationFunction<DeletePagesMutation, DeletePagesMutationVariables>;

/**
 * __useDeletePagesMutation__
 *
 * To run a mutation, you first call `useDeletePagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePagesMutation, { data, loading, error }] = useDeletePagesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeletePagesMutation(baseOptions?: Apollo.MutationHookOptions<DeletePagesMutation, DeletePagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePagesMutation, DeletePagesMutationVariables>(DeletePagesDocument, options);
      }
export type DeletePagesMutationHookResult = ReturnType<typeof useDeletePagesMutation>;
export type DeletePagesMutationResult = Apollo.MutationResult<DeletePagesMutation>;
export type DeletePagesMutationOptions = Apollo.BaseMutationOptions<DeletePagesMutation, DeletePagesMutationVariables>;
export const DeletePersonaDocument = gql`
    mutation deletePersona($siteId: ID!, $personaId: ID!) {
  deletePersona(siteId: $siteId, personaId: $personaId) {
    siteId
    id
    name
    description
    answerStyle
  }
}
    `;
export type DeletePersonaMutationFn = Apollo.MutationFunction<DeletePersonaMutation, DeletePersonaMutationVariables>;

/**
 * __useDeletePersonaMutation__
 *
 * To run a mutation, you first call `useDeletePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonaMutation, { data, loading, error }] = useDeletePersonaMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      personaId: // value for 'personaId'
 *   },
 * });
 */
export function useDeletePersonaMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonaMutation, DeletePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonaMutation, DeletePersonaMutationVariables>(DeletePersonaDocument, options);
      }
export type DeletePersonaMutationHookResult = ReturnType<typeof useDeletePersonaMutation>;
export type DeletePersonaMutationResult = Apollo.MutationResult<DeletePersonaMutation>;
export type DeletePersonaMutationOptions = Apollo.BaseMutationOptions<DeletePersonaMutation, DeletePersonaMutationVariables>;
export const DeletePublicPersonaDocument = gql`
    mutation deletePublicPersona($siteId: ID!, $personaId: ID!) {
  deletePublicPersona(siteId: $siteId, personaId: $personaId) {
    siteId
    id
    name
    description
    answerStyle
    active
  }
}
    `;
export type DeletePublicPersonaMutationFn = Apollo.MutationFunction<DeletePublicPersonaMutation, DeletePublicPersonaMutationVariables>;

/**
 * __useDeletePublicPersonaMutation__
 *
 * To run a mutation, you first call `useDeletePublicPersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublicPersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublicPersonaMutation, { data, loading, error }] = useDeletePublicPersonaMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      personaId: // value for 'personaId'
 *   },
 * });
 */
export function useDeletePublicPersonaMutation(baseOptions?: Apollo.MutationHookOptions<DeletePublicPersonaMutation, DeletePublicPersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePublicPersonaMutation, DeletePublicPersonaMutationVariables>(DeletePublicPersonaDocument, options);
      }
export type DeletePublicPersonaMutationHookResult = ReturnType<typeof useDeletePublicPersonaMutation>;
export type DeletePublicPersonaMutationResult = Apollo.MutationResult<DeletePublicPersonaMutation>;
export type DeletePublicPersonaMutationOptions = Apollo.BaseMutationOptions<DeletePublicPersonaMutation, DeletePublicPersonaMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation deleteQuestion($siteId: ID!, $questionId: ID!) {
  deleteQuestion(siteId: $siteId, questionId: $questionId) {
    siteId
    id
    question
    answer
    questionKey
    deprecated
  }
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const DeleteSiteDocument = gql`
    mutation deleteSite($siteId: ID!) {
  deleteSite(id: $siteId) {
    id
    name
  }
}
    `;
export type DeleteSiteMutationFn = Apollo.MutationFunction<DeleteSiteMutation, DeleteSiteMutationVariables>;

/**
 * __useDeleteSiteMutation__
 *
 * To run a mutation, you first call `useDeleteSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteMutation, { data, loading, error }] = useDeleteSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDeleteSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteMutation, DeleteSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteMutation, DeleteSiteMutationVariables>(DeleteSiteDocument, options);
      }
export type DeleteSiteMutationHookResult = ReturnType<typeof useDeleteSiteMutation>;
export type DeleteSiteMutationResult = Apollo.MutationResult<DeleteSiteMutation>;
export type DeleteSiteMutationOptions = Apollo.BaseMutationOptions<DeleteSiteMutation, DeleteSiteMutationVariables>;
export const DeleteSubscriptionGiftDocument = gql`
    mutation deleteSubscriptionGift($gift: DeleteSubscriptionGiftInput!) {
  deleteSubscriptionGift(gift: $gift) {
    productId
  }
}
    `;
export type DeleteSubscriptionGiftMutationFn = Apollo.MutationFunction<DeleteSubscriptionGiftMutation, DeleteSubscriptionGiftMutationVariables>;

/**
 * __useDeleteSubscriptionGiftMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionGiftMutation, { data, loading, error }] = useDeleteSubscriptionGiftMutation({
 *   variables: {
 *      gift: // value for 'gift'
 *   },
 * });
 */
export function useDeleteSubscriptionGiftMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionGiftMutation, DeleteSubscriptionGiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionGiftMutation, DeleteSubscriptionGiftMutationVariables>(DeleteSubscriptionGiftDocument, options);
      }
export type DeleteSubscriptionGiftMutationHookResult = ReturnType<typeof useDeleteSubscriptionGiftMutation>;
export type DeleteSubscriptionGiftMutationResult = Apollo.MutationResult<DeleteSubscriptionGiftMutation>;
export type DeleteSubscriptionGiftMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionGiftMutation, DeleteSubscriptionGiftMutationVariables>;
export const DeleteSubscriptionPlanDocument = gql`
    mutation deleteSubscriptionPlan($plan: DeleteSubscriptionPlanInput!) {
  deleteSubscriptionPlan(plan: $plan) {
    benefits
    planSummary
    name
    subtitle
    priceForMonthlyToggleChoice
    priceForYearlyToggleChoice
    priceSubtitleMonthly
    priceSubtitleYearly
    productId
    stripeDescription
    stripePriceIdMonthly
    stripePriceIdYearly
    collectPhoneNumber
    collectShipping
    adSettings
    printOnly
    monthlyPlanLabel
    yearlyPlanLabel
  }
}
    `;
export type DeleteSubscriptionPlanMutationFn = Apollo.MutationFunction<DeleteSubscriptionPlanMutation, DeleteSubscriptionPlanMutationVariables>;

/**
 * __useDeleteSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionPlanMutation, { data, loading, error }] = useDeleteSubscriptionPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useDeleteSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionPlanMutation, DeleteSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionPlanMutation, DeleteSubscriptionPlanMutationVariables>(DeleteSubscriptionPlanDocument, options);
      }
export type DeleteSubscriptionPlanMutationHookResult = ReturnType<typeof useDeleteSubscriptionPlanMutation>;
export type DeleteSubscriptionPlanMutationResult = Apollo.MutationResult<DeleteSubscriptionPlanMutation>;
export type DeleteSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionPlanMutation, DeleteSubscriptionPlanMutationVariables>;
export const DeleteSubscriptionPromoDocument = gql`
    mutation DeleteSubscriptionPromo($promo: DeleteSubscriptionPromoInput!) {
  deleteSubscriptionPromo(promo: $promo) {
    siteId
    couponId
    name
    percentageOff
    durationInMonths
  }
}
    `;
export type DeleteSubscriptionPromoMutationFn = Apollo.MutationFunction<DeleteSubscriptionPromoMutation, DeleteSubscriptionPromoMutationVariables>;

/**
 * __useDeleteSubscriptionPromoMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionPromoMutation, { data, loading, error }] = useDeleteSubscriptionPromoMutation({
 *   variables: {
 *      promo: // value for 'promo'
 *   },
 * });
 */
export function useDeleteSubscriptionPromoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionPromoMutation, DeleteSubscriptionPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionPromoMutation, DeleteSubscriptionPromoMutationVariables>(DeleteSubscriptionPromoDocument, options);
      }
export type DeleteSubscriptionPromoMutationHookResult = ReturnType<typeof useDeleteSubscriptionPromoMutation>;
export type DeleteSubscriptionPromoMutationResult = Apollo.MutationResult<DeleteSubscriptionPromoMutation>;
export type DeleteSubscriptionPromoMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionPromoMutation, DeleteSubscriptionPromoMutationVariables>;
export const DeleteWildcardRedirectDocument = gql`
    mutation deleteWildcardRedirect($input: DeleteWildcardRedirectInput!) {
  deleteWildcardRedirect(input: $input)
}
    `;
export type DeleteWildcardRedirectMutationFn = Apollo.MutationFunction<DeleteWildcardRedirectMutation, DeleteWildcardRedirectMutationVariables>;

/**
 * __useDeleteWildcardRedirectMutation__
 *
 * To run a mutation, you first call `useDeleteWildcardRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWildcardRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWildcardRedirectMutation, { data, loading, error }] = useDeleteWildcardRedirectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWildcardRedirectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWildcardRedirectMutation, DeleteWildcardRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWildcardRedirectMutation, DeleteWildcardRedirectMutationVariables>(DeleteWildcardRedirectDocument, options);
      }
export type DeleteWildcardRedirectMutationHookResult = ReturnType<typeof useDeleteWildcardRedirectMutation>;
export type DeleteWildcardRedirectMutationResult = Apollo.MutationResult<DeleteWildcardRedirectMutation>;
export type DeleteWildcardRedirectMutationOptions = Apollo.BaseMutationOptions<DeleteWildcardRedirectMutation, DeleteWildcardRedirectMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation deleteWorkspace($id: ID!) {
  deleteWorkspace(id: $id) {
    name
    id
    subdomain
    updatedAt
  }
}
    `;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const DeleteWorkspaceUserDocument = gql`
    mutation deleteWorkspaceUser($workspaceId: ID!, $username: String!) {
  deleteWorkspaceUser(workspaceId: $workspaceId, username: $username) {
    id
    version
    createdAt
    updatedAt
    workspaceId
    username
    workspaceGroups
    brandGroups {
      brandId
      groups
    }
  }
}
    `;
export type DeleteWorkspaceUserMutationFn = Apollo.MutationFunction<DeleteWorkspaceUserMutation, DeleteWorkspaceUserMutationVariables>;

/**
 * __useDeleteWorkspaceUserMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceUserMutation, { data, loading, error }] = useDeleteWorkspaceUserMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useDeleteWorkspaceUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceUserMutation, DeleteWorkspaceUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceUserMutation, DeleteWorkspaceUserMutationVariables>(DeleteWorkspaceUserDocument, options);
      }
export type DeleteWorkspaceUserMutationHookResult = ReturnType<typeof useDeleteWorkspaceUserMutation>;
export type DeleteWorkspaceUserMutationResult = Apollo.MutationResult<DeleteWorkspaceUserMutation>;
export type DeleteWorkspaceUserMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceUserMutation, DeleteWorkspaceUserMutationVariables>;
export const DeleteWorkspaceWritingRuleDocument = gql`
    mutation deleteWorkspaceWritingRule($workspaceId: ID!, $workspaceWritingRuleId: ID!) {
  deleteWorkspaceWritingRule(
    workspaceId: $workspaceId
    workspaceWritingRuleId: $workspaceWritingRuleId
  ) {
    workspaceId
    id
    name
    ruleText
    active
    type
    level
  }
}
    `;
export type DeleteWorkspaceWritingRuleMutationFn = Apollo.MutationFunction<DeleteWorkspaceWritingRuleMutation, DeleteWorkspaceWritingRuleMutationVariables>;

/**
 * __useDeleteWorkspaceWritingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceWritingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceWritingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceWritingRuleMutation, { data, loading, error }] = useDeleteWorkspaceWritingRuleMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      workspaceWritingRuleId: // value for 'workspaceWritingRuleId'
 *   },
 * });
 */
export function useDeleteWorkspaceWritingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceWritingRuleMutation, DeleteWorkspaceWritingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceWritingRuleMutation, DeleteWorkspaceWritingRuleMutationVariables>(DeleteWorkspaceWritingRuleDocument, options);
      }
export type DeleteWorkspaceWritingRuleMutationHookResult = ReturnType<typeof useDeleteWorkspaceWritingRuleMutation>;
export type DeleteWorkspaceWritingRuleMutationResult = Apollo.MutationResult<DeleteWorkspaceWritingRuleMutation>;
export type DeleteWorkspaceWritingRuleMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceWritingRuleMutation, DeleteWorkspaceWritingRuleMutationVariables>;
export const DeleteWritingRuleDocument = gql`
    mutation deleteWritingRule($siteId: ID!, $writingRuleId: ID!) {
  deleteWritingRule(siteId: $siteId, writingRuleId: $writingRuleId) {
    siteId
    id
    name
    ruleText
    active
    type
  }
}
    `;
export type DeleteWritingRuleMutationFn = Apollo.MutationFunction<DeleteWritingRuleMutation, DeleteWritingRuleMutationVariables>;

/**
 * __useDeleteWritingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteWritingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWritingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWritingRuleMutation, { data, loading, error }] = useDeleteWritingRuleMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      writingRuleId: // value for 'writingRuleId'
 *   },
 * });
 */
export function useDeleteWritingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWritingRuleMutation, DeleteWritingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWritingRuleMutation, DeleteWritingRuleMutationVariables>(DeleteWritingRuleDocument, options);
      }
export type DeleteWritingRuleMutationHookResult = ReturnType<typeof useDeleteWritingRuleMutation>;
export type DeleteWritingRuleMutationResult = Apollo.MutationResult<DeleteWritingRuleMutation>;
export type DeleteWritingRuleMutationOptions = Apollo.BaseMutationOptions<DeleteWritingRuleMutation, DeleteWritingRuleMutationVariables>;
export const DisconnectGelatoAccountDocument = gql`
    mutation disconnectGelatoAccount($siteId: ID!) {
  disconnectGelatoAccount(siteId: $siteId) {
    id
    gelatoApiKey
    gelatoWebhookSecret
    gelatoActive
    gelatoNewsroomMarkupPercent
    gelatoEnabledProductTypes
  }
}
    `;
export type DisconnectGelatoAccountMutationFn = Apollo.MutationFunction<DisconnectGelatoAccountMutation, DisconnectGelatoAccountMutationVariables>;

/**
 * __useDisconnectGelatoAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectGelatoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectGelatoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectGelatoAccountMutation, { data, loading, error }] = useDisconnectGelatoAccountMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDisconnectGelatoAccountMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectGelatoAccountMutation, DisconnectGelatoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectGelatoAccountMutation, DisconnectGelatoAccountMutationVariables>(DisconnectGelatoAccountDocument, options);
      }
export type DisconnectGelatoAccountMutationHookResult = ReturnType<typeof useDisconnectGelatoAccountMutation>;
export type DisconnectGelatoAccountMutationResult = Apollo.MutationResult<DisconnectGelatoAccountMutation>;
export type DisconnectGelatoAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectGelatoAccountMutation, DisconnectGelatoAccountMutationVariables>;
export const DisconnectSiteToMailchimpDocument = gql`
    mutation disconnectSiteToMailchimp($siteId: ID!) {
  disconnectSiteToMailchimp(siteId: $siteId)
}
    `;
export type DisconnectSiteToMailchimpMutationFn = Apollo.MutationFunction<DisconnectSiteToMailchimpMutation, DisconnectSiteToMailchimpMutationVariables>;

/**
 * __useDisconnectSiteToMailchimpMutation__
 *
 * To run a mutation, you first call `useDisconnectSiteToMailchimpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectSiteToMailchimpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectSiteToMailchimpMutation, { data, loading, error }] = useDisconnectSiteToMailchimpMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDisconnectSiteToMailchimpMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectSiteToMailchimpMutation, DisconnectSiteToMailchimpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectSiteToMailchimpMutation, DisconnectSiteToMailchimpMutationVariables>(DisconnectSiteToMailchimpDocument, options);
      }
export type DisconnectSiteToMailchimpMutationHookResult = ReturnType<typeof useDisconnectSiteToMailchimpMutation>;
export type DisconnectSiteToMailchimpMutationResult = Apollo.MutationResult<DisconnectSiteToMailchimpMutation>;
export type DisconnectSiteToMailchimpMutationOptions = Apollo.BaseMutationOptions<DisconnectSiteToMailchimpMutation, DisconnectSiteToMailchimpMutationVariables>;
export const DisconnectStripeAccountDocument = gql`
    mutation disconnectStripeAccount($siteId: ID!) {
  disconnectStripeAccount(siteId: $siteId) {
    id
    name
    version
    updatedAt
    siteCategory
    brandId
    connectedStripeAccount {
      accountId
      status
      notificationEmail
      type
      subscriptionPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        struckOutpriceForMonthlyToggleChoice
        struckOutPriceForYearlyToggleChoice
        priceSubtitleMonthly
        priceSubtitleYearly
        stripeDescription
        productId
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        promoCouponIdMonthly
        promoCouponIdYearly
      }
    }
  }
}
    `;
export type DisconnectStripeAccountMutationFn = Apollo.MutationFunction<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>;

/**
 * __useDisconnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectStripeAccountMutation, { data, loading, error }] = useDisconnectStripeAccountMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDisconnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>(DisconnectStripeAccountDocument, options);
      }
export type DisconnectStripeAccountMutationHookResult = ReturnType<typeof useDisconnectStripeAccountMutation>;
export type DisconnectStripeAccountMutationResult = Apollo.MutationResult<DisconnectStripeAccountMutation>;
export type DisconnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>;
export const DownloadApNewsStoryDocument = gql`
    mutation downloadAPNewsStory($siteId: ID!, $apStoryId: ID!, $sectionId: ID!) {
  downloadAPNewsStory(
    siteId: $siteId
    apStoryId: $apStoryId
    sectionId: $sectionId
  ) {
    brandId
    getPageTemplate(status: {state: Latest}) {
      items {
        blockTemplates {
          ids
          slot
        }
        blockVariants {
          componentId
          defaultVariant
        }
        brandId
        createdAt
        id
        pageTemplateCategory
        componentId
        savedAt
        siteId
        sk
        updatedAt
        state
        version
      }
    }
    gsk1
    gsk2
    id
    listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
      items {
        blockCategory
        brandId
        createdAt
        gsk1
        id
        componentId
        pageId
        data {
          ...BlockDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        archivedAt
        version
        externalBlockIds
        listExternalBlocks {
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
      }
    }
    localBlockSlots {
      ids
      slot
    }
    listPageAdditionalBlocks {
      items {
        blockCategory
        componentId
        data {
          ...BlockDataFragment
        }
        id
        variant
        version
        state
        pageId
        createdAt
        sk
        updatedAt
        archivedAt
        brandId
        gsk1
        siteId
        slug
      }
    }
    pageCategory
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    version
    createdAt
    seoTitle
    seoDescription
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type DownloadApNewsStoryMutationFn = Apollo.MutationFunction<DownloadApNewsStoryMutation, DownloadApNewsStoryMutationVariables>;

/**
 * __useDownloadApNewsStoryMutation__
 *
 * To run a mutation, you first call `useDownloadApNewsStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadApNewsStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadApNewsStoryMutation, { data, loading, error }] = useDownloadApNewsStoryMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      apStoryId: // value for 'apStoryId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useDownloadApNewsStoryMutation(baseOptions?: Apollo.MutationHookOptions<DownloadApNewsStoryMutation, DownloadApNewsStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadApNewsStoryMutation, DownloadApNewsStoryMutationVariables>(DownloadApNewsStoryDocument, options);
      }
export type DownloadApNewsStoryMutationHookResult = ReturnType<typeof useDownloadApNewsStoryMutation>;
export type DownloadApNewsStoryMutationResult = Apollo.MutationResult<DownloadApNewsStoryMutation>;
export type DownloadApNewsStoryMutationOptions = Apollo.BaseMutationOptions<DownloadApNewsStoryMutation, DownloadApNewsStoryMutationVariables>;
export const DuplicatePagesDocument = gql`
    mutation duplicatePages($ids: [ID!]!) {
  duplicatePages(ids: $ids) {
    id
    slug
    sk
    state
    pageCategory
    siteId
    brandId
  }
}
    `;
export type DuplicatePagesMutationFn = Apollo.MutationFunction<DuplicatePagesMutation, DuplicatePagesMutationVariables>;

/**
 * __useDuplicatePagesMutation__
 *
 * To run a mutation, you first call `useDuplicatePagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePagesMutation, { data, loading, error }] = useDuplicatePagesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDuplicatePagesMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePagesMutation, DuplicatePagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePagesMutation, DuplicatePagesMutationVariables>(DuplicatePagesDocument, options);
      }
export type DuplicatePagesMutationHookResult = ReturnType<typeof useDuplicatePagesMutation>;
export type DuplicatePagesMutationResult = Apollo.MutationResult<DuplicatePagesMutation>;
export type DuplicatePagesMutationOptions = Apollo.BaseMutationOptions<DuplicatePagesMutation, DuplicatePagesMutationVariables>;
export const ExportChatbotConversationsDocument = gql`
    mutation exportChatbotConversations($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportChatbotConversations(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportChatbotConversationsMutationFn = Apollo.MutationFunction<ExportChatbotConversationsMutation, ExportChatbotConversationsMutationVariables>;

/**
 * __useExportChatbotConversationsMutation__
 *
 * To run a mutation, you first call `useExportChatbotConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChatbotConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChatbotConversationsMutation, { data, loading, error }] = useExportChatbotConversationsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportChatbotConversationsMutation(baseOptions?: Apollo.MutationHookOptions<ExportChatbotConversationsMutation, ExportChatbotConversationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportChatbotConversationsMutation, ExportChatbotConversationsMutationVariables>(ExportChatbotConversationsDocument, options);
      }
export type ExportChatbotConversationsMutationHookResult = ReturnType<typeof useExportChatbotConversationsMutation>;
export type ExportChatbotConversationsMutationResult = Apollo.MutationResult<ExportChatbotConversationsMutation>;
export type ExportChatbotConversationsMutationOptions = Apollo.BaseMutationOptions<ExportChatbotConversationsMutation, ExportChatbotConversationsMutationVariables>;
export const ExportDisputesDocument = gql`
    mutation exportDisputes($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportDisputes(siteId: $siteId, startDate: $startDate, endDate: $endDate)
}
    `;
export type ExportDisputesMutationFn = Apollo.MutationFunction<ExportDisputesMutation, ExportDisputesMutationVariables>;

/**
 * __useExportDisputesMutation__
 *
 * To run a mutation, you first call `useExportDisputesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDisputesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDisputesMutation, { data, loading, error }] = useExportDisputesMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportDisputesMutation(baseOptions?: Apollo.MutationHookOptions<ExportDisputesMutation, ExportDisputesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportDisputesMutation, ExportDisputesMutationVariables>(ExportDisputesDocument, options);
      }
export type ExportDisputesMutationHookResult = ReturnType<typeof useExportDisputesMutation>;
export type ExportDisputesMutationResult = Apollo.MutationResult<ExportDisputesMutation>;
export type ExportDisputesMutationOptions = Apollo.BaseMutationOptions<ExportDisputesMutation, ExportDisputesMutationVariables>;
export const ExportEventsDocument = gql`
    mutation exportEvents($siteId: ID!, $startDate: String!, $endDate: String!, $format: EventsExportFormat!) {
  exportEvents(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
    format: $format
  )
}
    `;
export type ExportEventsMutationFn = Apollo.MutationFunction<ExportEventsMutation, ExportEventsMutationVariables>;

/**
 * __useExportEventsMutation__
 *
 * To run a mutation, you first call `useExportEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEventsMutation, { data, loading, error }] = useExportEventsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportEventsMutation(baseOptions?: Apollo.MutationHookOptions<ExportEventsMutation, ExportEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEventsMutation, ExportEventsMutationVariables>(ExportEventsDocument, options);
      }
export type ExportEventsMutationHookResult = ReturnType<typeof useExportEventsMutation>;
export type ExportEventsMutationResult = Apollo.MutationResult<ExportEventsMutation>;
export type ExportEventsMutationOptions = Apollo.BaseMutationOptions<ExportEventsMutation, ExportEventsMutationVariables>;
export const ExportGeneralLedgerRevenueExpenseDocument = gql`
    mutation exportGeneralLedgerRevenueExpense($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportGeneralLedgerRevenueExpense(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportGeneralLedgerRevenueExpenseMutationFn = Apollo.MutationFunction<ExportGeneralLedgerRevenueExpenseMutation, ExportGeneralLedgerRevenueExpenseMutationVariables>;

/**
 * __useExportGeneralLedgerRevenueExpenseMutation__
 *
 * To run a mutation, you first call `useExportGeneralLedgerRevenueExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportGeneralLedgerRevenueExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportGeneralLedgerRevenueExpenseMutation, { data, loading, error }] = useExportGeneralLedgerRevenueExpenseMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportGeneralLedgerRevenueExpenseMutation(baseOptions?: Apollo.MutationHookOptions<ExportGeneralLedgerRevenueExpenseMutation, ExportGeneralLedgerRevenueExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportGeneralLedgerRevenueExpenseMutation, ExportGeneralLedgerRevenueExpenseMutationVariables>(ExportGeneralLedgerRevenueExpenseDocument, options);
      }
export type ExportGeneralLedgerRevenueExpenseMutationHookResult = ReturnType<typeof useExportGeneralLedgerRevenueExpenseMutation>;
export type ExportGeneralLedgerRevenueExpenseMutationResult = Apollo.MutationResult<ExportGeneralLedgerRevenueExpenseMutation>;
export type ExportGeneralLedgerRevenueExpenseMutationOptions = Apollo.BaseMutationOptions<ExportGeneralLedgerRevenueExpenseMutation, ExportGeneralLedgerRevenueExpenseMutationVariables>;
export const ExportMonthlyPayoutsDocument = gql`
    mutation exportMonthlyPayouts($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportMonthlyPayouts(siteId: $siteId, startDate: $startDate, endDate: $endDate)
}
    `;
export type ExportMonthlyPayoutsMutationFn = Apollo.MutationFunction<ExportMonthlyPayoutsMutation, ExportMonthlyPayoutsMutationVariables>;

/**
 * __useExportMonthlyPayoutsMutation__
 *
 * To run a mutation, you first call `useExportMonthlyPayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMonthlyPayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMonthlyPayoutsMutation, { data, loading, error }] = useExportMonthlyPayoutsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportMonthlyPayoutsMutation(baseOptions?: Apollo.MutationHookOptions<ExportMonthlyPayoutsMutation, ExportMonthlyPayoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMonthlyPayoutsMutation, ExportMonthlyPayoutsMutationVariables>(ExportMonthlyPayoutsDocument, options);
      }
export type ExportMonthlyPayoutsMutationHookResult = ReturnType<typeof useExportMonthlyPayoutsMutation>;
export type ExportMonthlyPayoutsMutationResult = Apollo.MutationResult<ExportMonthlyPayoutsMutation>;
export type ExportMonthlyPayoutsMutationOptions = Apollo.BaseMutationOptions<ExportMonthlyPayoutsMutation, ExportMonthlyPayoutsMutationVariables>;
export const ExportMonthlyRevenueByProductDocument = gql`
    mutation exportMonthlyRevenueByProduct($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportMonthlyRevenueByProduct(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportMonthlyRevenueByProductMutationFn = Apollo.MutationFunction<ExportMonthlyRevenueByProductMutation, ExportMonthlyRevenueByProductMutationVariables>;

/**
 * __useExportMonthlyRevenueByProductMutation__
 *
 * To run a mutation, you first call `useExportMonthlyRevenueByProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMonthlyRevenueByProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMonthlyRevenueByProductMutation, { data, loading, error }] = useExportMonthlyRevenueByProductMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportMonthlyRevenueByProductMutation(baseOptions?: Apollo.MutationHookOptions<ExportMonthlyRevenueByProductMutation, ExportMonthlyRevenueByProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMonthlyRevenueByProductMutation, ExportMonthlyRevenueByProductMutationVariables>(ExportMonthlyRevenueByProductDocument, options);
      }
export type ExportMonthlyRevenueByProductMutationHookResult = ReturnType<typeof useExportMonthlyRevenueByProductMutation>;
export type ExportMonthlyRevenueByProductMutationResult = Apollo.MutationResult<ExportMonthlyRevenueByProductMutation>;
export type ExportMonthlyRevenueByProductMutationOptions = Apollo.BaseMutationOptions<ExportMonthlyRevenueByProductMutation, ExportMonthlyRevenueByProductMutationVariables>;
export const ExportPagesDocument = gql`
    mutation exportPages($ids: [ID!]!, $type: ExportPageType) {
  exportPages(ids: $ids, type: $type) {
    type
    url
  }
}
    `;
export type ExportPagesMutationFn = Apollo.MutationFunction<ExportPagesMutation, ExportPagesMutationVariables>;

/**
 * __useExportPagesMutation__
 *
 * To run a mutation, you first call `useExportPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPagesMutation, { data, loading, error }] = useExportPagesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useExportPagesMutation(baseOptions?: Apollo.MutationHookOptions<ExportPagesMutation, ExportPagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPagesMutation, ExportPagesMutationVariables>(ExportPagesDocument, options);
      }
export type ExportPagesMutationHookResult = ReturnType<typeof useExportPagesMutation>;
export type ExportPagesMutationResult = Apollo.MutationResult<ExportPagesMutation>;
export type ExportPagesMutationOptions = Apollo.BaseMutationOptions<ExportPagesMutation, ExportPagesMutationVariables>;
export const ExportPromotionalCreditsDocument = gql`
    mutation exportPromotionalCredits($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportPromotionalCredits(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportPromotionalCreditsMutationFn = Apollo.MutationFunction<ExportPromotionalCreditsMutation, ExportPromotionalCreditsMutationVariables>;

/**
 * __useExportPromotionalCreditsMutation__
 *
 * To run a mutation, you first call `useExportPromotionalCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPromotionalCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPromotionalCreditsMutation, { data, loading, error }] = useExportPromotionalCreditsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportPromotionalCreditsMutation(baseOptions?: Apollo.MutationHookOptions<ExportPromotionalCreditsMutation, ExportPromotionalCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPromotionalCreditsMutation, ExportPromotionalCreditsMutationVariables>(ExportPromotionalCreditsDocument, options);
      }
export type ExportPromotionalCreditsMutationHookResult = ReturnType<typeof useExportPromotionalCreditsMutation>;
export type ExportPromotionalCreditsMutationResult = Apollo.MutationResult<ExportPromotionalCreditsMutation>;
export type ExportPromotionalCreditsMutationOptions = Apollo.BaseMutationOptions<ExportPromotionalCreditsMutation, ExportPromotionalCreditsMutationVariables>;
export const ExportRefundsDocument = gql`
    mutation exportRefunds($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportRefunds(siteId: $siteId, startDate: $startDate, endDate: $endDate)
}
    `;
export type ExportRefundsMutationFn = Apollo.MutationFunction<ExportRefundsMutation, ExportRefundsMutationVariables>;

/**
 * __useExportRefundsMutation__
 *
 * To run a mutation, you first call `useExportRefundsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportRefundsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportRefundsMutation, { data, loading, error }] = useExportRefundsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportRefundsMutation(baseOptions?: Apollo.MutationHookOptions<ExportRefundsMutation, ExportRefundsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportRefundsMutation, ExportRefundsMutationVariables>(ExportRefundsDocument, options);
      }
export type ExportRefundsMutationHookResult = ReturnType<typeof useExportRefundsMutation>;
export type ExportRefundsMutationResult = Apollo.MutationResult<ExportRefundsMutation>;
export type ExportRefundsMutationOptions = Apollo.BaseMutationOptions<ExportRefundsMutation, ExportRefundsMutationVariables>;
export const ExportSubscriberActivityDocument = gql`
    mutation exportSubscriberActivity($siteId: ID!, $products: [ID!], $eventTypes: [String!]!, $startDate: String!, $endDate: String!) {
  exportSubscriberActivity(
    siteId: $siteId
    products: $products
    eventTypes: $eventTypes
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportSubscriberActivityMutationFn = Apollo.MutationFunction<ExportSubscriberActivityMutation, ExportSubscriberActivityMutationVariables>;

/**
 * __useExportSubscriberActivityMutation__
 *
 * To run a mutation, you first call `useExportSubscriberActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSubscriberActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSubscriberActivityMutation, { data, loading, error }] = useExportSubscriberActivityMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      products: // value for 'products'
 *      eventTypes: // value for 'eventTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSubscriberActivityMutation(baseOptions?: Apollo.MutationHookOptions<ExportSubscriberActivityMutation, ExportSubscriberActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSubscriberActivityMutation, ExportSubscriberActivityMutationVariables>(ExportSubscriberActivityDocument, options);
      }
export type ExportSubscriberActivityMutationHookResult = ReturnType<typeof useExportSubscriberActivityMutation>;
export type ExportSubscriberActivityMutationResult = Apollo.MutationResult<ExportSubscriberActivityMutation>;
export type ExportSubscriberActivityMutationOptions = Apollo.BaseMutationOptions<ExportSubscriberActivityMutation, ExportSubscriberActivityMutationVariables>;
export const ExportSubscriberFulfillmentDocument = gql`
    mutation exportSubscriberFulfillment($siteId: ID!, $products: [ID!], $status: StripeSubscriptionStatus) {
  exportSubscriberFulfillment(
    siteId: $siteId
    products: $products
    status: $status
  )
}
    `;
export type ExportSubscriberFulfillmentMutationFn = Apollo.MutationFunction<ExportSubscriberFulfillmentMutation, ExportSubscriberFulfillmentMutationVariables>;

/**
 * __useExportSubscriberFulfillmentMutation__
 *
 * To run a mutation, you first call `useExportSubscriberFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSubscriberFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSubscriberFulfillmentMutation, { data, loading, error }] = useExportSubscriberFulfillmentMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      products: // value for 'products'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useExportSubscriberFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<ExportSubscriberFulfillmentMutation, ExportSubscriberFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSubscriberFulfillmentMutation, ExportSubscriberFulfillmentMutationVariables>(ExportSubscriberFulfillmentDocument, options);
      }
export type ExportSubscriberFulfillmentMutationHookResult = ReturnType<typeof useExportSubscriberFulfillmentMutation>;
export type ExportSubscriberFulfillmentMutationResult = Apollo.MutationResult<ExportSubscriberFulfillmentMutation>;
export type ExportSubscriberFulfillmentMutationOptions = Apollo.BaseMutationOptions<ExportSubscriberFulfillmentMutation, ExportSubscriberFulfillmentMutationVariables>;
export const ExportSubscriberFulfillmentPeriodDocument = gql`
    mutation exportSubscriberFulfillmentPeriod($siteId: ID!, $products: [ID!], $status: StripeSubscriptionStatus, $startDate: String!, $endDate: String!) {
  exportSubscriberFulfillmentPeriod(
    siteId: $siteId
    products: $products
    status: $status
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportSubscriberFulfillmentPeriodMutationFn = Apollo.MutationFunction<ExportSubscriberFulfillmentPeriodMutation, ExportSubscriberFulfillmentPeriodMutationVariables>;

/**
 * __useExportSubscriberFulfillmentPeriodMutation__
 *
 * To run a mutation, you first call `useExportSubscriberFulfillmentPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSubscriberFulfillmentPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSubscriberFulfillmentPeriodMutation, { data, loading, error }] = useExportSubscriberFulfillmentPeriodMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      products: // value for 'products'
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSubscriberFulfillmentPeriodMutation(baseOptions?: Apollo.MutationHookOptions<ExportSubscriberFulfillmentPeriodMutation, ExportSubscriberFulfillmentPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSubscriberFulfillmentPeriodMutation, ExportSubscriberFulfillmentPeriodMutationVariables>(ExportSubscriberFulfillmentPeriodDocument, options);
      }
export type ExportSubscriberFulfillmentPeriodMutationHookResult = ReturnType<typeof useExportSubscriberFulfillmentPeriodMutation>;
export type ExportSubscriberFulfillmentPeriodMutationResult = Apollo.MutationResult<ExportSubscriberFulfillmentPeriodMutation>;
export type ExportSubscriberFulfillmentPeriodMutationOptions = Apollo.BaseMutationOptions<ExportSubscriberFulfillmentPeriodMutation, ExportSubscriberFulfillmentPeriodMutationVariables>;
export const ExportSubscriptionAdjustmentsDocument = gql`
    mutation exportSubscriptionAdjustments($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportSubscriptionAdjustments(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export type ExportSubscriptionAdjustmentsMutationFn = Apollo.MutationFunction<ExportSubscriptionAdjustmentsMutation, ExportSubscriptionAdjustmentsMutationVariables>;

/**
 * __useExportSubscriptionAdjustmentsMutation__
 *
 * To run a mutation, you first call `useExportSubscriptionAdjustmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSubscriptionAdjustmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSubscriptionAdjustmentsMutation, { data, loading, error }] = useExportSubscriptionAdjustmentsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportSubscriptionAdjustmentsMutation(baseOptions?: Apollo.MutationHookOptions<ExportSubscriptionAdjustmentsMutation, ExportSubscriptionAdjustmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSubscriptionAdjustmentsMutation, ExportSubscriptionAdjustmentsMutationVariables>(ExportSubscriptionAdjustmentsDocument, options);
      }
export type ExportSubscriptionAdjustmentsMutationHookResult = ReturnType<typeof useExportSubscriptionAdjustmentsMutation>;
export type ExportSubscriptionAdjustmentsMutationResult = Apollo.MutationResult<ExportSubscriptionAdjustmentsMutation>;
export type ExportSubscriptionAdjustmentsMutationOptions = Apollo.BaseMutationOptions<ExportSubscriptionAdjustmentsMutation, ExportSubscriptionAdjustmentsMutationVariables>;
export const ExportTransactionDataDocument = gql`
    mutation exportTransactionData($siteId: ID!, $fromDate: String) {
  exportTransactionData(siteId: $siteId, fromDate: $fromDate)
}
    `;
export type ExportTransactionDataMutationFn = Apollo.MutationFunction<ExportTransactionDataMutation, ExportTransactionDataMutationVariables>;

/**
 * __useExportTransactionDataMutation__
 *
 * To run a mutation, you first call `useExportTransactionDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTransactionDataMutation, { data, loading, error }] = useExportTransactionDataMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useExportTransactionDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportTransactionDataMutation, ExportTransactionDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportTransactionDataMutation, ExportTransactionDataMutationVariables>(ExportTransactionDataDocument, options);
      }
export type ExportTransactionDataMutationHookResult = ReturnType<typeof useExportTransactionDataMutation>;
export type ExportTransactionDataMutationResult = Apollo.MutationResult<ExportTransactionDataMutation>;
export type ExportTransactionDataMutationOptions = Apollo.BaseMutationOptions<ExportTransactionDataMutation, ExportTransactionDataMutationVariables>;
export const ExportUnearnedRevenueDocument = gql`
    mutation exportUnearnedRevenue($siteId: ID!, $startDate: String!, $endDate: String!) {
  exportUnearnedRevenue(siteId: $siteId, startDate: $startDate, endDate: $endDate)
}
    `;
export type ExportUnearnedRevenueMutationFn = Apollo.MutationFunction<ExportUnearnedRevenueMutation, ExportUnearnedRevenueMutationVariables>;

/**
 * __useExportUnearnedRevenueMutation__
 *
 * To run a mutation, you first call `useExportUnearnedRevenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUnearnedRevenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUnearnedRevenueMutation, { data, loading, error }] = useExportUnearnedRevenueMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportUnearnedRevenueMutation(baseOptions?: Apollo.MutationHookOptions<ExportUnearnedRevenueMutation, ExportUnearnedRevenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUnearnedRevenueMutation, ExportUnearnedRevenueMutationVariables>(ExportUnearnedRevenueDocument, options);
      }
export type ExportUnearnedRevenueMutationHookResult = ReturnType<typeof useExportUnearnedRevenueMutation>;
export type ExportUnearnedRevenueMutationResult = Apollo.MutationResult<ExportUnearnedRevenueMutation>;
export type ExportUnearnedRevenueMutationOptions = Apollo.BaseMutationOptions<ExportUnearnedRevenueMutation, ExportUnearnedRevenueMutationVariables>;
export const ExportUserDataDocument = gql`
    mutation exportUserData($siteId: ID!) {
  exportUserData(siteId: $siteId)
}
    `;
export type ExportUserDataMutationFn = Apollo.MutationFunction<ExportUserDataMutation, ExportUserDataMutationVariables>;

/**
 * __useExportUserDataMutation__
 *
 * To run a mutation, you first call `useExportUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUserDataMutation, { data, loading, error }] = useExportUserDataMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useExportUserDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportUserDataMutation, ExportUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUserDataMutation, ExportUserDataMutationVariables>(ExportUserDataDocument, options);
      }
export type ExportUserDataMutationHookResult = ReturnType<typeof useExportUserDataMutation>;
export type ExportUserDataMutationResult = Apollo.MutationResult<ExportUserDataMutation>;
export type ExportUserDataMutationOptions = Apollo.BaseMutationOptions<ExportUserDataMutation, ExportUserDataMutationVariables>;
export const ExportUserSignupsSessionsDocument = gql`
    mutation exportUserSignupsSessions($siteId: ID!, $fromDate: String, $toDate: String) {
  exportUserSignupsSessions(siteId: $siteId, fromDate: $fromDate, toDate: $toDate)
}
    `;
export type ExportUserSignupsSessionsMutationFn = Apollo.MutationFunction<ExportUserSignupsSessionsMutation, ExportUserSignupsSessionsMutationVariables>;

/**
 * __useExportUserSignupsSessionsMutation__
 *
 * To run a mutation, you first call `useExportUserSignupsSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUserSignupsSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUserSignupsSessionsMutation, { data, loading, error }] = useExportUserSignupsSessionsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useExportUserSignupsSessionsMutation(baseOptions?: Apollo.MutationHookOptions<ExportUserSignupsSessionsMutation, ExportUserSignupsSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUserSignupsSessionsMutation, ExportUserSignupsSessionsMutationVariables>(ExportUserSignupsSessionsDocument, options);
      }
export type ExportUserSignupsSessionsMutationHookResult = ReturnType<typeof useExportUserSignupsSessionsMutation>;
export type ExportUserSignupsSessionsMutationResult = Apollo.MutationResult<ExportUserSignupsSessionsMutation>;
export type ExportUserSignupsSessionsMutationOptions = Apollo.BaseMutationOptions<ExportUserSignupsSessionsMutation, ExportUserSignupsSessionsMutationVariables>;
export const GenerateArticleBodyDocument = gql`
    mutation generateArticleBody($generateArticle: GenerateArticle!) {
  generateArticleBody(params: $generateArticle)
}
    `;
export type GenerateArticleBodyMutationFn = Apollo.MutationFunction<GenerateArticleBodyMutation, GenerateArticleBodyMutationVariables>;

/**
 * __useGenerateArticleBodyMutation__
 *
 * To run a mutation, you first call `useGenerateArticleBodyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateArticleBodyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateArticleBodyMutation, { data, loading, error }] = useGenerateArticleBodyMutation({
 *   variables: {
 *      generateArticle: // value for 'generateArticle'
 *   },
 * });
 */
export function useGenerateArticleBodyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateArticleBodyMutation, GenerateArticleBodyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateArticleBodyMutation, GenerateArticleBodyMutationVariables>(GenerateArticleBodyDocument, options);
      }
export type GenerateArticleBodyMutationHookResult = ReturnType<typeof useGenerateArticleBodyMutation>;
export type GenerateArticleBodyMutationResult = Apollo.MutationResult<GenerateArticleBodyMutation>;
export type GenerateArticleBodyMutationOptions = Apollo.BaseMutationOptions<GenerateArticleBodyMutation, GenerateArticleBodyMutationVariables>;
export const GenerateArticleHeadlineDocument = gql`
    mutation generateArticleHeadline($body: String!, $siteId: ID!) {
  generateArticleHeadline(body: $body, siteId: $siteId)
}
    `;
export type GenerateArticleHeadlineMutationFn = Apollo.MutationFunction<GenerateArticleHeadlineMutation, GenerateArticleHeadlineMutationVariables>;

/**
 * __useGenerateArticleHeadlineMutation__
 *
 * To run a mutation, you first call `useGenerateArticleHeadlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateArticleHeadlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateArticleHeadlineMutation, { data, loading, error }] = useGenerateArticleHeadlineMutation({
 *   variables: {
 *      body: // value for 'body'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGenerateArticleHeadlineMutation(baseOptions?: Apollo.MutationHookOptions<GenerateArticleHeadlineMutation, GenerateArticleHeadlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateArticleHeadlineMutation, GenerateArticleHeadlineMutationVariables>(GenerateArticleHeadlineDocument, options);
      }
export type GenerateArticleHeadlineMutationHookResult = ReturnType<typeof useGenerateArticleHeadlineMutation>;
export type GenerateArticleHeadlineMutationResult = Apollo.MutationResult<GenerateArticleHeadlineMutation>;
export type GenerateArticleHeadlineMutationOptions = Apollo.BaseMutationOptions<GenerateArticleHeadlineMutation, GenerateArticleHeadlineMutationVariables>;
export const GenerateArticleLeadDocument = gql`
    mutation generateArticleLead($body: String!, $siteId: ID!, $title: String!) {
  generateArticleLead(body: $body, siteId: $siteId, title: $title)
}
    `;
export type GenerateArticleLeadMutationFn = Apollo.MutationFunction<GenerateArticleLeadMutation, GenerateArticleLeadMutationVariables>;

/**
 * __useGenerateArticleLeadMutation__
 *
 * To run a mutation, you first call `useGenerateArticleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateArticleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateArticleLeadMutation, { data, loading, error }] = useGenerateArticleLeadMutation({
 *   variables: {
 *      body: // value for 'body'
 *      siteId: // value for 'siteId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGenerateArticleLeadMutation(baseOptions?: Apollo.MutationHookOptions<GenerateArticleLeadMutation, GenerateArticleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateArticleLeadMutation, GenerateArticleLeadMutationVariables>(GenerateArticleLeadDocument, options);
      }
export type GenerateArticleLeadMutationHookResult = ReturnType<typeof useGenerateArticleLeadMutation>;
export type GenerateArticleLeadMutationResult = Apollo.MutationResult<GenerateArticleLeadMutation>;
export type GenerateArticleLeadMutationOptions = Apollo.BaseMutationOptions<GenerateArticleLeadMutation, GenerateArticleLeadMutationVariables>;
export const GenerateBlogDocument = gql`
    mutation generateBlog($generateBlog: GenerateBlog!) {
  generateBlog(params: $generateBlog)
}
    `;
export type GenerateBlogMutationFn = Apollo.MutationFunction<GenerateBlogMutation, GenerateBlogMutationVariables>;

/**
 * __useGenerateBlogMutation__
 *
 * To run a mutation, you first call `useGenerateBlogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBlogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBlogMutation, { data, loading, error }] = useGenerateBlogMutation({
 *   variables: {
 *      generateBlog: // value for 'generateBlog'
 *   },
 * });
 */
export function useGenerateBlogMutation(baseOptions?: Apollo.MutationHookOptions<GenerateBlogMutation, GenerateBlogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateBlogMutation, GenerateBlogMutationVariables>(GenerateBlogDocument, options);
      }
export type GenerateBlogMutationHookResult = ReturnType<typeof useGenerateBlogMutation>;
export type GenerateBlogMutationResult = Apollo.MutationResult<GenerateBlogMutation>;
export type GenerateBlogMutationOptions = Apollo.BaseMutationOptions<GenerateBlogMutation, GenerateBlogMutationVariables>;
export const GenerateImageDocument = gql`
    mutation generateImage($generateImage: GenerateImageInput!) {
  generateImage(params: $generateImage)
}
    `;
export type GenerateImageMutationFn = Apollo.MutationFunction<GenerateImageMutation, GenerateImageMutationVariables>;

/**
 * __useGenerateImageMutation__
 *
 * To run a mutation, you first call `useGenerateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateImageMutation, { data, loading, error }] = useGenerateImageMutation({
 *   variables: {
 *      generateImage: // value for 'generateImage'
 *   },
 * });
 */
export function useGenerateImageMutation(baseOptions?: Apollo.MutationHookOptions<GenerateImageMutation, GenerateImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateImageMutation, GenerateImageMutationVariables>(GenerateImageDocument, options);
      }
export type GenerateImageMutationHookResult = ReturnType<typeof useGenerateImageMutation>;
export type GenerateImageMutationResult = Apollo.MutationResult<GenerateImageMutation>;
export type GenerateImageMutationOptions = Apollo.BaseMutationOptions<GenerateImageMutation, GenerateImageMutationVariables>;
export const GenerateSectionSuggestionDocument = gql`
    mutation generateSectionSuggestion($siteId: ID!, $title: String, $lead: String, $availableSections: [String!]!) {
  generateSectionSuggestion(
    siteId: $siteId
    title: $title
    lead: $lead
    availableSections: $availableSections
  )
}
    `;
export type GenerateSectionSuggestionMutationFn = Apollo.MutationFunction<GenerateSectionSuggestionMutation, GenerateSectionSuggestionMutationVariables>;

/**
 * __useGenerateSectionSuggestionMutation__
 *
 * To run a mutation, you first call `useGenerateSectionSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSectionSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSectionSuggestionMutation, { data, loading, error }] = useGenerateSectionSuggestionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      title: // value for 'title'
 *      lead: // value for 'lead'
 *      availableSections: // value for 'availableSections'
 *   },
 * });
 */
export function useGenerateSectionSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSectionSuggestionMutation, GenerateSectionSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSectionSuggestionMutation, GenerateSectionSuggestionMutationVariables>(GenerateSectionSuggestionDocument, options);
      }
export type GenerateSectionSuggestionMutationHookResult = ReturnType<typeof useGenerateSectionSuggestionMutation>;
export type GenerateSectionSuggestionMutationResult = Apollo.MutationResult<GenerateSectionSuggestionMutation>;
export type GenerateSectionSuggestionMutationOptions = Apollo.BaseMutationOptions<GenerateSectionSuggestionMutation, GenerateSectionSuggestionMutationVariables>;
export const GenerateSignInCodeDocument = gql`
    mutation generateSignInCode($siteId: ID!, $email: String!) {
  generateSignInCode(siteId: $siteId, email: $email)
}
    `;
export type GenerateSignInCodeMutationFn = Apollo.MutationFunction<GenerateSignInCodeMutation, GenerateSignInCodeMutationVariables>;

/**
 * __useGenerateSignInCodeMutation__
 *
 * To run a mutation, you first call `useGenerateSignInCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSignInCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSignInCodeMutation, { data, loading, error }] = useGenerateSignInCodeMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateSignInCodeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSignInCodeMutation, GenerateSignInCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSignInCodeMutation, GenerateSignInCodeMutationVariables>(GenerateSignInCodeDocument, options);
      }
export type GenerateSignInCodeMutationHookResult = ReturnType<typeof useGenerateSignInCodeMutation>;
export type GenerateSignInCodeMutationResult = Apollo.MutationResult<GenerateSignInCodeMutation>;
export type GenerateSignInCodeMutationOptions = Apollo.BaseMutationOptions<GenerateSignInCodeMutation, GenerateSignInCodeMutationVariables>;
export const GenerateSignInLinkDocument = gql`
    mutation generateSignInLink($siteId: ID!, $email: String!) {
  generateSignInLink(siteId: $siteId, email: $email)
}
    `;
export type GenerateSignInLinkMutationFn = Apollo.MutationFunction<GenerateSignInLinkMutation, GenerateSignInLinkMutationVariables>;

/**
 * __useGenerateSignInLinkMutation__
 *
 * To run a mutation, you first call `useGenerateSignInLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSignInLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSignInLinkMutation, { data, loading, error }] = useGenerateSignInLinkMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateSignInLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSignInLinkMutation, GenerateSignInLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSignInLinkMutation, GenerateSignInLinkMutationVariables>(GenerateSignInLinkDocument, options);
      }
export type GenerateSignInLinkMutationHookResult = ReturnType<typeof useGenerateSignInLinkMutation>;
export type GenerateSignInLinkMutationResult = Apollo.MutationResult<GenerateSignInLinkMutation>;
export type GenerateSignInLinkMutationOptions = Apollo.BaseMutationOptions<GenerateSignInLinkMutation, GenerateSignInLinkMutationVariables>;
export const GenerateTagsSuggestionDocument = gql`
    mutation generateTagsSuggestion($siteId: ID!, $title: String, $lead: String, $availableTags: [String!]!) {
  generateTagsSuggestion(
    siteId: $siteId
    title: $title
    lead: $lead
    availableTags: $availableTags
  )
}
    `;
export type GenerateTagsSuggestionMutationFn = Apollo.MutationFunction<GenerateTagsSuggestionMutation, GenerateTagsSuggestionMutationVariables>;

/**
 * __useGenerateTagsSuggestionMutation__
 *
 * To run a mutation, you first call `useGenerateTagsSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTagsSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTagsSuggestionMutation, { data, loading, error }] = useGenerateTagsSuggestionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      title: // value for 'title'
 *      lead: // value for 'lead'
 *      availableTags: // value for 'availableTags'
 *   },
 * });
 */
export function useGenerateTagsSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTagsSuggestionMutation, GenerateTagsSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTagsSuggestionMutation, GenerateTagsSuggestionMutationVariables>(GenerateTagsSuggestionDocument, options);
      }
export type GenerateTagsSuggestionMutationHookResult = ReturnType<typeof useGenerateTagsSuggestionMutation>;
export type GenerateTagsSuggestionMutationResult = Apollo.MutationResult<GenerateTagsSuggestionMutation>;
export type GenerateTagsSuggestionMutationOptions = Apollo.BaseMutationOptions<GenerateTagsSuggestionMutation, GenerateTagsSuggestionMutationVariables>;
export const ImportExternalFeedNowDocument = gql`
    mutation importExternalFeedNow($siteId: ID!, $id: ID!, $startDate: AWSDateTime) {
  importExternalFeedNow(siteId: $siteId, id: $id, startDate: $startDate) {
    success
    articlesCreated
    skipped
    errors
    articles {
      title
      url
    }
  }
}
    `;
export type ImportExternalFeedNowMutationFn = Apollo.MutationFunction<ImportExternalFeedNowMutation, ImportExternalFeedNowMutationVariables>;

/**
 * __useImportExternalFeedNowMutation__
 *
 * To run a mutation, you first call `useImportExternalFeedNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportExternalFeedNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importExternalFeedNowMutation, { data, loading, error }] = useImportExternalFeedNowMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useImportExternalFeedNowMutation(baseOptions?: Apollo.MutationHookOptions<ImportExternalFeedNowMutation, ImportExternalFeedNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportExternalFeedNowMutation, ImportExternalFeedNowMutationVariables>(ImportExternalFeedNowDocument, options);
      }
export type ImportExternalFeedNowMutationHookResult = ReturnType<typeof useImportExternalFeedNowMutation>;
export type ImportExternalFeedNowMutationResult = Apollo.MutationResult<ImportExternalFeedNowMutation>;
export type ImportExternalFeedNowMutationOptions = Apollo.BaseMutationOptions<ImportExternalFeedNowMutation, ImportExternalFeedNowMutationVariables>;
export const ImportPagesDocument = gql`
    mutation importPages($siteId: ID!, $zipAssetKey: String!) {
  importPages(siteId: $siteId, zipAssetKey: $zipAssetKey) {
    type
    pages {
      id
      brandId
      createdAt
      gsk1
      gsk2
      pageCategory
      savedAt
      sk
      siteId
      slug
      state
      templateId
      updatedAt
      publishedAt
      version
    }
  }
}
    `;
export type ImportPagesMutationFn = Apollo.MutationFunction<ImportPagesMutation, ImportPagesMutationVariables>;

/**
 * __useImportPagesMutation__
 *
 * To run a mutation, you first call `useImportPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPagesMutation, { data, loading, error }] = useImportPagesMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      zipAssetKey: // value for 'zipAssetKey'
 *   },
 * });
 */
export function useImportPagesMutation(baseOptions?: Apollo.MutationHookOptions<ImportPagesMutation, ImportPagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPagesMutation, ImportPagesMutationVariables>(ImportPagesDocument, options);
      }
export type ImportPagesMutationHookResult = ReturnType<typeof useImportPagesMutation>;
export type ImportPagesMutationResult = Apollo.MutationResult<ImportPagesMutation>;
export type ImportPagesMutationOptions = Apollo.BaseMutationOptions<ImportPagesMutation, ImportPagesMutationVariables>;
export const ImportSingleFeedItemDocument = gql`
    mutation importSingleFeedItem($siteId: ID!, $feedId: ID!, $itemId: String!) {
  importSingleFeedItem(siteId: $siteId, feedId: $feedId, itemId: $itemId) {
    success
    articlesCreated
    articlesUpdated
    skipped
    errors
    articles {
      title
      url
    }
  }
}
    `;
export type ImportSingleFeedItemMutationFn = Apollo.MutationFunction<ImportSingleFeedItemMutation, ImportSingleFeedItemMutationVariables>;

/**
 * __useImportSingleFeedItemMutation__
 *
 * To run a mutation, you first call `useImportSingleFeedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSingleFeedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSingleFeedItemMutation, { data, loading, error }] = useImportSingleFeedItemMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      feedId: // value for 'feedId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useImportSingleFeedItemMutation(baseOptions?: Apollo.MutationHookOptions<ImportSingleFeedItemMutation, ImportSingleFeedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSingleFeedItemMutation, ImportSingleFeedItemMutationVariables>(ImportSingleFeedItemDocument, options);
      }
export type ImportSingleFeedItemMutationHookResult = ReturnType<typeof useImportSingleFeedItemMutation>;
export type ImportSingleFeedItemMutationResult = Apollo.MutationResult<ImportSingleFeedItemMutation>;
export type ImportSingleFeedItemMutationOptions = Apollo.BaseMutationOptions<ImportSingleFeedItemMutation, ImportSingleFeedItemMutationVariables>;
export const OrderSubscriptionPlansDocument = gql`
    mutation orderSubscriptionPlans($planIds: OrderSubscriptionPlansInput!) {
  orderSubscriptionPlans(planIds: $planIds) {
    benefits
    planSummary
    name
    subtitle
    priceForMonthlyToggleChoice
    priceForYearlyToggleChoice
    priceSubtitleMonthly
    priceSubtitleYearly
    productId
    stripeDescription
    stripePriceIdMonthly
    stripePriceIdYearly
    collectPhoneNumber
    collectShipping
    adSettings
    printOnly
    monthlyPlanLabel
    yearlyPlanLabel
  }
}
    `;
export type OrderSubscriptionPlansMutationFn = Apollo.MutationFunction<OrderSubscriptionPlansMutation, OrderSubscriptionPlansMutationVariables>;

/**
 * __useOrderSubscriptionPlansMutation__
 *
 * To run a mutation, you first call `useOrderSubscriptionPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSubscriptionPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSubscriptionPlansMutation, { data, loading, error }] = useOrderSubscriptionPlansMutation({
 *   variables: {
 *      planIds: // value for 'planIds'
 *   },
 * });
 */
export function useOrderSubscriptionPlansMutation(baseOptions?: Apollo.MutationHookOptions<OrderSubscriptionPlansMutation, OrderSubscriptionPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSubscriptionPlansMutation, OrderSubscriptionPlansMutationVariables>(OrderSubscriptionPlansDocument, options);
      }
export type OrderSubscriptionPlansMutationHookResult = ReturnType<typeof useOrderSubscriptionPlansMutation>;
export type OrderSubscriptionPlansMutationResult = Apollo.MutationResult<OrderSubscriptionPlansMutation>;
export type OrderSubscriptionPlansMutationOptions = Apollo.BaseMutationOptions<OrderSubscriptionPlansMutation, OrderSubscriptionPlansMutationVariables>;
export const PublishBlockTemplateDocument = gql`
    mutation publishBlockTemplate($pageTemplate: PublishPublishedNodeInput!) {
  publishBlockTemplate(param: $pageTemplate) {
    data {
      ...BlockTemplateDataFragment
    }
    blockCategory
    brandId
    componentId
    createdAt
    gsk1
    id
    publishedAt
    savedAt
    siteId
    sk
    state
    updatedAt
    variant
    version
  }
}
    ${BlockTemplateDataFragmentFragmentDoc}`;
export type PublishBlockTemplateMutationFn = Apollo.MutationFunction<PublishBlockTemplateMutation, PublishBlockTemplateMutationVariables>;

/**
 * __usePublishBlockTemplateMutation__
 *
 * To run a mutation, you first call `usePublishBlockTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishBlockTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishBlockTemplateMutation, { data, loading, error }] = usePublishBlockTemplateMutation({
 *   variables: {
 *      pageTemplate: // value for 'pageTemplate'
 *   },
 * });
 */
export function usePublishBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<PublishBlockTemplateMutation, PublishBlockTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishBlockTemplateMutation, PublishBlockTemplateMutationVariables>(PublishBlockTemplateDocument, options);
      }
export type PublishBlockTemplateMutationHookResult = ReturnType<typeof usePublishBlockTemplateMutation>;
export type PublishBlockTemplateMutationResult = Apollo.MutationResult<PublishBlockTemplateMutation>;
export type PublishBlockTemplateMutationOptions = Apollo.BaseMutationOptions<PublishBlockTemplateMutation, PublishBlockTemplateMutationVariables>;
export const PublishBlockTemplatesDocument = gql`
    mutation publishBlockTemplates($input: [PublishPublishedNodeInput!]!) {
  publishBlockTemplates(param: $input) {
    data {
      ...BlockTemplateDataFragment
    }
    blockCategory
    brandId
    componentId
    createdAt
    gsk1
    id
    publishedAt
    savedAt
    siteId
    sk
    state
    updatedAt
    variant
    version
  }
}
    ${BlockTemplateDataFragmentFragmentDoc}`;
export type PublishBlockTemplatesMutationFn = Apollo.MutationFunction<PublishBlockTemplatesMutation, PublishBlockTemplatesMutationVariables>;

/**
 * __usePublishBlockTemplatesMutation__
 *
 * To run a mutation, you first call `usePublishBlockTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishBlockTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishBlockTemplatesMutation, { data, loading, error }] = usePublishBlockTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishBlockTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<PublishBlockTemplatesMutation, PublishBlockTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishBlockTemplatesMutation, PublishBlockTemplatesMutationVariables>(PublishBlockTemplatesDocument, options);
      }
export type PublishBlockTemplatesMutationHookResult = ReturnType<typeof usePublishBlockTemplatesMutation>;
export type PublishBlockTemplatesMutationResult = Apollo.MutationResult<PublishBlockTemplatesMutation>;
export type PublishBlockTemplatesMutationOptions = Apollo.BaseMutationOptions<PublishBlockTemplatesMutation, PublishBlockTemplatesMutationVariables>;
export const PublishPageDocument = gql`
    mutation publishPage($page: PublishPublishedNodeInput!) {
  publishPage(param: $page) {
    brandId
    createdAt
    gsk1
    gsk2
    id
    pageCategory
    publishedAt
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    version
  }
}
    `;
export type PublishPageMutationFn = Apollo.MutationFunction<PublishPageMutation, PublishPageMutationVariables>;

/**
 * __usePublishPageMutation__
 *
 * To run a mutation, you first call `usePublishPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPageMutation, { data, loading, error }] = usePublishPageMutation({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublishPageMutation(baseOptions?: Apollo.MutationHookOptions<PublishPageMutation, PublishPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPageMutation, PublishPageMutationVariables>(PublishPageDocument, options);
      }
export type PublishPageMutationHookResult = ReturnType<typeof usePublishPageMutation>;
export type PublishPageMutationResult = Apollo.MutationResult<PublishPageMutation>;
export type PublishPageMutationOptions = Apollo.BaseMutationOptions<PublishPageMutation, PublishPageMutationVariables>;
export const PublishPagesToFeedsDocument = gql`
    mutation publishPagesToFeeds($params: PublishPagesToFeedsInput!) {
  publishPagesToFeeds(params: $params) {
    id
    sk
    slug
    pageCategory
  }
}
    `;
export type PublishPagesToFeedsMutationFn = Apollo.MutationFunction<PublishPagesToFeedsMutation, PublishPagesToFeedsMutationVariables>;

/**
 * __usePublishPagesToFeedsMutation__
 *
 * To run a mutation, you first call `usePublishPagesToFeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPagesToFeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPagesToFeedsMutation, { data, loading, error }] = usePublishPagesToFeedsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePublishPagesToFeedsMutation(baseOptions?: Apollo.MutationHookOptions<PublishPagesToFeedsMutation, PublishPagesToFeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPagesToFeedsMutation, PublishPagesToFeedsMutationVariables>(PublishPagesToFeedsDocument, options);
      }
export type PublishPagesToFeedsMutationHookResult = ReturnType<typeof usePublishPagesToFeedsMutation>;
export type PublishPagesToFeedsMutationResult = Apollo.MutationResult<PublishPagesToFeedsMutation>;
export type PublishPagesToFeedsMutationOptions = Apollo.BaseMutationOptions<PublishPagesToFeedsMutation, PublishPagesToFeedsMutationVariables>;
export const RemoveEmailSuppressionDocument = gql`
    mutation removeEmailSuppression($siteId: ID!, $email: String!) {
  removeEmailSuppression(siteId: $siteId, email: $email)
}
    `;
export type RemoveEmailSuppressionMutationFn = Apollo.MutationFunction<RemoveEmailSuppressionMutation, RemoveEmailSuppressionMutationVariables>;

/**
 * __useRemoveEmailSuppressionMutation__
 *
 * To run a mutation, you first call `useRemoveEmailSuppressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailSuppressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailSuppressionMutation, { data, loading, error }] = useRemoveEmailSuppressionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveEmailSuppressionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmailSuppressionMutation, RemoveEmailSuppressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmailSuppressionMutation, RemoveEmailSuppressionMutationVariables>(RemoveEmailSuppressionDocument, options);
      }
export type RemoveEmailSuppressionMutationHookResult = ReturnType<typeof useRemoveEmailSuppressionMutation>;
export type RemoveEmailSuppressionMutationResult = Apollo.MutationResult<RemoveEmailSuppressionMutation>;
export type RemoveEmailSuppressionMutationOptions = Apollo.BaseMutationOptions<RemoveEmailSuppressionMutation, RemoveEmailSuppressionMutationVariables>;
export const RemoveItemFromCollectionsDocument = gql`
    mutation RemoveItemFromCollections($params: RemoveItemFromCollectionsInput!) {
  removeItemFromCollections(params: $params) {
    name
    assetKey
    siteId
    assetId
    collectionId
    credit
    caption
    alt
    width
    height
    createdAt
    updatedAt
  }
}
    `;
export type RemoveItemFromCollectionsMutationFn = Apollo.MutationFunction<RemoveItemFromCollectionsMutation, RemoveItemFromCollectionsMutationVariables>;

/**
 * __useRemoveItemFromCollectionsMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromCollectionsMutation, { data, loading, error }] = useRemoveItemFromCollectionsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRemoveItemFromCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemFromCollectionsMutation, RemoveItemFromCollectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemFromCollectionsMutation, RemoveItemFromCollectionsMutationVariables>(RemoveItemFromCollectionsDocument, options);
      }
export type RemoveItemFromCollectionsMutationHookResult = ReturnType<typeof useRemoveItemFromCollectionsMutation>;
export type RemoveItemFromCollectionsMutationResult = Apollo.MutationResult<RemoveItemFromCollectionsMutation>;
export type RemoveItemFromCollectionsMutationOptions = Apollo.BaseMutationOptions<RemoveItemFromCollectionsMutation, RemoveItemFromCollectionsMutationVariables>;
export const RemoveItemsFromCollectionDocument = gql`
    mutation removeItemsFromCollection($params: RemoveItemsFromCollectionInput!) {
  removeItemsFromCollection(params: $params) {
    name
    assetKey
    siteId
    assetId
    collectionId
    credit
    caption
    alt
    width
    height
    createdAt
    updatedAt
  }
}
    `;
export type RemoveItemsFromCollectionMutationFn = Apollo.MutationFunction<RemoveItemsFromCollectionMutation, RemoveItemsFromCollectionMutationVariables>;

/**
 * __useRemoveItemsFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveItemsFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemsFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemsFromCollectionMutation, { data, loading, error }] = useRemoveItemsFromCollectionMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRemoveItemsFromCollectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemsFromCollectionMutation, RemoveItemsFromCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemsFromCollectionMutation, RemoveItemsFromCollectionMutationVariables>(RemoveItemsFromCollectionDocument, options);
      }
export type RemoveItemsFromCollectionMutationHookResult = ReturnType<typeof useRemoveItemsFromCollectionMutation>;
export type RemoveItemsFromCollectionMutationResult = Apollo.MutationResult<RemoveItemsFromCollectionMutation>;
export type RemoveItemsFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveItemsFromCollectionMutation, RemoveItemsFromCollectionMutationVariables>;
export const ResendInvitationEmailDocument = gql`
    mutation resendInvitationEmail($workspaceId: ID!, $username: String!) {
  resendInvitationEmail(
    workspaceUser: {username: $username, workspaceId: $workspaceId}
  ) {
    workspaceUser {
      id
      version
      createdAt
      updatedAt
      workspaceId
      username
      workspaceGroups
      brandGroups {
        brandId
        groups
      }
    }
    inviteLink
  }
}
    `;
export type ResendInvitationEmailMutationFn = Apollo.MutationFunction<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;

/**
 * __useResendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationEmailMutation, { data, loading, error }] = useResendInvitationEmailMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useResendInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>(ResendInvitationEmailDocument, options);
      }
export type ResendInvitationEmailMutationHookResult = ReturnType<typeof useResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationResult = Apollo.MutationResult<ResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;
export const RevertPageDocument = gql`
    mutation revertPage($param: RevertPublishedNodeInput!) {
  revertPage(param: $param) {
    brandId
    getPageTemplate(status: {state: Latest}) {
      items {
        blockTemplates {
          ids
          slot
        }
        blockVariants {
          componentId
          defaultVariant
        }
        brandId
        createdAt
        id
        pageTemplateCategory
        componentId
        savedAt
        siteId
        sk
        updatedAt
        state
        version
      }
    }
    gsk1
    gsk2
    id
    listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
      items {
        blockCategory
        brandId
        createdAt
        gsk1
        id
        componentId
        pageId
        data {
          ...BlockDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        archivedAt
        version
        externalBlockIds
        slug
        listExternalBlocks {
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
      }
    }
    localBlockSlots {
      ids
      slot
    }
    listPageAdditionalBlocks {
      items {
        blockCategory
        componentId
        data {
          ...BlockDataFragment
        }
        id
        variant
        version
        state
        pageId
        createdAt
        sk
        updatedAt
        archivedAt
        brandId
        gsk1
        siteId
        listExternalBlocks {
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
        slug
      }
      nextToken
    }
    pageCategory
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    publishedAt
    version
    createdAt
    seoTitle
    seoDescription
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type RevertPageMutationFn = Apollo.MutationFunction<RevertPageMutation, RevertPageMutationVariables>;

/**
 * __useRevertPageMutation__
 *
 * To run a mutation, you first call `useRevertPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertPageMutation, { data, loading, error }] = useRevertPageMutation({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useRevertPageMutation(baseOptions?: Apollo.MutationHookOptions<RevertPageMutation, RevertPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertPageMutation, RevertPageMutationVariables>(RevertPageDocument, options);
      }
export type RevertPageMutationHookResult = ReturnType<typeof useRevertPageMutation>;
export type RevertPageMutationResult = Apollo.MutationResult<RevertPageMutation>;
export type RevertPageMutationOptions = Apollo.BaseMutationOptions<RevertPageMutation, RevertPageMutationVariables>;
export const RotateGelatoWebhookSecretDocument = gql`
    mutation rotateGelatoWebhookSecret($siteId: ID!) {
  rotateGelatoWebhookSecret(siteId: $siteId) {
    id
    gelatoApiKey
    gelatoWebhookSecret
    gelatoActive
    gelatoNewsroomMarkupPercent
    gelatoEnabledProductTypes
  }
}
    `;
export type RotateGelatoWebhookSecretMutationFn = Apollo.MutationFunction<RotateGelatoWebhookSecretMutation, RotateGelatoWebhookSecretMutationVariables>;

/**
 * __useRotateGelatoWebhookSecretMutation__
 *
 * To run a mutation, you first call `useRotateGelatoWebhookSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateGelatoWebhookSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateGelatoWebhookSecretMutation, { data, loading, error }] = useRotateGelatoWebhookSecretMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRotateGelatoWebhookSecretMutation(baseOptions?: Apollo.MutationHookOptions<RotateGelatoWebhookSecretMutation, RotateGelatoWebhookSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateGelatoWebhookSecretMutation, RotateGelatoWebhookSecretMutationVariables>(RotateGelatoWebhookSecretDocument, options);
      }
export type RotateGelatoWebhookSecretMutationHookResult = ReturnType<typeof useRotateGelatoWebhookSecretMutation>;
export type RotateGelatoWebhookSecretMutationResult = Apollo.MutationResult<RotateGelatoWebhookSecretMutation>;
export type RotateGelatoWebhookSecretMutationOptions = Apollo.BaseMutationOptions<RotateGelatoWebhookSecretMutation, RotateGelatoWebhookSecretMutationVariables>;
export const SavePageDocument = gql`
    mutation savePage($param: SavePublishedNodeInput!) {
  savePage(param: $param) {
    brandId
    getPageTemplate(status: {state: Latest}) {
      items {
        blockTemplates {
          ids
          slot
        }
        blockVariants {
          componentId
          defaultVariant
        }
        brandId
        createdAt
        id
        pageTemplateCategory
        componentId
        savedAt
        siteId
        sk
        updatedAt
        state
        version
      }
    }
    gsk1
    gsk2
    id
    listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
      items {
        blockCategory
        brandId
        createdAt
        gsk1
        id
        componentId
        pageId
        data {
          ...BlockDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        archivedAt
        version
        externalBlockIds
        listExternalBlocks {
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
      }
    }
    localBlockSlots {
      ids
      slot
    }
    listPageAdditionalBlocks {
      items {
        blockCategory
        componentId
        data {
          ...BlockDataFragment
        }
        id
        variant
        version
        state
        pageId
        createdAt
        sk
        updatedAt
        archivedAt
        brandId
        gsk1
        siteId
        slug
      }
    }
    pageCategory
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    version
    createdAt
    seoTitle
    seoDescription
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type SavePageMutationFn = Apollo.MutationFunction<SavePageMutation, SavePageMutationVariables>;

/**
 * __useSavePageMutation__
 *
 * To run a mutation, you first call `useSavePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePageMutation, { data, loading, error }] = useSavePageMutation({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useSavePageMutation(baseOptions?: Apollo.MutationHookOptions<SavePageMutation, SavePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePageMutation, SavePageMutationVariables>(SavePageDocument, options);
      }
export type SavePageMutationHookResult = ReturnType<typeof useSavePageMutation>;
export type SavePageMutationResult = Apollo.MutationResult<SavePageMutation>;
export type SavePageMutationOptions = Apollo.BaseMutationOptions<SavePageMutation, SavePageMutationVariables>;
export const SendChatMessageDocument = gql`
    mutation sendChatMessage($params: SendChatMessageInput!) {
  sendChatMessage(params: $params)
}
    `;
export type SendChatMessageMutationFn = Apollo.MutationFunction<SendChatMessageMutation, SendChatMessageMutationVariables>;

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = useSendChatMessageMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSendChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMessageMutation, SendChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMessageMutation, SendChatMessageMutationVariables>(SendChatMessageDocument, options);
      }
export type SendChatMessageMutationHookResult = ReturnType<typeof useSendChatMessageMutation>;
export type SendChatMessageMutationResult = Apollo.MutationResult<SendChatMessageMutation>;
export type SendChatMessageMutationOptions = Apollo.BaseMutationOptions<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const SetApNewsTokenDocument = gql`
    mutation setAPNewsToken($siteId: ID!, $token: String!) {
  setAPNewsToken(siteId: $siteId, token: $token) {
    brandId
  }
}
    `;
export type SetApNewsTokenMutationFn = Apollo.MutationFunction<SetApNewsTokenMutation, SetApNewsTokenMutationVariables>;

/**
 * __useSetApNewsTokenMutation__
 *
 * To run a mutation, you first call `useSetApNewsTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetApNewsTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setApNewsTokenMutation, { data, loading, error }] = useSetApNewsTokenMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetApNewsTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetApNewsTokenMutation, SetApNewsTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetApNewsTokenMutation, SetApNewsTokenMutationVariables>(SetApNewsTokenDocument, options);
      }
export type SetApNewsTokenMutationHookResult = ReturnType<typeof useSetApNewsTokenMutation>;
export type SetApNewsTokenMutationResult = Apollo.MutationResult<SetApNewsTokenMutation>;
export type SetApNewsTokenMutationOptions = Apollo.BaseMutationOptions<SetApNewsTokenMutation, SetApNewsTokenMutationVariables>;
export const SetCustomerPortalConfigurationDocument = gql`
    mutation setCustomerPortalConfiguration($input: SetCustomerPortalConfigurationInput!) {
  setCustomerPortalConfiguration(input: $input) {
    id
    connectedStripeAccount {
      accountId
      customerPortalConfig {
        id
        enabled
        isDefault
        active
        allowPaymentMethodUpdate
        allowCancellation
        allowPlanSwitching
        switchablePrices
      }
    }
  }
}
    `;
export type SetCustomerPortalConfigurationMutationFn = Apollo.MutationFunction<SetCustomerPortalConfigurationMutation, SetCustomerPortalConfigurationMutationVariables>;

/**
 * __useSetCustomerPortalConfigurationMutation__
 *
 * To run a mutation, you first call `useSetCustomerPortalConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerPortalConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerPortalConfigurationMutation, { data, loading, error }] = useSetCustomerPortalConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomerPortalConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomerPortalConfigurationMutation, SetCustomerPortalConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomerPortalConfigurationMutation, SetCustomerPortalConfigurationMutationVariables>(SetCustomerPortalConfigurationDocument, options);
      }
export type SetCustomerPortalConfigurationMutationHookResult = ReturnType<typeof useSetCustomerPortalConfigurationMutation>;
export type SetCustomerPortalConfigurationMutationResult = Apollo.MutationResult<SetCustomerPortalConfigurationMutation>;
export type SetCustomerPortalConfigurationMutationOptions = Apollo.BaseMutationOptions<SetCustomerPortalConfigurationMutation, SetCustomerPortalConfigurationMutationVariables>;
export const UnpublishPageDocument = gql`
    mutation unpublishPage($page: UnpublishPublishedNodeInput!) {
  unpublishPage(param: $page) {
    brandId
    createdAt
    gsk1
    gsk2
    id
    pageCategory
    publishedAt
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    version
  }
}
    `;
export type UnpublishPageMutationFn = Apollo.MutationFunction<UnpublishPageMutation, UnpublishPageMutationVariables>;

/**
 * __useUnpublishPageMutation__
 *
 * To run a mutation, you first call `useUnpublishPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishPageMutation, { data, loading, error }] = useUnpublishPageMutation({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUnpublishPageMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishPageMutation, UnpublishPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishPageMutation, UnpublishPageMutationVariables>(UnpublishPageDocument, options);
      }
export type UnpublishPageMutationHookResult = ReturnType<typeof useUnpublishPageMutation>;
export type UnpublishPageMutationResult = Apollo.MutationResult<UnpublishPageMutation>;
export type UnpublishPageMutationOptions = Apollo.BaseMutationOptions<UnpublishPageMutation, UnpublishPageMutationVariables>;
export const UpdateApNewsTopicDocument = gql`
    mutation updateAPNewsTopic($siteId: ID!, $topic: APNewsTopicInput!) {
  updateAPNewsTopic(siteId: $siteId, topic: $topic) {
    id
    name
    pricing
    feedLink
    active
    sectionId
    publishStatus
    paywall
    display
    imgRequired
  }
}
    `;
export type UpdateApNewsTopicMutationFn = Apollo.MutationFunction<UpdateApNewsTopicMutation, UpdateApNewsTopicMutationVariables>;

/**
 * __useUpdateApNewsTopicMutation__
 *
 * To run a mutation, you first call `useUpdateApNewsTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApNewsTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApNewsTopicMutation, { data, loading, error }] = useUpdateApNewsTopicMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useUpdateApNewsTopicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApNewsTopicMutation, UpdateApNewsTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApNewsTopicMutation, UpdateApNewsTopicMutationVariables>(UpdateApNewsTopicDocument, options);
      }
export type UpdateApNewsTopicMutationHookResult = ReturnType<typeof useUpdateApNewsTopicMutation>;
export type UpdateApNewsTopicMutationResult = Apollo.MutationResult<UpdateApNewsTopicMutation>;
export type UpdateApNewsTopicMutationOptions = Apollo.BaseMutationOptions<UpdateApNewsTopicMutation, UpdateApNewsTopicMutationVariables>;
export const UpdateAssetDocument = gql`
    mutation updateAsset($asset: UpdateAssetInput!) {
  updateAsset(asset: $asset) {
    brandId
    createdAt
    height
    id
    imagePlaceholder
    key
    name
    public
    tags
    type
    updatedAt
    uploaded
    usedIn
    version
    width
  }
}
    `;
export type UpdateAssetMutationFn = Apollo.MutationFunction<UpdateAssetMutation, UpdateAssetMutationVariables>;

/**
 * __useUpdateAssetMutation__
 *
 * To run a mutation, you first call `useUpdateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetMutation, { data, loading, error }] = useUpdateAssetMutation({
 *   variables: {
 *      asset: // value for 'asset'
 *   },
 * });
 */
export function useUpdateAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssetMutation, UpdateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssetMutation, UpdateAssetMutationVariables>(UpdateAssetDocument, options);
      }
export type UpdateAssetMutationHookResult = ReturnType<typeof useUpdateAssetMutation>;
export type UpdateAssetMutationResult = Apollo.MutationResult<UpdateAssetMutation>;
export type UpdateAssetMutationOptions = Apollo.BaseMutationOptions<UpdateAssetMutation, UpdateAssetMutationVariables>;
export const UpdateBlockDocument = gql`
    mutation updateBlock($updateBlockInput: UpdateBlockInput!) {
  updateBlock(block: $updateBlockInput) {
    blockCategory
    brandId
    createdAt
    gsk1
    id
    componentId
    pageId
    data {
      ...BlockDataFragment
    }
    variant
    savedAt
    siteId
    sk
    state
    updatedAt
    archivedAt
    version
    externalBlockIds
    listExternalBlocks {
      items {
        blockCategory
        brandId
        componentId
        createdAt
        data {
          ...BlockDataFragment
        }
        gsk1
        externalBlockIds
        id
        pageId
        savedAt
        siteId
        state
        updatedAt
        archivedAt
        sk
        variant
        version
      }
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type UpdateBlockMutationFn = Apollo.MutationFunction<UpdateBlockMutation, UpdateBlockMutationVariables>;

/**
 * __useUpdateBlockMutation__
 *
 * To run a mutation, you first call `useUpdateBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockMutation, { data, loading, error }] = useUpdateBlockMutation({
 *   variables: {
 *      updateBlockInput: // value for 'updateBlockInput'
 *   },
 * });
 */
export function useUpdateBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockMutation, UpdateBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockMutation, UpdateBlockMutationVariables>(UpdateBlockDocument, options);
      }
export type UpdateBlockMutationHookResult = ReturnType<typeof useUpdateBlockMutation>;
export type UpdateBlockMutationResult = Apollo.MutationResult<UpdateBlockMutation>;
export type UpdateBlockMutationOptions = Apollo.BaseMutationOptions<UpdateBlockMutation, UpdateBlockMutationVariables>;
export const UpdateBlockTemplateDocument = gql`
    mutation updateBlockTemplate($updateBlockTemplateInput: UpdateBlockTemplateInput!) {
  updateBlockTemplate(blockTemplate: $updateBlockTemplateInput) {
    data {
      ...BlockTemplateDataFragment
    }
    blockCategory
    brandId
    componentId
    createdAt
    gsk1
    id
    publishedAt
    savedAt
    siteId
    sk
    state
    updatedAt
    variant
    version
  }
}
    ${BlockTemplateDataFragmentFragmentDoc}`;
export type UpdateBlockTemplateMutationFn = Apollo.MutationFunction<UpdateBlockTemplateMutation, UpdateBlockTemplateMutationVariables>;

/**
 * __useUpdateBlockTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateBlockTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockTemplateMutation, { data, loading, error }] = useUpdateBlockTemplateMutation({
 *   variables: {
 *      updateBlockTemplateInput: // value for 'updateBlockTemplateInput'
 *   },
 * });
 */
export function useUpdateBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockTemplateMutation, UpdateBlockTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockTemplateMutation, UpdateBlockTemplateMutationVariables>(UpdateBlockTemplateDocument, options);
      }
export type UpdateBlockTemplateMutationHookResult = ReturnType<typeof useUpdateBlockTemplateMutation>;
export type UpdateBlockTemplateMutationResult = Apollo.MutationResult<UpdateBlockTemplateMutation>;
export type UpdateBlockTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateBlockTemplateMutation, UpdateBlockTemplateMutationVariables>;
export const UpdateBlockTemplatesDocument = gql`
    mutation updateBlockTemplates($input: [UpdateBlockTemplateInput!]!) {
  updateBlockTemplates(blockTemplates: $input) {
    data {
      ...BlockTemplateDataFragment
    }
    blockCategory
    brandId
    componentId
    createdAt
    gsk1
    id
    publishedAt
    savedAt
    siteId
    sk
    state
    updatedAt
    variant
    version
  }
}
    ${BlockTemplateDataFragmentFragmentDoc}`;
export type UpdateBlockTemplatesMutationFn = Apollo.MutationFunction<UpdateBlockTemplatesMutation, UpdateBlockTemplatesMutationVariables>;

/**
 * __useUpdateBlockTemplatesMutation__
 *
 * To run a mutation, you first call `useUpdateBlockTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockTemplatesMutation, { data, loading, error }] = useUpdateBlockTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockTemplatesMutation, UpdateBlockTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockTemplatesMutation, UpdateBlockTemplatesMutationVariables>(UpdateBlockTemplatesDocument, options);
      }
export type UpdateBlockTemplatesMutationHookResult = ReturnType<typeof useUpdateBlockTemplatesMutation>;
export type UpdateBlockTemplatesMutationResult = Apollo.MutationResult<UpdateBlockTemplatesMutation>;
export type UpdateBlockTemplatesMutationOptions = Apollo.BaseMutationOptions<UpdateBlockTemplatesMutation, UpdateBlockTemplatesMutationVariables>;
export const UpdateBlocksDocument = gql`
    mutation updateBlocks($updateBlocksInput: [UpdateBlockInput!]!) {
  updateBlocks(blocks: $updateBlocksInput) {
    blockCategory
    brandId
    createdAt
    gsk1
    id
    componentId
    pageId
    data {
      ...BlockDataFragment
    }
    variant
    savedAt
    siteId
    sk
    state
    updatedAt
    archivedAt
    version
    externalBlockIds
    listExternalBlocks {
      items {
        blockCategory
        brandId
        componentId
        createdAt
        data {
          ...BlockDataFragment
        }
        gsk1
        externalBlockIds
        id
        pageId
        savedAt
        siteId
        state
        updatedAt
        archivedAt
        sk
        variant
        version
      }
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type UpdateBlocksMutationFn = Apollo.MutationFunction<UpdateBlocksMutation, UpdateBlocksMutationVariables>;

/**
 * __useUpdateBlocksMutation__
 *
 * To run a mutation, you first call `useUpdateBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlocksMutation, { data, loading, error }] = useUpdateBlocksMutation({
 *   variables: {
 *      updateBlocksInput: // value for 'updateBlocksInput'
 *   },
 * });
 */
export function useUpdateBlocksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlocksMutation, UpdateBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlocksMutation, UpdateBlocksMutationVariables>(UpdateBlocksDocument, options);
      }
export type UpdateBlocksMutationHookResult = ReturnType<typeof useUpdateBlocksMutation>;
export type UpdateBlocksMutationResult = Apollo.MutationResult<UpdateBlocksMutation>;
export type UpdateBlocksMutationOptions = Apollo.BaseMutationOptions<UpdateBlocksMutation, UpdateBlocksMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation updateBrand($brand: UpdateBrandInput!) {
  updateBrand(brand: $brand) {
    id
    version
    createdAt
    updatedAt
    name
    path
    workspaceId
    brandStyleId
  }
}
    `;
export type UpdateBrandMutationFn = Apollo.MutationFunction<UpdateBrandMutation, UpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const UpdateBrandStyleDocument = gql`
    mutation updateBrandStyle($brandStyle: UpdateBrandStyleInput!) {
  updateBrandStyle(brandStyle: $brandStyle) {
    brandId
    createdAt
    id
    properties {
      ...ClientThemePropertiesFragment
    }
    updatedAt
    version
  }
}
    ${ClientThemePropertiesFragmentFragmentDoc}`;
export type UpdateBrandStyleMutationFn = Apollo.MutationFunction<UpdateBrandStyleMutation, UpdateBrandStyleMutationVariables>;

/**
 * __useUpdateBrandStyleMutation__
 *
 * To run a mutation, you first call `useUpdateBrandStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandStyleMutation, { data, loading, error }] = useUpdateBrandStyleMutation({
 *   variables: {
 *      brandStyle: // value for 'brandStyle'
 *   },
 * });
 */
export function useUpdateBrandStyleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandStyleMutation, UpdateBrandStyleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandStyleMutation, UpdateBrandStyleMutationVariables>(UpdateBrandStyleDocument, options);
      }
export type UpdateBrandStyleMutationHookResult = ReturnType<typeof useUpdateBrandStyleMutation>;
export type UpdateBrandStyleMutationResult = Apollo.MutationResult<UpdateBrandStyleMutation>;
export type UpdateBrandStyleMutationOptions = Apollo.BaseMutationOptions<UpdateBrandStyleMutation, UpdateBrandStyleMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation updateCollection($collection: UpdateCollectionInput!) {
  updateCollection(collection: $collection) {
    collectionId
    name
    siteId
    listCollectionItems {
      items {
        name
        assetKey
        siteId
        assetId
        collectionId
        credit
        caption
        alt
        width
        height
        createdAt
        updatedAt
        metadata
      }
    }
  }
}
    `;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<UpdateCollectionMutation, UpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *   },
 * });
 */
export function useUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
      }
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const UpdateCollectionItemDocument = gql`
    mutation updateCollectionItem($params: UpdateCollectionItemInput!) {
  updateCollectionItem(params: $params) {
    name
    assetKey
    siteId
    assetId
    collectionId
    credit
    caption
    alt
    width
    height
    createdAt
    updatedAt
    metadata
  }
}
    `;
export type UpdateCollectionItemMutationFn = Apollo.MutationFunction<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>;

/**
 * __useUpdateCollectionItemMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionItemMutation, { data, loading, error }] = useUpdateCollectionItemMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>(UpdateCollectionItemDocument, options);
      }
export type UpdateCollectionItemMutationHookResult = ReturnType<typeof useUpdateCollectionItemMutation>;
export type UpdateCollectionItemMutationResult = Apollo.MutationResult<UpdateCollectionItemMutation>;
export type UpdateCollectionItemMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionItemMutation, UpdateCollectionItemMutationVariables>;
export const ConnectDomainForSiteDocument = gql`
    mutation connectDomainForSite($domainName: String!, $id: ID!) {
  connectDomainForSite(domainName: $domainName, id: $id) {
    brandId
    createdAt
    domain {
      createdAt
      domainCloudFormation
      domainCloudfront
      domainName
      externalProvider
      hostedZoneId
      nameServers
      operationId
      siteId
      status
      updatedAt
      workspaceId
    }
    domainName
    id
    name
    updatedAt
    version
  }
}
    `;
export type ConnectDomainForSiteMutationFn = Apollo.MutationFunction<ConnectDomainForSiteMutation, ConnectDomainForSiteMutationVariables>;

/**
 * __useConnectDomainForSiteMutation__
 *
 * To run a mutation, you first call `useConnectDomainForSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectDomainForSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectDomainForSiteMutation, { data, loading, error }] = useConnectDomainForSiteMutation({
 *   variables: {
 *      domainName: // value for 'domainName'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectDomainForSiteMutation(baseOptions?: Apollo.MutationHookOptions<ConnectDomainForSiteMutation, ConnectDomainForSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectDomainForSiteMutation, ConnectDomainForSiteMutationVariables>(ConnectDomainForSiteDocument, options);
      }
export type ConnectDomainForSiteMutationHookResult = ReturnType<typeof useConnectDomainForSiteMutation>;
export type ConnectDomainForSiteMutationResult = Apollo.MutationResult<ConnectDomainForSiteMutation>;
export type ConnectDomainForSiteMutationOptions = Apollo.BaseMutationOptions<ConnectDomainForSiteMutation, ConnectDomainForSiteMutationVariables>;
export const UpdateContextTemplateDocument = gql`
    mutation updateContextTemplate($contextTemplate: UpdateContextTemplateInput!) {
  updateContextTemplate(contextTemplate: $contextTemplate) {
    siteId
    id
    name
    content
    active
  }
}
    `;
export type UpdateContextTemplateMutationFn = Apollo.MutationFunction<UpdateContextTemplateMutation, UpdateContextTemplateMutationVariables>;

/**
 * __useUpdateContextTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateContextTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContextTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContextTemplateMutation, { data, loading, error }] = useUpdateContextTemplateMutation({
 *   variables: {
 *      contextTemplate: // value for 'contextTemplate'
 *   },
 * });
 */
export function useUpdateContextTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContextTemplateMutation, UpdateContextTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContextTemplateMutation, UpdateContextTemplateMutationVariables>(UpdateContextTemplateDocument, options);
      }
export type UpdateContextTemplateMutationHookResult = ReturnType<typeof useUpdateContextTemplateMutation>;
export type UpdateContextTemplateMutationResult = Apollo.MutationResult<UpdateContextTemplateMutation>;
export type UpdateContextTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateContextTemplateMutation, UpdateContextTemplateMutationVariables>;
export const UpdateExternalFeedDocument = gql`
    mutation updateExternalFeed($siteId: ID!, $feed: UpdateExternalFeedInput!) {
  updateExternalFeed(siteId: $siteId, feed: $feed) {
    id
  }
}
    `;
export type UpdateExternalFeedMutationFn = Apollo.MutationFunction<UpdateExternalFeedMutation, UpdateExternalFeedMutationVariables>;

/**
 * __useUpdateExternalFeedMutation__
 *
 * To run a mutation, you first call `useUpdateExternalFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalFeedMutation, { data, loading, error }] = useUpdateExternalFeedMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useUpdateExternalFeedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalFeedMutation, UpdateExternalFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalFeedMutation, UpdateExternalFeedMutationVariables>(UpdateExternalFeedDocument, options);
      }
export type UpdateExternalFeedMutationHookResult = ReturnType<typeof useUpdateExternalFeedMutation>;
export type UpdateExternalFeedMutationResult = Apollo.MutationResult<UpdateExternalFeedMutation>;
export type UpdateExternalFeedMutationOptions = Apollo.BaseMutationOptions<UpdateExternalFeedMutation, UpdateExternalFeedMutationVariables>;
export const UpdateFeaturedChatbotPromptDocument = gql`
    mutation updateFeaturedChatbotPrompt($prompt: UpdateFeaturedChatbotPromptInput!) {
  updateFeaturedChatbotPrompt(prompt: $prompt) {
    siteId
    id
    prompt
    active
    label
    category
    pageType
  }
}
    `;
export type UpdateFeaturedChatbotPromptMutationFn = Apollo.MutationFunction<UpdateFeaturedChatbotPromptMutation, UpdateFeaturedChatbotPromptMutationVariables>;

/**
 * __useUpdateFeaturedChatbotPromptMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedChatbotPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedChatbotPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedChatbotPromptMutation, { data, loading, error }] = useUpdateFeaturedChatbotPromptMutation({
 *   variables: {
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useUpdateFeaturedChatbotPromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedChatbotPromptMutation, UpdateFeaturedChatbotPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeaturedChatbotPromptMutation, UpdateFeaturedChatbotPromptMutationVariables>(UpdateFeaturedChatbotPromptDocument, options);
      }
export type UpdateFeaturedChatbotPromptMutationHookResult = ReturnType<typeof useUpdateFeaturedChatbotPromptMutation>;
export type UpdateFeaturedChatbotPromptMutationResult = Apollo.MutationResult<UpdateFeaturedChatbotPromptMutation>;
export type UpdateFeaturedChatbotPromptMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedChatbotPromptMutation, UpdateFeaturedChatbotPromptMutationVariables>;
export const UpdateFeedDocument = gql`
    mutation updateFeed($feed: UpdateFeedInput!) {
  updateFeed(feed: $feed) {
    id
    workspaceId
    name
    description
    createdAt
    updatedAt
    webhooks {
      url
      active
    }
    filters {
      pattern
      active
    }
  }
}
    `;
export type UpdateFeedMutationFn = Apollo.MutationFunction<UpdateFeedMutation, UpdateFeedMutationVariables>;

/**
 * __useUpdateFeedMutation__
 *
 * To run a mutation, you first call `useUpdateFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedMutation, { data, loading, error }] = useUpdateFeedMutation({
 *   variables: {
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useUpdateFeedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedMutation, UpdateFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedMutation, UpdateFeedMutationVariables>(UpdateFeedDocument, options);
      }
export type UpdateFeedMutationHookResult = ReturnType<typeof useUpdateFeedMutation>;
export type UpdateFeedMutationResult = Apollo.MutationResult<UpdateFeedMutation>;
export type UpdateFeedMutationOptions = Apollo.BaseMutationOptions<UpdateFeedMutation, UpdateFeedMutationVariables>;
export const UpdateFeedSiteSubscriptionsDocument = gql`
    mutation updateFeedSiteSubscriptions($feedSiteSubscriptions: UpdateFeedSiteSubscriptionsInput!) {
  updateFeedSiteSubscriptions(feedSiteSubscriptions: $feedSiteSubscriptions) {
    workspaceId
    feedId
    siteId
    active
    name
    description
    publishStatus
    paywall
    section
    createdAt
    updatedAt
    tags
  }
}
    `;
export type UpdateFeedSiteSubscriptionsMutationFn = Apollo.MutationFunction<UpdateFeedSiteSubscriptionsMutation, UpdateFeedSiteSubscriptionsMutationVariables>;

/**
 * __useUpdateFeedSiteSubscriptionsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedSiteSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedSiteSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedSiteSubscriptionsMutation, { data, loading, error }] = useUpdateFeedSiteSubscriptionsMutation({
 *   variables: {
 *      feedSiteSubscriptions: // value for 'feedSiteSubscriptions'
 *   },
 * });
 */
export function useUpdateFeedSiteSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedSiteSubscriptionsMutation, UpdateFeedSiteSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedSiteSubscriptionsMutation, UpdateFeedSiteSubscriptionsMutationVariables>(UpdateFeedSiteSubscriptionsDocument, options);
      }
export type UpdateFeedSiteSubscriptionsMutationHookResult = ReturnType<typeof useUpdateFeedSiteSubscriptionsMutation>;
export type UpdateFeedSiteSubscriptionsMutationResult = Apollo.MutationResult<UpdateFeedSiteSubscriptionsMutation>;
export type UpdateFeedSiteSubscriptionsMutationOptions = Apollo.BaseMutationOptions<UpdateFeedSiteSubscriptionsMutation, UpdateFeedSiteSubscriptionsMutationVariables>;
export const UpdateGelatoActiveDocument = gql`
    mutation updateGelatoActive($siteId: ID!, $active: Boolean!) {
  updateGelatoActive(siteId: $siteId, active: $active) {
    id
    gelatoApiKey
    gelatoActive
    gelatoNewsroomMarkupPercent
    gelatoEnabledProductTypes
  }
}
    `;
export type UpdateGelatoActiveMutationFn = Apollo.MutationFunction<UpdateGelatoActiveMutation, UpdateGelatoActiveMutationVariables>;

/**
 * __useUpdateGelatoActiveMutation__
 *
 * To run a mutation, you first call `useUpdateGelatoActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGelatoActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGelatoActiveMutation, { data, loading, error }] = useUpdateGelatoActiveMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateGelatoActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGelatoActiveMutation, UpdateGelatoActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGelatoActiveMutation, UpdateGelatoActiveMutationVariables>(UpdateGelatoActiveDocument, options);
      }
export type UpdateGelatoActiveMutationHookResult = ReturnType<typeof useUpdateGelatoActiveMutation>;
export type UpdateGelatoActiveMutationResult = Apollo.MutationResult<UpdateGelatoActiveMutation>;
export type UpdateGelatoActiveMutationOptions = Apollo.BaseMutationOptions<UpdateGelatoActiveMutation, UpdateGelatoActiveMutationVariables>;
export const UpdateNewsletterDocument = gql`
    mutation updateNewsletter($newsletter: NewsletterInput!) {
  updateNewsletter(newsletter: $newsletter) {
    siteId
    name
    description
    id
    order
  }
}
    `;
export type UpdateNewsletterMutationFn = Apollo.MutationFunction<UpdateNewsletterMutation, UpdateNewsletterMutationVariables>;

/**
 * __useUpdateNewsletterMutation__
 *
 * To run a mutation, you first call `useUpdateNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsletterMutation, { data, loading, error }] = useUpdateNewsletterMutation({
 *   variables: {
 *      newsletter: // value for 'newsletter'
 *   },
 * });
 */
export function useUpdateNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsletterMutation, UpdateNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsletterMutation, UpdateNewsletterMutationVariables>(UpdateNewsletterDocument, options);
      }
export type UpdateNewsletterMutationHookResult = ReturnType<typeof useUpdateNewsletterMutation>;
export type UpdateNewsletterMutationResult = Apollo.MutationResult<UpdateNewsletterMutation>;
export type UpdateNewsletterMutationOptions = Apollo.BaseMutationOptions<UpdateNewsletterMutation, UpdateNewsletterMutationVariables>;
export const UpdateNewslettersDocument = gql`
    mutation updateNewsletters($newsletters: [NewsletterInput!]!) {
  updateNewsletters(newsletters: $newsletters) {
    siteId
    name
    description
    id
    order
  }
}
    `;
export type UpdateNewslettersMutationFn = Apollo.MutationFunction<UpdateNewslettersMutation, UpdateNewslettersMutationVariables>;

/**
 * __useUpdateNewslettersMutation__
 *
 * To run a mutation, you first call `useUpdateNewslettersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewslettersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewslettersMutation, { data, loading, error }] = useUpdateNewslettersMutation({
 *   variables: {
 *      newsletters: // value for 'newsletters'
 *   },
 * });
 */
export function useUpdateNewslettersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewslettersMutation, UpdateNewslettersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewslettersMutation, UpdateNewslettersMutationVariables>(UpdateNewslettersDocument, options);
      }
export type UpdateNewslettersMutationHookResult = ReturnType<typeof useUpdateNewslettersMutation>;
export type UpdateNewslettersMutationResult = Apollo.MutationResult<UpdateNewslettersMutation>;
export type UpdateNewslettersMutationOptions = Apollo.BaseMutationOptions<UpdateNewslettersMutation, UpdateNewslettersMutationVariables>;
export const UpdatePageDocument = gql`
    mutation updatePage($page: UpdatePageInput!) {
  updatePage(page: $page) {
    brandId
    getPageTemplate(status: {state: Latest}) {
      items {
        blockTemplates {
          ids
          slot
        }
        blockVariants {
          componentId
          defaultVariant
        }
        brandId
        createdAt
        id
        pageTemplateCategory
        componentId
        savedAt
        siteId
        sk
        updatedAt
        state
        version
      }
    }
    gsk1
    gsk2
    id
    listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
      items {
        blockCategory
        brandId
        createdAt
        gsk1
        id
        componentId
        pageId
        data {
          ...BlockDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        archivedAt
        version
        externalBlockIds
        listExternalBlocks {
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
      }
    }
    localBlockSlots {
      ids
      slot
    }
    listPageAdditionalBlocks {
      items {
        blockCategory
        componentId
        data {
          ...BlockDataFragment
        }
        id
        variant
        version
        state
        pageId
        createdAt
        sk
        updatedAt
        archivedAt
        brandId
        gsk1
        siteId
        slug
      }
    }
    pageCategory
    savedAt
    siteId
    sk
    slug
    state
    templateId
    updatedAt
    version
    createdAt
    seoTitle
    seoDescription
    seoImageSrc
    seoImageWidth
    seoImageHeight
  }
}
    ${BlockDataFragmentFragmentDoc}`;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const UpdatePageSlugDocument = gql`
    mutation updatePageSlug($page: UpdatePageSlugInput!) {
  updatePageSlug(page: $page) {
    id
    brandId
    createdAt
    gsk1
    gsk2
    pageCategory
    savedAt
    sk
    siteId
    slug
    state
    templateId
    updatedAt
    publishedAt
    version
  }
}
    `;
export type UpdatePageSlugMutationFn = Apollo.MutationFunction<UpdatePageSlugMutation, UpdatePageSlugMutationVariables>;

/**
 * __useUpdatePageSlugMutation__
 *
 * To run a mutation, you first call `useUpdatePageSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageSlugMutation, { data, loading, error }] = useUpdatePageSlugMutation({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUpdatePageSlugMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageSlugMutation, UpdatePageSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageSlugMutation, UpdatePageSlugMutationVariables>(UpdatePageSlugDocument, options);
      }
export type UpdatePageSlugMutationHookResult = ReturnType<typeof useUpdatePageSlugMutation>;
export type UpdatePageSlugMutationResult = Apollo.MutationResult<UpdatePageSlugMutation>;
export type UpdatePageSlugMutationOptions = Apollo.BaseMutationOptions<UpdatePageSlugMutation, UpdatePageSlugMutationVariables>;
export const UpdatePersonaDocument = gql`
    mutation updatePersona($persona: UpdatePersonaInput!) {
  updatePersona(persona: $persona) {
    siteId
    id
    name
    description
    answerStyle
  }
}
    `;
export type UpdatePersonaMutationFn = Apollo.MutationFunction<UpdatePersonaMutation, UpdatePersonaMutationVariables>;

/**
 * __useUpdatePersonaMutation__
 *
 * To run a mutation, you first call `useUpdatePersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonaMutation, { data, loading, error }] = useUpdatePersonaMutation({
 *   variables: {
 *      persona: // value for 'persona'
 *   },
 * });
 */
export function useUpdatePersonaMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonaMutation, UpdatePersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonaMutation, UpdatePersonaMutationVariables>(UpdatePersonaDocument, options);
      }
export type UpdatePersonaMutationHookResult = ReturnType<typeof useUpdatePersonaMutation>;
export type UpdatePersonaMutationResult = Apollo.MutationResult<UpdatePersonaMutation>;
export type UpdatePersonaMutationOptions = Apollo.BaseMutationOptions<UpdatePersonaMutation, UpdatePersonaMutationVariables>;
export const UpdatePublicPersonaDocument = gql`
    mutation updatePublicPersona($persona: UpdatePublicPersonaInput!) {
  updatePublicPersona(persona: $persona) {
    siteId
    id
    name
    description
    answerStyle
    active
  }
}
    `;
export type UpdatePublicPersonaMutationFn = Apollo.MutationFunction<UpdatePublicPersonaMutation, UpdatePublicPersonaMutationVariables>;

/**
 * __useUpdatePublicPersonaMutation__
 *
 * To run a mutation, you first call `useUpdatePublicPersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicPersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicPersonaMutation, { data, loading, error }] = useUpdatePublicPersonaMutation({
 *   variables: {
 *      persona: // value for 'persona'
 *   },
 * });
 */
export function useUpdatePublicPersonaMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublicPersonaMutation, UpdatePublicPersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublicPersonaMutation, UpdatePublicPersonaMutationVariables>(UpdatePublicPersonaDocument, options);
      }
export type UpdatePublicPersonaMutationHookResult = ReturnType<typeof useUpdatePublicPersonaMutation>;
export type UpdatePublicPersonaMutationResult = Apollo.MutationResult<UpdatePublicPersonaMutation>;
export type UpdatePublicPersonaMutationOptions = Apollo.BaseMutationOptions<UpdatePublicPersonaMutation, UpdatePublicPersonaMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation updateQuestion($question: UpdateQuestionInput!) {
  updateQuestion(question: $question) {
    siteId
    id
    question
    answer
    questionKey
    deprecated
  }
}
    `;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      question: // value for 'question'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const UpdateRegisteredUserDocument = gql`
    mutation updateRegisteredUser($params: UpdateRegisteredUserInput!) {
  updateRegisteredUser(params: $params) {
    id
    email
    legacyPassword
    legacyUsername
    phoneNumber
    shippingAddress {
      firstName
      lastName
      address1
      address2
      city
      state
      zip
      country
    }
  }
}
    `;
export type UpdateRegisteredUserMutationFn = Apollo.MutationFunction<UpdateRegisteredUserMutation, UpdateRegisteredUserMutationVariables>;

/**
 * __useUpdateRegisteredUserMutation__
 *
 * To run a mutation, you first call `useUpdateRegisteredUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisteredUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisteredUserMutation, { data, loading, error }] = useUpdateRegisteredUserMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateRegisteredUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegisteredUserMutation, UpdateRegisteredUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegisteredUserMutation, UpdateRegisteredUserMutationVariables>(UpdateRegisteredUserDocument, options);
      }
export type UpdateRegisteredUserMutationHookResult = ReturnType<typeof useUpdateRegisteredUserMutation>;
export type UpdateRegisteredUserMutationResult = Apollo.MutationResult<UpdateRegisteredUserMutation>;
export type UpdateRegisteredUserMutationOptions = Apollo.BaseMutationOptions<UpdateRegisteredUserMutation, UpdateRegisteredUserMutationVariables>;
export const UpdateSiteDocument = gql`
    mutation updateSite($site: UpdateSiteInput!) {
  updateSite(site: $site) {
    id
    brandId
    name
    favicon
    protected
    chatOpenByDefault
    version
    updatedAt
    createdAt
    domainName
    siteCategory
    defaultArticleAccess
    defaultArticleExternalDisplay
    defaultMetadata
    emailCapture {
      title
      subtitle
      newsletterId
      customNewsletterId
    }
    disableStoryGeneration
    disableTitleGeneration
    disableLeadGeneration
    disableCmsChatbot
    emailServiceAutoTagSignedIn
    emailServiceAutoTagSubscribed
    sendNewsletterSubscriptionEmail
    newsletterProvider
    tollbitAnalyticsEnabled
    newspapersDotComTPAKey
    newspapersDotComSubdomain
    newzwareAccount {
      active
      instanceUrl
      site
      editionCode
    }
    engageAccount {
      active
      configScript
      subscribeUrl
      accountUrl
    }
    mirabelAccount {
      active
      baseUrl
      tenant
      apiKey
    }
    makeItFreeAccount {
      active
      publisherId
      apiKey
    }
    connectedIzootoAccount {
      active
      scriptId
    }
    navigaAccount {
      username
      password
      wsdlUrl
      active
      navigaSubscriptionAssociation {
        stripeProductId
        navigaPubId
      }
    }
    imgPlaceholder {
      src
      width
      height
    }
    metadataImage {
      src
      width
      height
    }
    chatbotImage {
      src
      width
      height
    }
    chatbotMinimizedDisplayName
    aiSettings {
      journalistType
      audienceType
      blogType
      primaryPersona
      publicPrimaryPersona
      greetingMessage
    }
    typesense {
      cmsKey
      siteKey
    }
    adTxtContent
    menus {
      id
      items {
        id
        name
        url
        type
        menuIds
      }
      name
    }
    googleTagAds {
      verticalHeaderScript
      vertical2HeaderScript
      horizontal1HeaderScript
      horizontal2HeaderScript
      footerHeaderScript
      adHeroHeaderScript
    }
    customAds {
      blockPubHeaderMenu {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSearch {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleBody {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubLatestArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubAuthorRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubTagRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubHomeTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockEmailCapture {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd1 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd2 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
    }
    adSystem
    playWirePubId
    playWireWebId
    shippingCountries
    getBrand {
      id
      brandStyleId
      createdAt
      version
      updatedAt
      name
      getBrandStyle {
        id
        brandId
        createdAt
        updatedAt
        version
        properties {
          ...ClientThemePropertiesFragment
        }
      }
      listBrandStyles {
        items {
          brandId
          createdAt
          id
          properties {
            ...ClientThemePropertiesFragment
          }
          version
          updatedAt
        }
      }
      path
    }
    companyInfo {
      cityName
      countyCode
      mainEmail
      mainPhoneNumber
      noaaGridPoint
      supportEmail
      supportPhoneNumber
      timeZone
      sendSubscriptionLifecycleEmailsToCustomer
      coordinates {
        lat
        lng
      }
    }
  }
}
    ${ClientThemePropertiesFragmentFragmentDoc}`;
export type UpdateSiteMutationFn = Apollo.MutationFunction<UpdateSiteMutation, UpdateSiteMutationVariables>;

/**
 * __useUpdateSiteMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMutation, { data, loading, error }] = useUpdateSiteMutation({
 *   variables: {
 *      site: // value for 'site'
 *   },
 * });
 */
export function useUpdateSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMutation, UpdateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteMutation, UpdateSiteMutationVariables>(UpdateSiteDocument, options);
      }
export type UpdateSiteMutationHookResult = ReturnType<typeof useUpdateSiteMutation>;
export type UpdateSiteMutationResult = Apollo.MutationResult<UpdateSiteMutation>;
export type UpdateSiteMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const UpdateStripeAccountDetailsDocument = gql`
    mutation UpdateStripeAccountDetails($details: UpdateStripeAccountDetailsInput!) {
  updateStripeAccountDetails(details: $details) {
    id
    name
    version
    updatedAt
    siteCategory
    brandId
    connectedStripeAccount {
      accountId
      status
      notificationEmail
      profileChangeNotificationEmail
      type
      subscriptionPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        struckOutpriceForMonthlyToggleChoice
        struckOutPriceForYearlyToggleChoice
        priceSubtitleMonthly
        priceSubtitleYearly
        stripeDescription
        productId
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        promoCouponIdMonthly
        promoCouponIdYearly
      }
    }
  }
}
    `;
export type UpdateStripeAccountDetailsMutationFn = Apollo.MutationFunction<UpdateStripeAccountDetailsMutation, UpdateStripeAccountDetailsMutationVariables>;

/**
 * __useUpdateStripeAccountDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateStripeAccountDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStripeAccountDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStripeAccountDetailsMutation, { data, loading, error }] = useUpdateStripeAccountDetailsMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateStripeAccountDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStripeAccountDetailsMutation, UpdateStripeAccountDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStripeAccountDetailsMutation, UpdateStripeAccountDetailsMutationVariables>(UpdateStripeAccountDetailsDocument, options);
      }
export type UpdateStripeAccountDetailsMutationHookResult = ReturnType<typeof useUpdateStripeAccountDetailsMutation>;
export type UpdateStripeAccountDetailsMutationResult = Apollo.MutationResult<UpdateStripeAccountDetailsMutation>;
export type UpdateStripeAccountDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateStripeAccountDetailsMutation, UpdateStripeAccountDetailsMutationVariables>;
export const UpdateSubscriptionGiftDocument = gql`
    mutation updateSubscriptionGift($gift: UpdateSubscriptionGiftInput!) {
  updateSubscriptionGift(gift: $gift) {
    siteId
    productId
    priceId
    planProductId
    couponId
    numberOfGiftedMonths
    priceInCents
    isActive
  }
}
    `;
export type UpdateSubscriptionGiftMutationFn = Apollo.MutationFunction<UpdateSubscriptionGiftMutation, UpdateSubscriptionGiftMutationVariables>;

/**
 * __useUpdateSubscriptionGiftMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionGiftMutation, { data, loading, error }] = useUpdateSubscriptionGiftMutation({
 *   variables: {
 *      gift: // value for 'gift'
 *   },
 * });
 */
export function useUpdateSubscriptionGiftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionGiftMutation, UpdateSubscriptionGiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionGiftMutation, UpdateSubscriptionGiftMutationVariables>(UpdateSubscriptionGiftDocument, options);
      }
export type UpdateSubscriptionGiftMutationHookResult = ReturnType<typeof useUpdateSubscriptionGiftMutation>;
export type UpdateSubscriptionGiftMutationResult = Apollo.MutationResult<UpdateSubscriptionGiftMutation>;
export type UpdateSubscriptionGiftMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionGiftMutation, UpdateSubscriptionGiftMutationVariables>;
export const UpdateSubscriptionPlanDocument = gql`
    mutation updateSubscriptionPlan($plan: UpdateSubscriptionPlanInput!) {
  updateSubscriptionPlan(plan: $plan) {
    benefits
    planSummary
    name
    subtitle
    priceForMonthlyToggleChoice
    priceForYearlyToggleChoice
    priceSubtitleMonthly
    priceSubtitleYearly
    productId
    stripeDescription
    stripePriceIdMonthly
    stripePriceIdYearly
    collectShipping
    collectPhoneNumber
    adSettings
    printOnly
    optionalProductId
    optionalProductName
    optionalProductDescription
    priceForMonthlyOptionalChoice
    priceForYearlyOptionalChoice
    optionalMonthlyState
    optionalYearlyState
    monthlyPlanLabel
    yearlyPlanLabel
  }
}
    `;
export type UpdateSubscriptionPlanMutationFn = Apollo.MutationFunction<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>;

/**
 * __useUpdateSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionPlanMutation, { data, loading, error }] = useUpdateSubscriptionPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useUpdateSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>(UpdateSubscriptionPlanDocument, options);
      }
export type UpdateSubscriptionPlanMutationHookResult = ReturnType<typeof useUpdateSubscriptionPlanMutation>;
export type UpdateSubscriptionPlanMutationResult = Apollo.MutationResult<UpdateSubscriptionPlanMutation>;
export type UpdateSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionPlanMutation, UpdateSubscriptionPlanMutationVariables>;
export const UpdateSubscriptionPromoDocument = gql`
    mutation UpdateSubscriptionPromo($promo: UpdateSubscriptionPromoInput!) {
  updateSubscriptionPromo(promo: $promo) {
    siteId
    couponId
    name
    percentageOff
    durationInMonths
  }
}
    `;
export type UpdateSubscriptionPromoMutationFn = Apollo.MutationFunction<UpdateSubscriptionPromoMutation, UpdateSubscriptionPromoMutationVariables>;

/**
 * __useUpdateSubscriptionPromoMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionPromoMutation, { data, loading, error }] = useUpdateSubscriptionPromoMutation({
 *   variables: {
 *      promo: // value for 'promo'
 *   },
 * });
 */
export function useUpdateSubscriptionPromoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionPromoMutation, UpdateSubscriptionPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionPromoMutation, UpdateSubscriptionPromoMutationVariables>(UpdateSubscriptionPromoDocument, options);
      }
export type UpdateSubscriptionPromoMutationHookResult = ReturnType<typeof useUpdateSubscriptionPromoMutation>;
export type UpdateSubscriptionPromoMutationResult = Apollo.MutationResult<UpdateSubscriptionPromoMutation>;
export type UpdateSubscriptionPromoMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionPromoMutation, UpdateSubscriptionPromoMutationVariables>;
export const UnconnectDomainForSiteDocument = gql`
    mutation unconnectDomainForSite($id: ID!) {
  unconnectDomainForSite(id: $id) {
    brandId
    createdAt
    domain {
      createdAt
      domainCloudFormation
      domainName
      externalProvider
      domainCloudfront
      hostedZoneId
      nameServers
      updatedAt
      operationId
      siteId
      status
      workspaceId
    }
    domainName
    id
    name
    updatedAt
    version
  }
}
    `;
export type UnconnectDomainForSiteMutationFn = Apollo.MutationFunction<UnconnectDomainForSiteMutation, UnconnectDomainForSiteMutationVariables>;

/**
 * __useUnconnectDomainForSiteMutation__
 *
 * To run a mutation, you first call `useUnconnectDomainForSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnconnectDomainForSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unconnectDomainForSiteMutation, { data, loading, error }] = useUnconnectDomainForSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnconnectDomainForSiteMutation(baseOptions?: Apollo.MutationHookOptions<UnconnectDomainForSiteMutation, UnconnectDomainForSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnconnectDomainForSiteMutation, UnconnectDomainForSiteMutationVariables>(UnconnectDomainForSiteDocument, options);
      }
export type UnconnectDomainForSiteMutationHookResult = ReturnType<typeof useUnconnectDomainForSiteMutation>;
export type UnconnectDomainForSiteMutationResult = Apollo.MutationResult<UnconnectDomainForSiteMutation>;
export type UnconnectDomainForSiteMutationOptions = Apollo.BaseMutationOptions<UnconnectDomainForSiteMutation, UnconnectDomainForSiteMutationVariables>;
export const UpdateWildcardRedirectDocument = gql`
    mutation updateWildcardRedirect($input: UpdateWildcardRedirectInput!) {
  updateWildcardRedirect(input: $input) {
    id
    matchType
    source
    destination
    preserveSuffix
    preserveQuery
    permanent
    enabled
    priority
    note
    createdAt
    updatedAt
  }
}
    `;
export type UpdateWildcardRedirectMutationFn = Apollo.MutationFunction<UpdateWildcardRedirectMutation, UpdateWildcardRedirectMutationVariables>;

/**
 * __useUpdateWildcardRedirectMutation__
 *
 * To run a mutation, you first call `useUpdateWildcardRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWildcardRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWildcardRedirectMutation, { data, loading, error }] = useUpdateWildcardRedirectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWildcardRedirectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWildcardRedirectMutation, UpdateWildcardRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWildcardRedirectMutation, UpdateWildcardRedirectMutationVariables>(UpdateWildcardRedirectDocument, options);
      }
export type UpdateWildcardRedirectMutationHookResult = ReturnType<typeof useUpdateWildcardRedirectMutation>;
export type UpdateWildcardRedirectMutationResult = Apollo.MutationResult<UpdateWildcardRedirectMutation>;
export type UpdateWildcardRedirectMutationOptions = Apollo.BaseMutationOptions<UpdateWildcardRedirectMutation, UpdateWildcardRedirectMutationVariables>;
export const UpdateWorkspaceDocument = gql`
    mutation updateWorkspace($workspace: UpdateWorkspaceInput!) {
  updateWorkspace(workspace: $workspace) {
    id
    name
    subdomain
    language
    updatedAt
    version
  }
}
    `;
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      workspace: // value for 'workspace'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(UpdateWorkspaceDocument, options);
      }
export type UpdateWorkspaceMutationHookResult = ReturnType<typeof useUpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationResult = Apollo.MutationResult<UpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;
export const UpdateWorkspaceUserDocument = gql`
    mutation updateWorkspaceUser($workspaceId: ID!, $username: String!, $workspaceGroups: [WorkspaceGroup!]!, $brandGroups: [BrandGroupTypeInput!]!) {
  updateWorkspaceUser(
    workspaceUser: {workspaceId: $workspaceId, username: $username, workspaceGroups: $workspaceGroups, brandGroups: $brandGroups}
  ) {
    createdAt
    firstName
    id
    lastName
    isConfirmed
    brandGroups {
      brandId
      groups
    }
    updatedAt
    username
    version
    workspaceId
    workspaceGroups
  }
}
    `;
export type UpdateWorkspaceUserMutationFn = Apollo.MutationFunction<UpdateWorkspaceUserMutation, UpdateWorkspaceUserMutationVariables>;

/**
 * __useUpdateWorkspaceUserMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceUserMutation, { data, loading, error }] = useUpdateWorkspaceUserMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      username: // value for 'username'
 *      workspaceGroups: // value for 'workspaceGroups'
 *      brandGroups: // value for 'brandGroups'
 *   },
 * });
 */
export function useUpdateWorkspaceUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceUserMutation, UpdateWorkspaceUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceUserMutation, UpdateWorkspaceUserMutationVariables>(UpdateWorkspaceUserDocument, options);
      }
export type UpdateWorkspaceUserMutationHookResult = ReturnType<typeof useUpdateWorkspaceUserMutation>;
export type UpdateWorkspaceUserMutationResult = Apollo.MutationResult<UpdateWorkspaceUserMutation>;
export type UpdateWorkspaceUserMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceUserMutation, UpdateWorkspaceUserMutationVariables>;
export const UpdateWorkspaceWritingRuleDocument = gql`
    mutation updateWorkspaceWritingRule($workspaceWritingRule: UpdateWorkspaceWritingRuleInput!) {
  updateWorkspaceWritingRule(workspaceWritingRule: $workspaceWritingRule) {
    workspaceId
    id
    name
    ruleText
    active
    type
    level
  }
}
    `;
export type UpdateWorkspaceWritingRuleMutationFn = Apollo.MutationFunction<UpdateWorkspaceWritingRuleMutation, UpdateWorkspaceWritingRuleMutationVariables>;

/**
 * __useUpdateWorkspaceWritingRuleMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceWritingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceWritingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceWritingRuleMutation, { data, loading, error }] = useUpdateWorkspaceWritingRuleMutation({
 *   variables: {
 *      workspaceWritingRule: // value for 'workspaceWritingRule'
 *   },
 * });
 */
export function useUpdateWorkspaceWritingRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceWritingRuleMutation, UpdateWorkspaceWritingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceWritingRuleMutation, UpdateWorkspaceWritingRuleMutationVariables>(UpdateWorkspaceWritingRuleDocument, options);
      }
export type UpdateWorkspaceWritingRuleMutationHookResult = ReturnType<typeof useUpdateWorkspaceWritingRuleMutation>;
export type UpdateWorkspaceWritingRuleMutationResult = Apollo.MutationResult<UpdateWorkspaceWritingRuleMutation>;
export type UpdateWorkspaceWritingRuleMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceWritingRuleMutation, UpdateWorkspaceWritingRuleMutationVariables>;
export const UpdateWritingRuleDocument = gql`
    mutation updateWritingRule($writingRule: UpdateWritingRuleInput!) {
  updateWritingRule(writingRule: $writingRule) {
    siteId
    id
    name
    ruleText
    active
    type
  }
}
    `;
export type UpdateWritingRuleMutationFn = Apollo.MutationFunction<UpdateWritingRuleMutation, UpdateWritingRuleMutationVariables>;

/**
 * __useUpdateWritingRuleMutation__
 *
 * To run a mutation, you first call `useUpdateWritingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWritingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWritingRuleMutation, { data, loading, error }] = useUpdateWritingRuleMutation({
 *   variables: {
 *      writingRule: // value for 'writingRule'
 *   },
 * });
 */
export function useUpdateWritingRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWritingRuleMutation, UpdateWritingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWritingRuleMutation, UpdateWritingRuleMutationVariables>(UpdateWritingRuleDocument, options);
      }
export type UpdateWritingRuleMutationHookResult = ReturnType<typeof useUpdateWritingRuleMutation>;
export type UpdateWritingRuleMutationResult = Apollo.MutationResult<UpdateWritingRuleMutation>;
export type UpdateWritingRuleMutationOptions = Apollo.BaseMutationOptions<UpdateWritingRuleMutation, UpdateWritingRuleMutationVariables>;
export const CreateSegmentDocument = gql`
    mutation createSegment($segment: SegmentInput!) {
  createSegment(segment: $segment) {
    id
    siteId
    name
    description
    rulesJson
  }
}
    `;
export type CreateSegmentMutationFn = Apollo.MutationFunction<CreateSegmentMutation, CreateSegmentMutationVariables>;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentMutation, { data, loading, error }] = useCreateSegmentMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useCreateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentMutation, CreateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentMutation, CreateSegmentMutationVariables>(CreateSegmentDocument, options);
      }
export type CreateSegmentMutationHookResult = ReturnType<typeof useCreateSegmentMutation>;
export type CreateSegmentMutationResult = Apollo.MutationResult<CreateSegmentMutation>;
export type CreateSegmentMutationOptions = Apollo.BaseMutationOptions<CreateSegmentMutation, CreateSegmentMutationVariables>;
export const UpdateSegmentDocument = gql`
    mutation updateSegment($segment: SegmentInput!) {
  updateSegment(segment: $segment) {
    id
    siteId
    name
    description
    rulesJson
  }
}
    `;
export type UpdateSegmentMutationFn = Apollo.MutationFunction<UpdateSegmentMutation, UpdateSegmentMutationVariables>;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentMutation, { data, loading, error }] = useUpdateSegmentMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useUpdateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentMutation, UpdateSegmentMutationVariables>(UpdateSegmentDocument, options);
      }
export type UpdateSegmentMutationHookResult = ReturnType<typeof useUpdateSegmentMutation>;
export type UpdateSegmentMutationResult = Apollo.MutationResult<UpdateSegmentMutation>;
export type UpdateSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>;
export const DeleteSegmentDocument = gql`
    mutation deleteSegment($siteId: ID!, $segmentId: ID!) {
  deleteSegment(siteId: $siteId, segmentId: $segmentId)
}
    `;
export type DeleteSegmentMutationFn = Apollo.MutationFunction<DeleteSegmentMutation, DeleteSegmentMutationVariables>;

/**
 * __useDeleteSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSegmentMutation, { data, loading, error }] = useDeleteSegmentMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useDeleteSegmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSegmentMutation, DeleteSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSegmentMutation, DeleteSegmentMutationVariables>(DeleteSegmentDocument, options);
      }
export type DeleteSegmentMutationHookResult = ReturnType<typeof useDeleteSegmentMutation>;
export type DeleteSegmentMutationResult = Apollo.MutationResult<DeleteSegmentMutation>;
export type DeleteSegmentMutationOptions = Apollo.BaseMutationOptions<DeleteSegmentMutation, DeleteSegmentMutationVariables>;
export const UpsertContactDocument = gql`
    mutation upsertContact($contact: ContactInput!) {
  upsertContact(contact: $contact) {
    id
    siteId
    email
    firstName
    lastName
    tags
    subscribedNewsletterIds
    status
    source
  }
}
    `;
export type UpsertContactMutationFn = Apollo.MutationFunction<UpsertContactMutation, UpsertContactMutationVariables>;

/**
 * __useUpsertContactMutation__
 *
 * To run a mutation, you first call `useUpsertContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContactMutation, { data, loading, error }] = useUpsertContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useUpsertContactMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContactMutation, UpsertContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContactMutation, UpsertContactMutationVariables>(UpsertContactDocument, options);
      }
export type UpsertContactMutationHookResult = ReturnType<typeof useUpsertContactMutation>;
export type UpsertContactMutationResult = Apollo.MutationResult<UpsertContactMutation>;
export type UpsertContactMutationOptions = Apollo.BaseMutationOptions<UpsertContactMutation, UpsertContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation deleteContact($siteId: ID!, $contactId: ID!) {
  deleteContact(siteId: $siteId, contactId: $contactId)
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const BulkSetContactStatusDocument = gql`
    mutation bulkSetContactStatus($siteId: ID!, $emails: [String!]!, $status: ContactStatus!) {
  bulkSetContactStatus(siteId: $siteId, emails: $emails, status: $status)
}
    `;
export type BulkSetContactStatusMutationFn = Apollo.MutationFunction<BulkSetContactStatusMutation, BulkSetContactStatusMutationVariables>;

/**
 * __useBulkSetContactStatusMutation__
 *
 * To run a mutation, you first call `useBulkSetContactStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetContactStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetContactStatusMutation, { data, loading, error }] = useBulkSetContactStatusMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      emails: // value for 'emails'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkSetContactStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkSetContactStatusMutation, BulkSetContactStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSetContactStatusMutation, BulkSetContactStatusMutationVariables>(BulkSetContactStatusDocument, options);
      }
export type BulkSetContactStatusMutationHookResult = ReturnType<typeof useBulkSetContactStatusMutation>;
export type BulkSetContactStatusMutationResult = Apollo.MutationResult<BulkSetContactStatusMutation>;
export type BulkSetContactStatusMutationOptions = Apollo.BaseMutationOptions<BulkSetContactStatusMutation, BulkSetContactStatusMutationVariables>;
export const BulkDeleteContactsDocument = gql`
    mutation bulkDeleteContacts($siteId: ID!, $emails: [String!]!) {
  bulkDeleteContacts(siteId: $siteId, emails: $emails)
}
    `;
export type BulkDeleteContactsMutationFn = Apollo.MutationFunction<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>;

/**
 * __useBulkDeleteContactsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteContactsMutation, { data, loading, error }] = useBulkDeleteContactsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useBulkDeleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>(BulkDeleteContactsDocument, options);
      }
export type BulkDeleteContactsMutationHookResult = ReturnType<typeof useBulkDeleteContactsMutation>;
export type BulkDeleteContactsMutationResult = Apollo.MutationResult<BulkDeleteContactsMutation>;
export type BulkDeleteContactsMutationOptions = Apollo.BaseMutationOptions<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>;
export const BulkUpdateContactTagsDocument = gql`
    mutation bulkUpdateContactTags($siteId: ID!, $emails: [String!]!, $addTags: [String!], $removeTags: [String!]) {
  bulkUpdateContactTags(
    siteId: $siteId
    emails: $emails
    addTags: $addTags
    removeTags: $removeTags
  )
}
    `;
export type BulkUpdateContactTagsMutationFn = Apollo.MutationFunction<BulkUpdateContactTagsMutation, BulkUpdateContactTagsMutationVariables>;

/**
 * __useBulkUpdateContactTagsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateContactTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateContactTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateContactTagsMutation, { data, loading, error }] = useBulkUpdateContactTagsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      emails: // value for 'emails'
 *      addTags: // value for 'addTags'
 *      removeTags: // value for 'removeTags'
 *   },
 * });
 */
export function useBulkUpdateContactTagsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateContactTagsMutation, BulkUpdateContactTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateContactTagsMutation, BulkUpdateContactTagsMutationVariables>(BulkUpdateContactTagsDocument, options);
      }
export type BulkUpdateContactTagsMutationHookResult = ReturnType<typeof useBulkUpdateContactTagsMutation>;
export type BulkUpdateContactTagsMutationResult = Apollo.MutationResult<BulkUpdateContactTagsMutation>;
export type BulkUpdateContactTagsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateContactTagsMutation, BulkUpdateContactTagsMutationVariables>;
export const ImportContactsCsvDocument = gql`
    mutation importContactsCsv($siteId: ID!, $fileName: String!, $tags: [String!]) {
  importContactsCsv(siteId: $siteId, fileName: $fileName, tags: $tags) {
    uploadUrl
    jobId
    s3Key
  }
}
    `;
export type ImportContactsCsvMutationFn = Apollo.MutationFunction<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>;

/**
 * __useImportContactsCsvMutation__
 *
 * To run a mutation, you first call `useImportContactsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportContactsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importContactsCsvMutation, { data, loading, error }] = useImportContactsCsvMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      fileName: // value for 'fileName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useImportContactsCsvMutation(baseOptions?: Apollo.MutationHookOptions<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>(ImportContactsCsvDocument, options);
      }
export type ImportContactsCsvMutationHookResult = ReturnType<typeof useImportContactsCsvMutation>;
export type ImportContactsCsvMutationResult = Apollo.MutationResult<ImportContactsCsvMutation>;
export type ImportContactsCsvMutationOptions = Apollo.BaseMutationOptions<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>;
export const FinalizeContactsCsvImportDocument = gql`
    mutation finalizeContactsCsvImport($siteId: ID!, $s3Key: String!, $tags: [String!]) {
  finalizeContactsCsvImport(siteId: $siteId, s3Key: $s3Key, tags: $tags)
}
    `;
export type FinalizeContactsCsvImportMutationFn = Apollo.MutationFunction<FinalizeContactsCsvImportMutation, FinalizeContactsCsvImportMutationVariables>;

/**
 * __useFinalizeContactsCsvImportMutation__
 *
 * To run a mutation, you first call `useFinalizeContactsCsvImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeContactsCsvImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeContactsCsvImportMutation, { data, loading, error }] = useFinalizeContactsCsvImportMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      s3Key: // value for 's3Key'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useFinalizeContactsCsvImportMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeContactsCsvImportMutation, FinalizeContactsCsvImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeContactsCsvImportMutation, FinalizeContactsCsvImportMutationVariables>(FinalizeContactsCsvImportDocument, options);
      }
export type FinalizeContactsCsvImportMutationHookResult = ReturnType<typeof useFinalizeContactsCsvImportMutation>;
export type FinalizeContactsCsvImportMutationResult = Apollo.MutationResult<FinalizeContactsCsvImportMutation>;
export type FinalizeContactsCsvImportMutationOptions = Apollo.BaseMutationOptions<FinalizeContactsCsvImportMutation, FinalizeContactsCsvImportMutationVariables>;
export const ListAutomationsDocument = gql`
    query listAutomations($siteId: ID!) {
  listAutomations(siteId: $siteId) {
    id
    siteId
    name
    description
    status
    trigger
    triggerNewsletterId
    triggerSegmentId
    triggerEventType
    activeEnrollments
    completedEnrollments
    lastSyncedAt
    createdAt
    updatedAt
    steps {
      id
      delay
      delayUnit
      subject
      blocksJson
    }
  }
}
    `;

/**
 * __useListAutomationsQuery__
 *
 * To run a query within a React component, call `useListAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAutomationsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListAutomationsQuery(baseOptions: Apollo.QueryHookOptions<ListAutomationsQuery, ListAutomationsQueryVariables> & ({ variables: ListAutomationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAutomationsQuery, ListAutomationsQueryVariables>(ListAutomationsDocument, options);
      }
export function useListAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAutomationsQuery, ListAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAutomationsQuery, ListAutomationsQueryVariables>(ListAutomationsDocument, options);
        }
// @ts-ignore
export function useListAutomationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAutomationsQuery, ListAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAutomationsQuery, ListAutomationsQueryVariables>;
export function useListAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAutomationsQuery, ListAutomationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAutomationsQuery | undefined, ListAutomationsQueryVariables>;
export function useListAutomationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAutomationsQuery, ListAutomationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAutomationsQuery, ListAutomationsQueryVariables>(ListAutomationsDocument, options);
        }
export type ListAutomationsQueryHookResult = ReturnType<typeof useListAutomationsQuery>;
export type ListAutomationsLazyQueryHookResult = ReturnType<typeof useListAutomationsLazyQuery>;
export type ListAutomationsSuspenseQueryHookResult = ReturnType<typeof useListAutomationsSuspenseQuery>;
export type ListAutomationsQueryResult = Apollo.QueryResult<ListAutomationsQuery, ListAutomationsQueryVariables>;
export const GetAutomationDocument = gql`
    query getAutomation($siteId: ID!, $automationId: ID!) {
  getAutomation(siteId: $siteId, automationId: $automationId) {
    id
    siteId
    name
    description
    status
    trigger
    triggerNewsletterId
    triggerSegmentId
    triggerEventType
    fromName
    replyToEmail
    exitTag
    activeEnrollments
    completedEnrollments
    lastSyncedAt
    createdAt
    updatedAt
    steps {
      id
      delay
      delayUnit
      subject
      blocksJson
    }
  }
}
    `;

/**
 * __useGetAutomationQuery__
 *
 * To run a query within a React component, call `useGetAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      automationId: // value for 'automationId'
 *   },
 * });
 */
export function useGetAutomationQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables> & ({ variables: GetAutomationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, options);
      }
export function useGetAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, options);
        }
// @ts-ignore
export function useGetAutomationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAutomationQuery, GetAutomationQueryVariables>;
export function useGetAutomationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAutomationQuery | undefined, GetAutomationQueryVariables>;
export function useGetAutomationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, options);
        }
export type GetAutomationQueryHookResult = ReturnType<typeof useGetAutomationQuery>;
export type GetAutomationLazyQueryHookResult = ReturnType<typeof useGetAutomationLazyQuery>;
export type GetAutomationSuspenseQueryHookResult = ReturnType<typeof useGetAutomationSuspenseQuery>;
export type GetAutomationQueryResult = Apollo.QueryResult<GetAutomationQuery, GetAutomationQueryVariables>;
export const ListAutomationEnrollmentsDocument = gql`
    query listAutomationEnrollments($siteId: ID!, $automationId: ID!, $pagination: PaginationInput, $search: String) {
  listAutomationEnrollments(
    siteId: $siteId
    automationId: $automationId
    pagination: $pagination
    search: $search
  ) {
    items {
      id
      email
      currentStep
      status
      enrolledAt
      nextRunAt
      lastStepSentAt
    }
    nextToken
  }
}
    `;

/**
 * __useListAutomationEnrollmentsQuery__
 *
 * To run a query within a React component, call `useListAutomationEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAutomationEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAutomationEnrollmentsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      automationId: // value for 'automationId'
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useListAutomationEnrollmentsQuery(baseOptions: Apollo.QueryHookOptions<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables> & ({ variables: ListAutomationEnrollmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>(ListAutomationEnrollmentsDocument, options);
      }
export function useListAutomationEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>(ListAutomationEnrollmentsDocument, options);
        }
// @ts-ignore
export function useListAutomationEnrollmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>;
export function useListAutomationEnrollmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAutomationEnrollmentsQuery | undefined, ListAutomationEnrollmentsQueryVariables>;
export function useListAutomationEnrollmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>(ListAutomationEnrollmentsDocument, options);
        }
export type ListAutomationEnrollmentsQueryHookResult = ReturnType<typeof useListAutomationEnrollmentsQuery>;
export type ListAutomationEnrollmentsLazyQueryHookResult = ReturnType<typeof useListAutomationEnrollmentsLazyQuery>;
export type ListAutomationEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useListAutomationEnrollmentsSuspenseQuery>;
export type ListAutomationEnrollmentsQueryResult = Apollo.QueryResult<ListAutomationEnrollmentsQuery, ListAutomationEnrollmentsQueryVariables>;
export const CreateAutomationDocument = gql`
    mutation createAutomation($automation: AutomationInput!) {
  createAutomation(automation: $automation) {
    id
  }
}
    `;
export type CreateAutomationMutationFn = Apollo.MutationFunction<CreateAutomationMutation, CreateAutomationMutationVariables>;

/**
 * __useCreateAutomationMutation__
 *
 * To run a mutation, you first call `useCreateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationMutation, { data, loading, error }] = useCreateAutomationMutation({
 *   variables: {
 *      automation: // value for 'automation'
 *   },
 * });
 */
export function useCreateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationMutation, CreateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationMutation, CreateAutomationMutationVariables>(CreateAutomationDocument, options);
      }
export type CreateAutomationMutationHookResult = ReturnType<typeof useCreateAutomationMutation>;
export type CreateAutomationMutationResult = Apollo.MutationResult<CreateAutomationMutation>;
export type CreateAutomationMutationOptions = Apollo.BaseMutationOptions<CreateAutomationMutation, CreateAutomationMutationVariables>;
export const UpdateAutomationDocument = gql`
    mutation updateAutomation($automation: AutomationInput!) {
  updateAutomation(automation: $automation) {
    id
  }
}
    `;
export type UpdateAutomationMutationFn = Apollo.MutationFunction<UpdateAutomationMutation, UpdateAutomationMutationVariables>;

/**
 * __useUpdateAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationMutation, { data, loading, error }] = useUpdateAutomationMutation({
 *   variables: {
 *      automation: // value for 'automation'
 *   },
 * });
 */
export function useUpdateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationMutation, UpdateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationMutation, UpdateAutomationMutationVariables>(UpdateAutomationDocument, options);
      }
export type UpdateAutomationMutationHookResult = ReturnType<typeof useUpdateAutomationMutation>;
export type UpdateAutomationMutationResult = Apollo.MutationResult<UpdateAutomationMutation>;
export type UpdateAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationMutation, UpdateAutomationMutationVariables>;
export const DeleteAutomationDocument = gql`
    mutation deleteAutomation($siteId: ID!, $automationId: ID!) {
  deleteAutomation(siteId: $siteId, automationId: $automationId)
}
    `;
export type DeleteAutomationMutationFn = Apollo.MutationFunction<DeleteAutomationMutation, DeleteAutomationMutationVariables>;

/**
 * __useDeleteAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationMutation, { data, loading, error }] = useDeleteAutomationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      automationId: // value for 'automationId'
 *   },
 * });
 */
export function useDeleteAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationMutation, DeleteAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationMutation, DeleteAutomationMutationVariables>(DeleteAutomationDocument, options);
      }
export type DeleteAutomationMutationHookResult = ReturnType<typeof useDeleteAutomationMutation>;
export type DeleteAutomationMutationResult = Apollo.MutationResult<DeleteAutomationMutation>;
export type DeleteAutomationMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationMutation, DeleteAutomationMutationVariables>;
export const EnrollSegmentInAutomationDocument = gql`
    mutation enrollSegmentInAutomation($siteId: ID!, $automationId: ID!, $segmentId: ID!) {
  enrollSegmentInAutomation(
    siteId: $siteId
    automationId: $automationId
    segmentId: $segmentId
  )
}
    `;
export type EnrollSegmentInAutomationMutationFn = Apollo.MutationFunction<EnrollSegmentInAutomationMutation, EnrollSegmentInAutomationMutationVariables>;

/**
 * __useEnrollSegmentInAutomationMutation__
 *
 * To run a mutation, you first call `useEnrollSegmentInAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollSegmentInAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollSegmentInAutomationMutation, { data, loading, error }] = useEnrollSegmentInAutomationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      automationId: // value for 'automationId'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useEnrollSegmentInAutomationMutation(baseOptions?: Apollo.MutationHookOptions<EnrollSegmentInAutomationMutation, EnrollSegmentInAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollSegmentInAutomationMutation, EnrollSegmentInAutomationMutationVariables>(EnrollSegmentInAutomationDocument, options);
      }
export type EnrollSegmentInAutomationMutationHookResult = ReturnType<typeof useEnrollSegmentInAutomationMutation>;
export type EnrollSegmentInAutomationMutationResult = Apollo.MutationResult<EnrollSegmentInAutomationMutation>;
export type EnrollSegmentInAutomationMutationOptions = Apollo.BaseMutationOptions<EnrollSegmentInAutomationMutation, EnrollSegmentInAutomationMutationVariables>;
export const UnenrollFromAutomationDocument = gql`
    mutation unenrollFromAutomation($siteId: ID!, $automationId: ID!, $email: String!) {
  unenrollFromAutomation(
    siteId: $siteId
    automationId: $automationId
    email: $email
  )
}
    `;
export type UnenrollFromAutomationMutationFn = Apollo.MutationFunction<UnenrollFromAutomationMutation, UnenrollFromAutomationMutationVariables>;

/**
 * __useUnenrollFromAutomationMutation__
 *
 * To run a mutation, you first call `useUnenrollFromAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollFromAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollFromAutomationMutation, { data, loading, error }] = useUnenrollFromAutomationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      automationId: // value for 'automationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUnenrollFromAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollFromAutomationMutation, UnenrollFromAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollFromAutomationMutation, UnenrollFromAutomationMutationVariables>(UnenrollFromAutomationDocument, options);
      }
export type UnenrollFromAutomationMutationHookResult = ReturnType<typeof useUnenrollFromAutomationMutation>;
export type UnenrollFromAutomationMutationResult = Apollo.MutationResult<UnenrollFromAutomationMutation>;
export type UnenrollFromAutomationMutationOptions = Apollo.BaseMutationOptions<UnenrollFromAutomationMutation, UnenrollFromAutomationMutationVariables>;
export const GetNewsletterSendLimitsDocument = gql`
    query getNewsletterSendLimits($siteId: ID!) {
  getSite(id: $siteId) {
    id
    newsletterDailyEmailLimit
    newsletterMonthlyEmailLimit
    newsletterProvider
  }
}
    `;

/**
 * __useGetNewsletterSendLimitsQuery__
 *
 * To run a query within a React component, call `useGetNewsletterSendLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterSendLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterSendLimitsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetNewsletterSendLimitsQuery(baseOptions: Apollo.QueryHookOptions<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables> & ({ variables: GetNewsletterSendLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>(GetNewsletterSendLimitsDocument, options);
      }
export function useGetNewsletterSendLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>(GetNewsletterSendLimitsDocument, options);
        }
// @ts-ignore
export function useGetNewsletterSendLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>;
export function useGetNewsletterSendLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewsletterSendLimitsQuery | undefined, GetNewsletterSendLimitsQueryVariables>;
export function useGetNewsletterSendLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>(GetNewsletterSendLimitsDocument, options);
        }
export type GetNewsletterSendLimitsQueryHookResult = ReturnType<typeof useGetNewsletterSendLimitsQuery>;
export type GetNewsletterSendLimitsLazyQueryHookResult = ReturnType<typeof useGetNewsletterSendLimitsLazyQuery>;
export type GetNewsletterSendLimitsSuspenseQueryHookResult = ReturnType<typeof useGetNewsletterSendLimitsSuspenseQuery>;
export type GetNewsletterSendLimitsQueryResult = Apollo.QueryResult<GetNewsletterSendLimitsQuery, GetNewsletterSendLimitsQueryVariables>;
export const ListNewsletterSendsDocument = gql`
    query listNewsletterSends($siteId: ID!, $newsletterId: ID, $pagination: PaginationInput) {
  listNewsletterSends(
    siteId: $siteId
    newsletterId: $newsletterId
    pagination: $pagination
  ) {
    items {
      id
      siteId
      newsletterId
      newsletterName
      scheduledFor
      sentAt
      status
      recipientSnapshot
      delivered
      opens
      clicks
      bounces
      complaints
      unsubscribes
      costCents
      errorMessage
    }
    nextToken
  }
}
    `;

/**
 * __useListNewsletterSendsQuery__
 *
 * To run a query within a React component, call `useListNewsletterSendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNewsletterSendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNewsletterSendsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newsletterId: // value for 'newsletterId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListNewsletterSendsQuery(baseOptions: Apollo.QueryHookOptions<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables> & ({ variables: ListNewsletterSendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>(ListNewsletterSendsDocument, options);
      }
export function useListNewsletterSendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>(ListNewsletterSendsDocument, options);
        }
// @ts-ignore
export function useListNewsletterSendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>): Apollo.UseSuspenseQueryResult<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>;
export function useListNewsletterSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>): Apollo.UseSuspenseQueryResult<ListNewsletterSendsQuery | undefined, ListNewsletterSendsQueryVariables>;
export function useListNewsletterSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>(ListNewsletterSendsDocument, options);
        }
export type ListNewsletterSendsQueryHookResult = ReturnType<typeof useListNewsletterSendsQuery>;
export type ListNewsletterSendsLazyQueryHookResult = ReturnType<typeof useListNewsletterSendsLazyQuery>;
export type ListNewsletterSendsSuspenseQueryHookResult = ReturnType<typeof useListNewsletterSendsSuspenseQuery>;
export type ListNewsletterSendsQueryResult = Apollo.QueryResult<ListNewsletterSendsQuery, ListNewsletterSendsQueryVariables>;
export const ListUpcomingNewsletterSendsDocument = gql`
    query listUpcomingNewsletterSends($siteId: ID!, $pagination: PaginationInput) {
  listUpcomingNewsletterSends(siteId: $siteId, pagination: $pagination) {
    items {
      id
      siteId
      newsletterId
      newsletterName
      scheduledFor
      status
    }
    nextToken
  }
}
    `;

/**
 * __useListUpcomingNewsletterSendsQuery__
 *
 * To run a query within a React component, call `useListUpcomingNewsletterSendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUpcomingNewsletterSendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUpcomingNewsletterSendsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListUpcomingNewsletterSendsQuery(baseOptions: Apollo.QueryHookOptions<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables> & ({ variables: ListUpcomingNewsletterSendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>(ListUpcomingNewsletterSendsDocument, options);
      }
export function useListUpcomingNewsletterSendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>(ListUpcomingNewsletterSendsDocument, options);
        }
// @ts-ignore
export function useListUpcomingNewsletterSendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>): Apollo.UseSuspenseQueryResult<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>;
export function useListUpcomingNewsletterSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>): Apollo.UseSuspenseQueryResult<ListUpcomingNewsletterSendsQuery | undefined, ListUpcomingNewsletterSendsQueryVariables>;
export function useListUpcomingNewsletterSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>(ListUpcomingNewsletterSendsDocument, options);
        }
export type ListUpcomingNewsletterSendsQueryHookResult = ReturnType<typeof useListUpcomingNewsletterSendsQuery>;
export type ListUpcomingNewsletterSendsLazyQueryHookResult = ReturnType<typeof useListUpcomingNewsletterSendsLazyQuery>;
export type ListUpcomingNewsletterSendsSuspenseQueryHookResult = ReturnType<typeof useListUpcomingNewsletterSendsSuspenseQuery>;
export type ListUpcomingNewsletterSendsQueryResult = Apollo.QueryResult<ListUpcomingNewsletterSendsQuery, ListUpcomingNewsletterSendsQueryVariables>;
export const CancelNewsletterSendDocument = gql`
    mutation cancelNewsletterSend($siteId: ID!, $sendId: ID!) {
  cancelNewsletterSend(siteId: $siteId, sendId: $sendId)
}
    `;
export type CancelNewsletterSendMutationFn = Apollo.MutationFunction<CancelNewsletterSendMutation, CancelNewsletterSendMutationVariables>;

/**
 * __useCancelNewsletterSendMutation__
 *
 * To run a mutation, you first call `useCancelNewsletterSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelNewsletterSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelNewsletterSendMutation, { data, loading, error }] = useCancelNewsletterSendMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      sendId: // value for 'sendId'
 *   },
 * });
 */
export function useCancelNewsletterSendMutation(baseOptions?: Apollo.MutationHookOptions<CancelNewsletterSendMutation, CancelNewsletterSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelNewsletterSendMutation, CancelNewsletterSendMutationVariables>(CancelNewsletterSendDocument, options);
      }
export type CancelNewsletterSendMutationHookResult = ReturnType<typeof useCancelNewsletterSendMutation>;
export type CancelNewsletterSendMutationResult = Apollo.MutationResult<CancelNewsletterSendMutation>;
export type CancelNewsletterSendMutationOptions = Apollo.BaseMutationOptions<CancelNewsletterSendMutation, CancelNewsletterSendMutationVariables>;
export const ListSendRecipientEngagementDocument = gql`
    query listSendRecipientEngagement($siteId: ID!, $sendId: ID!, $pagination: PaginationInput) {
  listSendRecipientEngagement(
    siteId: $siteId
    sendId: $sendId
    pagination: $pagination
  ) {
    items {
      email
      deliveredAt
      openedAt
      openCount
      clickedAt
      clickCount
      bouncedAt
      complainedAt
    }
    nextToken
  }
}
    `;

/**
 * __useListSendRecipientEngagementQuery__
 *
 * To run a query within a React component, call `useListSendRecipientEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSendRecipientEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSendRecipientEngagementQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      sendId: // value for 'sendId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListSendRecipientEngagementQuery(baseOptions: Apollo.QueryHookOptions<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables> & ({ variables: ListSendRecipientEngagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>(ListSendRecipientEngagementDocument, options);
      }
export function useListSendRecipientEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>(ListSendRecipientEngagementDocument, options);
        }
// @ts-ignore
export function useListSendRecipientEngagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>): Apollo.UseSuspenseQueryResult<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>;
export function useListSendRecipientEngagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>): Apollo.UseSuspenseQueryResult<ListSendRecipientEngagementQuery | undefined, ListSendRecipientEngagementQueryVariables>;
export function useListSendRecipientEngagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>(ListSendRecipientEngagementDocument, options);
        }
export type ListSendRecipientEngagementQueryHookResult = ReturnType<typeof useListSendRecipientEngagementQuery>;
export type ListSendRecipientEngagementLazyQueryHookResult = ReturnType<typeof useListSendRecipientEngagementLazyQuery>;
export type ListSendRecipientEngagementSuspenseQueryHookResult = ReturnType<typeof useListSendRecipientEngagementSuspenseQuery>;
export type ListSendRecipientEngagementQueryResult = Apollo.QueryResult<ListSendRecipientEngagementQuery, ListSendRecipientEngagementQueryVariables>;
export const ResendToNonOpenersDocument = gql`
    mutation resendToNonOpeners($siteId: ID!, $sendId: ID!) {
  resendToNonOpeners(siteId: $siteId, sendId: $sendId)
}
    `;
export type ResendToNonOpenersMutationFn = Apollo.MutationFunction<ResendToNonOpenersMutation, ResendToNonOpenersMutationVariables>;

/**
 * __useResendToNonOpenersMutation__
 *
 * To run a mutation, you first call `useResendToNonOpenersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendToNonOpenersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendToNonOpenersMutation, { data, loading, error }] = useResendToNonOpenersMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      sendId: // value for 'sendId'
 *   },
 * });
 */
export function useResendToNonOpenersMutation(baseOptions?: Apollo.MutationHookOptions<ResendToNonOpenersMutation, ResendToNonOpenersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendToNonOpenersMutation, ResendToNonOpenersMutationVariables>(ResendToNonOpenersDocument, options);
      }
export type ResendToNonOpenersMutationHookResult = ReturnType<typeof useResendToNonOpenersMutation>;
export type ResendToNonOpenersMutationResult = Apollo.MutationResult<ResendToNonOpenersMutation>;
export type ResendToNonOpenersMutationOptions = Apollo.BaseMutationOptions<ResendToNonOpenersMutation, ResendToNonOpenersMutationVariables>;
export const SendTestNewsletterDocument = gql`
    mutation sendTestNewsletter($siteId: ID!, $newsletterId: ID!, $toEmail: String!) {
  sendTestNewsletter(
    siteId: $siteId
    newsletterId: $newsletterId
    toEmail: $toEmail
  )
}
    `;
export type SendTestNewsletterMutationFn = Apollo.MutationFunction<SendTestNewsletterMutation, SendTestNewsletterMutationVariables>;

/**
 * __useSendTestNewsletterMutation__
 *
 * To run a mutation, you first call `useSendTestNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNewsletterMutation, { data, loading, error }] = useSendTestNewsletterMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newsletterId: // value for 'newsletterId'
 *      toEmail: // value for 'toEmail'
 *   },
 * });
 */
export function useSendTestNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNewsletterMutation, SendTestNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNewsletterMutation, SendTestNewsletterMutationVariables>(SendTestNewsletterDocument, options);
      }
export type SendTestNewsletterMutationHookResult = ReturnType<typeof useSendTestNewsletterMutation>;
export type SendTestNewsletterMutationResult = Apollo.MutationResult<SendTestNewsletterMutation>;
export type SendTestNewsletterMutationOptions = Apollo.BaseMutationOptions<SendTestNewsletterMutation, SendTestNewsletterMutationVariables>;
export const GetSendingDomainDocument = gql`
    query getSendingDomain($siteId: ID!) {
  getSendingDomain(siteId: $siteId) {
    id
    siteId
    domain
    status
    autoInjected
    records {
      recordType
      host
      value
      ttl
      priority
    }
    createdAt
    verifiedAt
  }
}
    `;

/**
 * __useGetSendingDomainQuery__
 *
 * To run a query within a React component, call `useGetSendingDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendingDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendingDomainQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSendingDomainQuery(baseOptions: Apollo.QueryHookOptions<GetSendingDomainQuery, GetSendingDomainQueryVariables> & ({ variables: GetSendingDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendingDomainQuery, GetSendingDomainQueryVariables>(GetSendingDomainDocument, options);
      }
export function useGetSendingDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendingDomainQuery, GetSendingDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendingDomainQuery, GetSendingDomainQueryVariables>(GetSendingDomainDocument, options);
        }
// @ts-ignore
export function useGetSendingDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSendingDomainQuery, GetSendingDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetSendingDomainQuery, GetSendingDomainQueryVariables>;
export function useGetSendingDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSendingDomainQuery, GetSendingDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetSendingDomainQuery | undefined, GetSendingDomainQueryVariables>;
export function useGetSendingDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSendingDomainQuery, GetSendingDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSendingDomainQuery, GetSendingDomainQueryVariables>(GetSendingDomainDocument, options);
        }
export type GetSendingDomainQueryHookResult = ReturnType<typeof useGetSendingDomainQuery>;
export type GetSendingDomainLazyQueryHookResult = ReturnType<typeof useGetSendingDomainLazyQuery>;
export type GetSendingDomainSuspenseQueryHookResult = ReturnType<typeof useGetSendingDomainSuspenseQuery>;
export type GetSendingDomainQueryResult = Apollo.QueryResult<GetSendingDomainQuery, GetSendingDomainQueryVariables>;
export const CreateSendingDomainDocument = gql`
    mutation createSendingDomain($siteId: ID!, $domain: String!) {
  createSendingDomain(siteId: $siteId, domain: $domain) {
    id
    domain
    status
    autoInjected
    records {
      recordType
      host
      value
      ttl
      priority
    }
  }
}
    `;
export type CreateSendingDomainMutationFn = Apollo.MutationFunction<CreateSendingDomainMutation, CreateSendingDomainMutationVariables>;

/**
 * __useCreateSendingDomainMutation__
 *
 * To run a mutation, you first call `useCreateSendingDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSendingDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSendingDomainMutation, { data, loading, error }] = useCreateSendingDomainMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCreateSendingDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateSendingDomainMutation, CreateSendingDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSendingDomainMutation, CreateSendingDomainMutationVariables>(CreateSendingDomainDocument, options);
      }
export type CreateSendingDomainMutationHookResult = ReturnType<typeof useCreateSendingDomainMutation>;
export type CreateSendingDomainMutationResult = Apollo.MutationResult<CreateSendingDomainMutation>;
export type CreateSendingDomainMutationOptions = Apollo.BaseMutationOptions<CreateSendingDomainMutation, CreateSendingDomainMutationVariables>;
export const RefreshSendingDomainStatusDocument = gql`
    mutation refreshSendingDomainStatus($siteId: ID!) {
  refreshSendingDomainStatus(siteId: $siteId) {
    id
    status
    verifiedAt
  }
}
    `;
export type RefreshSendingDomainStatusMutationFn = Apollo.MutationFunction<RefreshSendingDomainStatusMutation, RefreshSendingDomainStatusMutationVariables>;

/**
 * __useRefreshSendingDomainStatusMutation__
 *
 * To run a mutation, you first call `useRefreshSendingDomainStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSendingDomainStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSendingDomainStatusMutation, { data, loading, error }] = useRefreshSendingDomainStatusMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRefreshSendingDomainStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSendingDomainStatusMutation, RefreshSendingDomainStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshSendingDomainStatusMutation, RefreshSendingDomainStatusMutationVariables>(RefreshSendingDomainStatusDocument, options);
      }
export type RefreshSendingDomainStatusMutationHookResult = ReturnType<typeof useRefreshSendingDomainStatusMutation>;
export type RefreshSendingDomainStatusMutationResult = Apollo.MutationResult<RefreshSendingDomainStatusMutation>;
export type RefreshSendingDomainStatusMutationOptions = Apollo.BaseMutationOptions<RefreshSendingDomainStatusMutation, RefreshSendingDomainStatusMutationVariables>;
export const DeleteSendingDomainDocument = gql`
    mutation deleteSendingDomain($siteId: ID!) {
  deleteSendingDomain(siteId: $siteId)
}
    `;
export type DeleteSendingDomainMutationFn = Apollo.MutationFunction<DeleteSendingDomainMutation, DeleteSendingDomainMutationVariables>;

/**
 * __useDeleteSendingDomainMutation__
 *
 * To run a mutation, you first call `useDeleteSendingDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSendingDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSendingDomainMutation, { data, loading, error }] = useDeleteSendingDomainMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDeleteSendingDomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSendingDomainMutation, DeleteSendingDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSendingDomainMutation, DeleteSendingDomainMutationVariables>(DeleteSendingDomainDocument, options);
      }
export type DeleteSendingDomainMutationHookResult = ReturnType<typeof useDeleteSendingDomainMutation>;
export type DeleteSendingDomainMutationResult = Apollo.MutationResult<DeleteSendingDomainMutation>;
export type DeleteSendingDomainMutationOptions = Apollo.BaseMutationOptions<DeleteSendingDomainMutation, DeleteSendingDomainMutationVariables>;
export const ExportArticlesPublishedReportDocument = gql`
    query exportArticlesPublishedReport($siteId: ID!, $startDate: String!, $endDate: String!, $timeZone: String) {
  exportArticlesPublishedReport(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
    timeZone: $timeZone
  )
}
    `;

/**
 * __useExportArticlesPublishedReportQuery__
 *
 * To run a query within a React component, call `useExportArticlesPublishedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportArticlesPublishedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportArticlesPublishedReportQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useExportArticlesPublishedReportQuery(baseOptions: Apollo.QueryHookOptions<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables> & ({ variables: ExportArticlesPublishedReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>(ExportArticlesPublishedReportDocument, options);
      }
export function useExportArticlesPublishedReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>(ExportArticlesPublishedReportDocument, options);
        }
// @ts-ignore
export function useExportArticlesPublishedReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>): Apollo.UseSuspenseQueryResult<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>;
export function useExportArticlesPublishedReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>): Apollo.UseSuspenseQueryResult<ExportArticlesPublishedReportQuery | undefined, ExportArticlesPublishedReportQueryVariables>;
export function useExportArticlesPublishedReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>(ExportArticlesPublishedReportDocument, options);
        }
export type ExportArticlesPublishedReportQueryHookResult = ReturnType<typeof useExportArticlesPublishedReportQuery>;
export type ExportArticlesPublishedReportLazyQueryHookResult = ReturnType<typeof useExportArticlesPublishedReportLazyQuery>;
export type ExportArticlesPublishedReportSuspenseQueryHookResult = ReturnType<typeof useExportArticlesPublishedReportSuspenseQuery>;
export type ExportArticlesPublishedReportQueryResult = Apollo.QueryResult<ExportArticlesPublishedReportQuery, ExportArticlesPublishedReportQueryVariables>;
export const GetApNewsFeedItemDetailDocument = gql`
    query getAPNewsFeedItemDetail($siteId: ID!, $apStoryId: String!) {
  getAPNewsFeedItemDetail(siteId: $siteId, apStoryId: $apStoryId) {
    id
    title
    byline
    releaseDate
    pubStatus
    lead
    body
    imported
    importedPageId
    importedTitle
    skipReason
  }
}
    `;

/**
 * __useGetApNewsFeedItemDetailQuery__
 *
 * To run a query within a React component, call `useGetApNewsFeedItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApNewsFeedItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApNewsFeedItemDetailQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      apStoryId: // value for 'apStoryId'
 *   },
 * });
 */
export function useGetApNewsFeedItemDetailQuery(baseOptions: Apollo.QueryHookOptions<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables> & ({ variables: GetApNewsFeedItemDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>(GetApNewsFeedItemDetailDocument, options);
      }
export function useGetApNewsFeedItemDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>(GetApNewsFeedItemDetailDocument, options);
        }
// @ts-ignore
export function useGetApNewsFeedItemDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>;
export function useGetApNewsFeedItemDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetApNewsFeedItemDetailQuery | undefined, GetApNewsFeedItemDetailQueryVariables>;
export function useGetApNewsFeedItemDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>(GetApNewsFeedItemDetailDocument, options);
        }
export type GetApNewsFeedItemDetailQueryHookResult = ReturnType<typeof useGetApNewsFeedItemDetailQuery>;
export type GetApNewsFeedItemDetailLazyQueryHookResult = ReturnType<typeof useGetApNewsFeedItemDetailLazyQuery>;
export type GetApNewsFeedItemDetailSuspenseQueryHookResult = ReturnType<typeof useGetApNewsFeedItemDetailSuspenseQuery>;
export type GetApNewsFeedItemDetailQueryResult = Apollo.QueryResult<GetApNewsFeedItemDetailQuery, GetApNewsFeedItemDetailQueryVariables>;
export const GetAnalyticsForSiteDocument = gql`
    query getAnalyticsForSite($params: GetAnalyticsForSiteParams!) {
  getAnalyticsForSite(params: $params) {
    pages {
      blockId
      count
      getBlock(status: {state: Latest}) {
        items {
          blockCategory
          brandId
          createdAt
          gsk1
          id
          componentId
          pageId
          data {
            ...BlockDataFragment
          }
          variant
          savedAt
          siteId
          sk
          state
          updatedAt
          archivedAt
          version
          externalBlockIds
          slug
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
        }
      }
    }
    hitsByInterval {
      interval
      count
    }
    uniqueHitsByInterval {
      interval
      count
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useGetAnalyticsForSiteQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsForSiteQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAnalyticsForSiteQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables> & ({ variables: GetAnalyticsForSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>(GetAnalyticsForSiteDocument, options);
      }
export function useGetAnalyticsForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>(GetAnalyticsForSiteDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>;
export function useGetAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsForSiteQuery | undefined, GetAnalyticsForSiteQueryVariables>;
export function useGetAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>(GetAnalyticsForSiteDocument, options);
        }
export type GetAnalyticsForSiteQueryHookResult = ReturnType<typeof useGetAnalyticsForSiteQuery>;
export type GetAnalyticsForSiteLazyQueryHookResult = ReturnType<typeof useGetAnalyticsForSiteLazyQuery>;
export type GetAnalyticsForSiteSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsForSiteSuspenseQuery>;
export type GetAnalyticsForSiteQueryResult = Apollo.QueryResult<GetAnalyticsForSiteQuery, GetAnalyticsForSiteQueryVariables>;
export const GetAnalyticsForWorkspaceDocument = gql`
    query getAnalyticsForWorkspace($params: GetAnalyticsForWorkspaceParams!) {
  getAnalyticsForWorkspace(params: $params) {
    hitsByInterval {
      interval
      count
    }
    uniqueHitsByInterval {
      interval
      count
    }
  }
}
    `;

/**
 * __useGetAnalyticsForWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsForWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsForWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsForWorkspaceQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAnalyticsForWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables> & ({ variables: GetAnalyticsForWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>(GetAnalyticsForWorkspaceDocument, options);
      }
export function useGetAnalyticsForWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>(GetAnalyticsForWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>;
export function useGetAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyticsForWorkspaceQuery | undefined, GetAnalyticsForWorkspaceQueryVariables>;
export function useGetAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>(GetAnalyticsForWorkspaceDocument, options);
        }
export type GetAnalyticsForWorkspaceQueryHookResult = ReturnType<typeof useGetAnalyticsForWorkspaceQuery>;
export type GetAnalyticsForWorkspaceLazyQueryHookResult = ReturnType<typeof useGetAnalyticsForWorkspaceLazyQuery>;
export type GetAnalyticsForWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsForWorkspaceSuspenseQuery>;
export type GetAnalyticsForWorkspaceQueryResult = Apollo.QueryResult<GetAnalyticsForWorkspaceQuery, GetAnalyticsForWorkspaceQueryVariables>;
export const GetApNewsTokenDocument = gql`
    query getAPNewsToken($siteId: ID!) {
  getAPNewsToken(siteId: $siteId)
}
    `;

/**
 * __useGetApNewsTokenQuery__
 *
 * To run a query within a React component, call `useGetApNewsTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApNewsTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApNewsTokenQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetApNewsTokenQuery(baseOptions: Apollo.QueryHookOptions<GetApNewsTokenQuery, GetApNewsTokenQueryVariables> & ({ variables: GetApNewsTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>(GetApNewsTokenDocument, options);
      }
export function useGetApNewsTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>(GetApNewsTokenDocument, options);
        }
// @ts-ignore
export function useGetApNewsTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>;
export function useGetApNewsTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetApNewsTokenQuery | undefined, GetApNewsTokenQueryVariables>;
export function useGetApNewsTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>(GetApNewsTokenDocument, options);
        }
export type GetApNewsTokenQueryHookResult = ReturnType<typeof useGetApNewsTokenQuery>;
export type GetApNewsTokenLazyQueryHookResult = ReturnType<typeof useGetApNewsTokenLazyQuery>;
export type GetApNewsTokenSuspenseQueryHookResult = ReturnType<typeof useGetApNewsTokenSuspenseQuery>;
export type GetApNewsTokenQueryResult = Apollo.QueryResult<GetApNewsTokenQuery, GetApNewsTokenQueryVariables>;
export const GetAssetDocument = gql`
    query getAsset($id: ID!) {
  getAsset(id: $id) {
    brandId
    createdAt
    height
    id
    imagePlaceholder
    key
    name
    public
    tags
    type
    updatedAt
    uploaded
    usedIn
    version
    width
  }
}
    `;

/**
 * __useGetAssetQuery__
 *
 * To run a query within a React component, call `useGetAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssetQuery(baseOptions: Apollo.QueryHookOptions<GetAssetQuery, GetAssetQueryVariables> & ({ variables: GetAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetQuery, GetAssetQueryVariables>(GetAssetDocument, options);
      }
export function useGetAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetQuery, GetAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetQuery, GetAssetQueryVariables>(GetAssetDocument, options);
        }
// @ts-ignore
export function useGetAssetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssetQuery, GetAssetQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssetQuery, GetAssetQueryVariables>;
export function useGetAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetQuery, GetAssetQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssetQuery | undefined, GetAssetQueryVariables>;
export function useGetAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetQuery, GetAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssetQuery, GetAssetQueryVariables>(GetAssetDocument, options);
        }
export type GetAssetQueryHookResult = ReturnType<typeof useGetAssetQuery>;
export type GetAssetLazyQueryHookResult = ReturnType<typeof useGetAssetLazyQuery>;
export type GetAssetSuspenseQueryHookResult = ReturnType<typeof useGetAssetSuspenseQuery>;
export type GetAssetQueryResult = Apollo.QueryResult<GetAssetQuery, GetAssetQueryVariables>;
export const GetBlockDocument = gql`
    query getBlock($blockId: ID!) {
  getBlock(id: $blockId, status: {state: Latest}) {
    items {
      blockCategory
      brandId
      createdAt
      gsk1
      id
      componentId
      pageId
      data {
        ...BlockDataFragment
      }
      variant
      savedAt
      siteId
      sk
      state
      updatedAt
      archivedAt
      version
      externalBlockIds
      slug
      listExternalBlocks {
        items {
          blockCategory
          brandId
          componentId
          createdAt
          data {
            ...BlockDataFragment
          }
          gsk1
          externalBlockIds
          id
          pageId
          savedAt
          siteId
          state
          updatedAt
          archivedAt
          sk
          variant
          version
          slug
        }
      }
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useGetBlockQuery__
 *
 * To run a query within a React component, call `useGetBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useGetBlockQuery(baseOptions: Apollo.QueryHookOptions<GetBlockQuery, GetBlockQueryVariables> & ({ variables: GetBlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockQuery, GetBlockQueryVariables>(GetBlockDocument, options);
      }
export function useGetBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockQuery, GetBlockQueryVariables>(GetBlockDocument, options);
        }
// @ts-ignore
export function useGetBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>): Apollo.UseSuspenseQueryResult<GetBlockQuery, GetBlockQueryVariables>;
export function useGetBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>): Apollo.UseSuspenseQueryResult<GetBlockQuery | undefined, GetBlockQueryVariables>;
export function useGetBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlockQuery, GetBlockQueryVariables>(GetBlockDocument, options);
        }
export type GetBlockQueryHookResult = ReturnType<typeof useGetBlockQuery>;
export type GetBlockLazyQueryHookResult = ReturnType<typeof useGetBlockLazyQuery>;
export type GetBlockSuspenseQueryHookResult = ReturnType<typeof useGetBlockSuspenseQuery>;
export type GetBlockQueryResult = Apollo.QueryResult<GetBlockQuery, GetBlockQueryVariables>;
export const GetBlocksDocument = gql`
    query getBlocks($blockIds: [ID!]!, $status: PublishedStatusInput) {
  getBlocks(blockIds: $blockIds, status: $status) {
    items {
      blockCategory
      brandId
      createdAt
      gsk1
      id
      componentId
      pageId
      data {
        ...BlockDataFragment
      }
      variant
      savedAt
      siteId
      sk
      state
      updatedAt
      archivedAt
      version
      externalBlockIds
      slug
    }
    nextToken
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useGetBlocksQuery__
 *
 * To run a query within a React component, call `useGetBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlocksQuery({
 *   variables: {
 *      blockIds: // value for 'blockIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetBlocksQuery(baseOptions: Apollo.QueryHookOptions<GetBlocksQuery, GetBlocksQueryVariables> & ({ variables: GetBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlocksQuery, GetBlocksQueryVariables>(GetBlocksDocument, options);
      }
export function useGetBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlocksQuery, GetBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlocksQuery, GetBlocksQueryVariables>(GetBlocksDocument, options);
        }
// @ts-ignore
export function useGetBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlocksQuery, GetBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetBlocksQuery, GetBlocksQueryVariables>;
export function useGetBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlocksQuery, GetBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetBlocksQuery | undefined, GetBlocksQueryVariables>;
export function useGetBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlocksQuery, GetBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlocksQuery, GetBlocksQueryVariables>(GetBlocksDocument, options);
        }
export type GetBlocksQueryHookResult = ReturnType<typeof useGetBlocksQuery>;
export type GetBlocksLazyQueryHookResult = ReturnType<typeof useGetBlocksLazyQuery>;
export type GetBlocksSuspenseQueryHookResult = ReturnType<typeof useGetBlocksSuspenseQuery>;
export type GetBlocksQueryResult = Apollo.QueryResult<GetBlocksQuery, GetBlocksQueryVariables>;
export const GetBrandStyleDocument = gql`
    query getBrandStyle($siteId: ID!) {
  getSite(id: $siteId) {
    version
    updatedAt
    name
    favicon
    protected
    chatOpenByDefault
    id
    brandId
    getBrandStyle {
      id
      brandId
      createdAt
      updatedAt
      version
      properties {
        ...ClientThemePropertiesFragment
      }
    }
  }
}
    ${ClientThemePropertiesFragmentFragmentDoc}`;

/**
 * __useGetBrandStyleQuery__
 *
 * To run a query within a React component, call `useGetBrandStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandStyleQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetBrandStyleQuery(baseOptions: Apollo.QueryHookOptions<GetBrandStyleQuery, GetBrandStyleQueryVariables> & ({ variables: GetBrandStyleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandStyleQuery, GetBrandStyleQueryVariables>(GetBrandStyleDocument, options);
      }
export function useGetBrandStyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandStyleQuery, GetBrandStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandStyleQuery, GetBrandStyleQueryVariables>(GetBrandStyleDocument, options);
        }
// @ts-ignore
export function useGetBrandStyleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBrandStyleQuery, GetBrandStyleQueryVariables>): Apollo.UseSuspenseQueryResult<GetBrandStyleQuery, GetBrandStyleQueryVariables>;
export function useGetBrandStyleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandStyleQuery, GetBrandStyleQueryVariables>): Apollo.UseSuspenseQueryResult<GetBrandStyleQuery | undefined, GetBrandStyleQueryVariables>;
export function useGetBrandStyleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandStyleQuery, GetBrandStyleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandStyleQuery, GetBrandStyleQueryVariables>(GetBrandStyleDocument, options);
        }
export type GetBrandStyleQueryHookResult = ReturnType<typeof useGetBrandStyleQuery>;
export type GetBrandStyleLazyQueryHookResult = ReturnType<typeof useGetBrandStyleLazyQuery>;
export type GetBrandStyleSuspenseQueryHookResult = ReturnType<typeof useGetBrandStyleSuspenseQuery>;
export type GetBrandStyleQueryResult = Apollo.QueryResult<GetBrandStyleQuery, GetBrandStyleQueryVariables>;
export const GetBulkEditArticlesJobDocument = gql`
    query getBulkEditArticlesJob($jobId: ID!) {
  getBulkEditArticlesJob(jobId: $jobId) {
    jobId
    status
    total
    processed
    succeeded
    failed
    skipped
    results {
      pageId
      status
      reason
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetBulkEditArticlesJobQuery__
 *
 * To run a query within a React component, call `useGetBulkEditArticlesJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkEditArticlesJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkEditArticlesJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetBulkEditArticlesJobQuery(baseOptions: Apollo.QueryHookOptions<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables> & ({ variables: GetBulkEditArticlesJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>(GetBulkEditArticlesJobDocument, options);
      }
export function useGetBulkEditArticlesJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>(GetBulkEditArticlesJobDocument, options);
        }
// @ts-ignore
export function useGetBulkEditArticlesJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>;
export function useGetBulkEditArticlesJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetBulkEditArticlesJobQuery | undefined, GetBulkEditArticlesJobQueryVariables>;
export function useGetBulkEditArticlesJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>(GetBulkEditArticlesJobDocument, options);
        }
export type GetBulkEditArticlesJobQueryHookResult = ReturnType<typeof useGetBulkEditArticlesJobQuery>;
export type GetBulkEditArticlesJobLazyQueryHookResult = ReturnType<typeof useGetBulkEditArticlesJobLazyQuery>;
export type GetBulkEditArticlesJobSuspenseQueryHookResult = ReturnType<typeof useGetBulkEditArticlesJobSuspenseQuery>;
export type GetBulkEditArticlesJobQueryResult = Apollo.QueryResult<GetBulkEditArticlesJobQuery, GetBulkEditArticlesJobQueryVariables>;
export const GetCollectionDocument = gql`
    query getCollection($siteId: ID!, $collectionId: ID!, $pagination: PaginationInput) {
  getCollection(siteId: $siteId, collectionId: $collectionId) {
    collectionId
    name
    siteId
    listCollectionItems(pagination: $pagination) {
      items {
        name
        assetKey
        siteId
        assetId
        collectionId
        credit
        caption
        metadata
      }
      nextToken
    }
  }
}
    `;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      collectionId: // value for 'collectionId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables> & ({ variables: GetCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
        }
// @ts-ignore
export function useGetCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectionQuery, GetCollectionQueryVariables>;
export function useGetCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectionQuery | undefined, GetCollectionQueryVariables>;
export function useGetCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionSuspenseQueryHookResult = ReturnType<typeof useGetCollectionSuspenseQuery>;
export type GetCollectionQueryResult = Apollo.QueryResult<GetCollectionQuery, GetCollectionQueryVariables>;
export const GetCollectionItemDocument = gql`
    query getCollectionItem($siteId: ID!, $collectionId: ID!, $assetId: ID!) {
  getCollectionItem(
    siteId: $siteId
    collectionId: $collectionId
    assetId: $assetId
  ) {
    name
    assetKey
    siteId
    assetId
    collectionId
    credit
    caption
    metadata
  }
}
    `;

/**
 * __useGetCollectionItemQuery__
 *
 * To run a query within a React component, call `useGetCollectionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionItemQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      collectionId: // value for 'collectionId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetCollectionItemQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionItemQuery, GetCollectionItemQueryVariables> & ({ variables: GetCollectionItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionItemQuery, GetCollectionItemQueryVariables>(GetCollectionItemDocument, options);
      }
export function useGetCollectionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionItemQuery, GetCollectionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionItemQuery, GetCollectionItemQueryVariables>(GetCollectionItemDocument, options);
        }
// @ts-ignore
export function useGetCollectionItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollectionItemQuery, GetCollectionItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectionItemQuery, GetCollectionItemQueryVariables>;
export function useGetCollectionItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionItemQuery, GetCollectionItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectionItemQuery | undefined, GetCollectionItemQueryVariables>;
export function useGetCollectionItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionItemQuery, GetCollectionItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectionItemQuery, GetCollectionItemQueryVariables>(GetCollectionItemDocument, options);
        }
export type GetCollectionItemQueryHookResult = ReturnType<typeof useGetCollectionItemQuery>;
export type GetCollectionItemLazyQueryHookResult = ReturnType<typeof useGetCollectionItemLazyQuery>;
export type GetCollectionItemSuspenseQueryHookResult = ReturnType<typeof useGetCollectionItemSuspenseQuery>;
export type GetCollectionItemQueryResult = Apollo.QueryResult<GetCollectionItemQuery, GetCollectionItemQueryVariables>;
export const GetCollectionItemsByAssetIdDocument = gql`
    query getCollectionItemsByAssetId($siteId: ID!, $assetId: ID!) {
  getCollectionItemsByAssetId(siteId: $siteId, assetId: $assetId) {
    assetId
    collectionId
  }
}
    `;

/**
 * __useGetCollectionItemsByAssetIdQuery__
 *
 * To run a query within a React component, call `useGetCollectionItemsByAssetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionItemsByAssetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionItemsByAssetIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetCollectionItemsByAssetIdQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables> & ({ variables: GetCollectionItemsByAssetIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>(GetCollectionItemsByAssetIdDocument, options);
      }
export function useGetCollectionItemsByAssetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>(GetCollectionItemsByAssetIdDocument, options);
        }
// @ts-ignore
export function useGetCollectionItemsByAssetIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>;
export function useGetCollectionItemsByAssetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectionItemsByAssetIdQuery | undefined, GetCollectionItemsByAssetIdQueryVariables>;
export function useGetCollectionItemsByAssetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>(GetCollectionItemsByAssetIdDocument, options);
        }
export type GetCollectionItemsByAssetIdQueryHookResult = ReturnType<typeof useGetCollectionItemsByAssetIdQuery>;
export type GetCollectionItemsByAssetIdLazyQueryHookResult = ReturnType<typeof useGetCollectionItemsByAssetIdLazyQuery>;
export type GetCollectionItemsByAssetIdSuspenseQueryHookResult = ReturnType<typeof useGetCollectionItemsByAssetIdSuspenseQuery>;
export type GetCollectionItemsByAssetIdQueryResult = Apollo.QueryResult<GetCollectionItemsByAssetIdQuery, GetCollectionItemsByAssetIdQueryVariables>;
export const GetConversationAndMessagesDocument = gql`
    query getConversationAndMessages($siteId: ID!, $conversationId: ID!, $pagination: PaginationInput, $order: SortOrder) {
  getConversation(siteId: $siteId, conversationId: $conversationId) {
    id
    siteId
    userId
    title
    createdAt
    updatedAt
  }
  listConversationMessages(
    siteId: $siteId
    conversationId: $conversationId
    pagination: $pagination
    order: $order
  ) {
    items {
      id
      conversationId
      userId
      role
      content
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `;

/**
 * __useGetConversationAndMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationAndMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationAndMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationAndMessagesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      conversationId: // value for 'conversationId'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetConversationAndMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables> & ({ variables: GetConversationAndMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>(GetConversationAndMessagesDocument, options);
      }
export function useGetConversationAndMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>(GetConversationAndMessagesDocument, options);
        }
// @ts-ignore
export function useGetConversationAndMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>;
export function useGetConversationAndMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationAndMessagesQuery | undefined, GetConversationAndMessagesQueryVariables>;
export function useGetConversationAndMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>(GetConversationAndMessagesDocument, options);
        }
export type GetConversationAndMessagesQueryHookResult = ReturnType<typeof useGetConversationAndMessagesQuery>;
export type GetConversationAndMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationAndMessagesLazyQuery>;
export type GetConversationAndMessagesSuspenseQueryHookResult = ReturnType<typeof useGetConversationAndMessagesSuspenseQuery>;
export type GetConversationAndMessagesQueryResult = Apollo.QueryResult<GetConversationAndMessagesQuery, GetConversationAndMessagesQueryVariables>;
export const GetConversionAnalyticsForSiteDocument = gql`
    query getConversionAnalyticsForSite($params: GetConversionAnalyticsForSiteParams!) {
  getConversionAnalyticsForSite(params: $params) {
    topArticles {
      blockId
      paywallHits
      planViews
      checkoutStarts
      purchases
    }
  }
}
    `;

/**
 * __useGetConversionAnalyticsForSiteQuery__
 *
 * To run a query within a React component, call `useGetConversionAnalyticsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionAnalyticsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionAnalyticsForSiteQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetConversionAnalyticsForSiteQuery(baseOptions: Apollo.QueryHookOptions<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables> & ({ variables: GetConversionAnalyticsForSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>(GetConversionAnalyticsForSiteDocument, options);
      }
export function useGetConversionAnalyticsForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>(GetConversionAnalyticsForSiteDocument, options);
        }
// @ts-ignore
export function useGetConversionAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>;
export function useGetConversionAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversionAnalyticsForSiteQuery | undefined, GetConversionAnalyticsForSiteQueryVariables>;
export function useGetConversionAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>(GetConversionAnalyticsForSiteDocument, options);
        }
export type GetConversionAnalyticsForSiteQueryHookResult = ReturnType<typeof useGetConversionAnalyticsForSiteQuery>;
export type GetConversionAnalyticsForSiteLazyQueryHookResult = ReturnType<typeof useGetConversionAnalyticsForSiteLazyQuery>;
export type GetConversionAnalyticsForSiteSuspenseQueryHookResult = ReturnType<typeof useGetConversionAnalyticsForSiteSuspenseQuery>;
export type GetConversionAnalyticsForSiteQueryResult = Apollo.QueryResult<GetConversionAnalyticsForSiteQuery, GetConversionAnalyticsForSiteQueryVariables>;
export const GetConversionAnalyticsForWorkspaceDocument = gql`
    query getConversionAnalyticsForWorkspace($params: GetConversionAnalyticsForWorkspaceParams!) {
  getConversionAnalyticsForWorkspace(params: $params) {
    topArticles {
      blockId
      paywallHits
      planViews
      checkoutStarts
      purchases
    }
  }
}
    `;

/**
 * __useGetConversionAnalyticsForWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetConversionAnalyticsForWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionAnalyticsForWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionAnalyticsForWorkspaceQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetConversionAnalyticsForWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables> & ({ variables: GetConversionAnalyticsForWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>(GetConversionAnalyticsForWorkspaceDocument, options);
      }
export function useGetConversionAnalyticsForWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>(GetConversionAnalyticsForWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetConversionAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>;
export function useGetConversionAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversionAnalyticsForWorkspaceQuery | undefined, GetConversionAnalyticsForWorkspaceQueryVariables>;
export function useGetConversionAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>(GetConversionAnalyticsForWorkspaceDocument, options);
        }
export type GetConversionAnalyticsForWorkspaceQueryHookResult = ReturnType<typeof useGetConversionAnalyticsForWorkspaceQuery>;
export type GetConversionAnalyticsForWorkspaceLazyQueryHookResult = ReturnType<typeof useGetConversionAnalyticsForWorkspaceLazyQuery>;
export type GetConversionAnalyticsForWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetConversionAnalyticsForWorkspaceSuspenseQuery>;
export type GetConversionAnalyticsForWorkspaceQueryResult = Apollo.QueryResult<GetConversionAnalyticsForWorkspaceQuery, GetConversionAnalyticsForWorkspaceQueryVariables>;
export const GetEditFieldsSiteDefaultsDocument = gql`
    query getEditFieldsSiteDefaults($id: ID!) {
  getSite(id: $id) {
    id
    defaultArticleAccess
    defaultArticleExternalDisplay
    companyInfo {
      timeZone
    }
  }
}
    `;

/**
 * __useGetEditFieldsSiteDefaultsQuery__
 *
 * To run a query within a React component, call `useGetEditFieldsSiteDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditFieldsSiteDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditFieldsSiteDefaultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditFieldsSiteDefaultsQuery(baseOptions: Apollo.QueryHookOptions<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables> & ({ variables: GetEditFieldsSiteDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>(GetEditFieldsSiteDefaultsDocument, options);
      }
export function useGetEditFieldsSiteDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>(GetEditFieldsSiteDefaultsDocument, options);
        }
// @ts-ignore
export function useGetEditFieldsSiteDefaultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>;
export function useGetEditFieldsSiteDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEditFieldsSiteDefaultsQuery | undefined, GetEditFieldsSiteDefaultsQueryVariables>;
export function useGetEditFieldsSiteDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>(GetEditFieldsSiteDefaultsDocument, options);
        }
export type GetEditFieldsSiteDefaultsQueryHookResult = ReturnType<typeof useGetEditFieldsSiteDefaultsQuery>;
export type GetEditFieldsSiteDefaultsLazyQueryHookResult = ReturnType<typeof useGetEditFieldsSiteDefaultsLazyQuery>;
export type GetEditFieldsSiteDefaultsSuspenseQueryHookResult = ReturnType<typeof useGetEditFieldsSiteDefaultsSuspenseQuery>;
export type GetEditFieldsSiteDefaultsQueryResult = Apollo.QueryResult<GetEditFieldsSiteDefaultsQuery, GetEditFieldsSiteDefaultsQueryVariables>;
export const GetEmailSuppressionStatusDocument = gql`
    query getEmailSuppressionStatus($siteId: ID!, $email: String!) {
  getEmailSuppressionStatus(siteId: $siteId, email: $email) {
    suppressed
    reason
    lastUpdateTime
  }
}
    `;

/**
 * __useGetEmailSuppressionStatusQuery__
 *
 * To run a query within a React component, call `useGetEmailSuppressionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailSuppressionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailSuppressionStatusQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetEmailSuppressionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables> & ({ variables: GetEmailSuppressionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>(GetEmailSuppressionStatusDocument, options);
      }
export function useGetEmailSuppressionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>(GetEmailSuppressionStatusDocument, options);
        }
// @ts-ignore
export function useGetEmailSuppressionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>;
export function useGetEmailSuppressionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailSuppressionStatusQuery | undefined, GetEmailSuppressionStatusQueryVariables>;
export function useGetEmailSuppressionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>(GetEmailSuppressionStatusDocument, options);
        }
export type GetEmailSuppressionStatusQueryHookResult = ReturnType<typeof useGetEmailSuppressionStatusQuery>;
export type GetEmailSuppressionStatusLazyQueryHookResult = ReturnType<typeof useGetEmailSuppressionStatusLazyQuery>;
export type GetEmailSuppressionStatusSuspenseQueryHookResult = ReturnType<typeof useGetEmailSuppressionStatusSuspenseQuery>;
export type GetEmailSuppressionStatusQueryResult = Apollo.QueryResult<GetEmailSuppressionStatusQuery, GetEmailSuppressionStatusQueryVariables>;
export const GetEventAnalyticsForSiteDocument = gql`
    query getEventAnalyticsForSite($params: GetEventAnalyticsForSiteParams!) {
  getEventAnalyticsForSite(params: $params) {
    eventCounts {
      eventType
      count
    }
    hitsByInterval {
      interval
      count
    }
  }
}
    `;

/**
 * __useGetEventAnalyticsForSiteQuery__
 *
 * To run a query within a React component, call `useGetEventAnalyticsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAnalyticsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAnalyticsForSiteQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetEventAnalyticsForSiteQuery(baseOptions: Apollo.QueryHookOptions<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables> & ({ variables: GetEventAnalyticsForSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>(GetEventAnalyticsForSiteDocument, options);
      }
export function useGetEventAnalyticsForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>(GetEventAnalyticsForSiteDocument, options);
        }
// @ts-ignore
export function useGetEventAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>;
export function useGetEventAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventAnalyticsForSiteQuery | undefined, GetEventAnalyticsForSiteQueryVariables>;
export function useGetEventAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>(GetEventAnalyticsForSiteDocument, options);
        }
export type GetEventAnalyticsForSiteQueryHookResult = ReturnType<typeof useGetEventAnalyticsForSiteQuery>;
export type GetEventAnalyticsForSiteLazyQueryHookResult = ReturnType<typeof useGetEventAnalyticsForSiteLazyQuery>;
export type GetEventAnalyticsForSiteSuspenseQueryHookResult = ReturnType<typeof useGetEventAnalyticsForSiteSuspenseQuery>;
export type GetEventAnalyticsForSiteQueryResult = Apollo.QueryResult<GetEventAnalyticsForSiteQuery, GetEventAnalyticsForSiteQueryVariables>;
export const GetEventAnalyticsForWorkspaceDocument = gql`
    query getEventAnalyticsForWorkspace($params: GetEventAnalyticsForWorkspaceParams!) {
  getEventAnalyticsForWorkspace(params: $params) {
    eventCounts {
      eventType
      count
    }
    hitsByInterval {
      interval
      count
    }
  }
}
    `;

/**
 * __useGetEventAnalyticsForWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetEventAnalyticsForWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAnalyticsForWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAnalyticsForWorkspaceQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetEventAnalyticsForWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables> & ({ variables: GetEventAnalyticsForWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>(GetEventAnalyticsForWorkspaceDocument, options);
      }
export function useGetEventAnalyticsForWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>(GetEventAnalyticsForWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetEventAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>;
export function useGetEventAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventAnalyticsForWorkspaceQuery | undefined, GetEventAnalyticsForWorkspaceQueryVariables>;
export function useGetEventAnalyticsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>(GetEventAnalyticsForWorkspaceDocument, options);
        }
export type GetEventAnalyticsForWorkspaceQueryHookResult = ReturnType<typeof useGetEventAnalyticsForWorkspaceQuery>;
export type GetEventAnalyticsForWorkspaceLazyQueryHookResult = ReturnType<typeof useGetEventAnalyticsForWorkspaceLazyQuery>;
export type GetEventAnalyticsForWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetEventAnalyticsForWorkspaceSuspenseQuery>;
export type GetEventAnalyticsForWorkspaceQueryResult = Apollo.QueryResult<GetEventAnalyticsForWorkspaceQuery, GetEventAnalyticsForWorkspaceQueryVariables>;
export const GetEventArticleAnalyticsForSiteDocument = gql`
    query getEventArticleAnalyticsForSite($params: GetEventArticleAnalyticsForSiteParams!) {
  getEventArticleAnalyticsForSite(params: $params) {
    topEventArticles {
      blockId
      ticketClicks
      calendarAdds
      shares
      calls
      directions
      joins
    }
  }
}
    `;

/**
 * __useGetEventArticleAnalyticsForSiteQuery__
 *
 * To run a query within a React component, call `useGetEventArticleAnalyticsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventArticleAnalyticsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventArticleAnalyticsForSiteQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetEventArticleAnalyticsForSiteQuery(baseOptions: Apollo.QueryHookOptions<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables> & ({ variables: GetEventArticleAnalyticsForSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>(GetEventArticleAnalyticsForSiteDocument, options);
      }
export function useGetEventArticleAnalyticsForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>(GetEventArticleAnalyticsForSiteDocument, options);
        }
// @ts-ignore
export function useGetEventArticleAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>;
export function useGetEventArticleAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventArticleAnalyticsForSiteQuery | undefined, GetEventArticleAnalyticsForSiteQueryVariables>;
export function useGetEventArticleAnalyticsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>(GetEventArticleAnalyticsForSiteDocument, options);
        }
export type GetEventArticleAnalyticsForSiteQueryHookResult = ReturnType<typeof useGetEventArticleAnalyticsForSiteQuery>;
export type GetEventArticleAnalyticsForSiteLazyQueryHookResult = ReturnType<typeof useGetEventArticleAnalyticsForSiteLazyQuery>;
export type GetEventArticleAnalyticsForSiteSuspenseQueryHookResult = ReturnType<typeof useGetEventArticleAnalyticsForSiteSuspenseQuery>;
export type GetEventArticleAnalyticsForSiteQueryResult = Apollo.QueryResult<GetEventArticleAnalyticsForSiteQuery, GetEventArticleAnalyticsForSiteQueryVariables>;
export const GetEventShareBreakdownForBlockDocument = gql`
    query getEventShareBreakdownForBlock($params: GetEventShareBreakdownForBlockParams!) {
  getEventShareBreakdownForBlock(params: $params) {
    entries {
      method
      count
    }
  }
}
    `;

/**
 * __useGetEventShareBreakdownForBlockQuery__
 *
 * To run a query within a React component, call `useGetEventShareBreakdownForBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventShareBreakdownForBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventShareBreakdownForBlockQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetEventShareBreakdownForBlockQuery(baseOptions: Apollo.QueryHookOptions<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables> & ({ variables: GetEventShareBreakdownForBlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>(GetEventShareBreakdownForBlockDocument, options);
      }
export function useGetEventShareBreakdownForBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>(GetEventShareBreakdownForBlockDocument, options);
        }
// @ts-ignore
export function useGetEventShareBreakdownForBlockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>;
export function useGetEventShareBreakdownForBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventShareBreakdownForBlockQuery | undefined, GetEventShareBreakdownForBlockQueryVariables>;
export function useGetEventShareBreakdownForBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>(GetEventShareBreakdownForBlockDocument, options);
        }
export type GetEventShareBreakdownForBlockQueryHookResult = ReturnType<typeof useGetEventShareBreakdownForBlockQuery>;
export type GetEventShareBreakdownForBlockLazyQueryHookResult = ReturnType<typeof useGetEventShareBreakdownForBlockLazyQuery>;
export type GetEventShareBreakdownForBlockSuspenseQueryHookResult = ReturnType<typeof useGetEventShareBreakdownForBlockSuspenseQuery>;
export type GetEventShareBreakdownForBlockQueryResult = Apollo.QueryResult<GetEventShareBreakdownForBlockQuery, GetEventShareBreakdownForBlockQueryVariables>;
export const GetExternalFeedDocument = gql`
    query getExternalFeed($siteId: ID!, $id: ID!) {
  getExternalFeed(siteId: $siteId, id: $id) {
    id
    siteId
    name
    url
    parserType
    active
    activatedAt
    publishStatus
    paywall
    display
    sectionId
    imgRequired
    lastImportedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetExternalFeedQuery__
 *
 * To run a query within a React component, call `useGetExternalFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalFeedQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExternalFeedQuery(baseOptions: Apollo.QueryHookOptions<GetExternalFeedQuery, GetExternalFeedQueryVariables> & ({ variables: GetExternalFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalFeedQuery, GetExternalFeedQueryVariables>(GetExternalFeedDocument, options);
      }
export function useGetExternalFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalFeedQuery, GetExternalFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalFeedQuery, GetExternalFeedQueryVariables>(GetExternalFeedDocument, options);
        }
// @ts-ignore
export function useGetExternalFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalFeedQuery, GetExternalFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalFeedQuery, GetExternalFeedQueryVariables>;
export function useGetExternalFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalFeedQuery, GetExternalFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalFeedQuery | undefined, GetExternalFeedQueryVariables>;
export function useGetExternalFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalFeedQuery, GetExternalFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalFeedQuery, GetExternalFeedQueryVariables>(GetExternalFeedDocument, options);
        }
export type GetExternalFeedQueryHookResult = ReturnType<typeof useGetExternalFeedQuery>;
export type GetExternalFeedLazyQueryHookResult = ReturnType<typeof useGetExternalFeedLazyQuery>;
export type GetExternalFeedSuspenseQueryHookResult = ReturnType<typeof useGetExternalFeedSuspenseQuery>;
export type GetExternalFeedQueryResult = Apollo.QueryResult<GetExternalFeedQuery, GetExternalFeedQueryVariables>;
export const GetFeedDocument = gql`
    query getFeed($workspaceId: ID!, $id: ID!) {
  getFeed(workspaceId: $workspaceId, id: $id) {
    id
    workspaceId
    name
    description
    createdAt
    updatedAt
    webhooks {
      url
      active
    }
    filters {
      pattern
      active
    }
  }
}
    `;

/**
 * __useGetFeedQuery__
 *
 * To run a query within a React component, call `useGetFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFeedQuery(baseOptions: Apollo.QueryHookOptions<GetFeedQuery, GetFeedQueryVariables> & ({ variables: GetFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, options);
      }
export function useGetFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedQuery, GetFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, options);
        }
// @ts-ignore
export function useGetFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeedQuery, GetFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeedQuery, GetFeedQueryVariables>;
export function useGetFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedQuery, GetFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeedQuery | undefined, GetFeedQueryVariables>;
export function useGetFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedQuery, GetFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, options);
        }
export type GetFeedQueryHookResult = ReturnType<typeof useGetFeedQuery>;
export type GetFeedLazyQueryHookResult = ReturnType<typeof useGetFeedLazyQuery>;
export type GetFeedSuspenseQueryHookResult = ReturnType<typeof useGetFeedSuspenseQuery>;
export type GetFeedQueryResult = Apollo.QueryResult<GetFeedQuery, GetFeedQueryVariables>;
export const GetNewsletterDocument = gql`
    query getNewsletter($siteId: ID!, $newsletterId: ID!) {
  getNewsletter(siteId: $siteId, newsletterId: $newsletterId) {
    id
    siteId
    name
    description
    order
    kind
    status
    provider
    publicVisibility
    publicOrder
    template {
      blocksJson
    }
    schedule {
      cadence
      daysOfWeek
      timeOfDay
      timezone
      startAt
      endAt
      iCal
    }
    segmentIds
    fromName
    replyToEmail
  }
}
    `;

/**
 * __useGetNewsletterQuery__
 *
 * To run a query within a React component, call `useGetNewsletterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newsletterId: // value for 'newsletterId'
 *   },
 * });
 */
export function useGetNewsletterQuery(baseOptions: Apollo.QueryHookOptions<GetNewsletterQuery, GetNewsletterQueryVariables> & ({ variables: GetNewsletterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsletterQuery, GetNewsletterQueryVariables>(GetNewsletterDocument, options);
      }
export function useGetNewsletterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsletterQuery, GetNewsletterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsletterQuery, GetNewsletterQueryVariables>(GetNewsletterDocument, options);
        }
// @ts-ignore
export function useGetNewsletterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewsletterQuery, GetNewsletterQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewsletterQuery, GetNewsletterQueryVariables>;
export function useGetNewsletterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewsletterQuery, GetNewsletterQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewsletterQuery | undefined, GetNewsletterQueryVariables>;
export function useGetNewsletterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewsletterQuery, GetNewsletterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewsletterQuery, GetNewsletterQueryVariables>(GetNewsletterDocument, options);
        }
export type GetNewsletterQueryHookResult = ReturnType<typeof useGetNewsletterQuery>;
export type GetNewsletterLazyQueryHookResult = ReturnType<typeof useGetNewsletterLazyQuery>;
export type GetNewsletterSuspenseQueryHookResult = ReturnType<typeof useGetNewsletterSuspenseQuery>;
export type GetNewsletterQueryResult = Apollo.QueryResult<GetNewsletterQuery, GetNewsletterQueryVariables>;
export const GetPageDocument = gql`
    query getPage($pageId: ID!, $siteId: ID!) {
  getSite(id: $siteId) {
    brandId
    domainName
    id
    name
    seoPublicationName
    titleTag
    metaDescription
    favicon
    protected
    chatOpenByDefault
    version
    updatedAt
    defaultArticleAccess
    defaultArticleExternalDisplay
    storyCommentsOnByDefault
    adSystem
    disableStoryGeneration
    disableTitleGeneration
    disableLeadGeneration
    menus {
      id
      name
    }
    chatbotImage {
      src
      width
      height
    }
    typesense {
      cmsKey
      siteKey
    }
    companyInfo {
      timeZone
    }
    columnInchSettings {
      method
      wordsPerInch
      charactersPerColumnInch
    }
    listSitePageTemplates {
      items {
        pageTemplateCategory
        id
        sk
      }
    }
    gelatoApiKey
    gelatoActive
  }
  getPage(id: $pageId, status: {state: Latest}) {
    items {
      brandId
      getPageTemplate(status: {state: Latest}) {
        items {
          blockTemplates {
            ids
            slot
          }
          blockVariants {
            componentId
            defaultVariant
          }
          brandId
          createdAt
          id
          pageTemplateCategory
          componentId
          savedAt
          siteId
          sk
          updatedAt
          state
          version
        }
      }
      gsk1
      gsk2
      id
      listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
        items {
          blockCategory
          brandId
          createdAt
          gsk1
          id
          componentId
          pageId
          data {
            ...BlockDataFragment
          }
          variant
          savedAt
          siteId
          sk
          state
          updatedAt
          archivedAt
          version
          externalBlockIds
          slug
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
        }
      }
      localBlockSlots {
        ids
        slot
      }
      listPageAdditionalBlocks {
        items {
          blockCategory
          componentId
          data {
            ...BlockDataFragment
          }
          id
          variant
          version
          state
          pageId
          createdAt
          sk
          updatedAt
          archivedAt
          brandId
          gsk1
          siteId
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
          slug
        }
        nextToken
      }
      pageCategory
      savedAt
      siteId
      sk
      slug
      state
      templateId
      updatedAt
      publishedAt
      version
      createdAt
      createdBy
      seoTitle
      seoDescription
      seoCanonical
      seoNoindex
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetPageQuery(baseOptions: Apollo.QueryHookOptions<GetPageQuery, GetPageQueryVariables> & ({ variables: GetPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
      }
export function useGetPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
// @ts-ignore
export function useGetPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageQuery, GetPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageQuery, GetPageQueryVariables>;
export function useGetPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageQuery, GetPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageQuery | undefined, GetPageQueryVariables>;
export function useGetPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>;
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>;
export type GetPageSuspenseQueryHookResult = ReturnType<typeof useGetPageSuspenseQuery>;
export type GetPageQueryResult = Apollo.QueryResult<GetPageQuery, GetPageQueryVariables>;
export const GetPageAndLocalBlocksDocument = gql`
    query getPageAndLocalBlocks($pageId: ID!) {
  getPage(id: $pageId, status: {state: Latest}) {
    items {
      brandId
      listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
        items {
          blockCategory
          brandId
          createdAt
          gsk1
          id
          componentId
          pageId
          variant
          savedAt
          siteId
          sk
          state
          updatedAt
          version
        }
      }
      id
      pageCategory
      savedAt
      siteId
      sk
      slug
      state
      templateId
      updatedAt
      publishedAt
      version
      createdAt
    }
  }
}
    `;

/**
 * __useGetPageAndLocalBlocksQuery__
 *
 * To run a query within a React component, call `useGetPageAndLocalBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageAndLocalBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageAndLocalBlocksQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useGetPageAndLocalBlocksQuery(baseOptions: Apollo.QueryHookOptions<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables> & ({ variables: GetPageAndLocalBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>(GetPageAndLocalBlocksDocument, options);
      }
export function useGetPageAndLocalBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>(GetPageAndLocalBlocksDocument, options);
        }
// @ts-ignore
export function useGetPageAndLocalBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>;
export function useGetPageAndLocalBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageAndLocalBlocksQuery | undefined, GetPageAndLocalBlocksQueryVariables>;
export function useGetPageAndLocalBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>(GetPageAndLocalBlocksDocument, options);
        }
export type GetPageAndLocalBlocksQueryHookResult = ReturnType<typeof useGetPageAndLocalBlocksQuery>;
export type GetPageAndLocalBlocksLazyQueryHookResult = ReturnType<typeof useGetPageAndLocalBlocksLazyQuery>;
export type GetPageAndLocalBlocksSuspenseQueryHookResult = ReturnType<typeof useGetPageAndLocalBlocksSuspenseQuery>;
export type GetPageAndLocalBlocksQueryResult = Apollo.QueryResult<GetPageAndLocalBlocksQuery, GetPageAndLocalBlocksQueryVariables>;
export const GetPageBySlugDocument = gql`
    query getPageBySlug($slug: String!, $siteId: ID!) {
  getSite(id: $siteId) {
    brandId
    domainName
    id
    name
    titleTag
    metaDescription
    favicon
    protected
    chatOpenByDefault
    version
    updatedAt
    typesense {
      cmsKey
      siteKey
    }
    chatbotImage {
      src
      width
      height
    }
    chatbotMinimizedDisplayName
    menus {
      id
      items {
        id
        name
        url
        type
        menuIds
      }
      name
    }
    adSystem
    listSitePageTemplates {
      items {
        pageTemplateCategory
        id
        sk
      }
    }
  }
  getPageBySlug(slug: $slug, siteId: $siteId, status: {state: Latest}) {
    items {
      brandId
      getPageTemplate(status: {state: Latest}) {
        items {
          blockTemplates {
            ids
            slot
          }
          blockVariants {
            componentId
            defaultVariant
          }
          brandId
          createdAt
          id
          pageTemplateCategory
          componentId
          savedAt
          siteId
          sk
          updatedAt
          state
          version
        }
      }
      gsk1
      gsk2
      id
      listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
        items {
          blockCategory
          brandId
          createdAt
          gsk1
          id
          slug
          componentId
          pageId
          data {
            ...BlockDataFragment
          }
          variant
          savedAt
          siteId
          sk
          state
          updatedAt
          archivedAt
          version
          externalBlockIds
          slug
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
        }
      }
      localBlockSlots {
        ids
        slot
      }
      listPageAdditionalBlocks {
        items {
          blockCategory
          componentId
          data {
            ...BlockDataFragment
          }
          id
          variant
          version
          state
          pageId
          createdAt
          sk
          updatedAt
          archivedAt
          brandId
          gsk1
          siteId
          slug
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
          slug
        }
      }
      pageCategory
      savedAt
      siteId
      sk
      slug
      state
      templateId
      updatedAt
      publishedAt
      version
      createdAt
      seoTitle
      seoDescription
      seoCanonical
      seoNoindex
      seoImageSrc
      seoImageWidth
      seoImageHeight
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useGetPageBySlugQuery__
 *
 * To run a query within a React component, call `useGetPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables> & ({ variables: GetPageBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, options);
      }
export function useGetPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, options);
        }
// @ts-ignore
export function useGetPageBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageBySlugQuery, GetPageBySlugQueryVariables>;
export function useGetPageBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageBySlugQuery | undefined, GetPageBySlugQueryVariables>;
export function useGetPageBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageBySlugQuery, GetPageBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, options);
        }
export type GetPageBySlugQueryHookResult = ReturnType<typeof useGetPageBySlugQuery>;
export type GetPageBySlugLazyQueryHookResult = ReturnType<typeof useGetPageBySlugLazyQuery>;
export type GetPageBySlugSuspenseQueryHookResult = ReturnType<typeof useGetPageBySlugSuspenseQuery>;
export type GetPageBySlugQueryResult = Apollo.QueryResult<GetPageBySlugQuery, GetPageBySlugQueryVariables>;
export const GetPageBySlugForRedirectDocument = gql`
    query getPageBySlugForRedirect($siteId: ID!, $slug: String!) {
  getPageBySlug(siteId: $siteId, slug: $slug, status: {state: Published}) {
    items {
      id
      sk
      slug
      pageCategory
      createdAt
      updatedAt
      redirect {
        destination
        permanent
      }
    }
  }
}
    `;

/**
 * __useGetPageBySlugForRedirectQuery__
 *
 * To run a query within a React component, call `useGetPageBySlugForRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageBySlugForRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageBySlugForRedirectQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPageBySlugForRedirectQuery(baseOptions: Apollo.QueryHookOptions<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables> & ({ variables: GetPageBySlugForRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>(GetPageBySlugForRedirectDocument, options);
      }
export function useGetPageBySlugForRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>(GetPageBySlugForRedirectDocument, options);
        }
// @ts-ignore
export function useGetPageBySlugForRedirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>;
export function useGetPageBySlugForRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageBySlugForRedirectQuery | undefined, GetPageBySlugForRedirectQueryVariables>;
export function useGetPageBySlugForRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>(GetPageBySlugForRedirectDocument, options);
        }
export type GetPageBySlugForRedirectQueryHookResult = ReturnType<typeof useGetPageBySlugForRedirectQuery>;
export type GetPageBySlugForRedirectLazyQueryHookResult = ReturnType<typeof useGetPageBySlugForRedirectLazyQuery>;
export type GetPageBySlugForRedirectSuspenseQueryHookResult = ReturnType<typeof useGetPageBySlugForRedirectSuspenseQuery>;
export type GetPageBySlugForRedirectQueryResult = Apollo.QueryResult<GetPageBySlugForRedirectQuery, GetPageBySlugForRedirectQueryVariables>;
export const GetPagePublicationSettingsDocument = gql`
    query getPagePublicationSettings($siteId: ID!) {
  getSite(id: $siteId) {
    id
    brandId
    name
    seoPublicationName
    authToken
    exportAuthToken
    newzwareAccount {
      active
      instanceUrl
      site
      editionCode
    }
    engageAccount {
      active
      configScript
      subscribeUrl
      accountUrl
    }
    mirabelAccount {
      active
      baseUrl
      tenant
      apiKey
    }
    contentCreditsAccount {
      active
      apiKey
    }
    makeItFreeAccount {
      active
      publisherId
      apiKey
    }
    navigaAccount {
      username
      password
      wsdlUrl
      active
      navigaSubscriptionAssociation {
        stripeProductId
        navigaPubId
        navigaRateId
      }
    }
    disableStoryGeneration
    disableTitleGeneration
    disableLeadGeneration
    disableCmsChatbot
    disableAuthentication
    emailServiceAutoTagSignedIn
    emailServiceAutoTagSubscribed
    sendNewsletterSubscriptionEmail
    tollbitAnalyticsEnabled
    s3TransferFolderName
    newspapersDotComTPAKey
    newspapersDotComSubdomain
    storyCommentsOnByDefault
    language
    languageFollowsWorkspace
    articleBodySidebarMode
    chatbotPageBlacklist {
      hideFromAllPages
      home
      stories
      writers
      tags
      sections
      search
      latestStories
      newsletters
      signIn
      subscribe
      account
      contactUs
      terms
      privacyPolicy
      thankYou
      gift
      giftRedeem
      printOrderTracking
    }
    pubgenSubscription {
      id
      status
    }
    favicon
    protected
    defaultArticleAccess
    defaultArticleExternalDisplay
    defaultMetadata
    chatOpenByDefault
    version
    updatedAt
    imgPlaceholder {
      src
      width
      height
    }
    metadataImage {
      src
      width
      height
    }
    chatbotImage {
      src
      width
      height
    }
    chatbotMinimizedDisplayName
    connectedGoogleAnalyticsAccount {
      gaMeasurementId
    }
    connectedMarfeelAnalyticsAccount {
      marfeelId
    }
    connectedIzootoAccount {
      active
      scriptId
    }
    connectedGoogleTagManagerAccount {
      containerId
    }
    connectedFotomotoAccount {
      accountId
    }
    gelatoApiKey
    gelatoWebhookSecret
    gelatoActive
    gelatoNewsroomMarkupPercent
    gelatoEnabledProductTypes
    shippingCountries
    connectedGoogleAdsAccount {
      adClient
      verticalAdSlot
      horizontalAdSlot
    }
    googleTagAds {
      verticalHeaderScript
      vertical2HeaderScript
      chatbotPrimaryHeaderScript
      chatbotSecondaryHeaderScript
      horizontal1HeaderScript
      horizontal2HeaderScript
      footerHeaderScript
      adHeroHeaderScript
      stickyFooterHeaderScript
      articleInContentHeaderScript
      videoHeaderScript
    }
    customAds {
      blockPubHeaderMenu {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSearch {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleBody {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubLatestArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubAuthorRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubTagRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubHomeTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockEmailCapture {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd1 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd2 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      chatbotPrimary {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      chatbotSecondary {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      stickyFooter {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      articleInContent {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      video {
        href
        imgSrc
        imgHeight
        imgWidth
        videoUrl
      }
    }
    typesense {
      cmsKey
      siteKey
    }
    adTxtContent
    emailCapture {
      title
      subtitle
      newsletterId
      customNewsletterId
    }
    newsletterProvider
    aiSettings {
      journalistType
      audienceType
      blogType
      primaryPersona
      publicPrimaryPersona
      greetingMessage
    }
    adSystem
    playWirePubId
    playWireWebId
    companyInfo {
      cityName
      countyCode
      mainEmail
      mainPhoneNumber
      noaaGridPoint
      supportEmail
      supportPhoneNumber
      timeZone
      sendSubscriptionLifecycleEmailsToCustomer
      coordinates {
        lat
        lng
      }
    }
    columnInchSettings {
      method
      wordsPerInch
      charactersPerColumnInch
    }
    connectedStripeAccount {
      accountId
      status
      notificationEmail
      profileChangeNotificationEmail
      type
      subscriptionPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        struckOutpriceForMonthlyToggleChoice
        struckOutPriceForYearlyToggleChoice
        priceSubtitleMonthly
        priceSubtitleYearly
        productId
        stripeDescription
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        collectShipping
        collectPhoneNumber
        clickSubscribeLinkOverrideMonthly
        clickSubscribeLinkOverrideYearly
        promoCouponIdMonthly
        promoCouponIdYearly
        adSettings
        printOnly
        optionalProductId
        optionalProductName
        optionalProductDescription
        priceForMonthlyOptionalChoice
        priceForYearlyOptionalChoice
        optionalMonthlyState
        optionalYearlyState
        monthlyPlanLabel
        yearlyPlanLabel
        ctaMonthly
        ctaYearly
      }
      supportPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        priceSubtitleYearly
        priceSubtitleMonthly
        productId
        stripeDescription
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        collectShipping
      }
      subscriptionGifts {
        siteId
        productId
        priceId
        planProductId
        couponId
        numberOfGiftedMonths
        priceInCents
        isActive
      }
      subscriptionPromos {
        siteId
        couponId
        name
        percentageOff
        durationInMonths
      }
      donationProduct {
        productId
        priceId
        name
        stripeDescription
        isActive
        siteId
        collectPhoneNumber
        minimumAmount
        maximumAmount
        defaultAmount
      }
      customerPortalConfig {
        id
        enabled
        isDefault
        active
        allowPaymentMethodUpdate
        allowCancellation
        allowPlanSwitching
        switchablePrices
      }
    }
    domain {
      createdAt
      domainCloudFormation
      domainCloudfront
      domainName
      externalProvider
      hostedZoneId
      nameServers
      operationId
      siteId
      status
      updatedAt
      workspaceId
    }
    domainName
    getBrand {
      workspaceId
      id
      brandStyleId
      createdAt
      version
      updatedAt
      name
      getBrandStyle {
        id
        brandId
        createdAt
        updatedAt
        version
        properties {
          ...ClientThemePropertiesFragment
        }
      }
      listBrandStyles {
        items {
          brandId
          createdAt
          id
          properties {
            ...ClientThemePropertiesFragment
          }
          version
          updatedAt
        }
      }
      path
    }
  }
}
    ${ClientThemePropertiesFragmentFragmentDoc}`;

/**
 * __useGetPagePublicationSettingsQuery__
 *
 * To run a query within a React component, call `useGetPagePublicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagePublicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagePublicationSettingsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetPagePublicationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables> & ({ variables: GetPagePublicationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>(GetPagePublicationSettingsDocument, options);
      }
export function useGetPagePublicationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>(GetPagePublicationSettingsDocument, options);
        }
// @ts-ignore
export function useGetPagePublicationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>;
export function useGetPagePublicationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPagePublicationSettingsQuery | undefined, GetPagePublicationSettingsQueryVariables>;
export function useGetPagePublicationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>(GetPagePublicationSettingsDocument, options);
        }
export type GetPagePublicationSettingsQueryHookResult = ReturnType<typeof useGetPagePublicationSettingsQuery>;
export type GetPagePublicationSettingsLazyQueryHookResult = ReturnType<typeof useGetPagePublicationSettingsLazyQuery>;
export type GetPagePublicationSettingsSuspenseQueryHookResult = ReturnType<typeof useGetPagePublicationSettingsSuspenseQuery>;
export type GetPagePublicationSettingsQueryResult = Apollo.QueryResult<GetPagePublicationSettingsQuery, GetPagePublicationSettingsQueryVariables>;
export const GetRedirectPageDocument = gql`
    query getRedirectPage($pageId: ID!) {
  getPage(id: $pageId, status: {state: Latest}) {
    items {
      id
      sk
      slug
      pageCategory
      createdAt
      updatedAt
      redirect {
        destination
        permanent
      }
    }
  }
}
    `;

/**
 * __useGetRedirectPageQuery__
 *
 * To run a query within a React component, call `useGetRedirectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedirectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedirectPageQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useGetRedirectPageQuery(baseOptions: Apollo.QueryHookOptions<GetRedirectPageQuery, GetRedirectPageQueryVariables> & ({ variables: GetRedirectPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedirectPageQuery, GetRedirectPageQueryVariables>(GetRedirectPageDocument, options);
      }
export function useGetRedirectPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedirectPageQuery, GetRedirectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedirectPageQuery, GetRedirectPageQueryVariables>(GetRedirectPageDocument, options);
        }
// @ts-ignore
export function useGetRedirectPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRedirectPageQuery, GetRedirectPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetRedirectPageQuery, GetRedirectPageQueryVariables>;
export function useGetRedirectPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedirectPageQuery, GetRedirectPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetRedirectPageQuery | undefined, GetRedirectPageQueryVariables>;
export function useGetRedirectPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedirectPageQuery, GetRedirectPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRedirectPageQuery, GetRedirectPageQueryVariables>(GetRedirectPageDocument, options);
        }
export type GetRedirectPageQueryHookResult = ReturnType<typeof useGetRedirectPageQuery>;
export type GetRedirectPageLazyQueryHookResult = ReturnType<typeof useGetRedirectPageLazyQuery>;
export type GetRedirectPageSuspenseQueryHookResult = ReturnType<typeof useGetRedirectPageSuspenseQuery>;
export type GetRedirectPageQueryResult = Apollo.QueryResult<GetRedirectPageQuery, GetRedirectPageQueryVariables>;
export const GetSavedPageVersionsDocument = gql`
    query getSavedPageVersions($pageId: ID!) {
  getPage(id: $pageId, status: {state: Saved}) {
    items {
      createdBy
      savedBy
      brandId
      getPageTemplate(status: {state: Saved}) {
        items {
          blockTemplates {
            ids
            slot
          }
          blockVariants {
            componentId
            defaultVariant
          }
          brandId
          createdAt
          id
          pageTemplateCategory
          componentId
          savedAt
          savedBy
          siteId
          sk
          updatedAt
          state
          version
        }
      }
      gsk1
      gsk2
      id
      listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
        items {
          blockCategory
          brandId
          createdAt
          gsk1
          id
          componentId
          pageId
          data {
            ...BlockDataFragment
          }
          variant
          savedAt
          siteId
          sk
          state
          updatedAt
          archivedAt
          version
          externalBlockIds
          slug
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
        }
      }
      localBlockSlots {
        ids
        slot
      }
      listPageAdditionalBlocks {
        items {
          blockCategory
          componentId
          data {
            ...BlockDataFragment
          }
          id
          variant
          version
          state
          pageId
          createdAt
          sk
          updatedAt
          archivedAt
          brandId
          gsk1
          siteId
          listExternalBlocks {
            items {
              blockCategory
              brandId
              componentId
              createdAt
              data {
                ...BlockDataFragment
              }
              gsk1
              externalBlockIds
              id
              pageId
              savedAt
              siteId
              state
              updatedAt
              archivedAt
              sk
              variant
              version
              slug
            }
          }
          slug
        }
        nextToken
      }
      pageCategory
      savedAt
      siteId
      sk
      slug
      state
      templateId
      updatedAt
      publishedAt
      version
      createdAt
      seoTitle
      seoDescription
      seoCanonical
      seoNoindex
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useGetSavedPageVersionsQuery__
 *
 * To run a query within a React component, call `useGetSavedPageVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedPageVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedPageVersionsQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useGetSavedPageVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables> & ({ variables: GetSavedPageVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>(GetSavedPageVersionsDocument, options);
      }
export function useGetSavedPageVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>(GetSavedPageVersionsDocument, options);
        }
// @ts-ignore
export function useGetSavedPageVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>;
export function useGetSavedPageVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedPageVersionsQuery | undefined, GetSavedPageVersionsQueryVariables>;
export function useGetSavedPageVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>(GetSavedPageVersionsDocument, options);
        }
export type GetSavedPageVersionsQueryHookResult = ReturnType<typeof useGetSavedPageVersionsQuery>;
export type GetSavedPageVersionsLazyQueryHookResult = ReturnType<typeof useGetSavedPageVersionsLazyQuery>;
export type GetSavedPageVersionsSuspenseQueryHookResult = ReturnType<typeof useGetSavedPageVersionsSuspenseQuery>;
export type GetSavedPageVersionsQueryResult = Apollo.QueryResult<GetSavedPageVersionsQuery, GetSavedPageVersionsQueryVariables>;
export const GetSegmentDocument = gql`
    query getSegment($siteId: ID!, $segmentId: ID!) {
  getSegment(siteId: $siteId, segmentId: $segmentId) {
    id
    siteId
    name
    description
    rulesJson
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSegmentQuery__
 *
 * To run a query within a React component, call `useGetSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useGetSegmentQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables> & ({ variables: GetSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
      }
export function useGetSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
        }
// @ts-ignore
export function useGetSegmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetSegmentQuery, GetSegmentQueryVariables>;
export function useGetSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetSegmentQuery | undefined, GetSegmentQueryVariables>;
export function useGetSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
        }
export type GetSegmentQueryHookResult = ReturnType<typeof useGetSegmentQuery>;
export type GetSegmentLazyQueryHookResult = ReturnType<typeof useGetSegmentLazyQuery>;
export type GetSegmentSuspenseQueryHookResult = ReturnType<typeof useGetSegmentSuspenseQuery>;
export type GetSegmentQueryResult = Apollo.QueryResult<GetSegmentQuery, GetSegmentQueryVariables>;
export const GetSiteDocument = gql`
    query getSite($id: ID!) {
  getSite(id: $id) {
    brandId
    createdAt
    domainName
    protected
    id
    name
    seoPublicationName
    titleTag
    metaDescription
    updatedAt
    version
    disableTitleGeneration
    disableLeadGeneration
    disableStoryGeneration
    disableCmsChatbot
    emailServiceAutoTagSignedIn
    emailServiceAutoTagSubscribed
    sendNewsletterSubscriptionEmail
    connectedStripeAccount {
      accountId
      status
      notificationEmail
      type
      subscriptionPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        struckOutpriceForMonthlyToggleChoice
        struckOutPriceForYearlyToggleChoice
        priceSubtitleMonthly
        priceSubtitleYearly
        productId
        stripeDescription
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        collectShipping
        collectPhoneNumber
        clickSubscribeLinkOverrideMonthly
        clickSubscribeLinkOverrideYearly
        promoCouponIdMonthly
        promoCouponIdYearly
        adSettings
        printOnly
        optionalProductId
        optionalProductName
        optionalProductDescription
        priceForMonthlyOptionalChoice
        priceForYearlyOptionalChoice
        optionalMonthlyState
        optionalYearlyState
        monthlyPlanLabel
        yearlyPlanLabel
        ctaMonthly
        ctaYearly
      }
      supportPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        priceSubtitleYearly
        priceSubtitleMonthly
        productId
        stripeDescription
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        collectShipping
      }
    }
    companyInfo {
      timeZone
    }
    columnInchSettings {
      method
      wordsPerInch
      charactersPerColumnInch
    }
    menus {
      id
      items {
        id
        name
        url
        type
        menuIds
      }
      name
    }
    storyCommentsOnByDefault
    language
    articleBodySidebarMode
    defaultArticleAccess
    defaultArticleExternalDisplay
    defaultMetadata
    chatbotImage {
      src
      width
      height
    }
    customAds {
      blockPubHeaderMenu {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSearch {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleBody {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubLatestArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubAuthorRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubTagRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubHomeTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockEmailCapture {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd1 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd2 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      articleInContent {
        href
        imgSrc
        imgHeight
        imgWidth
      }
    }
    adSystem
    typesense {
      cmsKey
      siteKey
    }
    domain {
      createdAt
      domainCloudfront
      domainName
      hostedZoneId
      nameServers
      externalProvider
      domainCloudFormation
      operationId
      siteId
      status
      updatedAt
      workspaceId
    }
    listSitePageTemplates {
      items {
        pageTemplateCategory
        id
        sk
      }
    }
    gelatoApiKey
    gelatoActive
  }
}
    `;

/**
 * __useGetSiteQuery__
 *
 * To run a query within a React component, call `useGetSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSiteQuery(baseOptions: Apollo.QueryHookOptions<GetSiteQuery, GetSiteQueryVariables> & ({ variables: GetSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument, options);
      }
export function useGetSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument, options);
        }
// @ts-ignore
export function useGetSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteQuery, GetSiteQueryVariables>;
export function useGetSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteQuery | undefined, GetSiteQueryVariables>;
export function useGetSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument, options);
        }
export type GetSiteQueryHookResult = ReturnType<typeof useGetSiteQuery>;
export type GetSiteLazyQueryHookResult = ReturnType<typeof useGetSiteLazyQuery>;
export type GetSiteSuspenseQueryHookResult = ReturnType<typeof useGetSiteSuspenseQuery>;
export type GetSiteQueryResult = Apollo.QueryResult<GetSiteQuery, GetSiteQueryVariables>;
export const GetSitePageDocument = gql`
    query getSitePage($id: ID!, $slug: String!) {
  getSite(id: $id) {
    id
    brandId
    createdAt
    domainName
    name
    seoPublicationName
    titleTag
    metaDescription
    favicon
    protected
    disableAuthentication
    chatOpenByDefault
    version
    updatedAt
    siteCategory
    brandStyleId
    defaultArticleAccess
    disableStoryGeneration
    newzwareAccount {
      active
      instanceUrl
      site
      editionCode
    }
    engageAccount {
      active
      configScript
      subscribeUrl
      accountUrl
    }
    mirabelAccount {
      active
      baseUrl
      tenant
      apiKey
    }
    contentCreditsAccount {
      active
      apiKey
    }
    storyCommentsOnByDefault
    imgPlaceholder {
      src
      width
      height
    }
    chatbotMinimizedDisplayName
    metadataImage {
      src
      width
      height
    }
    chatbotImage {
      src
      width
      height
    }
    menus {
      id
      items {
        id
        name
        url
        type
        menuIds
      }
      name
    }
    adSystem
    customAds {
      blockPubHeaderMenu {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSearch {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleBody {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubLatestArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubAuthorRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubTagRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubHomeTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockEmailCapture {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubArticleRelatedArticles {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockPubSectionTopStories {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd1 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      blockGoogleAd2 {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      chatbotPrimary {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      chatbotSecondary {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      articleInContent {
        href
        imgSrc
        imgHeight
        imgWidth
      }
      video {
        href
        imgSrc
        imgHeight
        imgWidth
        videoUrl
      }
      stickyFooter {
        href
        imgSrc
        imgHeight
        imgWidth
      }
    }
    emailCapture {
      title
      subtitle
      newsletterId
    }
    connectedStripeAccount {
      accountId
      status
      notificationEmail
      type
      subscriptionPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        clickSubscribeLinkOverrideMonthly
        clickSubscribeLinkOverrideYearly
        struckOutpriceForMonthlyToggleChoice
        struckOutPriceForYearlyToggleChoice
        priceSubtitleMonthly
        priceSubtitleYearly
        productId
        stripeDescription
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
        collectShipping
        collectPhoneNumber
        promoCouponIdMonthly
        promoCouponIdYearly
        ctaMonthly
        ctaYearly
      }
      supportPlans {
        benefits
        planSummary
        name
        subtitle
        priceForMonthlyToggleChoice
        priceForYearlyToggleChoice
        priceSubtitleYearly
        priceSubtitleMonthly
        productId
        stripeDescription
        stripePriceIdMonthly
        stripePriceIdYearly
        previousPriceIds
      }
      subscriptionGifts {
        siteId
        productId
        priceId
        planProductId
        couponId
        numberOfGiftedMonths
        priceInCents
        isActive
      }
      subscriptionPromos {
        siteId
        couponId
        name
        percentageOff
        durationInMonths
      }
      donationProduct {
        siteId
        productId
        name
        isActive
        stripeDescription
        priceId
      }
    }
    connectedGoogleAdsAccount {
      adClient
      verticalAdSlot
      horizontalAdSlot
    }
    googleTagAds {
      verticalHeaderScript
      vertical2HeaderScript
      chatbotPrimaryHeaderScript
      chatbotSecondaryHeaderScript
      horizontal1HeaderScript
      horizontal2HeaderScript
      footerHeaderScript
      adHeroHeaderScript
      articleInContentHeaderScript
      videoHeaderScript
      stickyFooterHeaderScript
    }
    typesense {
      cmsKey
      siteKey
    }
    connectedGoogleAnalyticsAccount {
      gaMeasurementId
    }
    connectedMarfeelAnalyticsAccount {
      marfeelId
    }
    companyInfo {
      coordinates {
        lat
        lng
      }
      noaaGridPoint
      countyCode
      timeZone
      cityName
      mainPhoneNumber
      mainEmail
      supportPhoneNumber
      supportEmail
    }
    getMostViewedStories {
      items {
        blockCategory
        brandId
        createdAt
        gsk1
        id
        componentId
        pageId
        data {
          ...BlockDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        archivedAt
        version
        externalBlockIds
        slug
        listExternalBlocks {
          nextToken
          items {
            blockCategory
            brandId
            componentId
            createdAt
            data {
              ...BlockDataFragment
            }
            gsk1
            externalBlockIds
            id
            pageId
            savedAt
            siteId
            state
            updatedAt
            archivedAt
            sk
            variant
            version
            slug
          }
        }
      }
    }
    getWeatherData {
      currentWeather {
        temp
        date
        highTemp
        lowTemp
        summary
        img
      }
      weatherSlots {
        date
        highTemp
        lowTemp
        summary
        img
      }
      weatherAdvisory {
        message
        weatherSiteUrl
        instructions
        description
        timestamp
        expires
        id
      }
    }
    getAvailableNewsletters {
      id
      name
      siteId
      description
      order
    }
    listSitePageTemplates {
      items {
        pageTemplateCategory
        id
        sk
      }
    }
    listSiteBlockTemplates(pagination: {limit: 1000}) {
      items {
        blockCategory
        brandId
        componentId
        createdAt
        id
        data {
          ...BlockTemplateDataFragment
        }
        variant
        savedAt
        siteId
        sk
        state
        updatedAt
        version
        gsk1
      }
    }
    getPageBySlug(slug: $slug, status: {state: Latest}) {
      items {
        brandId
        getPageTemplate(status: {state: Latest}) {
          items {
            blockTemplates {
              ids
              slot
            }
            blockVariants {
              componentId
              defaultVariant
            }
            brandId
            createdAt
            id
            pageTemplateCategory
            componentId
            savedAt
            siteId
            sk
            updatedAt
            state
            version
          }
        }
        gsk1
        gsk2
        id
        listPageLocalBlocks(status: {state: Latest}, pagination: {limit: 1000}) {
          items {
            blockCategory
            brandId
            createdAt
            gsk1
            id
            componentId
            pageId
            data {
              ...BlockDataFragment
            }
            variant
            savedAt
            siteId
            sk
            state
            updatedAt
            archivedAt
            version
            externalBlockIds
            slug
            listExternalBlocks {
              nextToken
              items {
                blockCategory
                brandId
                componentId
                createdAt
                data {
                  ...BlockDataFragment
                }
                gsk1
                externalBlockIds
                id
                pageId
                savedAt
                siteId
                state
                updatedAt
                archivedAt
                sk
                variant
                version
                slug
              }
            }
          }
        }
        localBlockSlots {
          ids
          slot
        }
        listPageAdditionalBlocks {
          items {
            blockCategory
            componentId
            data {
              ...BlockDataFragment
            }
            id
            variant
            version
            state
            pageId
            createdAt
            sk
            updatedAt
            archivedAt
            brandId
            gsk1
            siteId
            listExternalBlocks {
              items {
                blockCategory
                brandId
                componentId
                createdAt
                data {
                  ...BlockDataFragment
                }
                gsk1
                externalBlockIds
                id
                pageId
                savedAt
                siteId
                state
                updatedAt
                archivedAt
                sk
                variant
                version
                slug
              }
            }
            slug
          }
          nextToken
        }
        pageCategory
        savedAt
        siteId
        sk
        slug
        state
        templateId
        updatedAt
        publishedAt
        version
        createdAt
        seoTitle
        seoDescription
        seoCanonical
        seoNoindex
        seoImageSrc
        seoImageWidth
        seoImageHeight
      }
    }
  }
}
    ${BlockDataFragmentFragmentDoc}
${BlockTemplateDataFragmentFragmentDoc}`;

/**
 * __useGetSitePageQuery__
 *
 * To run a query within a React component, call `useGetSitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSitePageQuery(baseOptions: Apollo.QueryHookOptions<GetSitePageQuery, GetSitePageQueryVariables> & ({ variables: GetSitePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitePageQuery, GetSitePageQueryVariables>(GetSitePageDocument, options);
      }
export function useGetSitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitePageQuery, GetSitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitePageQuery, GetSitePageQueryVariables>(GetSitePageDocument, options);
        }
// @ts-ignore
export function useGetSitePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSitePageQuery, GetSitePageQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitePageQuery, GetSitePageQueryVariables>;
export function useGetSitePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitePageQuery, GetSitePageQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitePageQuery | undefined, GetSitePageQueryVariables>;
export function useGetSitePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitePageQuery, GetSitePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSitePageQuery, GetSitePageQueryVariables>(GetSitePageDocument, options);
        }
export type GetSitePageQueryHookResult = ReturnType<typeof useGetSitePageQuery>;
export type GetSitePageLazyQueryHookResult = ReturnType<typeof useGetSitePageLazyQuery>;
export type GetSitePageSuspenseQueryHookResult = ReturnType<typeof useGetSitePageSuspenseQuery>;
export type GetSitePageQueryResult = Apollo.QueryResult<GetSitePageQuery, GetSitePageQueryVariables>;
export const GetSiteSubscriptionDocument = gql`
    query getSiteSubscription($id: ID!) {
  getSite(id: $id) {
    id
    name
    pubgenSubscription {
      id
      status
    }
  }
}
    `;

/**
 * __useGetSiteSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSiteSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSiteSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables> & ({ variables: GetSiteSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>(GetSiteSubscriptionDocument, options);
      }
export function useGetSiteSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>(GetSiteSubscriptionDocument, options);
        }
// @ts-ignore
export function useGetSiteSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>;
export function useGetSiteSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSubscriptionQuery | undefined, GetSiteSubscriptionQueryVariables>;
export function useGetSiteSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>(GetSiteSubscriptionDocument, options);
        }
export type GetSiteSubscriptionQueryHookResult = ReturnType<typeof useGetSiteSubscriptionQuery>;
export type GetSiteSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSiteSubscriptionLazyQuery>;
export type GetSiteSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSiteSubscriptionSuspenseQuery>;
export type GetSiteSubscriptionQueryResult = Apollo.QueryResult<GetSiteSubscriptionQuery, GetSiteSubscriptionQueryVariables>;
export const GetSiteWildcardRedirectsDocument = gql`
    query getSiteWildcardRedirects($siteId: ID!) {
  getSite(id: $siteId) {
    id
    name
    wildcardRedirects {
      id
      matchType
      source
      destination
      preserveSuffix
      preserveQuery
      permanent
      enabled
      priority
      note
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetSiteWildcardRedirectsQuery__
 *
 * To run a query within a React component, call `useGetSiteWildcardRedirectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteWildcardRedirectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteWildcardRedirectsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteWildcardRedirectsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables> & ({ variables: GetSiteWildcardRedirectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>(GetSiteWildcardRedirectsDocument, options);
      }
export function useGetSiteWildcardRedirectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>(GetSiteWildcardRedirectsDocument, options);
        }
// @ts-ignore
export function useGetSiteWildcardRedirectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>;
export function useGetSiteWildcardRedirectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteWildcardRedirectsQuery | undefined, GetSiteWildcardRedirectsQueryVariables>;
export function useGetSiteWildcardRedirectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>(GetSiteWildcardRedirectsDocument, options);
        }
export type GetSiteWildcardRedirectsQueryHookResult = ReturnType<typeof useGetSiteWildcardRedirectsQuery>;
export type GetSiteWildcardRedirectsLazyQueryHookResult = ReturnType<typeof useGetSiteWildcardRedirectsLazyQuery>;
export type GetSiteWildcardRedirectsSuspenseQueryHookResult = ReturnType<typeof useGetSiteWildcardRedirectsSuspenseQuery>;
export type GetSiteWildcardRedirectsQueryResult = Apollo.QueryResult<GetSiteWildcardRedirectsQuery, GetSiteWildcardRedirectsQueryVariables>;
export const GetSubscriberByIdDocument = gql`
    query getSubscriberById($siteId: ID!, $userId: ID!) {
  getSubscriberById(siteId: $siteId, userId: $userId) {
    id
    email
    legacyPassword
    legacyUsername
    phoneNumber
    siteId
    shippingAddress {
      firstName
      lastName
      address1
      address2
      city
      state
      zip
      country
    }
  }
}
    `;

/**
 * __useGetSubscriberByIdQuery__
 *
 * To run a query within a React component, call `useGetSubscriberByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriberByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriberByIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSubscriberByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables> & ({ variables: GetSubscriberByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>(GetSubscriberByIdDocument, options);
      }
export function useGetSubscriberByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>(GetSubscriberByIdDocument, options);
        }
// @ts-ignore
export function useGetSubscriberByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>;
export function useGetSubscriberByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriberByIdQuery | undefined, GetSubscriberByIdQueryVariables>;
export function useGetSubscriberByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>(GetSubscriberByIdDocument, options);
        }
export type GetSubscriberByIdQueryHookResult = ReturnType<typeof useGetSubscriberByIdQuery>;
export type GetSubscriberByIdLazyQueryHookResult = ReturnType<typeof useGetSubscriberByIdLazyQuery>;
export type GetSubscriberByIdSuspenseQueryHookResult = ReturnType<typeof useGetSubscriberByIdSuspenseQuery>;
export type GetSubscriberByIdQueryResult = Apollo.QueryResult<GetSubscriberByIdQuery, GetSubscriberByIdQueryVariables>;
export const GetSubscriberBySubscriptionIdAndPlanIdDocument = gql`
    query getSubscriberBySubscriptionIdAndPlanId($subscriptionId: ID!, $planId: ID!) {
  getSubscriberBySubscriptionIdAndPlanId(
    subscriptionId: $subscriptionId
    planId: $planId
  ) {
    id
    email
    legacyPassword
    legacyUsername
    phoneNumber
    siteId
    shippingAddress {
      firstName
      lastName
      address1
      address2
      city
      state
      zip
      country
    }
  }
}
    `;

/**
 * __useGetSubscriberBySubscriptionIdAndPlanIdQuery__
 *
 * To run a query within a React component, call `useGetSubscriberBySubscriptionIdAndPlanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriberBySubscriptionIdAndPlanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriberBySubscriptionIdAndPlanIdQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useGetSubscriberBySubscriptionIdAndPlanIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables> & ({ variables: GetSubscriberBySubscriptionIdAndPlanIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>(GetSubscriberBySubscriptionIdAndPlanIdDocument, options);
      }
export function useGetSubscriberBySubscriptionIdAndPlanIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>(GetSubscriberBySubscriptionIdAndPlanIdDocument, options);
        }
// @ts-ignore
export function useGetSubscriberBySubscriptionIdAndPlanIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>;
export function useGetSubscriberBySubscriptionIdAndPlanIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriberBySubscriptionIdAndPlanIdQuery | undefined, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>;
export function useGetSubscriberBySubscriptionIdAndPlanIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>(GetSubscriberBySubscriptionIdAndPlanIdDocument, options);
        }
export type GetSubscriberBySubscriptionIdAndPlanIdQueryHookResult = ReturnType<typeof useGetSubscriberBySubscriptionIdAndPlanIdQuery>;
export type GetSubscriberBySubscriptionIdAndPlanIdLazyQueryHookResult = ReturnType<typeof useGetSubscriberBySubscriptionIdAndPlanIdLazyQuery>;
export type GetSubscriberBySubscriptionIdAndPlanIdSuspenseQueryHookResult = ReturnType<typeof useGetSubscriberBySubscriptionIdAndPlanIdSuspenseQuery>;
export type GetSubscriberBySubscriptionIdAndPlanIdQueryResult = Apollo.QueryResult<GetSubscriberBySubscriptionIdAndPlanIdQuery, GetSubscriberBySubscriptionIdAndPlanIdQueryVariables>;
export const GetTimezoneDocument = gql`
    query getTimezone($id: ID!) {
  getSite(id: $id) {
    id
    companyInfo {
      timeZone
    }
  }
}
    `;

/**
 * __useGetTimezoneQuery__
 *
 * To run a query within a React component, call `useGetTimezoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimezoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimezoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimezoneQuery(baseOptions: Apollo.QueryHookOptions<GetTimezoneQuery, GetTimezoneQueryVariables> & ({ variables: GetTimezoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimezoneQuery, GetTimezoneQueryVariables>(GetTimezoneDocument, options);
      }
export function useGetTimezoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimezoneQuery, GetTimezoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimezoneQuery, GetTimezoneQueryVariables>(GetTimezoneDocument, options);
        }
// @ts-ignore
export function useGetTimezoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimezoneQuery, GetTimezoneQueryVariables>): Apollo.UseSuspenseQueryResult<GetTimezoneQuery, GetTimezoneQueryVariables>;
export function useGetTimezoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimezoneQuery, GetTimezoneQueryVariables>): Apollo.UseSuspenseQueryResult<GetTimezoneQuery | undefined, GetTimezoneQueryVariables>;
export function useGetTimezoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimezoneQuery, GetTimezoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimezoneQuery, GetTimezoneQueryVariables>(GetTimezoneDocument, options);
        }
export type GetTimezoneQueryHookResult = ReturnType<typeof useGetTimezoneQuery>;
export type GetTimezoneLazyQueryHookResult = ReturnType<typeof useGetTimezoneLazyQuery>;
export type GetTimezoneSuspenseQueryHookResult = ReturnType<typeof useGetTimezoneSuspenseQuery>;
export type GetTimezoneQueryResult = Apollo.QueryResult<GetTimezoneQuery, GetTimezoneQueryVariables>;
export const GetTopBlocksByEventForSiteDocument = gql`
    query getTopBlocksByEventForSite($params: GetTopBlocksByEventForSiteParams!) {
  getTopBlocksByEventForSite(params: $params) {
    topBlocks {
      blockId
      count
    }
  }
}
    `;

/**
 * __useGetTopBlocksByEventForSiteQuery__
 *
 * To run a query within a React component, call `useGetTopBlocksByEventForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopBlocksByEventForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopBlocksByEventForSiteQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTopBlocksByEventForSiteQuery(baseOptions: Apollo.QueryHookOptions<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables> & ({ variables: GetTopBlocksByEventForSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>(GetTopBlocksByEventForSiteDocument, options);
      }
export function useGetTopBlocksByEventForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>(GetTopBlocksByEventForSiteDocument, options);
        }
// @ts-ignore
export function useGetTopBlocksByEventForSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>;
export function useGetTopBlocksByEventForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopBlocksByEventForSiteQuery | undefined, GetTopBlocksByEventForSiteQueryVariables>;
export function useGetTopBlocksByEventForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>(GetTopBlocksByEventForSiteDocument, options);
        }
export type GetTopBlocksByEventForSiteQueryHookResult = ReturnType<typeof useGetTopBlocksByEventForSiteQuery>;
export type GetTopBlocksByEventForSiteLazyQueryHookResult = ReturnType<typeof useGetTopBlocksByEventForSiteLazyQuery>;
export type GetTopBlocksByEventForSiteSuspenseQueryHookResult = ReturnType<typeof useGetTopBlocksByEventForSiteSuspenseQuery>;
export type GetTopBlocksByEventForSiteQueryResult = Apollo.QueryResult<GetTopBlocksByEventForSiteQuery, GetTopBlocksByEventForSiteQueryVariables>;
export const GetTopPagesByConversionEventDocument = gql`
    query getTopPagesByConversionEvent($params: GetTopPagesByConversionEventParams!) {
  getTopPagesByConversionEvent(params: $params) {
    topPages {
      url
      count
    }
  }
}
    `;

/**
 * __useGetTopPagesByConversionEventQuery__
 *
 * To run a query within a React component, call `useGetTopPagesByConversionEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopPagesByConversionEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopPagesByConversionEventQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTopPagesByConversionEventQuery(baseOptions: Apollo.QueryHookOptions<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables> & ({ variables: GetTopPagesByConversionEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>(GetTopPagesByConversionEventDocument, options);
      }
export function useGetTopPagesByConversionEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>(GetTopPagesByConversionEventDocument, options);
        }
// @ts-ignore
export function useGetTopPagesByConversionEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>;
export function useGetTopPagesByConversionEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopPagesByConversionEventQuery | undefined, GetTopPagesByConversionEventQueryVariables>;
export function useGetTopPagesByConversionEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>(GetTopPagesByConversionEventDocument, options);
        }
export type GetTopPagesByConversionEventQueryHookResult = ReturnType<typeof useGetTopPagesByConversionEventQuery>;
export type GetTopPagesByConversionEventLazyQueryHookResult = ReturnType<typeof useGetTopPagesByConversionEventLazyQuery>;
export type GetTopPagesByConversionEventSuspenseQueryHookResult = ReturnType<typeof useGetTopPagesByConversionEventSuspenseQuery>;
export type GetTopPagesByConversionEventQueryResult = Apollo.QueryResult<GetTopPagesByConversionEventQuery, GetTopPagesByConversionEventQueryVariables>;
export const GetTypesenseKeyDocument = gql`
    query getTypesenseKey($id: ID!) {
  getSite(id: $id) {
    id
    typesense {
      cmsKey
      siteKey
    }
  }
}
    `;

/**
 * __useGetTypesenseKeyQuery__
 *
 * To run a query within a React component, call `useGetTypesenseKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTypesenseKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTypesenseKeyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTypesenseKeyQuery(baseOptions: Apollo.QueryHookOptions<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables> & ({ variables: GetTypesenseKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>(GetTypesenseKeyDocument, options);
      }
export function useGetTypesenseKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>(GetTypesenseKeyDocument, options);
        }
// @ts-ignore
export function useGetTypesenseKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>;
export function useGetTypesenseKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetTypesenseKeyQuery | undefined, GetTypesenseKeyQueryVariables>;
export function useGetTypesenseKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>(GetTypesenseKeyDocument, options);
        }
export type GetTypesenseKeyQueryHookResult = ReturnType<typeof useGetTypesenseKeyQuery>;
export type GetTypesenseKeyLazyQueryHookResult = ReturnType<typeof useGetTypesenseKeyLazyQuery>;
export type GetTypesenseKeySuspenseQueryHookResult = ReturnType<typeof useGetTypesenseKeySuspenseQuery>;
export type GetTypesenseKeyQueryResult = Apollo.QueryResult<GetTypesenseKeyQuery, GetTypesenseKeyQueryVariables>;
export const GetUserByDomainDocument = gql`
    query getUserByDomain($path: String!, $domain: String!, $username: ID!) {
  getWorkspaceByDomain(domain: $domain) {
    getBrandByPath(path: $path) {
      id
      name
      path
    }
    domainName
    id
    name
    version
    updatedAt
    subdomain
    getWorkspaceUser(username: $username) {
      createdAt
      brandGroups {
        brandId
        groups
      }
      id
      updatedAt
      username
      version
      workspaceGroups
      workspaceId
      firstName
      lastName
      isConfirmed
    }
  }
}
    `;

/**
 * __useGetUserByDomainQuery__
 *
 * To run a query within a React component, call `useGetUserByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByDomainQuery({
 *   variables: {
 *      path: // value for 'path'
 *      domain: // value for 'domain'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUserByDomainQuery(baseOptions: Apollo.QueryHookOptions<GetUserByDomainQuery, GetUserByDomainQueryVariables> & ({ variables: GetUserByDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByDomainQuery, GetUserByDomainQueryVariables>(GetUserByDomainDocument, options);
      }
export function useGetUserByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByDomainQuery, GetUserByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByDomainQuery, GetUserByDomainQueryVariables>(GetUserByDomainDocument, options);
        }
// @ts-ignore
export function useGetUserByDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByDomainQuery, GetUserByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByDomainQuery, GetUserByDomainQueryVariables>;
export function useGetUserByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByDomainQuery, GetUserByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByDomainQuery | undefined, GetUserByDomainQueryVariables>;
export function useGetUserByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByDomainQuery, GetUserByDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByDomainQuery, GetUserByDomainQueryVariables>(GetUserByDomainDocument, options);
        }
export type GetUserByDomainQueryHookResult = ReturnType<typeof useGetUserByDomainQuery>;
export type GetUserByDomainLazyQueryHookResult = ReturnType<typeof useGetUserByDomainLazyQuery>;
export type GetUserByDomainSuspenseQueryHookResult = ReturnType<typeof useGetUserByDomainSuspenseQuery>;
export type GetUserByDomainQueryResult = Apollo.QueryResult<GetUserByDomainQuery, GetUserByDomainQueryVariables>;
export const GetWorkspaceByDomainDocument = gql`
    query getWorkspaceByDomain($domain: String!) {
  getWorkspaceByDomain(domain: $domain) {
    listWorkspaceBrands(pagination: {limit: 1000}) {
      nextToken
      items {
        name
        path
        id
        listBrandSites {
          items {
            id
            name
            domainName
            pubgenSubscription {
              id
              status
            }
            domain {
              createdAt
              domainCloudFormation
              domainCloudfront
              domainName
              externalProvider
              hostedZoneId
              nameServers
              operationId
              siteId
              status
              updatedAt
              workspaceId
            }
          }
        }
      }
    }
    id
    name
    subdomain
    language
    tollbitAnalytics {
      bucketName
      bucketRegion
      createdAt
      updatedAt
    }
    updatedAt
    version
  }
}
    `;

/**
 * __useGetWorkspaceByDomainQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetWorkspaceByDomainQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables> & ({ variables: GetWorkspaceByDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>(GetWorkspaceByDomainDocument, options);
      }
export function useGetWorkspaceByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>(GetWorkspaceByDomainDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceByDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>;
export function useGetWorkspaceByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceByDomainQuery | undefined, GetWorkspaceByDomainQueryVariables>;
export function useGetWorkspaceByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>(GetWorkspaceByDomainDocument, options);
        }
export type GetWorkspaceByDomainQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainQuery>;
export type GetWorkspaceByDomainLazyQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainLazyQuery>;
export type GetWorkspaceByDomainSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainSuspenseQuery>;
export type GetWorkspaceByDomainQueryResult = Apollo.QueryResult<GetWorkspaceByDomainQuery, GetWorkspaceByDomainQueryVariables>;
export const GetWorkspaceByDomainWithUserDocument = gql`
    query getWorkspaceByDomainWithUser($domain: String!, $username: ID!) {
  getWorkspaceByDomain(domain: $domain) {
    listWorkspaceBrands(pagination: {limit: 1000}) {
      nextToken
      items {
        name
        path
        id
        listBrandSites {
          items {
            id
            name
            domainName
            pubgenSubscription {
              id
              status
            }
          }
        }
      }
    }
    id
    name
    subdomain
    tollbitAnalytics {
      bucketName
      bucketRegion
      createdAt
      updatedAt
    }
    updatedAt
    version
    getWorkspaceUser(username: $username) {
      brandGroups {
        brandId
        groups
      }
      createdAt
      firstName
      id
      isConfirmed
      lastName
      updatedAt
      username
      version
      workspaceGroups
      workspaceId
    }
  }
}
    `;

/**
 * __useGetWorkspaceByDomainWithUserQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceByDomainWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceByDomainWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceByDomainWithUserQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetWorkspaceByDomainWithUserQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables> & ({ variables: GetWorkspaceByDomainWithUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>(GetWorkspaceByDomainWithUserDocument, options);
      }
export function useGetWorkspaceByDomainWithUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>(GetWorkspaceByDomainWithUserDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceByDomainWithUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>;
export function useGetWorkspaceByDomainWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceByDomainWithUserQuery | undefined, GetWorkspaceByDomainWithUserQueryVariables>;
export function useGetWorkspaceByDomainWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>(GetWorkspaceByDomainWithUserDocument, options);
        }
export type GetWorkspaceByDomainWithUserQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainWithUserQuery>;
export type GetWorkspaceByDomainWithUserLazyQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainWithUserLazyQuery>;
export type GetWorkspaceByDomainWithUserSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainWithUserSuspenseQuery>;
export type GetWorkspaceByDomainWithUserQueryResult = Apollo.QueryResult<GetWorkspaceByDomainWithUserQuery, GetWorkspaceByDomainWithUserQueryVariables>;
export const GetWorkspaceByDomainWithUserAndFeedsDocument = gql`
    query getWorkspaceByDomainWithUserAndFeeds($domain: String!, $username: ID!) {
  getWorkspaceByDomain(domain: $domain) {
    listFeeds(pagination: {limit: 1000}) {
      nextToken
      items {
        id
        name
        description
      }
    }
    listWorkspaceBrands(pagination: {limit: 1000}) {
      nextToken
      items {
        name
        path
        id
        listBrandSites {
          items {
            id
            name
            domainName
            pubgenSubscription {
              id
              status
            }
          }
        }
      }
    }
    id
    name
    subdomain
    updatedAt
    version
    getWorkspaceUser(username: $username) {
      brandGroups {
        brandId
        groups
      }
      createdAt
      firstName
      id
      isConfirmed
      lastName
      updatedAt
      username
      version
      workspaceGroups
      workspaceId
    }
  }
}
    `;

/**
 * __useGetWorkspaceByDomainWithUserAndFeedsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceByDomainWithUserAndFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceByDomainWithUserAndFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceByDomainWithUserAndFeedsQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetWorkspaceByDomainWithUserAndFeedsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables> & ({ variables: GetWorkspaceByDomainWithUserAndFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>(GetWorkspaceByDomainWithUserAndFeedsDocument, options);
      }
export function useGetWorkspaceByDomainWithUserAndFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>(GetWorkspaceByDomainWithUserAndFeedsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceByDomainWithUserAndFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>;
export function useGetWorkspaceByDomainWithUserAndFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceByDomainWithUserAndFeedsQuery | undefined, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>;
export function useGetWorkspaceByDomainWithUserAndFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>(GetWorkspaceByDomainWithUserAndFeedsDocument, options);
        }
export type GetWorkspaceByDomainWithUserAndFeedsQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainWithUserAndFeedsQuery>;
export type GetWorkspaceByDomainWithUserAndFeedsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainWithUserAndFeedsLazyQuery>;
export type GetWorkspaceByDomainWithUserAndFeedsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceByDomainWithUserAndFeedsSuspenseQuery>;
export type GetWorkspaceByDomainWithUserAndFeedsQueryResult = Apollo.QueryResult<GetWorkspaceByDomainWithUserAndFeedsQuery, GetWorkspaceByDomainWithUserAndFeedsQueryVariables>;
export const ListApNewsTopicsDocument = gql`
    query listAPNewsTopics($siteId: ID!) {
  listAPNewsTopics(siteId: $siteId) {
    items {
      id
      name
      pricing
      feedLink
      active
      sectionId
      publishStatus
      paywall
      display
      imgRequired
    }
  }
}
    `;

/**
 * __useListApNewsTopicsQuery__
 *
 * To run a query within a React component, call `useListApNewsTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApNewsTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApNewsTopicsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListApNewsTopicsQuery(baseOptions: Apollo.QueryHookOptions<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables> & ({ variables: ListApNewsTopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>(ListApNewsTopicsDocument, options);
      }
export function useListApNewsTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>(ListApNewsTopicsDocument, options);
        }
// @ts-ignore
export function useListApNewsTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>;
export function useListApNewsTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<ListApNewsTopicsQuery | undefined, ListApNewsTopicsQueryVariables>;
export function useListApNewsTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>(ListApNewsTopicsDocument, options);
        }
export type ListApNewsTopicsQueryHookResult = ReturnType<typeof useListApNewsTopicsQuery>;
export type ListApNewsTopicsLazyQueryHookResult = ReturnType<typeof useListApNewsTopicsLazyQuery>;
export type ListApNewsTopicsSuspenseQueryHookResult = ReturnType<typeof useListApNewsTopicsSuspenseQuery>;
export type ListApNewsTopicsQueryResult = Apollo.QueryResult<ListApNewsTopicsQuery, ListApNewsTopicsQueryVariables>;
export const ListCollectionItemsDocument = gql`
    query listCollectionItems($siteId: ID!, $collectionId: ID!, $pagination: PaginationInput) {
  listCollectionItems(
    siteId: $siteId
    collectionId: $collectionId
    pagination: $pagination
  ) {
    items {
      name
      assetKey
      siteId
      assetId
      collectionId
      credit
      caption
      alt
      width
      height
      createdAt
      updatedAt
      metadata
    }
    nextToken
  }
}
    `;

/**
 * __useListCollectionItemsQuery__
 *
 * To run a query within a React component, call `useListCollectionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCollectionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCollectionItemsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      collectionId: // value for 'collectionId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListCollectionItemsQuery(baseOptions: Apollo.QueryHookOptions<ListCollectionItemsQuery, ListCollectionItemsQueryVariables> & ({ variables: ListCollectionItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>(ListCollectionItemsDocument, options);
      }
export function useListCollectionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>(ListCollectionItemsDocument, options);
        }
// @ts-ignore
export function useListCollectionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>): Apollo.UseSuspenseQueryResult<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>;
export function useListCollectionItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>): Apollo.UseSuspenseQueryResult<ListCollectionItemsQuery | undefined, ListCollectionItemsQueryVariables>;
export function useListCollectionItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>(ListCollectionItemsDocument, options);
        }
export type ListCollectionItemsQueryHookResult = ReturnType<typeof useListCollectionItemsQuery>;
export type ListCollectionItemsLazyQueryHookResult = ReturnType<typeof useListCollectionItemsLazyQuery>;
export type ListCollectionItemsSuspenseQueryHookResult = ReturnType<typeof useListCollectionItemsSuspenseQuery>;
export type ListCollectionItemsQueryResult = Apollo.QueryResult<ListCollectionItemsQuery, ListCollectionItemsQueryVariables>;
export const ListCollectionsDocument = gql`
    query listCollections($siteId: ID!, $pagination: PaginationInput) {
  listCollections(siteId: $siteId, pagination: $pagination) {
    items {
      collectionId
      name
      siteId
      getCollectionLength
      createdAt
      updatedAt
      listCollectionItems(pagination: {limit: 1}) {
        items {
          name
          assetKey
          siteId
          assetId
          collectionId
          credit
          caption
          alt
          width
          height
          createdAt
          updatedAt
          metadata
        }
      }
    }
  }
}
    `;

/**
 * __useListCollectionsQuery__
 *
 * To run a query within a React component, call `useListCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCollectionsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListCollectionsQuery(baseOptions: Apollo.QueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables> & ({ variables: ListCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, options);
      }
export function useListCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, options);
        }
// @ts-ignore
export function useListCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListCollectionsQuery, ListCollectionsQueryVariables>;
export function useListCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListCollectionsQuery | undefined, ListCollectionsQueryVariables>;
export function useListCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, options);
        }
export type ListCollectionsQueryHookResult = ReturnType<typeof useListCollectionsQuery>;
export type ListCollectionsLazyQueryHookResult = ReturnType<typeof useListCollectionsLazyQuery>;
export type ListCollectionsSuspenseQueryHookResult = ReturnType<typeof useListCollectionsSuspenseQuery>;
export type ListCollectionsQueryResult = Apollo.QueryResult<ListCollectionsQuery, ListCollectionsQueryVariables>;
export const ListContactsDocument = gql`
    query listContacts($siteId: ID!, $segmentId: ID, $pagination: PaginationInput) {
  listContacts(siteId: $siteId, segmentId: $segmentId, pagination: $pagination) {
    items {
      id
      siteId
      email
      firstName
      lastName
      tags
      subscribedNewsletterIds
      status
      source
      unsubscribeToken
      lifecycle {
        signedInAt
        planStatus
        subscribedAt
        cancelledAt
        lastDonationAt
        lastDonationCents
        totalDonationCents
      }
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `;

/**
 * __useListContactsQuery__
 *
 * To run a query within a React component, call `useListContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      segmentId: // value for 'segmentId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListContactsQuery(baseOptions: Apollo.QueryHookOptions<ListContactsQuery, ListContactsQueryVariables> & ({ variables: ListContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
      }
export function useListContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
// @ts-ignore
export function useListContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>): Apollo.UseSuspenseQueryResult<ListContactsQuery, ListContactsQueryVariables>;
export function useListContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>): Apollo.UseSuspenseQueryResult<ListContactsQuery | undefined, ListContactsQueryVariables>;
export function useListContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
export type ListContactsQueryHookResult = ReturnType<typeof useListContactsQuery>;
export type ListContactsLazyQueryHookResult = ReturnType<typeof useListContactsLazyQuery>;
export type ListContactsSuspenseQueryHookResult = ReturnType<typeof useListContactsSuspenseQuery>;
export type ListContactsQueryResult = Apollo.QueryResult<ListContactsQuery, ListContactsQueryVariables>;
export const ListContactEventsDocument = gql`
    query listContactEvents($siteId: ID!, $email: String!, $pagination: PaginationInput) {
  listContactEvents(siteId: $siteId, email: $email, pagination: $pagination) {
    items {
      id
      type
      occurredAt
      metadata
      createdAt
    }
    nextToken
  }
}
    `;

/**
 * __useListContactEventsQuery__
 *
 * To run a query within a React component, call `useListContactEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactEventsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      email: // value for 'email'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListContactEventsQuery(baseOptions: Apollo.QueryHookOptions<ListContactEventsQuery, ListContactEventsQueryVariables> & ({ variables: ListContactEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactEventsQuery, ListContactEventsQueryVariables>(ListContactEventsDocument, options);
      }
export function useListContactEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactEventsQuery, ListContactEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactEventsQuery, ListContactEventsQueryVariables>(ListContactEventsDocument, options);
        }
// @ts-ignore
export function useListContactEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListContactEventsQuery, ListContactEventsQueryVariables>): Apollo.UseSuspenseQueryResult<ListContactEventsQuery, ListContactEventsQueryVariables>;
export function useListContactEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContactEventsQuery, ListContactEventsQueryVariables>): Apollo.UseSuspenseQueryResult<ListContactEventsQuery | undefined, ListContactEventsQueryVariables>;
export function useListContactEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContactEventsQuery, ListContactEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListContactEventsQuery, ListContactEventsQueryVariables>(ListContactEventsDocument, options);
        }
export type ListContactEventsQueryHookResult = ReturnType<typeof useListContactEventsQuery>;
export type ListContactEventsLazyQueryHookResult = ReturnType<typeof useListContactEventsLazyQuery>;
export type ListContactEventsSuspenseQueryHookResult = ReturnType<typeof useListContactEventsSuspenseQuery>;
export type ListContactEventsQueryResult = Apollo.QueryResult<ListContactEventsQuery, ListContactEventsQueryVariables>;
export const ListContextTemplatesDocument = gql`
    query listContextTemplates($siteId: ID!) {
  listContextTemplates(siteId: $siteId) {
    siteId
    id
    name
    content
    active
  }
}
    `;

/**
 * __useListContextTemplatesQuery__
 *
 * To run a query within a React component, call `useListContextTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContextTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContextTemplatesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListContextTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListContextTemplatesQuery, ListContextTemplatesQueryVariables> & ({ variables: ListContextTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>(ListContextTemplatesDocument, options);
      }
export function useListContextTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>(ListContextTemplatesDocument, options);
        }
// @ts-ignore
export function useListContextTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>;
export function useListContextTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ListContextTemplatesQuery | undefined, ListContextTemplatesQueryVariables>;
export function useListContextTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>(ListContextTemplatesDocument, options);
        }
export type ListContextTemplatesQueryHookResult = ReturnType<typeof useListContextTemplatesQuery>;
export type ListContextTemplatesLazyQueryHookResult = ReturnType<typeof useListContextTemplatesLazyQuery>;
export type ListContextTemplatesSuspenseQueryHookResult = ReturnType<typeof useListContextTemplatesSuspenseQuery>;
export type ListContextTemplatesQueryResult = Apollo.QueryResult<ListContextTemplatesQuery, ListContextTemplatesQueryVariables>;
export const QueryListExternalFeedsDocument = gql`
    query queryListExternalFeeds($siteId: ID!) {
  listExternalFeeds(siteId: $siteId) {
    items {
      id
      name
      url
      parserType
      active
      activatedAt
      publishStatus
      paywall
      display
      sectionId
      imgRequired
      lastImportedAt
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useQueryListExternalFeedsQuery__
 *
 * To run a query within a React component, call `useQueryListExternalFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryListExternalFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryListExternalFeedsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useQueryListExternalFeedsQuery(baseOptions: Apollo.QueryHookOptions<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables> & ({ variables: QueryListExternalFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>(QueryListExternalFeedsDocument, options);
      }
export function useQueryListExternalFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>(QueryListExternalFeedsDocument, options);
        }
// @ts-ignore
export function useQueryListExternalFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>;
export function useQueryListExternalFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<QueryListExternalFeedsQuery | undefined, QueryListExternalFeedsQueryVariables>;
export function useQueryListExternalFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>(QueryListExternalFeedsDocument, options);
        }
export type QueryListExternalFeedsQueryHookResult = ReturnType<typeof useQueryListExternalFeedsQuery>;
export type QueryListExternalFeedsLazyQueryHookResult = ReturnType<typeof useQueryListExternalFeedsLazyQuery>;
export type QueryListExternalFeedsSuspenseQueryHookResult = ReturnType<typeof useQueryListExternalFeedsSuspenseQuery>;
export type QueryListExternalFeedsQueryResult = Apollo.QueryResult<QueryListExternalFeedsQuery, QueryListExternalFeedsQueryVariables>;
export const ListFeaturedChatbotPromptsDocument = gql`
    query listFeaturedChatbotPrompts($siteId: ID!) {
  listFeaturedChatbotPrompts(siteId: $siteId) {
    siteId
    id
    prompt
    active
    label
    category
    pageType
  }
}
    `;

/**
 * __useListFeaturedChatbotPromptsQuery__
 *
 * To run a query within a React component, call `useListFeaturedChatbotPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeaturedChatbotPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeaturedChatbotPromptsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListFeaturedChatbotPromptsQuery(baseOptions: Apollo.QueryHookOptions<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables> & ({ variables: ListFeaturedChatbotPromptsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>(ListFeaturedChatbotPromptsDocument, options);
      }
export function useListFeaturedChatbotPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>(ListFeaturedChatbotPromptsDocument, options);
        }
// @ts-ignore
export function useListFeaturedChatbotPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>;
export function useListFeaturedChatbotPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeaturedChatbotPromptsQuery | undefined, ListFeaturedChatbotPromptsQueryVariables>;
export function useListFeaturedChatbotPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>(ListFeaturedChatbotPromptsDocument, options);
        }
export type ListFeaturedChatbotPromptsQueryHookResult = ReturnType<typeof useListFeaturedChatbotPromptsQuery>;
export type ListFeaturedChatbotPromptsLazyQueryHookResult = ReturnType<typeof useListFeaturedChatbotPromptsLazyQuery>;
export type ListFeaturedChatbotPromptsSuspenseQueryHookResult = ReturnType<typeof useListFeaturedChatbotPromptsSuspenseQuery>;
export type ListFeaturedChatbotPromptsQueryResult = Apollo.QueryResult<ListFeaturedChatbotPromptsQuery, ListFeaturedChatbotPromptsQueryVariables>;
export const ListFeedSiteSubscriptionsDocument = gql`
    query listFeedSiteSubscriptions($siteId: ID!, $pagination: PaginationInput) {
  listFeedSiteSubscriptions(siteId: $siteId, pagination: $pagination) {
    items {
      workspaceId
      feedId
      siteId
      active
      name
      description
      publishStatus
      paywall
      section
      createdAt
      updatedAt
      tags
    }
    nextToken
  }
}
    `;

/**
 * __useListFeedSiteSubscriptionsQuery__
 *
 * To run a query within a React component, call `useListFeedSiteSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeedSiteSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeedSiteSubscriptionsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListFeedSiteSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables> & ({ variables: ListFeedSiteSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>(ListFeedSiteSubscriptionsDocument, options);
      }
export function useListFeedSiteSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>(ListFeedSiteSubscriptionsDocument, options);
        }
// @ts-ignore
export function useListFeedSiteSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>;
export function useListFeedSiteSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeedSiteSubscriptionsQuery | undefined, ListFeedSiteSubscriptionsQueryVariables>;
export function useListFeedSiteSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>(ListFeedSiteSubscriptionsDocument, options);
        }
export type ListFeedSiteSubscriptionsQueryHookResult = ReturnType<typeof useListFeedSiteSubscriptionsQuery>;
export type ListFeedSiteSubscriptionsLazyQueryHookResult = ReturnType<typeof useListFeedSiteSubscriptionsLazyQuery>;
export type ListFeedSiteSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useListFeedSiteSubscriptionsSuspenseQuery>;
export type ListFeedSiteSubscriptionsQueryResult = Apollo.QueryResult<ListFeedSiteSubscriptionsQuery, ListFeedSiteSubscriptionsQueryVariables>;
export const ListFeedStoriesDocument = gql`
    query listFeedStories($feedId: ID!, $pagination: PaginationInput) {
  listFeedStories(feedId: $feedId, pagination: $pagination) {
    items {
      feedId
      pageId
      articleData
      releaseDateOverride
      displayOverride
      source {
        siteId
        brandId
        brandName
        brandPath
      }
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `;

/**
 * __useListFeedStoriesQuery__
 *
 * To run a query within a React component, call `useListFeedStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeedStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeedStoriesQuery({
 *   variables: {
 *      feedId: // value for 'feedId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListFeedStoriesQuery(baseOptions: Apollo.QueryHookOptions<ListFeedStoriesQuery, ListFeedStoriesQueryVariables> & ({ variables: ListFeedStoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>(ListFeedStoriesDocument, options);
      }
export function useListFeedStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>(ListFeedStoriesDocument, options);
        }
// @ts-ignore
export function useListFeedStoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>;
export function useListFeedStoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeedStoriesQuery | undefined, ListFeedStoriesQueryVariables>;
export function useListFeedStoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>(ListFeedStoriesDocument, options);
        }
export type ListFeedStoriesQueryHookResult = ReturnType<typeof useListFeedStoriesQuery>;
export type ListFeedStoriesLazyQueryHookResult = ReturnType<typeof useListFeedStoriesLazyQuery>;
export type ListFeedStoriesSuspenseQueryHookResult = ReturnType<typeof useListFeedStoriesSuspenseQuery>;
export type ListFeedStoriesQueryResult = Apollo.QueryResult<ListFeedStoriesQuery, ListFeedStoriesQueryVariables>;
export const ListFeedsDocument = gql`
    query listFeeds($workspaceId: ID!, $pagination: PaginationInput!) {
  listFeeds(workspaceId: $workspaceId, pagination: $pagination) {
    items {
      id
      workspaceId
      name
      description
      createdAt
      updatedAt
      webhooks {
        url
        active
      }
      filters {
        pattern
        active
      }
    }
    nextToken
  }
}
    `;

/**
 * __useListFeedsQuery__
 *
 * To run a query within a React component, call `useListFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeedsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListFeedsQuery(baseOptions: Apollo.QueryHookOptions<ListFeedsQuery, ListFeedsQueryVariables> & ({ variables: ListFeedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeedsQuery, ListFeedsQueryVariables>(ListFeedsDocument, options);
      }
export function useListFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeedsQuery, ListFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeedsQuery, ListFeedsQueryVariables>(ListFeedsDocument, options);
        }
// @ts-ignore
export function useListFeedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFeedsQuery, ListFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeedsQuery, ListFeedsQueryVariables>;
export function useListFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeedsQuery, ListFeedsQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeedsQuery | undefined, ListFeedsQueryVariables>;
export function useListFeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeedsQuery, ListFeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFeedsQuery, ListFeedsQueryVariables>(ListFeedsDocument, options);
        }
export type ListFeedsQueryHookResult = ReturnType<typeof useListFeedsQuery>;
export type ListFeedsLazyQueryHookResult = ReturnType<typeof useListFeedsLazyQuery>;
export type ListFeedsSuspenseQueryHookResult = ReturnType<typeof useListFeedsSuspenseQuery>;
export type ListFeedsQueryResult = Apollo.QueryResult<ListFeedsQuery, ListFeedsQueryVariables>;
export const ListMailchimpListsDocument = gql`
    query listMailchimpLists($siteId: ID!) {
  listMailchimpLists(siteId: $siteId) {
    name
    id
  }
}
    `;

/**
 * __useListMailchimpListsQuery__
 *
 * To run a query within a React component, call `useListMailchimpListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMailchimpListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMailchimpListsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListMailchimpListsQuery(baseOptions: Apollo.QueryHookOptions<ListMailchimpListsQuery, ListMailchimpListsQueryVariables> & ({ variables: ListMailchimpListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>(ListMailchimpListsDocument, options);
      }
export function useListMailchimpListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>(ListMailchimpListsDocument, options);
        }
// @ts-ignore
export function useListMailchimpListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>;
export function useListMailchimpListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMailchimpListsQuery | undefined, ListMailchimpListsQueryVariables>;
export function useListMailchimpListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>(ListMailchimpListsDocument, options);
        }
export type ListMailchimpListsQueryHookResult = ReturnType<typeof useListMailchimpListsQuery>;
export type ListMailchimpListsLazyQueryHookResult = ReturnType<typeof useListMailchimpListsLazyQuery>;
export type ListMailchimpListsSuspenseQueryHookResult = ReturnType<typeof useListMailchimpListsSuspenseQuery>;
export type ListMailchimpListsQueryResult = Apollo.QueryResult<ListMailchimpListsQuery, ListMailchimpListsQueryVariables>;
export const ListNewslettersDocument = gql`
    query listNewsletters($siteId: ID!) {
  listNewsletters(siteId: $siteId) {
    id
    name
    description
    siteId
    order
    kind
    status
    provider
    publicVisibility
    publicOrder
  }
}
    `;

/**
 * __useListNewslettersQuery__
 *
 * To run a query within a React component, call `useListNewslettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNewslettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNewslettersQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListNewslettersQuery(baseOptions: Apollo.QueryHookOptions<ListNewslettersQuery, ListNewslettersQueryVariables> & ({ variables: ListNewslettersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNewslettersQuery, ListNewslettersQueryVariables>(ListNewslettersDocument, options);
      }
export function useListNewslettersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNewslettersQuery, ListNewslettersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNewslettersQuery, ListNewslettersQueryVariables>(ListNewslettersDocument, options);
        }
// @ts-ignore
export function useListNewslettersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListNewslettersQuery, ListNewslettersQueryVariables>): Apollo.UseSuspenseQueryResult<ListNewslettersQuery, ListNewslettersQueryVariables>;
export function useListNewslettersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListNewslettersQuery, ListNewslettersQueryVariables>): Apollo.UseSuspenseQueryResult<ListNewslettersQuery | undefined, ListNewslettersQueryVariables>;
export function useListNewslettersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListNewslettersQuery, ListNewslettersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListNewslettersQuery, ListNewslettersQueryVariables>(ListNewslettersDocument, options);
        }
export type ListNewslettersQueryHookResult = ReturnType<typeof useListNewslettersQuery>;
export type ListNewslettersLazyQueryHookResult = ReturnType<typeof useListNewslettersLazyQuery>;
export type ListNewslettersSuspenseQueryHookResult = ReturnType<typeof useListNewslettersSuspenseQuery>;
export type ListNewslettersQueryResult = Apollo.QueryResult<ListNewslettersQuery, ListNewslettersQueryVariables>;
export const ListPersonasDocument = gql`
    query listPersonas($siteId: ID!) {
  listPersonas(siteId: $siteId) {
    id
    name
    description
    siteId
    answerStyle
  }
}
    `;

/**
 * __useListPersonasQuery__
 *
 * To run a query within a React component, call `useListPersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPersonasQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListPersonasQuery(baseOptions: Apollo.QueryHookOptions<ListPersonasQuery, ListPersonasQueryVariables> & ({ variables: ListPersonasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPersonasQuery, ListPersonasQueryVariables>(ListPersonasDocument, options);
      }
export function useListPersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPersonasQuery, ListPersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPersonasQuery, ListPersonasQueryVariables>(ListPersonasDocument, options);
        }
// @ts-ignore
export function useListPersonasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPersonasQuery, ListPersonasQueryVariables>): Apollo.UseSuspenseQueryResult<ListPersonasQuery, ListPersonasQueryVariables>;
export function useListPersonasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPersonasQuery, ListPersonasQueryVariables>): Apollo.UseSuspenseQueryResult<ListPersonasQuery | undefined, ListPersonasQueryVariables>;
export function useListPersonasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPersonasQuery, ListPersonasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPersonasQuery, ListPersonasQueryVariables>(ListPersonasDocument, options);
        }
export type ListPersonasQueryHookResult = ReturnType<typeof useListPersonasQuery>;
export type ListPersonasLazyQueryHookResult = ReturnType<typeof useListPersonasLazyQuery>;
export type ListPersonasSuspenseQueryHookResult = ReturnType<typeof useListPersonasSuspenseQuery>;
export type ListPersonasQueryResult = Apollo.QueryResult<ListPersonasQuery, ListPersonasQueryVariables>;
export const ListPublicPersonasDocument = gql`
    query listPublicPersonas($siteId: ID!, $activeOnly: Boolean) {
  listPublicPersonas(siteId: $siteId, activeOnly: $activeOnly) {
    id
    name
    description
    siteId
    answerStyle
    active
    image {
      src
      width
      height
    }
  }
}
    `;

/**
 * __useListPublicPersonasQuery__
 *
 * To run a query within a React component, call `useListPublicPersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPublicPersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPublicPersonasQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useListPublicPersonasQuery(baseOptions: Apollo.QueryHookOptions<ListPublicPersonasQuery, ListPublicPersonasQueryVariables> & ({ variables: ListPublicPersonasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>(ListPublicPersonasDocument, options);
      }
export function useListPublicPersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>(ListPublicPersonasDocument, options);
        }
// @ts-ignore
export function useListPublicPersonasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>): Apollo.UseSuspenseQueryResult<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>;
export function useListPublicPersonasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>): Apollo.UseSuspenseQueryResult<ListPublicPersonasQuery | undefined, ListPublicPersonasQueryVariables>;
export function useListPublicPersonasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>(ListPublicPersonasDocument, options);
        }
export type ListPublicPersonasQueryHookResult = ReturnType<typeof useListPublicPersonasQuery>;
export type ListPublicPersonasLazyQueryHookResult = ReturnType<typeof useListPublicPersonasLazyQuery>;
export type ListPublicPersonasSuspenseQueryHookResult = ReturnType<typeof useListPublicPersonasSuspenseQuery>;
export type ListPublicPersonasQueryResult = Apollo.QueryResult<ListPublicPersonasQuery, ListPublicPersonasQueryVariables>;
export const ListQuestionsDocument = gql`
    query listQuestions($siteId: ID!) {
  listQuestions(siteId: $siteId) {
    id
    question
    answer
    siteId
    questionKey
    deprecated
  }
}
    `;

/**
 * __useListQuestionsQuery__
 *
 * To run a query within a React component, call `useListQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQuestionsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables> & ({ variables: ListQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, options);
      }
export function useListQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, options);
        }
// @ts-ignore
export function useListQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListQuestionsQuery, ListQuestionsQueryVariables>;
export function useListQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListQuestionsQuery | undefined, ListQuestionsQueryVariables>;
export function useListQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, options);
        }
export type ListQuestionsQueryHookResult = ReturnType<typeof useListQuestionsQuery>;
export type ListQuestionsLazyQueryHookResult = ReturnType<typeof useListQuestionsLazyQuery>;
export type ListQuestionsSuspenseQueryHookResult = ReturnType<typeof useListQuestionsSuspenseQuery>;
export type ListQuestionsQueryResult = Apollo.QueryResult<ListQuestionsQuery, ListQuestionsQueryVariables>;
export const ListSegmentsDocument = gql`
    query listSegments($siteId: ID!, $pagination: PaginationInput) {
  listSegments(siteId: $siteId, pagination: $pagination) {
    items {
      id
      siteId
      name
      description
      rulesJson
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `;

/**
 * __useListSegmentsQuery__
 *
 * To run a query within a React component, call `useListSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSegmentsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListSegmentsQuery(baseOptions: Apollo.QueryHookOptions<ListSegmentsQuery, ListSegmentsQueryVariables> & ({ variables: ListSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSegmentsQuery, ListSegmentsQueryVariables>(ListSegmentsDocument, options);
      }
export function useListSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSegmentsQuery, ListSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSegmentsQuery, ListSegmentsQueryVariables>(ListSegmentsDocument, options);
        }
// @ts-ignore
export function useListSegmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSegmentsQuery, ListSegmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSegmentsQuery, ListSegmentsQueryVariables>;
export function useListSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSegmentsQuery, ListSegmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSegmentsQuery | undefined, ListSegmentsQueryVariables>;
export function useListSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSegmentsQuery, ListSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSegmentsQuery, ListSegmentsQueryVariables>(ListSegmentsDocument, options);
        }
export type ListSegmentsQueryHookResult = ReturnType<typeof useListSegmentsQuery>;
export type ListSegmentsLazyQueryHookResult = ReturnType<typeof useListSegmentsLazyQuery>;
export type ListSegmentsSuspenseQueryHookResult = ReturnType<typeof useListSegmentsSuspenseQuery>;
export type ListSegmentsQueryResult = Apollo.QueryResult<ListSegmentsQuery, ListSegmentsQueryVariables>;
export const ListSiteBlockTemplatesDocument = gql`
    query listSiteBlockTemplates($siteId: ID!, $blockCategory: BlockTemplateCategory, $status: PublishedStatusInput) {
  listSiteBlockTemplates(
    siteId: $siteId
    blockCategory: $blockCategory
    status: $status
  ) {
    items {
      id
      sk
      gsk1
      data {
        ...BlockTemplateDataFragment
      }
      brandId
      version
      updatedAt
      blockCategory
      publishedAt
      componentId
    }
  }
}
    ${BlockTemplateDataFragmentFragmentDoc}`;

/**
 * __useListSiteBlockTemplatesQuery__
 *
 * To run a query within a React component, call `useListSiteBlockTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSiteBlockTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSiteBlockTemplatesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      blockCategory: // value for 'blockCategory'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListSiteBlockTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables> & ({ variables: ListSiteBlockTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>(ListSiteBlockTemplatesDocument, options);
      }
export function useListSiteBlockTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>(ListSiteBlockTemplatesDocument, options);
        }
// @ts-ignore
export function useListSiteBlockTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>;
export function useListSiteBlockTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteBlockTemplatesQuery | undefined, ListSiteBlockTemplatesQueryVariables>;
export function useListSiteBlockTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>(ListSiteBlockTemplatesDocument, options);
        }
export type ListSiteBlockTemplatesQueryHookResult = ReturnType<typeof useListSiteBlockTemplatesQuery>;
export type ListSiteBlockTemplatesLazyQueryHookResult = ReturnType<typeof useListSiteBlockTemplatesLazyQuery>;
export type ListSiteBlockTemplatesSuspenseQueryHookResult = ReturnType<typeof useListSiteBlockTemplatesSuspenseQuery>;
export type ListSiteBlockTemplatesQueryResult = Apollo.QueryResult<ListSiteBlockTemplatesQuery, ListSiteBlockTemplatesQueryVariables>;
export const ListSiteBlocksDocument = gql`
    query listSiteBlocks($siteId: ID!, $blockCategory: BlockCategory, $status: PublishedStatusInput) {
  listSiteBlocks(siteId: $siteId, blockCategory: $blockCategory, status: $status) {
    items {
      id
      sk
      gsk1
      data {
        ...BlockDataFragment
      }
      brandId
      version
      updatedAt
      blockCategory
      publishedAt
      componentId
      archivedAt
      slug
    }
  }
}
    ${BlockDataFragmentFragmentDoc}`;

/**
 * __useListSiteBlocksQuery__
 *
 * To run a query within a React component, call `useListSiteBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSiteBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSiteBlocksQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      blockCategory: // value for 'blockCategory'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListSiteBlocksQuery(baseOptions: Apollo.QueryHookOptions<ListSiteBlocksQuery, ListSiteBlocksQueryVariables> & ({ variables: ListSiteBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>(ListSiteBlocksDocument, options);
      }
export function useListSiteBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>(ListSiteBlocksDocument, options);
        }
// @ts-ignore
export function useListSiteBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>;
export function useListSiteBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteBlocksQuery | undefined, ListSiteBlocksQueryVariables>;
export function useListSiteBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>(ListSiteBlocksDocument, options);
        }
export type ListSiteBlocksQueryHookResult = ReturnType<typeof useListSiteBlocksQuery>;
export type ListSiteBlocksLazyQueryHookResult = ReturnType<typeof useListSiteBlocksLazyQuery>;
export type ListSiteBlocksSuspenseQueryHookResult = ReturnType<typeof useListSiteBlocksSuspenseQuery>;
export type ListSiteBlocksQueryResult = Apollo.QueryResult<ListSiteBlocksQuery, ListSiteBlocksQueryVariables>;
export const ListSiteConversationsDocument = gql`
    query listSiteConversations($siteId: ID!, $pagination: PaginationInput) {
  listSiteConversations(siteId: $siteId, pagination: $pagination) {
    items {
      id
      siteId
      userId
      title
      isAnonymous
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `;

/**
 * __useListSiteConversationsQuery__
 *
 * To run a query within a React component, call `useListSiteConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSiteConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSiteConversationsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListSiteConversationsQuery(baseOptions: Apollo.QueryHookOptions<ListSiteConversationsQuery, ListSiteConversationsQueryVariables> & ({ variables: ListSiteConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>(ListSiteConversationsDocument, options);
      }
export function useListSiteConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>(ListSiteConversationsDocument, options);
        }
// @ts-ignore
export function useListSiteConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>;
export function useListSiteConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteConversationsQuery | undefined, ListSiteConversationsQueryVariables>;
export function useListSiteConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>(ListSiteConversationsDocument, options);
        }
export type ListSiteConversationsQueryHookResult = ReturnType<typeof useListSiteConversationsQuery>;
export type ListSiteConversationsLazyQueryHookResult = ReturnType<typeof useListSiteConversationsLazyQuery>;
export type ListSiteConversationsSuspenseQueryHookResult = ReturnType<typeof useListSiteConversationsSuspenseQuery>;
export type ListSiteConversationsQueryResult = Apollo.QueryResult<ListSiteConversationsQuery, ListSiteConversationsQueryVariables>;
export const ListSitePagesDocument = gql`
    query listSitePages($siteId: ID!, $pageCategories: [PageCategory!], $status: PublishedStatusInput!) {
  listSitePages(siteId: $siteId, pageCategories: $pageCategories, status: $status) {
    items {
      id
      slug
      state
      sk
      publishedAt
      updatedAt
      pageCategory
      listPageLocalBlocks(status: $status) {
        items {
          id
          sk
          publishedAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useListSitePagesQuery__
 *
 * To run a query within a React component, call `useListSitePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSitePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSitePagesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pageCategories: // value for 'pageCategories'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListSitePagesQuery(baseOptions: Apollo.QueryHookOptions<ListSitePagesQuery, ListSitePagesQueryVariables> & ({ variables: ListSitePagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSitePagesQuery, ListSitePagesQueryVariables>(ListSitePagesDocument, options);
      }
export function useListSitePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSitePagesQuery, ListSitePagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSitePagesQuery, ListSitePagesQueryVariables>(ListSitePagesDocument, options);
        }
// @ts-ignore
export function useListSitePagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSitePagesQuery, ListSitePagesQueryVariables>): Apollo.UseSuspenseQueryResult<ListSitePagesQuery, ListSitePagesQueryVariables>;
export function useListSitePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSitePagesQuery, ListSitePagesQueryVariables>): Apollo.UseSuspenseQueryResult<ListSitePagesQuery | undefined, ListSitePagesQueryVariables>;
export function useListSitePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSitePagesQuery, ListSitePagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSitePagesQuery, ListSitePagesQueryVariables>(ListSitePagesDocument, options);
        }
export type ListSitePagesQueryHookResult = ReturnType<typeof useListSitePagesQuery>;
export type ListSitePagesLazyQueryHookResult = ReturnType<typeof useListSitePagesLazyQuery>;
export type ListSitePagesSuspenseQueryHookResult = ReturnType<typeof useListSitePagesSuspenseQuery>;
export type ListSitePagesQueryResult = Apollo.QueryResult<ListSitePagesQuery, ListSitePagesQueryVariables>;
export const ListSiteTagsLightweightDocument = gql`
    query listSiteTagsLightweight($siteId: ID!, $status: PublishedStatusInput) {
  listSiteBlocks(siteId: $siteId, blockCategory: PubTagHeader, status: $status) {
    items {
      id
      sk
      data {
        ... on BlockPubTagHeader {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useListSiteTagsLightweightQuery__
 *
 * To run a query within a React component, call `useListSiteTagsLightweightQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSiteTagsLightweightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSiteTagsLightweightQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListSiteTagsLightweightQuery(baseOptions: Apollo.QueryHookOptions<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables> & ({ variables: ListSiteTagsLightweightQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>(ListSiteTagsLightweightDocument, options);
      }
export function useListSiteTagsLightweightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>(ListSiteTagsLightweightDocument, options);
        }
// @ts-ignore
export function useListSiteTagsLightweightSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>;
export function useListSiteTagsLightweightSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>): Apollo.UseSuspenseQueryResult<ListSiteTagsLightweightQuery | undefined, ListSiteTagsLightweightQueryVariables>;
export function useListSiteTagsLightweightSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>(ListSiteTagsLightweightDocument, options);
        }
export type ListSiteTagsLightweightQueryHookResult = ReturnType<typeof useListSiteTagsLightweightQuery>;
export type ListSiteTagsLightweightLazyQueryHookResult = ReturnType<typeof useListSiteTagsLightweightLazyQuery>;
export type ListSiteTagsLightweightSuspenseQueryHookResult = ReturnType<typeof useListSiteTagsLightweightSuspenseQuery>;
export type ListSiteTagsLightweightQueryResult = Apollo.QueryResult<ListSiteTagsLightweightQuery, ListSiteTagsLightweightQueryVariables>;
export const ListUserWorkspacesDocument = gql`
    query listUserWorkspaces($username: ID = "") {
  listUserWorkspaces {
    domain {
      createdAt
      domainCloudFormation
      domainCloudfront
      domainName
      externalProvider
      hostedZoneId
      nameServers
      operationId
      siteId
      status
      updatedAt
      workspaceId
    }
    listWorkspaceBrands {
      items {
        id
        name
      }
      nextToken
    }
    createdAt
    domainName
    id
    name
    subdomain
    updatedAt
    version
    getWorkspaceUser(username: $username) {
      brandGroups {
        brandId
        groups
      }
      createdAt
      firstName
      id
      isConfirmed
      lastName
      updatedAt
      username
      version
      workspaceGroups
      workspaceId
    }
  }
}
    `;

/**
 * __useListUserWorkspacesQuery__
 *
 * To run a query within a React component, call `useListUserWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserWorkspacesQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useListUserWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>(ListUserWorkspacesDocument, options);
      }
export function useListUserWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>(ListUserWorkspacesDocument, options);
        }
// @ts-ignore
export function useListUserWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>;
export function useListUserWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<ListUserWorkspacesQuery | undefined, ListUserWorkspacesQueryVariables>;
export function useListUserWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>(ListUserWorkspacesDocument, options);
        }
export type ListUserWorkspacesQueryHookResult = ReturnType<typeof useListUserWorkspacesQuery>;
export type ListUserWorkspacesLazyQueryHookResult = ReturnType<typeof useListUserWorkspacesLazyQuery>;
export type ListUserWorkspacesSuspenseQueryHookResult = ReturnType<typeof useListUserWorkspacesSuspenseQuery>;
export type ListUserWorkspacesQueryResult = Apollo.QueryResult<ListUserWorkspacesQuery, ListUserWorkspacesQueryVariables>;
export const QueryListWorkspaceRulesViaDomainWithUserDocument = gql`
    query queryListWorkspaceRulesViaDomainWithUser($domain: String!, $username: ID!) {
  getWorkspaceByDomain(domain: $domain) {
    id
    name
    subdomain
    updatedAt
    version
    listWorkspaceWritingRules {
      workspaceId
      id
      name
      ruleText
      active
      type
      level
    }
    getWorkspaceUser(username: $username) {
      brandGroups {
        brandId
        groups
      }
      createdAt
      firstName
      id
      isConfirmed
      lastName
      updatedAt
      username
      version
      workspaceGroups
      workspaceId
    }
  }
}
    `;

/**
 * __useQueryListWorkspaceRulesViaDomainWithUserQuery__
 *
 * To run a query within a React component, call `useQueryListWorkspaceRulesViaDomainWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryListWorkspaceRulesViaDomainWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryListWorkspaceRulesViaDomainWithUserQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useQueryListWorkspaceRulesViaDomainWithUserQuery(baseOptions: Apollo.QueryHookOptions<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables> & ({ variables: QueryListWorkspaceRulesViaDomainWithUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>(QueryListWorkspaceRulesViaDomainWithUserDocument, options);
      }
export function useQueryListWorkspaceRulesViaDomainWithUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>(QueryListWorkspaceRulesViaDomainWithUserDocument, options);
        }
// @ts-ignore
export function useQueryListWorkspaceRulesViaDomainWithUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>): Apollo.UseSuspenseQueryResult<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>;
export function useQueryListWorkspaceRulesViaDomainWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>): Apollo.UseSuspenseQueryResult<QueryListWorkspaceRulesViaDomainWithUserQuery | undefined, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>;
export function useQueryListWorkspaceRulesViaDomainWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>(QueryListWorkspaceRulesViaDomainWithUserDocument, options);
        }
export type QueryListWorkspaceRulesViaDomainWithUserQueryHookResult = ReturnType<typeof useQueryListWorkspaceRulesViaDomainWithUserQuery>;
export type QueryListWorkspaceRulesViaDomainWithUserLazyQueryHookResult = ReturnType<typeof useQueryListWorkspaceRulesViaDomainWithUserLazyQuery>;
export type QueryListWorkspaceRulesViaDomainWithUserSuspenseQueryHookResult = ReturnType<typeof useQueryListWorkspaceRulesViaDomainWithUserSuspenseQuery>;
export type QueryListWorkspaceRulesViaDomainWithUserQueryResult = Apollo.QueryResult<QueryListWorkspaceRulesViaDomainWithUserQuery, QueryListWorkspaceRulesViaDomainWithUserQueryVariables>;
export const ListWorkspaceUsersViaDomainDocument = gql`
    query listWorkspaceUsersViaDomain($domain: String!, $path: String!) {
  getWorkspaceByDomain(domain: $domain) {
    getBrandByPath(path: $path) {
      name
      path
      id
      listWorkspaceUsers {
        items {
          id
          version
          username
          firstName
          lastName
          isConfirmed
          workspaceId
          createdAt
          updatedAt
          workspaceGroups
          brandGroups {
            groups
            brandId
          }
        }
      }
    }
    name
    subdomain
    updatedAt
    version
    id
    domainName
  }
}
    `;

/**
 * __useListWorkspaceUsersViaDomainQuery__
 *
 * To run a query within a React component, call `useListWorkspaceUsersViaDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkspaceUsersViaDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkspaceUsersViaDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useListWorkspaceUsersViaDomainQuery(baseOptions: Apollo.QueryHookOptions<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables> & ({ variables: ListWorkspaceUsersViaDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>(ListWorkspaceUsersViaDomainDocument, options);
      }
export function useListWorkspaceUsersViaDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>(ListWorkspaceUsersViaDomainDocument, options);
        }
// @ts-ignore
export function useListWorkspaceUsersViaDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>;
export function useListWorkspaceUsersViaDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkspaceUsersViaDomainQuery | undefined, ListWorkspaceUsersViaDomainQueryVariables>;
export function useListWorkspaceUsersViaDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>(ListWorkspaceUsersViaDomainDocument, options);
        }
export type ListWorkspaceUsersViaDomainQueryHookResult = ReturnType<typeof useListWorkspaceUsersViaDomainQuery>;
export type ListWorkspaceUsersViaDomainLazyQueryHookResult = ReturnType<typeof useListWorkspaceUsersViaDomainLazyQuery>;
export type ListWorkspaceUsersViaDomainSuspenseQueryHookResult = ReturnType<typeof useListWorkspaceUsersViaDomainSuspenseQuery>;
export type ListWorkspaceUsersViaDomainQueryResult = Apollo.QueryResult<ListWorkspaceUsersViaDomainQuery, ListWorkspaceUsersViaDomainQueryVariables>;
export const ListWritingRulesDocument = gql`
    query listWritingRules($siteId: ID!) {
  listWritingRules(siteId: $siteId) {
    siteId
    id
    name
    ruleText
    active
    type
  }
}
    `;

/**
 * __useListWritingRulesQuery__
 *
 * To run a query within a React component, call `useListWritingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWritingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWritingRulesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListWritingRulesQuery(baseOptions: Apollo.QueryHookOptions<ListWritingRulesQuery, ListWritingRulesQueryVariables> & ({ variables: ListWritingRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWritingRulesQuery, ListWritingRulesQueryVariables>(ListWritingRulesDocument, options);
      }
export function useListWritingRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWritingRulesQuery, ListWritingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWritingRulesQuery, ListWritingRulesQueryVariables>(ListWritingRulesDocument, options);
        }
// @ts-ignore
export function useListWritingRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWritingRulesQuery, ListWritingRulesQueryVariables>): Apollo.UseSuspenseQueryResult<ListWritingRulesQuery, ListWritingRulesQueryVariables>;
export function useListWritingRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWritingRulesQuery, ListWritingRulesQueryVariables>): Apollo.UseSuspenseQueryResult<ListWritingRulesQuery | undefined, ListWritingRulesQueryVariables>;
export function useListWritingRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWritingRulesQuery, ListWritingRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWritingRulesQuery, ListWritingRulesQueryVariables>(ListWritingRulesDocument, options);
        }
export type ListWritingRulesQueryHookResult = ReturnType<typeof useListWritingRulesQuery>;
export type ListWritingRulesLazyQueryHookResult = ReturnType<typeof useListWritingRulesLazyQuery>;
export type ListWritingRulesSuspenseQueryHookResult = ReturnType<typeof useListWritingRulesSuspenseQuery>;
export type ListWritingRulesQueryResult = Apollo.QueryResult<ListWritingRulesQuery, ListWritingRulesQueryVariables>;
export const PreviewApNewsFeedItemsDocument = gql`
    query previewAPNewsFeedItems($siteId: ID!, $topicId: Int!) {
  previewAPNewsFeedItems(siteId: $siteId, topicId: $topicId) {
    id
    title
    byline
    releaseDate
    pubStatus
    imageUrl
    imported
    importedPageId
    importedTitle
    skipReason
  }
}
    `;

/**
 * __usePreviewApNewsFeedItemsQuery__
 *
 * To run a query within a React component, call `usePreviewApNewsFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewApNewsFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewApNewsFeedItemsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function usePreviewApNewsFeedItemsQuery(baseOptions: Apollo.QueryHookOptions<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables> & ({ variables: PreviewApNewsFeedItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>(PreviewApNewsFeedItemsDocument, options);
      }
export function usePreviewApNewsFeedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>(PreviewApNewsFeedItemsDocument, options);
        }
// @ts-ignore
export function usePreviewApNewsFeedItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>;
export function usePreviewApNewsFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewApNewsFeedItemsQuery | undefined, PreviewApNewsFeedItemsQueryVariables>;
export function usePreviewApNewsFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>(PreviewApNewsFeedItemsDocument, options);
        }
export type PreviewApNewsFeedItemsQueryHookResult = ReturnType<typeof usePreviewApNewsFeedItemsQuery>;
export type PreviewApNewsFeedItemsLazyQueryHookResult = ReturnType<typeof usePreviewApNewsFeedItemsLazyQuery>;
export type PreviewApNewsFeedItemsSuspenseQueryHookResult = ReturnType<typeof usePreviewApNewsFeedItemsSuspenseQuery>;
export type PreviewApNewsFeedItemsQueryResult = Apollo.QueryResult<PreviewApNewsFeedItemsQuery, PreviewApNewsFeedItemsQueryVariables>;
export const PreviewExternalFeedItemsDocument = gql`
    query previewExternalFeedItems($siteId: ID!, $id: ID!) {
  previewExternalFeedItems(siteId: $siteId, id: $id) {
    id
    title
    byline
    releaseDate
    publishStatus
    lead
    tags
    metadata
    imageUrl
    body
    imported
    importedPageId
    section
  }
}
    `;

/**
 * __usePreviewExternalFeedItemsQuery__
 *
 * To run a query within a React component, call `usePreviewExternalFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewExternalFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewExternalFeedItemsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewExternalFeedItemsQuery(baseOptions: Apollo.QueryHookOptions<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables> & ({ variables: PreviewExternalFeedItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>(PreviewExternalFeedItemsDocument, options);
      }
export function usePreviewExternalFeedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>(PreviewExternalFeedItemsDocument, options);
        }
// @ts-ignore
export function usePreviewExternalFeedItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>;
export function usePreviewExternalFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewExternalFeedItemsQuery | undefined, PreviewExternalFeedItemsQueryVariables>;
export function usePreviewExternalFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>(PreviewExternalFeedItemsDocument, options);
        }
export type PreviewExternalFeedItemsQueryHookResult = ReturnType<typeof usePreviewExternalFeedItemsQuery>;
export type PreviewExternalFeedItemsLazyQueryHookResult = ReturnType<typeof usePreviewExternalFeedItemsLazyQuery>;
export type PreviewExternalFeedItemsSuspenseQueryHookResult = ReturnType<typeof usePreviewExternalFeedItemsSuspenseQuery>;
export type PreviewExternalFeedItemsQueryResult = Apollo.QueryResult<PreviewExternalFeedItemsQuery, PreviewExternalFeedItemsQueryVariables>;
export const ValidateMirabelConnectionDocument = gql`
    query validateMirabelConnection($input: ValidateMirabelConnectionInput!) {
  validateMirabelConnection(input: $input) {
    success
    error
    errorCode
    data {
      connectionValid
      issues
      statusCode
      statusMessage
    }
  }
}
    `;

/**
 * __useValidateMirabelConnectionQuery__
 *
 * To run a query within a React component, call `useValidateMirabelConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateMirabelConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateMirabelConnectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateMirabelConnectionQuery(baseOptions: Apollo.QueryHookOptions<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables> & ({ variables: ValidateMirabelConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>(ValidateMirabelConnectionDocument, options);
      }
export function useValidateMirabelConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>(ValidateMirabelConnectionDocument, options);
        }
// @ts-ignore
export function useValidateMirabelConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>;
export function useValidateMirabelConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateMirabelConnectionQuery | undefined, ValidateMirabelConnectionQueryVariables>;
export function useValidateMirabelConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>(ValidateMirabelConnectionDocument, options);
        }
export type ValidateMirabelConnectionQueryHookResult = ReturnType<typeof useValidateMirabelConnectionQuery>;
export type ValidateMirabelConnectionLazyQueryHookResult = ReturnType<typeof useValidateMirabelConnectionLazyQuery>;
export type ValidateMirabelConnectionSuspenseQueryHookResult = ReturnType<typeof useValidateMirabelConnectionSuspenseQuery>;
export type ValidateMirabelConnectionQueryResult = Apollo.QueryResult<ValidateMirabelConnectionQuery, ValidateMirabelConnectionQueryVariables>;
export const ValidateNavigaConnectionDocument = gql`
    query validateNavigaConnection($input: ValidateNavigaConnectionInput!) {
  validateNavigaConnection(input: $input) {
    success
    error
    errorCode
    data {
      connectionValid
      issues
      validatedSubscriptions {
        stripeProductId
        navigaPubId
        navigaRateId
        publicationName
        subRateName
        valid
        error
      }
    }
  }
}
    `;

/**
 * __useValidateNavigaConnectionQuery__
 *
 * To run a query within a React component, call `useValidateNavigaConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateNavigaConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateNavigaConnectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateNavigaConnectionQuery(baseOptions: Apollo.QueryHookOptions<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables> & ({ variables: ValidateNavigaConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>(ValidateNavigaConnectionDocument, options);
      }
export function useValidateNavigaConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>(ValidateNavigaConnectionDocument, options);
        }
// @ts-ignore
export function useValidateNavigaConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>;
export function useValidateNavigaConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateNavigaConnectionQuery | undefined, ValidateNavigaConnectionQueryVariables>;
export function useValidateNavigaConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>(ValidateNavigaConnectionDocument, options);
        }
export type ValidateNavigaConnectionQueryHookResult = ReturnType<typeof useValidateNavigaConnectionQuery>;
export type ValidateNavigaConnectionLazyQueryHookResult = ReturnType<typeof useValidateNavigaConnectionLazyQuery>;
export type ValidateNavigaConnectionSuspenseQueryHookResult = ReturnType<typeof useValidateNavigaConnectionSuspenseQuery>;
export type ValidateNavigaConnectionQueryResult = Apollo.QueryResult<ValidateNavigaConnectionQuery, ValidateNavigaConnectionQueryVariables>;
export const GetReutersCredentialsDocument = gql`
    query getReutersCredentials($siteId: ID!) {
  getReutersCredentials(siteId: $siteId) {
    isConfigured
    clientId
  }
}
    `;

/**
 * __useGetReutersCredentialsQuery__
 *
 * To run a query within a React component, call `useGetReutersCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReutersCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReutersCredentialsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetReutersCredentialsQuery(baseOptions: Apollo.QueryHookOptions<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables> & ({ variables: GetReutersCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>(GetReutersCredentialsDocument, options);
      }
export function useGetReutersCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>(GetReutersCredentialsDocument, options);
        }
// @ts-ignore
export function useGetReutersCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>;
export function useGetReutersCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReutersCredentialsQuery | undefined, GetReutersCredentialsQueryVariables>;
export function useGetReutersCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>(GetReutersCredentialsDocument, options);
        }
export type GetReutersCredentialsQueryHookResult = ReturnType<typeof useGetReutersCredentialsQuery>;
export type GetReutersCredentialsLazyQueryHookResult = ReturnType<typeof useGetReutersCredentialsLazyQuery>;
export type GetReutersCredentialsSuspenseQueryHookResult = ReturnType<typeof useGetReutersCredentialsSuspenseQuery>;
export type GetReutersCredentialsQueryResult = Apollo.QueryResult<GetReutersCredentialsQuery, GetReutersCredentialsQueryVariables>;
export const ListReutersChannelsDocument = gql`
    query listReutersChannels($siteId: ID!) {
  listReutersChannels(siteId: $siteId) {
    items {
      alias
      name
      channelCategory
      sectionId
      active
      publishStatus
      paywall
      display
      imgRequired
      mediaType
    }
  }
}
    `;

/**
 * __useListReutersChannelsQuery__
 *
 * To run a query within a React component, call `useListReutersChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReutersChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReutersChannelsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useListReutersChannelsQuery(baseOptions: Apollo.QueryHookOptions<ListReutersChannelsQuery, ListReutersChannelsQueryVariables> & ({ variables: ListReutersChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>(ListReutersChannelsDocument, options);
      }
export function useListReutersChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>(ListReutersChannelsDocument, options);
        }
// @ts-ignore
export function useListReutersChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>;
export function useListReutersChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<ListReutersChannelsQuery | undefined, ListReutersChannelsQueryVariables>;
export function useListReutersChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>(ListReutersChannelsDocument, options);
        }
export type ListReutersChannelsQueryHookResult = ReturnType<typeof useListReutersChannelsQuery>;
export type ListReutersChannelsLazyQueryHookResult = ReturnType<typeof useListReutersChannelsLazyQuery>;
export type ListReutersChannelsSuspenseQueryHookResult = ReturnType<typeof useListReutersChannelsSuspenseQuery>;
export type ListReutersChannelsQueryResult = Apollo.QueryResult<ListReutersChannelsQuery, ListReutersChannelsQueryVariables>;
export const SearchReutersItemsDocument = gql`
    query searchReutersItems($siteId: ID!, $input: ReutersSearchInput!) {
  searchReutersItems(siteId: $siteId, input: $input) {
    totalHits
    hasNextPage
    entitlementIssue {
      code
      message
      requestedChannels
      invalidChannels
    }
    items {
      id
      versionedGuid
      title
      itemType
      byline
      date
      channel
      thumbnailUrl
      fragment
      imported
      importedPageId
    }
  }
}
    `;

/**
 * __useSearchReutersItemsQuery__
 *
 * To run a query within a React component, call `useSearchReutersItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchReutersItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchReutersItemsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchReutersItemsQuery(baseOptions: Apollo.QueryHookOptions<SearchReutersItemsQuery, SearchReutersItemsQueryVariables> & ({ variables: SearchReutersItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>(SearchReutersItemsDocument, options);
      }
export function useSearchReutersItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>(SearchReutersItemsDocument, options);
        }
// @ts-ignore
export function useSearchReutersItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>;
export function useSearchReutersItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchReutersItemsQuery | undefined, SearchReutersItemsQueryVariables>;
export function useSearchReutersItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>(SearchReutersItemsDocument, options);
        }
export type SearchReutersItemsQueryHookResult = ReturnType<typeof useSearchReutersItemsQuery>;
export type SearchReutersItemsLazyQueryHookResult = ReturnType<typeof useSearchReutersItemsLazyQuery>;
export type SearchReutersItemsSuspenseQueryHookResult = ReturnType<typeof useSearchReutersItemsSuspenseQuery>;
export type SearchReutersItemsQueryResult = Apollo.QueryResult<SearchReutersItemsQuery, SearchReutersItemsQueryVariables>;
export const SyncReutersChannelsDocument = gql`
    mutation syncReutersChannels($siteId: ID!) {
  syncReutersChannels(siteId: $siteId) {
    syncedAt
    totalSubscriptions
    addedChannels
    removedChannels
  }
}
    `;
export type SyncReutersChannelsMutationFn = Apollo.MutationFunction<SyncReutersChannelsMutation, SyncReutersChannelsMutationVariables>;

/**
 * __useSyncReutersChannelsMutation__
 *
 * To run a mutation, you first call `useSyncReutersChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncReutersChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncReutersChannelsMutation, { data, loading, error }] = useSyncReutersChannelsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSyncReutersChannelsMutation(baseOptions?: Apollo.MutationHookOptions<SyncReutersChannelsMutation, SyncReutersChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncReutersChannelsMutation, SyncReutersChannelsMutationVariables>(SyncReutersChannelsDocument, options);
      }
export type SyncReutersChannelsMutationHookResult = ReturnType<typeof useSyncReutersChannelsMutation>;
export type SyncReutersChannelsMutationResult = Apollo.MutationResult<SyncReutersChannelsMutation>;
export type SyncReutersChannelsMutationOptions = Apollo.BaseMutationOptions<SyncReutersChannelsMutation, SyncReutersChannelsMutationVariables>;
export const GetReutersItemDetailDocument = gql`
    query getReutersItemDetail($siteId: ID!, $itemId: String!) {
  getReutersItemDetail(siteId: $siteId, itemId: $itemId) {
    id
    title
    itemType
    profile
    pubStatus
    usageTerms
    byline
    firstCreated
    versionCreated
    credit
    fragment
    channel
    slug
    thumbnailUrl
    urgency
    body
    imported
    importedPageId
    importable
    importabilityCode
    importabilityMessage
    recommendedDownloadMode
    associatedImages {
      uri
      thumbnailUrl
      caption
      credit
    }
  }
}
    `;

/**
 * __useGetReutersItemDetailQuery__
 *
 * To run a query within a React component, call `useGetReutersItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReutersItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReutersItemDetailQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetReutersItemDetailQuery(baseOptions: Apollo.QueryHookOptions<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables> & ({ variables: GetReutersItemDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>(GetReutersItemDetailDocument, options);
      }
export function useGetReutersItemDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>(GetReutersItemDetailDocument, options);
        }
// @ts-ignore
export function useGetReutersItemDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>;
export function useGetReutersItemDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetReutersItemDetailQuery | undefined, GetReutersItemDetailQueryVariables>;
export function useGetReutersItemDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>(GetReutersItemDetailDocument, options);
        }
export type GetReutersItemDetailQueryHookResult = ReturnType<typeof useGetReutersItemDetailQuery>;
export type GetReutersItemDetailLazyQueryHookResult = ReturnType<typeof useGetReutersItemDetailLazyQuery>;
export type GetReutersItemDetailSuspenseQueryHookResult = ReturnType<typeof useGetReutersItemDetailSuspenseQuery>;
export type GetReutersItemDetailQueryResult = Apollo.QueryResult<GetReutersItemDetailQuery, GetReutersItemDetailQueryVariables>;
export const SetReutersCredentialsDocument = gql`
    mutation setReutersCredentials($siteId: ID!, $clientId: String!, $clientSecret: String!) {
  setReutersCredentials(
    siteId: $siteId
    clientId: $clientId
    clientSecret: $clientSecret
  ) {
    isConfigured
  }
}
    `;
export type SetReutersCredentialsMutationFn = Apollo.MutationFunction<SetReutersCredentialsMutation, SetReutersCredentialsMutationVariables>;

/**
 * __useSetReutersCredentialsMutation__
 *
 * To run a mutation, you first call `useSetReutersCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReutersCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReutersCredentialsMutation, { data, loading, error }] = useSetReutersCredentialsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      clientId: // value for 'clientId'
 *      clientSecret: // value for 'clientSecret'
 *   },
 * });
 */
export function useSetReutersCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<SetReutersCredentialsMutation, SetReutersCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReutersCredentialsMutation, SetReutersCredentialsMutationVariables>(SetReutersCredentialsDocument, options);
      }
export type SetReutersCredentialsMutationHookResult = ReturnType<typeof useSetReutersCredentialsMutation>;
export type SetReutersCredentialsMutationResult = Apollo.MutationResult<SetReutersCredentialsMutation>;
export type SetReutersCredentialsMutationOptions = Apollo.BaseMutationOptions<SetReutersCredentialsMutation, SetReutersCredentialsMutationVariables>;
export const DeleteReutersCredentialsDocument = gql`
    mutation deleteReutersCredentials($siteId: ID!) {
  deleteReutersCredentials(siteId: $siteId) {
    isConfigured
  }
}
    `;
export type DeleteReutersCredentialsMutationFn = Apollo.MutationFunction<DeleteReutersCredentialsMutation, DeleteReutersCredentialsMutationVariables>;

/**
 * __useDeleteReutersCredentialsMutation__
 *
 * To run a mutation, you first call `useDeleteReutersCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReutersCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReutersCredentialsMutation, { data, loading, error }] = useDeleteReutersCredentialsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDeleteReutersCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReutersCredentialsMutation, DeleteReutersCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReutersCredentialsMutation, DeleteReutersCredentialsMutationVariables>(DeleteReutersCredentialsDocument, options);
      }
export type DeleteReutersCredentialsMutationHookResult = ReturnType<typeof useDeleteReutersCredentialsMutation>;
export type DeleteReutersCredentialsMutationResult = Apollo.MutationResult<DeleteReutersCredentialsMutation>;
export type DeleteReutersCredentialsMutationOptions = Apollo.BaseMutationOptions<DeleteReutersCredentialsMutation, DeleteReutersCredentialsMutationVariables>;
export const UpdateReutersChannelDocument = gql`
    mutation updateReutersChannel($siteId: ID!, $channel: ReutersChannelInput!) {
  updateReutersChannel(siteId: $siteId, channel: $channel) {
    alias
    name
    channelCategory
    sectionId
    active
    publishStatus
    paywall
    display
    imgRequired
    mediaType
  }
}
    `;
export type UpdateReutersChannelMutationFn = Apollo.MutationFunction<UpdateReutersChannelMutation, UpdateReutersChannelMutationVariables>;

/**
 * __useUpdateReutersChannelMutation__
 *
 * To run a mutation, you first call `useUpdateReutersChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReutersChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReutersChannelMutation, { data, loading, error }] = useUpdateReutersChannelMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useUpdateReutersChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReutersChannelMutation, UpdateReutersChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReutersChannelMutation, UpdateReutersChannelMutationVariables>(UpdateReutersChannelDocument, options);
      }
export type UpdateReutersChannelMutationHookResult = ReturnType<typeof useUpdateReutersChannelMutation>;
export type UpdateReutersChannelMutationResult = Apollo.MutationResult<UpdateReutersChannelMutation>;
export type UpdateReutersChannelMutationOptions = Apollo.BaseMutationOptions<UpdateReutersChannelMutation, UpdateReutersChannelMutationVariables>;
export const DownloadReutersStoryDocument = gql`
    mutation downloadReutersStory($siteId: ID!, $itemId: String!, $sectionId: ID!, $publishStatus: FeedPublishStatus, $paywall: Paywall) {
  downloadReutersStory(
    siteId: $siteId
    itemId: $itemId
    sectionId: $sectionId
    publishStatus: $publishStatus
    paywall: $paywall
  ) {
    id
    sk
    slug
  }
}
    `;
export type DownloadReutersStoryMutationFn = Apollo.MutationFunction<DownloadReutersStoryMutation, DownloadReutersStoryMutationVariables>;

/**
 * __useDownloadReutersStoryMutation__
 *
 * To run a mutation, you first call `useDownloadReutersStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadReutersStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadReutersStoryMutation, { data, loading, error }] = useDownloadReutersStoryMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      itemId: // value for 'itemId'
 *      sectionId: // value for 'sectionId'
 *      publishStatus: // value for 'publishStatus'
 *      paywall: // value for 'paywall'
 *   },
 * });
 */
export function useDownloadReutersStoryMutation(baseOptions?: Apollo.MutationHookOptions<DownloadReutersStoryMutation, DownloadReutersStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadReutersStoryMutation, DownloadReutersStoryMutationVariables>(DownloadReutersStoryDocument, options);
      }
export type DownloadReutersStoryMutationHookResult = ReturnType<typeof useDownloadReutersStoryMutation>;
export type DownloadReutersStoryMutationResult = Apollo.MutationResult<DownloadReutersStoryMutation>;
export type DownloadReutersStoryMutationOptions = Apollo.BaseMutationOptions<DownloadReutersStoryMutation, DownloadReutersStoryMutationVariables>;
export const OnBlogGenerationDocument = gql`
    subscription onBlogGeneration($generationId: ID!, $siteId: ID!) {
  onBlogGeneration(siteId: $siteId, generationId: $generationId) {
    generationId
    progress
    result
    siteId
    message
  }
}
    `;

/**
 * __useOnBlogGenerationSubscription__
 *
 * To run a query within a React component, call `useOnBlogGenerationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnBlogGenerationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnBlogGenerationSubscription({
 *   variables: {
 *      generationId: // value for 'generationId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useOnBlogGenerationSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnBlogGenerationSubscription, OnBlogGenerationSubscriptionVariables> & ({ variables: OnBlogGenerationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnBlogGenerationSubscription, OnBlogGenerationSubscriptionVariables>(OnBlogGenerationDocument, options);
      }
export type OnBlogGenerationSubscriptionHookResult = ReturnType<typeof useOnBlogGenerationSubscription>;
export type OnBlogGenerationSubscriptionResult = Apollo.SubscriptionResult<OnBlogGenerationSubscription>;
export const OnChatbotMessageDocument = gql`
    subscription onChatbotMessage($username: ID!, $siteId: ID!) {
  onChatbotMessage(siteId: $siteId, username: $username) {
    siteId
    messageId
    text
    username
    sequenceNumber
    fullMessage
    status
    prompt
    error
    totalNumberOfResults
    currentNumberOfResults
    type
  }
}
    `;

/**
 * __useOnChatbotMessageSubscription__
 *
 * To run a query within a React component, call `useOnChatbotMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnChatbotMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnChatbotMessageSubscription({
 *   variables: {
 *      username: // value for 'username'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useOnChatbotMessageSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnChatbotMessageSubscription, OnChatbotMessageSubscriptionVariables> & ({ variables: OnChatbotMessageSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnChatbotMessageSubscription, OnChatbotMessageSubscriptionVariables>(OnChatbotMessageDocument, options);
      }
export type OnChatbotMessageSubscriptionHookResult = ReturnType<typeof useOnChatbotMessageSubscription>;
export type OnChatbotMessageSubscriptionResult = Apollo.SubscriptionResult<OnChatbotMessageSubscription>;
export const OnArticleGenerationDocument = gql`
    subscription onArticleGeneration($generationId: ID!, $siteId: ID!) {
  onArticleGeneration(siteId: $siteId, generationId: $generationId) {
    generationId
    progress
    result
    siteId
    message
    articlePart
    sequenceNumber
    error
  }
}
    `;

/**
 * __useOnArticleGenerationSubscription__
 *
 * To run a query within a React component, call `useOnArticleGenerationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnArticleGenerationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnArticleGenerationSubscription({
 *   variables: {
 *      generationId: // value for 'generationId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useOnArticleGenerationSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnArticleGenerationSubscription, OnArticleGenerationSubscriptionVariables> & ({ variables: OnArticleGenerationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnArticleGenerationSubscription, OnArticleGenerationSubscriptionVariables>(OnArticleGenerationDocument, options);
      }
export type OnArticleGenerationSubscriptionHookResult = ReturnType<typeof useOnArticleGenerationSubscription>;
export type OnArticleGenerationSubscriptionResult = Apollo.SubscriptionResult<OnArticleGenerationSubscription>;
export const OnImageGenerationDocument = gql`
    subscription onImageGeneration($imageGenerationId: ID!, $siteId: ID!) {
  onImageGeneration(siteId: $siteId, imageGenerationId: $imageGenerationId) {
    siteId
    imageGenerationId
    images {
      id
      public
      brandId
      key
      uploaded
      name
      width
      height
      type
      tags
      createdAt
      updatedAt
      version
      usedIn
    }
    progress
    error
  }
}
    `;

/**
 * __useOnImageGenerationSubscription__
 *
 * To run a query within a React component, call `useOnImageGenerationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnImageGenerationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnImageGenerationSubscription({
 *   variables: {
 *      imageGenerationId: // value for 'imageGenerationId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useOnImageGenerationSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnImageGenerationSubscription, OnImageGenerationSubscriptionVariables> & ({ variables: OnImageGenerationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnImageGenerationSubscription, OnImageGenerationSubscriptionVariables>(OnImageGenerationDocument, options);
      }
export type OnImageGenerationSubscriptionHookResult = ReturnType<typeof useOnImageGenerationSubscription>;
export type OnImageGenerationSubscriptionResult = Apollo.SubscriptionResult<OnImageGenerationSubscription>;